var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/enums/region.enum.ts
var Region = /* @__PURE__ */ ((Region2) => {
  Region2[Region2["US"] = 0] = "US";
  Region2[Region2["EU"] = 1] = "EU";
  Region2[Region2["CN"] = 2] = "CN";
  return Region2;
})(Region || {});
var WorkspaceRegion = /* @__PURE__ */ ((WorkspaceRegion2) => {
  WorkspaceRegion2["US"] = "US";
  WorkspaceRegion2["EU"] = "EU";
  WorkspaceRegion2["CN"] = "CN";
  return WorkspaceRegion2;
})(WorkspaceRegion || {});

// src/enums/application-type.enum.ts
var ApplicationType = /* @__PURE__ */ ((ApplicationType2) => {
  ApplicationType2[ApplicationType2["OnePhase"] = 1] = "OnePhase";
  ApplicationType2[ApplicationType2["Condenser"] = 2] = "Condenser";
  ApplicationType2[ApplicationType2["Evaporator"] = 3] = "Evaporator";
  ApplicationType2[ApplicationType2["Cascade"] = 4] = "Cascade";
  ApplicationType2[ApplicationType2["PartialCascade"] = 5] = "PartialCascade";
  ApplicationType2[ApplicationType2["MultiCondenser"] = 6] = "MultiCondenser";
  ApplicationType2[ApplicationType2["DropletSeparator"] = 7] = "DropletSeparator";
  return ApplicationType2;
})(ApplicationType || {});
var applicationTypeSpec = {
  [1 /* OnePhase */]: { label: "OnePhase", cpq: 1, orp: 1 },
  [2 /* Condenser */]: { label: "Condenser", cpq: 2, orp: 2 },
  [3 /* Evaporator */]: { label: "Evaporator", cpq: 3, orp: 3 },
  [4 /* Cascade */]: { label: "Cascade", cpq: 4, orp: 4 },
  [5 /* PartialCascade */]: {
    label: "Partial cascade",
    cpq: 5,
    orp: 5
  },
  [6 /* MultiCondenser */]: {
    label: "Multi condenser",
    cpq: 6,
    orp: 6
  },
  [7 /* DropletSeparator */]: {
    label: "Droplet Separator",
    cpq: null,
    orp: 7
  }
};
var applicationTypeLabelMapping = new Map(
  Object.entries(applicationTypeSpec).map(([k, v]) => [
    Number(k),
    v.label
  ])
);
var CpqApplicationType = Object.keys(applicationTypeSpec).map(Number).filter((a) => applicationTypeSpec[a].cpq !== null);
var OrpApplicationType = Object.keys(applicationTypeSpec).map(Number).filter((a) => applicationTypeSpec[a].orp !== null);

// src/enums/approval-type.enum.ts
var ApprovalType = /* @__PURE__ */ ((ApprovalType2) => {
  ApprovalType2[ApprovalType2["PED"] = 0] = "PED";
  ApprovalType2[ApprovalType2["ASME"] = 1] = "ASME";
  ApprovalType2[ApprovalType2["PEDEN"] = 2] = "PEDEN";
  ApprovalType2[ApprovalType2["GB150"] = 3] = "GB150";
  ApprovalType2[ApprovalType2["Marine"] = 4] = "Marine";
  ApprovalType2[ApprovalType2["Offshore"] = 5] = "Offshore";
  ApprovalType2[ApprovalType2["China"] = 6] = "China";
  ApprovalType2[ApprovalType2["Other"] = 7] = "Other";
  return ApprovalType2;
})(ApprovalType || {});
var approvalTypeSpec = {
  [0 /* PED */]: { label: "PED", cpq: 0, orp: 0 },
  [1 /* ASME */]: { label: "ASME", cpq: 1, orp: 1 },
  [2 /* PEDEN */]: { label: "PED-EN", cpq: 2, orp: null },
  [3 /* GB150 */]: { label: "GB150", cpq: 3, orp: null },
  [4 /* Marine */]: { label: "Marine", cpq: null, orp: 4 },
  [5 /* Offshore */]: { label: "Offshore", cpq: null, orp: 5 },
  /** Complete unit from Finland — see `ChinaClassification`. */
  [6 /* China */]: { label: "China", cpq: null, orp: 6 },
  [7 /* Other */]: { label: "Other", cpq: null, orp: 7 }
};
var approvalTypeMappingLabel = new Map(
  Object.entries(approvalTypeSpec).map(([k, v]) => [
    Number(k),
    v.label
  ])
);
var CpqApprovalType = Object.keys(approvalTypeSpec).map(Number).filter((a) => approvalTypeSpec[a].cpq !== null);
var OrpApprovalType = Object.keys(approvalTypeSpec).map(Number).filter((a) => approvalTypeSpec[a].orp !== null);

// src/enums/bypass-facture.enum.ts
var ByPassFactor = /* @__PURE__ */ ((ByPassFactor2) => {
  ByPassFactor2[ByPassFactor2["Normal"] = 1] = "Normal";
  ByPassFactor2[ByPassFactor2["Ignore"] = 6] = "Ignore";
  return ByPassFactor2;
})(ByPassFactor || {});

// src/enums/calculation-option.ts
var CalculationOption = /* @__PURE__ */ ((CalculationOption2) => {
  CalculationOption2[CalculationOption2["Manual"] = 0] = "Manual";
  CalculationOption2[CalculationOption2["Automatic"] = 1] = "Automatic";
  CalculationOption2[CalculationOption2["Performance"] = 2] = "Performance";
  CalculationOption2[CalculationOption2["Rating"] = 3] = "Rating";
  CalculationOption2[CalculationOption2["AI"] = 4] = "AI";
  return CalculationOption2;
})(CalculationOption || {});
var calculationOptionLabelMapping = /* @__PURE__ */ new Map(
  [
    [0 /* Manual */, "Manual"],
    [1 /* Automatic */, "Automatic"],
    [2 /* Performance */, "Performance"],
    [3 /* Rating */, "Rating"],
    [4 /* AI */, "AI"]
  ]
);

// src/enums/calculation.state.enum.ts
var CalculationState = /* @__PURE__ */ ((CalculationState2) => {
  CalculationState2["Warning"] = "warning";
  CalculationState2["Success"] = "success";
  CalculationState2["Error"] = "error";
  CalculationState2["Initial"] = "initial";
  return CalculationState2;
})(CalculationState || {});

// src/enums/cascade-type.enum.ts
var CascadeType = /* @__PURE__ */ ((CascadeType2) => {
  CascadeType2[CascadeType2["DX"] = 0] = "DX";
  CascadeType2[CascadeType2["Flooded"] = 1] = "Flooded";
  return CascadeType2;
})(CascadeType || {});
var CascadeTypeLableMapping = /* @__PURE__ */ new Map([
  [0 /* DX */, "DX"],
  [1 /* Flooded */, "Flooded"]
]);

// src/enums/circulation.enum.ts
var Circulation = /* @__PURE__ */ ((Circulation2) => {
  Circulation2[Circulation2["External"] = 1] = "External";
  Circulation2[Circulation2["Internal"] = 2] = "Internal";
  Circulation2[Circulation2["Combined"] = 3] = "Combined";
  Circulation2[Circulation2["Kettle"] = 4] = "Kettle";
  return Circulation2;
})(Circulation || {});
var CirculationMappingLabel = /* @__PURE__ */ new Map([
  [1 /* External */, "External"],
  [2 /* Internal */, "Internal"],
  [3 /* Combined */, "Combined"],
  [4 /* Kettle */, "Kettle"]
]);

// src/enums/combination.enum.ts
var Combination = /* @__PURE__ */ ((Combination2) => {
  Combination2[Combination2["DesupCondSubc"] = 1] = "DesupCondSubc";
  Combination2[Combination2["DesupCond"] = 2] = "DesupCond";
  Combination2[Combination2["CondSubc"] = 3] = "CondSubc";
  return Combination2;
})(Combination || {});
var combinationMappingLabel = /* @__PURE__ */ new Map([
  [1 /* DesupCondSubc */, "Desup + Cond + Subc"],
  [2 /* DesupCond */, "Desup + Cond"],
  [3 /* CondSubc */, "Cond + Subc"]
]);

// src/enums/condenser-type.enum.ts
var CondenserType = /* @__PURE__ */ ((CondenserType2) => {
  CondenserType2[CondenserType2["Normal"] = 0] = "Normal";
  CondenserType2[CondenserType2["VentCondenser"] = 1] = "VentCondenser";
  CondenserType2[CondenserType2["CondGasSeparator"] = 2] = "CondGasSeparator";
  return CondenserType2;
})(CondenserType || {});
var condenserTypeNameMapping = /* @__PURE__ */ new Map([
  [0 /* Normal */, "Normal"],
  [1 /* VentCondenser */, "Vent Condenser"],
  [2 /* CondGasSeparator */, "Condenser-Gas-Seperator"]
]);

// src/enums/currency-code.enum.ts
var CurrencyCode = /* @__PURE__ */ ((CurrencyCode2) => {
  CurrencyCode2[CurrencyCode2["EUR"] = 1] = "EUR";
  CurrencyCode2[CurrencyCode2["USD"] = 2] = "USD";
  CurrencyCode2[CurrencyCode2["GBP"] = 3] = "GBP";
  CurrencyCode2[CurrencyCode2["CAD"] = 4] = "CAD";
  CurrencyCode2[CurrencyCode2["CNY"] = 5] = "CNY";
  return CurrencyCode2;
})(CurrencyCode || {});
var currencyCodeLabelMapping = {
  [1 /* EUR */]: "EUR",
  [2 /* USD */]: "USD",
  [3 /* GBP */]: "GBP",
  [4 /* CAD */]: "CAD",
  [5 /* CNY */]: "CNY"
};
var currencyCodeSymbolMapping = {
  [1 /* EUR */]: "\u20AC",
  [2 /* USD */]: "$",
  [3 /* GBP */]: "\xA3",
  [4 /* CAD */]: "CA$",
  [5 /* CNY */]: "CN\xA5"
};

// src/enums/design-classification.enum.ts
var DesignClassification = /* @__PURE__ */ ((DesignClassification2) => {
  DesignClassification2[DesignClassification2["PED"] = 0] = "PED";
  DesignClassification2[DesignClassification2["U_STAMP"] = 1] = "U_STAMP";
  DesignClassification2[DesignClassification2["WITHOUTU_STAMP"] = 2] = "WITHOUTU_STAMP";
  DesignClassification2[DesignClassification2["SELO"] = 3] = "SELO";
  DesignClassification2[DesignClassification2["ABS"] = 4] = "ABS";
  DesignClassification2[DesignClassification2["BV"] = 5] = "BV";
  DesignClassification2[DesignClassification2["DNV"] = 6] = "DNV";
  DesignClassification2[DesignClassification2["CCS"] = 7] = "CCS";
  DesignClassification2[DesignClassification2["KRS"] = 8] = "KRS";
  DesignClassification2[DesignClassification2["LR"] = 9] = "LR";
  DesignClassification2[DesignClassification2["NK"] = 10] = "NK";
  DesignClassification2[DesignClassification2["Rina"] = 11] = "Rina";
  return DesignClassification2;
})(DesignClassification || {});
var designClassificationMappingLabel = /* @__PURE__ */ new Map([
  [0 /* PED */, "PED"],
  [1 /* U_STAMP */, "U-Stamp"],
  [2 /* WITHOUTU_STAMP */, "Without U-Stamp"],
  [4 /* ABS */, "ABS"],
  [5 /* BV */, "BV"],
  [7 /* CCS */, "CCS"],
  [6 /* DNV */, "DNV"],
  [8 /* KRS */, "KRS"],
  [9 /* LR */, "LR"],
  [10 /* NK */, "NK"],
  [11 /* Rina */, "Rina"],
  [3 /* SELO */, "Selo"]
]);

// src/enums/design-pressure-option.enum.ts
var DesignPressureOption = /* @__PURE__ */ ((DesignPressureOption2) => {
  DesignPressureOption2[DesignPressureOption2["Bar6"] = 0] = "Bar6";
  DesignPressureOption2[DesignPressureOption2["Bar10"] = 1] = "Bar10";
  DesignPressureOption2[DesignPressureOption2["Bar16"] = 2] = "Bar16";
  DesignPressureOption2[DesignPressureOption2["Bar25"] = 3] = "Bar25";
  DesignPressureOption2[DesignPressureOption2["Bar40"] = 4] = "Bar40";
  DesignPressureOption2[DesignPressureOption2["Bar60"] = 5] = "Bar60";
  DesignPressureOption2[DesignPressureOption2["Bar80"] = 6] = "Bar80";
  DesignPressureOption2[DesignPressureOption2["Bar100"] = 7] = "Bar100";
  DesignPressureOption2[DesignPressureOption2["Bar120"] = 8] = "Bar120";
  DesignPressureOption2[DesignPressureOption2["Bar150"] = 9] = "Bar150";
  DesignPressureOption2[DesignPressureOption2["Psi150"] = 10] = "Psi150";
  DesignPressureOption2[DesignPressureOption2["Psi300"] = 11] = "Psi300";
  DesignPressureOption2[DesignPressureOption2["Psi600"] = 12] = "Psi600";
  DesignPressureOption2[DesignPressureOption2["Psi900"] = 13] = "Psi900";
  DesignPressureOption2[DesignPressureOption2["Psi1500"] = 14] = "Psi1500";
  DesignPressureOption2[DesignPressureOption2["Bar65"] = 15] = "Bar65";
  return DesignPressureOption2;
})(DesignPressureOption || {});
var designPressureOptionMappingValue = /* @__PURE__ */ new Map([
  [0 /* Bar6 */, 6],
  [1 /* Bar10 */, 10],
  [2 /* Bar16 */, 16],
  [3 /* Bar25 */, 25],
  [4 /* Bar40 */, 40],
  [5 /* Bar60 */, 60],
  // 65bar is only valid if design temperature is <= 200C, passing to SizingDLL as 60Bar but isHighPressure65Barg = true
  [15 /* Bar65 */, 60],
  [6 /* Bar80 */, 80],
  [7 /* Bar100 */, 100],
  [8 /* Bar120 */, 120],
  [9 /* Bar150 */, 150],
  [10 /* Psi150 */, 150],
  [11 /* Psi300 */, 300],
  [12 /* Psi600 */, 600],
  [13 /* Psi900 */, 900],
  [14 /* Psi1500 */, 1500]
]);
var designPressureOptionMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Bar6 */, "6 bar(g)"],
  [1 /* Bar10 */, "10 bar(g)"],
  [2 /* Bar16 */, "16 bar(g)"],
  [3 /* Bar25 */, "25 bar(g)"],
  [4 /* Bar40 */, "40 bar(g)"],
  [5 /* Bar60 */, "60 bar(g)"],
  [15 /* Bar65 */, "65 bar(g) [60 bar(g) approval]"],
  [6 /* Bar80 */, "80 bar(g)"],
  [7 /* Bar100 */, "100 bar(g)"],
  [8 /* Bar120 */, "120 bar(g)"],
  [9 /* Bar150 */, "150 bar(g)"],
  [10 /* Psi150 */, "150 psi(g)"],
  [11 /* Psi300 */, "300 psi(g)"],
  [12 /* Psi600 */, "600 psi(g)"],
  [13 /* Psi900 */, "900 psi(g)"],
  [14 /* Psi1500 */, "1500 psi(g)"]
]);

// src/enums/direction.enum.ts
var Direction = /* @__PURE__ */ ((Direction2) => {
  Direction2[Direction2["Horizontal"] = 1] = "Horizontal";
  Direction2[Direction2["Vertical"] = 2] = "Vertical";
  return Direction2;
})(Direction || {});
var directionMappingLabel = /* @__PURE__ */ new Map([
  [1 /* Horizontal */, "Horizontal"],
  [2 /* Vertical */, "Vertical"]
]);

// src/enums/drawing-state.enum.ts
var DrawingState = /* @__PURE__ */ ((DrawingState2) => {
  DrawingState2[DrawingState2["New"] = 0] = "New";
  DrawingState2[DrawingState2["Running"] = 1] = "Running";
  DrawingState2[DrawingState2["Failed"] = 2] = "Failed";
  DrawingState2[DrawingState2["Completed"] = 10] = "Completed";
  DrawingState2[DrawingState2["PermanentlyFailed"] = 11] = "PermanentlyFailed";
  return DrawingState2;
})(DrawingState || {});
var DrawingEvent = /* @__PURE__ */ ((DrawingEvent2) => {
  DrawingEvent2["IdSent"] = "drawing_id_sent";
  DrawingEvent2["StatusReceived"] = "drawing_status_received";
  return DrawingEvent2;
})(DrawingEvent || {});

// src/enums/drawing-type.enum.ts
var BodySideV2 = /* @__PURE__ */ ((BodySideV22) => {
  BodySideV22["TOP"] = "TOP";
  BodySideV22["BOTTOM"] = "BOTTOM";
  BodySideV22["LEFT"] = "LEFT";
  BodySideV22["RIGHT"] = "RIGHT";
  BodySideV22["FRONT_BACK"] = "FRONT-BACK";
  return BodySideV22;
})(BodySideV2 || {});
var DrawingEndPlateV2 = /* @__PURE__ */ ((DrawingEndPlateV22) => {
  DrawingEndPlateV22["KETTLE"] = "KETTLE";
  DrawingEndPlateV22["WELDED"] = "WELDED";
  DrawingEndPlateV22["OPENABLE"] = "OPENABLE";
  return DrawingEndPlateV22;
})(DrawingEndPlateV2 || {});
var BodyTypeV2 = /* @__PURE__ */ ((BodyTypeV22) => {
  BodyTypeV22["CORE"] = "CORE";
  BodyTypeV22["MULTI_CONDENSER"] = "MULTI_CONDENSER";
  BodyTypeV22["COMBINED_C"] = "COMBINED_C";
  return BodyTypeV22;
})(BodyTypeV2 || {});
var NozzleFlowV2 = /* @__PURE__ */ ((NozzleFlowV22) => {
  NozzleFlowV22["IN"] = "IN";
  NozzleFlowV22["OUT"] = "OUT";
  return NozzleFlowV22;
})(NozzleFlowV2 || {});
var NozzleTypeV2 = /* @__PURE__ */ ((NozzleTypeV22) => {
  NozzleTypeV22["BASE"] = "BASE";
  NozzleTypeV22["FLANGE"] = "FLANGE";
  return NozzleTypeV22;
})(NozzleTypeV2 || {});
var FlowTempV2 = /* @__PURE__ */ ((FlowTempV22) => {
  FlowTempV22["HOT"] = "HOT";
  FlowTempV22["COLD"] = "COLD";
  return FlowTempV22;
})(FlowTempV2 || {});

// src/enums/end-plate-type.enum.ts
var EndPlateType = /* @__PURE__ */ ((EndPlateType2) => {
  EndPlateType2[EndPlateType2["NoEndPlate"] = 0] = "NoEndPlate";
  EndPlateType2[EndPlateType2["OpenableVersion"] = 1] = "OpenableVersion";
  EndPlateType2[EndPlateType2["WeldedEndPlate"] = 2] = "WeldedEndPlate";
  EndPlateType2[EndPlateType2["WeldedEccentric"] = 3] = "WeldedEccentric";
  EndPlateType2[EndPlateType2["OpenableDouble"] = 4] = "OpenableDouble";
  EndPlateType2[EndPlateType2["Compact"] = 5] = "Compact";
  EndPlateType2[EndPlateType2["OpenableGirthFlange"] = 6] = "OpenableGirthFlange";
  EndPlateType2[EndPlateType2["OpenableGirthFlangeDouble"] = 7] = "OpenableGirthFlangeDouble";
  return EndPlateType2;
})(EndPlateType || {});
var endPlateTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* NoEndPlate */, "No End Plate"],
  [1 /* OpenableVersion */, "Openable Version"],
  [2 /* WeldedEndPlate */, "Welded End Plates"],
  [3 /* WeldedEccentric */, "Welded/Eccentric"],
  [4 /* OpenableDouble */, "Openable - Double"],
  [6 /* OpenableGirthFlange */, "Openable - Girth Flange"],
  [7 /* OpenableGirthFlangeDouble */, "Openable - Girth Flange (double)"],
  [5 /* Compact */, "Compact"]
]);

// src/enums/evaporator-type.enum.ts
var EvaporatorType = /* @__PURE__ */ ((EvaporatorType2) => {
  EvaporatorType2[EvaporatorType2["DXEvaporator"] = 0] = "DXEvaporator";
  EvaporatorType2[EvaporatorType2["FloodedEvaporator"] = 1] = "FloodedEvaporator";
  return EvaporatorType2;
})(EvaporatorType || {});
var EvaporatorTypeLabelMapping = /* @__PURE__ */ new Map([
  [0 /* DXEvaporator */, "DX Evaporator"],
  [1 /* FloodedEvaporator */, "Flooded Evaporato"]
]);

// src/enums/feet.enum.ts
var Feet = /* @__PURE__ */ ((Feet2) => {
  Feet2[Feet2["NoFeet"] = 0] = "NoFeet";
  Feet2[Feet2["EndPlateFeetBoltedCS"] = 1] = "EndPlateFeetBoltedCS";
  Feet2[Feet2["EndPlateFeetBoltedAISI"] = 2] = "EndPlateFeetBoltedAISI";
  Feet2[Feet2["ShellFeetCS"] = 3] = "ShellFeetCS";
  Feet2[Feet2["ShellFeetAISI"] = 4] = "ShellFeetAISI";
  Feet2[Feet2["EndPlateFeetWeldedCS"] = 5] = "EndPlateFeetWeldedCS";
  Feet2[Feet2["EndPlateFeetWeldedAISI"] = 6] = "EndPlateFeetWeldedAISI";
  Feet2[Feet2["BracketsWelededCS"] = 7] = "BracketsWelededCS";
  Feet2[Feet2["BracketsWeldedAISI"] = 8] = "BracketsWeldedAISI";
  Feet2[Feet2["VerticalFeetWeldedCS"] = 9] = "VerticalFeetWeldedCS";
  Feet2[Feet2["VerticalFeetWeldedAISI"] = 10] = "VerticalFeetWeldedAISI";
  Feet2[Feet2["SleeveWeldedCS"] = 11] = "SleeveWeldedCS";
  Feet2[Feet2["SleeveWeldedAISI"] = 12] = "SleeveWeldedAISI";
  return Feet2;
})(Feet || {});
var feetMappingLabel = /* @__PURE__ */ new Map([
  [0 /* NoFeet */, "No feet"],
  [1 /* EndPlateFeetBoltedCS */, "End plate feet (Bolted CS)"],
  [2 /* EndPlateFeetBoltedAISI */, "End plate feet (Bolted AISI)"],
  [3 /* ShellFeetCS */, "Shell feet (CS)"],
  [4 /* ShellFeetAISI */, "Shell feet (AISI)"],
  [5 /* EndPlateFeetWeldedCS */, "End plate feet (Welded CS)"],
  [6 /* EndPlateFeetWeldedAISI */, "End plate feet (Welded AISI)"],
  [7 /* BracketsWelededCS */, "Brackets (Welded CS)"],
  [8 /* BracketsWeldedAISI */, "Brackets (Welded AISI)"],
  [9 /* VerticalFeetWeldedCS */, "Vertical feet (Welded CS)"],
  [10 /* VerticalFeetWeldedAISI */, "Vertical feet (Welded AISI)"],
  [11 /* SleeveWeldedCS */, "Sleeve (Welded CS)"],
  [12 /* SleeveWeldedAISI */, "Sleeve (Welded AISI)"]
]);

// src/enums/flow-direction.enum.ts
var FlowDirection = /* @__PURE__ */ ((FlowDirection2) => {
  FlowDirection2[FlowDirection2["Countercurrent"] = 0] = "Countercurrent";
  FlowDirection2[FlowDirection2["Cocurrent"] = 1] = "Cocurrent";
  FlowDirection2[FlowDirection2["Crossflow"] = 2] = "Crossflow";
  return FlowDirection2;
})(FlowDirection || {});
var flowDriectionMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Countercurrent */, "Countercurrent"],
  [1 /* Cocurrent */, "Co-current"],
  [2 /* Crossflow */, "Crossflow"]
]);
var CoCurrentFlowConfig = /* @__PURE__ */ ((CoCurrentFlowConfig2) => {
  CoCurrentFlowConfig2[CoCurrentFlowConfig2["HotSideDownCondensation"] = 0] = "HotSideDownCondensation";
  CoCurrentFlowConfig2[CoCurrentFlowConfig2["ColdSideUpEvaporation"] = 1] = "ColdSideUpEvaporation";
  return CoCurrentFlowConfig2;
})(CoCurrentFlowConfig || {});
var CoCurrentFlowConfigMappingLabel = /* @__PURE__ */ new Map([
  [0 /* HotSideDownCondensation */, "Hot side down / condensation"],
  [1 /* ColdSideUpEvaporation */, "Cold side up / evaporation"]
]);

// src/enums/flow-directory-material-option.enum.ts
var FlowDirectorMaterialOption = /* @__PURE__ */ ((FlowDirectorMaterialOption2) => {
  FlowDirectorMaterialOption2[FlowDirectorMaterialOption2["EPDM"] = 0] = "EPDM";
  FlowDirectorMaterialOption2[FlowDirectorMaterialOption2["Nitrile"] = 1] = "Nitrile";
  FlowDirectorMaterialOption2[FlowDirectorMaterialOption2["Fluorinesilicone"] = 2] = "Fluorinesilicone";
  FlowDirectorMaterialOption2[FlowDirectorMaterialOption2["SiliconeN"] = 3] = "SiliconeN";
  FlowDirectorMaterialOption2[FlowDirectorMaterialOption2["SiliconeHT"] = 4] = "SiliconeHT";
  FlowDirectorMaterialOption2[FlowDirectorMaterialOption2["PTFE"] = 5] = "PTFE";
  FlowDirectorMaterialOption2[FlowDirectorMaterialOption2["Graphite"] = 6] = "Graphite";
  FlowDirectorMaterialOption2[FlowDirectorMaterialOption2["Other"] = 7] = "Other";
  FlowDirectorMaterialOption2[FlowDirectorMaterialOption2["NoFlDirector"] = 8] = "NoFlDirector";
  return FlowDirectorMaterialOption2;
})(FlowDirectorMaterialOption || {});
var flowDirectorMaterialOptionValueMapping = /* @__PURE__ */ new Map([
  [0 /* EPDM */, "EPDM"],
  [1 /* Nitrile */, "Nitrile"],
  [2 /* Fluorinesilicone */, "Fluorinesilicone"],
  [3 /* SiliconeN */, "Silicone (N)"],
  [4 /* SiliconeHT */, "Silicone (HT)"],
  [5 /* PTFE */, "PTFE"],
  [6 /* Graphite */, "Graphite"],
  [7 /* Other */, "Other"],
  [8 /* NoFlDirector */, "No fl. director"]
]);

// src/enums/fraction-type.enum.ts
var FractionType = /* @__PURE__ */ ((FractionType2) => {
  FractionType2[FractionType2["Mass"] = 0] = "Mass";
  FractionType2[FractionType2["Mole"] = 1] = "Mole";
  return FractionType2;
})(FractionType || {});
var fractionTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Mass */, "Mass"],
  [1 /* Mole */, "Mole"]
]);

// src/enums/hot-site.enum.ts
var HotSide = /* @__PURE__ */ ((HotSide2) => {
  HotSide2[HotSide2["PlateSide"] = 1] = "PlateSide";
  HotSide2[HotSide2["ShellSide"] = 2] = "ShellSide";
  return HotSide2;
})(HotSide || {});
var HotSideLableMapping = /* @__PURE__ */ new Map([
  [1 /* PlateSide */, "Plate Side"],
  [2 /* ShellSide */, "Shell Side"]
]);

// src/enums/language.enum.ts
var Language = /* @__PURE__ */ ((Language2) => {
  Language2["English"] = "en";
  Language2["Finland"] = "fi";
  Language2["Chinese"] = "cn";
  Language2["Deutsch"] = "de";
  Language2["Espanol"] = "es";
  Language2["Francais"] = "fr";
  Language2["Nederlands"] = "nl";
  return Language2;
})(Language || {});
var languageMappingLabel = /* @__PURE__ */ new Map([
  ["en" /* English */, "English - en"],
  ["fi" /* Finland */, "Suomi - fi"],
  ["cn" /* Chinese */, "Chinese - cn"],
  ["de" /* Deutsch */, "Deutsch - de"],
  ["es" /* Espanol */, "Espa\xF1ol - es"],
  ["fr" /* Francais */, "Fran\xE7ais - fr"],
  ["nl" /* Nederlands */, "Nederlands - nl"]
]);

// src/enums/liquid-side.enum.ts
var LiquidSide = /* @__PURE__ */ ((LiquidSide2) => {
  LiquidSide2[LiquidSide2["PlateSide"] = 1] = "PlateSide";
  LiquidSide2[LiquidSide2["Shellside"] = 2] = "Shellside";
  return LiquidSide2;
})(LiquidSide || {});
var LiquidSideLabelMapping = /* @__PURE__ */ new Map([
  [1 /* PlateSide */, "Plate Side"],
  [2 /* Shellside */, "Shell Side"]
]);

// src/enums/many-point-calc.enum.ts
var ManyPointCalc = /* @__PURE__ */ ((ManyPointCalc2) => {
  ManyPointCalc2[ManyPointCalc2["No"] = 0] = "No";
  ManyPointCalc2[ManyPointCalc2["Yes"] = 1] = "Yes";
  return ManyPointCalc2;
})(ManyPointCalc || {});
var ManyPointCalcMappingLabel = /* @__PURE__ */ new Map([
  [1 /* Yes */, "Yes"],
  [0 /* No */, "No"]
]);

// src/enums/medium-dangerous.enum.ts
var MediumDangerousOption = /* @__PURE__ */ ((MediumDangerousOption2) => {
  MediumDangerousOption2[MediumDangerousOption2["Dangerous"] = 0] = "Dangerous";
  MediumDangerousOption2[MediumDangerousOption2["NotDangerous"] = 1] = "NotDangerous";
  return MediumDangerousOption2;
})(MediumDangerousOption || {});

// src/enums/medium-mixture.enum.ts
var MediumMixture = /* @__PURE__ */ ((MediumMixture2) => {
  MediumMixture2[MediumMixture2["PureMedium"] = 0] = "PureMedium";
  MediumMixture2[MediumMixture2["Mixture"] = 1] = "Mixture";
  return MediumMixture2;
})(MediumMixture || {});
var mediumMixtureMappingLabel = /* @__PURE__ */ new Map([
  [1 /* Mixture */, "Mixture"],
  [0 /* PureMedium */, "Pure"]
]);

// src/enums/medium-option.enum.ts
var MediumOption = /* @__PURE__ */ ((MediumOption4) => {
  MediumOption4[MediumOption4["OtherMedia"] = 0] = "OtherMedia";
  MediumOption4[MediumOption4["Water"] = 1] = "Water";
  MediumOption4[MediumOption4["CaCl2"] = 2] = "CaCl2";
  MediumOption4[MediumOption4["Ethyleneglycol"] = 3] = "Ethyleneglycol";
  MediumOption4[MediumOption4["Freezium"] = 4] = "Freezium";
  MediumOption4[MediumOption4["Hycool"] = 5] = "Hycool";
  MediumOption4[MediumOption4["Pekasol2000"] = 6] = "Pekasol2000";
  MediumOption4[MediumOption4["Propyleneglycol"] = 7] = "Propyleneglycol";
  MediumOption4[MediumOption4["Tyfoxit"] = 8] = "Tyfoxit";
  MediumOption4[MediumOption4["NH3"] = 9] = "NH3";
  MediumOption4[MediumOption4["CO2"] = 10] = "CO2";
  MediumOption4[MediumOption4["Propane"] = 11] = "Propane";
  MediumOption4[MediumOption4["R134a"] = 12] = "R134a";
  MediumOption4[MediumOption4["R22"] = 13] = "R22";
  MediumOption4[MediumOption4["R23"] = 14] = "R23";
  MediumOption4[MediumOption4["R404a"] = 15] = "R404a";
  MediumOption4[MediumOption4["R407c"] = 16] = "R407c";
  MediumOption4[MediumOption4["R410a"] = 17] = "R410a";
  MediumOption4[MediumOption4["R507A"] = 18] = "R507A";
  MediumOption4[MediumOption4["R408a"] = 19] = "R408a";
  MediumOption4[MediumOption4["ArticSHC226"] = 20] = "ArticSHC226";
  MediumOption4[MediumOption4["DowthermJ"] = 21] = "DowthermJ";
  MediumOption4[MediumOption4["Essotherm500"] = 22] = "Essotherm500";
  MediumOption4[MediumOption4["GilothermD12"] = 23] = "GilothermD12";
  MediumOption4[MediumOption4["MarlothermL"] = 24] = "MarlothermL";
  MediumOption4[MediumOption4["MarlothermLH"] = 25] = "MarlothermLH";
  MediumOption4[MediumOption4["MarlothermS"] = 26] = "MarlothermS";
  MediumOption4[MediumOption4["Mobiltherm603"] = 27] = "Mobiltherm603";
  MediumOption4[MediumOption4["Palmoil"] = 28] = "Palmoil";
  MediumOption4[MediumOption4["SAE40W"] = 29] = "SAE40W";
  MediumOption4[MediumOption4["ShellThermiaB"] = 30] = "ShellThermiaB";
  MediumOption4[MediumOption4["SylthermXLT"] = 31] = "SylthermXLT";
  MediumOption4[MediumOption4["Syltherm"] = 32] = "Syltherm";
  MediumOption4[MediumOption4["Temper"] = 33] = "Temper";
  MediumOption4[MediumOption4["ACETONE30230C"] = 34] = "ACETONE30230C";
  MediumOption4[MediumOption4["ARTICSHC22620100C"] = 35] = "ARTICSHC22620100C";
  MediumOption4[MediumOption4["ARTICSHC32640100C"] = 36] = "ARTICSHC32640100C";
  MediumOption4[MediumOption4["BENZOL2575C"] = 37] = "BENZOL2575C";
  MediumOption4[MediumOption4["BIODIESEL10120C"] = 38] = "BIODIESEL10120C";
  MediumOption4[MediumOption4["BPTRANSCALN50300C"] = 39] = "BPTRANSCALN50300C";
  MediumOption4[MediumOption4["BSE17040100C"] = 40] = "BSE17040100C";
  MediumOption4[MediumOption4["BUTHYLACETAT1020C"] = 41] = "BUTHYLACETAT1020C";
  MediumOption4[MediumOption4["CALFLOLT2020C"] = 42] = "CALFLOLT2020C";
  MediumOption4[MediumOption4["CALFLOLT80160C"] = 43] = "CALFLOLT80160C";
  MediumOption4[MediumOption4["CL001BTTMS20120C"] = 44] = "CL001BTTMS20120C";
  MediumOption4[MediumOption4["CL002BTTMS35140C"] = 45] = "CL002BTTMS35140C";
  MediumOption4[MediumOption4["CL002FEED60130C"] = 46] = "CL002FEED60130C";
  MediumOption4[MediumOption4["CLAVUSG6840100C"] = 47] = "CLAVUSG6840100C";
  MediumOption4[MediumOption4["COCOABUTTER20170C"] = 48] = "COCOABUTTER20170C";
  MediumOption4[MediumOption4["COOKINGOIL160210C"] = 49] = "COOKINGOIL160210C";
  MediumOption4[MediumOption4["CP460046378933C"] = 50] = "CP460046378933C";
  MediumOption4[MediumOption4["CRUDEFATTYACID70100C"] = 51] = "CRUDEFATTYACID70100C";
  MediumOption4[MediumOption4["DIESELOIL520C"] = 52] = "DIESELOIL520C";
  MediumOption4[MediumOption4["DIPHYL180340C"] = 53] = "DIPHYL180340C";
  MediumOption4[MediumOption4["DISTILLEDFATTYACID16099C"] = 54] = "DISTILLEDFATTYACID16099C";
  MediumOption4[MediumOption4["DOWTHERMAC255405C"] = 55] = "DOWTHERMAC255405C";
  MediumOption4[MediumOption4["DOWTHERMJ5165C"] = 56] = "DOWTHERMJ5165C";
  MediumOption4[MediumOption4["DOWTHERMJ2545C"] = 57] = "DOWTHERMJ2545C";
  MediumOption4[MediumOption4["DOWTHERMJ100285C"] = 58] = "DOWTHERMJ100285C";
  MediumOption4[MediumOption4["DOWTHERMJ35125C"] = 59] = "DOWTHERMJ35125C";
  MediumOption4[MediumOption4["DOWTHERMQ40120C"] = 60] = "DOWTHERMQ40120C";
  MediumOption4[MediumOption4["DYNALINEMV100160C"] = 61] = "DYNALINEMV100160C";
  MediumOption4[MediumOption4["ETHYLENE10050C"] = 62] = "ETHYLENE10050C";
  MediumOption4[MediumOption4["FRICK11489878C"] = 63] = "FRICK11489878C";
  MediumOption4[MediumOption4["FRICK13489878C"] = 64] = "FRICK13489878C";
  MediumOption4[MediumOption4["FRICK14489878C"] = 65] = "FRICK14489878C";
  MediumOption4[MediumOption4["FRICK2A489878C"] = 66] = "FRICK2A489878C";
  MediumOption4[MediumOption4["FRICK3489878C"] = 67] = "FRICK3489878C";
  MediumOption4[MediumOption4["FRICK33893C"] = 68] = "FRICK33893C";
  MediumOption4[MediumOption4["FRICK94988C"] = 69] = "FRICK94988C";
  MediumOption4[MediumOption4["FRICKNG15441011C"] = 70] = "FRICKNG15441011C";
  MediumOption4[MediumOption4["HEAVYFUELOIL380CST50110C"] = 71] = "HEAVYFUELOIL380CST50110C";
  MediumOption4[MediumOption4["HEAVYFUELOIL380CST110150C"] = 72] = "HEAVYFUELOIL380CST110150C";
  MediumOption4[MediumOption4["HEAVYFUELOIL700CST50150C"] = 73] = "HEAVYFUELOIL700CST50150C";
  MediumOption4[MediumOption4["HEAVYFUELOIL700CST110150C"] = 74] = "HEAVYFUELOIL700CST110150C";
  MediumOption4[MediumOption4["HEXANE3050C"] = 75] = "HEXANE3050C";
  MediumOption4[MediumOption4["KEROSINE5070C"] = 76] = "KEROSINE5070C";
  MediumOption4[MediumOption4["LANOLIN4090C"] = 77] = "LANOLIN4090C";
  MediumOption4[MediumOption4["LEANGLYCOL45140C"] = 78] = "LEANGLYCOL45140C";
  MediumOption4[MediumOption4["LEANGLYCOL5751909C"] = 79] = "LEANGLYCOL5751909C";
  MediumOption4[MediumOption4["LEANGLYCOL4141933C"] = 80] = "LEANGLYCOL4141933C";
  MediumOption4[MediumOption4["LEANMEG32128C"] = 81] = "LEANMEG32128C";
  MediumOption4[MediumOption4["LEANSULFINOLD601287C"] = 82] = "LEANSULFINOLD601287C";
  MediumOption4[MediumOption4["LEANTEG5751909C"] = 83] = "LEANTEG5751909C";
  MediumOption4[MediumOption4["LEANTEG451268C"] = 84] = "LEANTEG451268C";
  MediumOption4[MediumOption4["LEANTEG78210C"] = 85] = "LEANTEG78210C";
  MediumOption4[MediumOption4["LEANTEG4641906C"] = 86] = "LEANTEG4641906C";
  MediumOption4[MediumOption4["LPG29130C"] = 87] = "LPG29130C";
  MediumOption4[MediumOption4["LVGO104159C"] = 88] = "LVGO104159C";
  MediumOption4[MediumOption4["M1002080C"] = 89] = "M1002080C";
  MediumOption4[MediumOption4["MARLOTHERM2740C"] = 90] = "MARLOTHERM2740C";
  MediumOption4[MediumOption4["MARLOTHERMSH40120C"] = 91] = "MARLOTHERMSH40120C";
  MediumOption4[MediumOption4["MARLOTHERMX60300C"] = 92] = "MARLOTHERMX60300C";
  MediumOption4[MediumOption4["MEG502080C"] = 93] = "MEG502080C";
  MediumOption4[MediumOption4["MEGBRINE075C"] = 94] = "MEGBRINE075C";
  MediumOption4[MediumOption4["METHANOL30240C"] = 95] = "METHANOL30240C";
  MediumOption4[MediumOption4["METHANOL1020C"] = 96] = "METHANOL1020C";
  MediumOption4[MediumOption4["MINERALOIL100285C"] = 97] = "MINERALOIL100285C";
  MediumOption4[MediumOption4["MOBILTHERM605185205C"] = 98] = "MOBILTHERM605185205C";
  MediumOption4[MediumOption4["M\xC4NTY\xD6LJY50150C"] = 99] = "M\xC4NTY\xD6LJY50150C";
  MediumOption4[MediumOption4["NAOCL1030C"] = 100] = "NAOCL1030C";
  MediumOption4[MediumOption4["NHEXANE6020C"] = 101] = "NHEXANE6020C";
  MediumOption4[MediumOption4["NHEXANE1459C"] = 102] = "NHEXANE1459C";
  MediumOption4[MediumOption4["NOVECHFE71006585C"] = 103] = "NOVECHFE71006585C";
  MediumOption4[MediumOption4["ORIMULSION4001070C"] = 104] = "ORIMULSION4001070C";
  MediumOption4[MediumOption4["PARATHERMNF200350C"] = 105] = "PARATHERMNF200350C";
  MediumOption4[MediumOption4["PHENOLICRESIN1030C"] = 106] = "PHENOLICRESIN1030C";
  MediumOption4[MediumOption4["PLASTIFICANTEDOP90150C"] = 107] = "PLASTIFICANTEDOP90150C";
  MediumOption4[MediumOption4["POLYOL1030C"] = 108] = "POLYOL1030C";
  MediumOption4[MediumOption4["POLYURETHANE4090C"] = 109] = "POLYURETHANE4090C";
  MediumOption4[MediumOption4["POR1803090C"] = 110] = "POR1803090C";
  MediumOption4[MediumOption4["PRODUCEDWATER60100C"] = 111] = "PRODUCEDWATER60100C";
  MediumOption4[MediumOption4["REACTOREFFLUENT112226C"] = 112] = "REACTOREFFLUENT112226C";
  MediumOption4[MediumOption4["REACTORFEED28220C"] = 113] = "REACTORFEED28220C";
  MediumOption4[MediumOption4["REFLO4630100C"] = 114] = "REFLO4630100C";
  MediumOption4[MediumOption4["REFLO6840120C"] = 115] = "REFLO6840120C";
  MediumOption4[MediumOption4["REOFOS75200C"] = 116] = "REOFOS75200C";
  MediumOption4[MediumOption4["REOFOS175200C"] = 117] = "REOFOS175200C";
  MediumOption4[MediumOption4["RICHGLYCOL466170C"] = 118] = "RICHGLYCOL466170C";
  MediumOption4[MediumOption4["RICHGLYCOL666160C"] = 119] = "RICHGLYCOL666160C";
  MediumOption4[MediumOption4["RICHMEG2254C"] = 120] = "RICHMEG2254C";
  MediumOption4[MediumOption4["RICHSULFINOLD401087C"] = 121] = "RICHSULFINOLD401087C";
  MediumOption4[MediumOption4["RICHTEG669170C"] = 122] = "RICHTEG669170C";
  MediumOption4[MediumOption4["RICHTEG4794C"] = 123] = "RICHTEG4794C";
  MediumOption4[MediumOption4["RICHTEG511180C"] = 124] = "RICHTEG511180C";
  MediumOption4[MediumOption4["RICHTEG45180C"] = 125] = "RICHTEG45180C";
  MediumOption4[MediumOption4["SAE4060100C"] = 126] = "SAE4060100C";
  MediumOption4[MediumOption4["SANTOTHERM6660300C"] = 127] = "SANTOTHERM6660300C";
  MediumOption4[MediumOption4["SEAWATER245C"] = 128] = "SEAWATER245C";
  MediumOption4[MediumOption4["SERIOLAETA10050300C"] = 129] = "SERIOLAETA10050300C";
  MediumOption4[MediumOption4["SHELLTHERMIAB20150C"] = 130] = "SHELLTHERMIAB20150C";
  MediumOption4[MediumOption4["SODIUMNITRATE401010C"] = 131] = "SODIUMNITRATE401010C";
  MediumOption4[MediumOption4["SOLESTLT3248985C"] = 132] = "SOLESTLT3248985C";
  MediumOption4[MediumOption4["SOLVENT5030100C"] = 133] = "SOLVENT5030100C";
  MediumOption4[MediumOption4["SOYABEANOIL60260C"] = 134] = "SOYABEANOIL60260C";
  MediumOption4[MediumOption4["SUNFLOWEROIL160210C"] = 135] = "SUNFLOWEROIL160210C";
  MediumOption4[MediumOption4["SYLTHERMXLT30150C"] = 136] = "SYLTHERMXLT30150C";
  MediumOption4[MediumOption4["SYLTHERMXLT400C"] = 137] = "SYLTHERMXLT400C";
  MediumOption4[MediumOption4["TALLOW60226C"] = 138] = "TALLOW60226C";
  MediumOption4[MediumOption4["TEG58120150C"] = 139] = "TEG58120150C";
  MediumOption4[MediumOption4["TEXACOA6830110C"] = 140] = "TEXACOA6830110C";
  MediumOption4[MediumOption4["TEXACOPREMIUM6830110C"] = 141] = "TEXACOPREMIUM6830110C";
  MediumOption4[MediumOption4["TEXACOWF6830110C"] = 142] = "TEXACOWF6830110C";
  MediumOption4[MediumOption4["THERMERA351020C"] = 143] = "THERMERA351020C";
  MediumOption4[MediumOption4["THERMERA502520C"] = 144] = "THERMERA502520C";
  MediumOption4[MediumOption4["THERMINOL55149216C"] = 145] = "THERMINOL55149216C";
  MediumOption4[MediumOption4["THERMINOL66120200C"] = 146] = "THERMINOL66120200C";
  MediumOption4[MediumOption4["THERMINOL72220320C"] = 147] = "THERMINOL72220320C";
  MediumOption4[MediumOption4["THERMINOLD12200C"] = 148] = "THERMINOLD12200C";
  MediumOption4[MediumOption4["THERMINOLD1249149C"] = 149] = "THERMINOLD1249149C";
  MediumOption4[MediumOption4["THERMINOLLT4016C"] = 150] = "THERMINOLLT4016C";
  MediumOption4[MediumOption4["TMP58210C"] = 151] = "TMP58210C";
  MediumOption4[MediumOption4["TOLUENE20240C"] = 152] = "TOLUENE20240C";
  MediumOption4[MediumOption4["TRANSCALLT0130C"] = 153] = "TRANSCALLT0130C";
  MediumOption4[MediumOption4["TRANSCALN1030C"] = 154] = "TRANSCALN1030C";
  MediumOption4[MediumOption4["UCOTHERMFG8450C"] = 155] = "UCOTHERMFG8450C";
  MediumOption4[MediumOption4["UCOTHERMFG80280C"] = 156] = "UCOTHERMFG80280C";
  MediumOption4[MediumOption4["VEGOIL100260C"] = 157] = "VEGOIL100260C";
  MediumOption4[MediumOption4["VG6840100C"] = 158] = "VG6840100C";
  MediumOption4[MediumOption4["VGO100245C"] = 159] = "VGO100245C";
  MediumOption4[MediumOption4["XYLENE25145C"] = 160] = "XYLENE25145C";
  MediumOption4[MediumOption4["ISOVG2230180C"] = 161] = "ISOVG2230180C";
  MediumOption4[MediumOption4["ISOVG3230180C"] = 162] = "ISOVG3230180C";
  MediumOption4[MediumOption4["ISOVG4630180C"] = 163] = "ISOVG4630180C";
  MediumOption4[MediumOption4["ISOVG6815180C"] = 164] = "ISOVG6815180C";
  MediumOption4[MediumOption4["ISOVG10015180C"] = 165] = "ISOVG10015180C";
  MediumOption4[MediumOption4["ISOVG1500140C"] = 166] = "ISOVG1500140C";
  MediumOption4[MediumOption4["ISOVG2200140C"] = 167] = "ISOVG2200140C";
  MediumOption4[MediumOption4["MOBILARCTICSHC2340200C"] = 168] = "MOBILARCTICSHC2340200C";
  MediumOption4[MediumOption4["THERMINOLVP12425C"] = 169] = "THERMINOLVP12425C";
  MediumOption4[MediumOption4["MOLTENSALT260593C"] = 170] = "MOLTENSALT260593C";
  MediumOption4[MediumOption4["NXT717OIL0140C"] = 171] = "NXT717OIL0140C";
  MediumOption4[MediumOption4["_1BUTENE"] = 172] = "_1BUTENE";
  MediumOption4[MediumOption4["ACETONE"] = 173] = "ACETONE";
  MediumOption4[MediumOption4["AIR"] = 174] = "AIR";
  MediumOption4[MediumOption4["AMMONIA"] = 175] = "AMMONIA";
  MediumOption4[MediumOption4["ARGON"] = 176] = "ARGON";
  MediumOption4[MediumOption4["BENZENE"] = 177] = "BENZENE";
  MediumOption4[MediumOption4["BUTANE"] = 178] = "BUTANE";
  MediumOption4[MediumOption4["C11"] = 179] = "C11";
  MediumOption4[MediumOption4["C12"] = 180] = "C12";
  MediumOption4[MediumOption4["C1CC6"] = 181] = "C1CC6";
  MediumOption4[MediumOption4["C2BUTENE"] = 182] = "C2BUTENE";
  MediumOption4[MediumOption4["C3CC6"] = 183] = "C3CC6";
  MediumOption4[MediumOption4["C4F10"] = 184] = "C4F10";
  MediumOption4[MediumOption4["C5F12"] = 185] = "C5F12";
  MediumOption4[MediumOption4["CF3I"] = 186] = "CF3I";
  MediumOption4[MediumOption4["CO"] = 187] = "CO";
  MediumOption4[MediumOption4["CO2Refprop"] = 188] = "CO2Refprop";
  MediumOption4[MediumOption4["COS"] = 189] = "COS";
  MediumOption4[MediumOption4["CYCLOHEX"] = 190] = "CYCLOHEX";
  MediumOption4[MediumOption4["CYCLOPEN"] = 191] = "CYCLOPEN";
  MediumOption4[MediumOption4["CYCLOPRO"] = 192] = "CYCLOPRO";
  MediumOption4[MediumOption4["D2"] = 193] = "D2";
  MediumOption4[MediumOption4["D2O"] = 194] = "D2O";
  MediumOption4[MediumOption4["D4"] = 195] = "D4";
  MediumOption4[MediumOption4["D5"] = 196] = "D5";
  MediumOption4[MediumOption4["D6"] = 197] = "D6";
  MediumOption4[MediumOption4["DECANE"] = 198] = "DECANE";
  MediumOption4[MediumOption4["DEE"] = 199] = "DEE";
  MediumOption4[MediumOption4["DMC"] = 200] = "DMC";
  MediumOption4[MediumOption4["DME"] = 201] = "DME";
  MediumOption4[MediumOption4["EBENZENE"] = 202] = "EBENZENE";
  MediumOption4[MediumOption4["ETHANE"] = 203] = "ETHANE";
  MediumOption4[MediumOption4["ETHANOL"] = 204] = "ETHANOL";
  MediumOption4[MediumOption4["ETHYLENE"] = 205] = "ETHYLENE";
  MediumOption4[MediumOption4["FLUORINE"] = 206] = "FLUORINE";
  MediumOption4[MediumOption4["H2S"] = 207] = "H2S";
  MediumOption4[MediumOption4["HCL"] = 208] = "HCL";
  MediumOption4[MediumOption4["HELIUM"] = 209] = "HELIUM";
  MediumOption4[MediumOption4["HEPTANE"] = 210] = "HEPTANE";
  MediumOption4[MediumOption4["HEXANE"] = 211] = "HEXANE";
  MediumOption4[MediumOption4["HYDROGEN"] = 212] = "HYDROGEN";
  MediumOption4[MediumOption4["IBUTENE"] = 213] = "IBUTENE";
  MediumOption4[MediumOption4["IHEXANE"] = 214] = "IHEXANE";
  MediumOption4[MediumOption4["IOCTANE"] = 215] = "IOCTANE";
  MediumOption4[MediumOption4["IPENTANE"] = 216] = "IPENTANE";
  MediumOption4[MediumOption4["ISOBUTAN"] = 217] = "ISOBUTAN";
  MediumOption4[MediumOption4["KRYPTON"] = 218] = "KRYPTON";
  MediumOption4[MediumOption4["LNG"] = 219] = "LNG";
  MediumOption4[MediumOption4["MD2M"] = 220] = "MD2M";
  MediumOption4[MediumOption4["MD3M"] = 221] = "MD3M";
  MediumOption4[MediumOption4["MD4M"] = 222] = "MD4M";
  MediumOption4[MediumOption4["MDM"] = 223] = "MDM";
  MediumOption4[MediumOption4["METHANE"] = 224] = "METHANE";
  MediumOption4[MediumOption4["METHANOL"] = 225] = "METHANOL";
  MediumOption4[MediumOption4["MLINOLEA"] = 226] = "MLINOLEA";
  MediumOption4[MediumOption4["MLINOLEN"] = 227] = "MLINOLEN";
  MediumOption4[MediumOption4["MM"] = 228] = "MM";
  MediumOption4[MediumOption4["MOLEATE"] = 229] = "MOLEATE";
  MediumOption4[MediumOption4["MPALMITA"] = 230] = "MPALMITA";
  MediumOption4[MediumOption4["MSTEARAT"] = 231] = "MSTEARAT";
  MediumOption4[MediumOption4["MXYLENE"] = 232] = "MXYLENE";
  MediumOption4[MediumOption4["N2O"] = 233] = "N2O";
  MediumOption4[MediumOption4["NEON"] = 234] = "NEON";
  MediumOption4[MediumOption4["NEOPENTN"] = 235] = "NEOPENTN";
  MediumOption4[MediumOption4["NF3"] = 236] = "NF3";
  MediumOption4[MediumOption4["NITROGEN"] = 237] = "NITROGEN";
  MediumOption4[MediumOption4["NONANE"] = 238] = "NONANE";
  MediumOption4[MediumOption4["NOVEC649"] = 239] = "NOVEC649";
  MediumOption4[MediumOption4["OCTANE"] = 240] = "OCTANE";
  MediumOption4[MediumOption4["ORTHOHYD"] = 241] = "ORTHOHYD";
  MediumOption4[MediumOption4["OXYGEN"] = 242] = "OXYGEN";
  MediumOption4[MediumOption4["OXYLENE"] = 243] = "OXYLENE";
  MediumOption4[MediumOption4["PARAHYD"] = 244] = "PARAHYD";
  MediumOption4[MediumOption4["PENTANE"] = 245] = "PENTANE";
  MediumOption4[MediumOption4["PROPANE"] = 246] = "PROPANE";
  MediumOption4[MediumOption4["PROPYLEN"] = 247] = "PROPYLEN";
  MediumOption4[MediumOption4["PROPYNE"] = 248] = "PROPYNE";
  MediumOption4[MediumOption4["PXYLENE"] = 249] = "PXYLENE";
  MediumOption4[MediumOption4["R11"] = 250] = "R11";
  MediumOption4[MediumOption4["R113"] = 251] = "R113";
  MediumOption4[MediumOption4["R114"] = 252] = "R114";
  MediumOption4[MediumOption4["R115"] = 253] = "R115";
  MediumOption4[MediumOption4["R116"] = 254] = "R116";
  MediumOption4[MediumOption4["R12"] = 255] = "R12";
  MediumOption4[MediumOption4["R1216"] = 256] = "R1216";
  MediumOption4[MediumOption4["R123"] = 257] = "R123";
  MediumOption4[MediumOption4["R1233ZDE"] = 258] = "R1233ZDE";
  MediumOption4[MediumOption4["R1234YF"] = 259] = "R1234YF";
  MediumOption4[MediumOption4["R1234ZEE"] = 260] = "R1234ZEE";
  MediumOption4[MediumOption4["R124"] = 261] = "R124";
  MediumOption4[MediumOption4["R125"] = 262] = "R125";
  MediumOption4[MediumOption4["R13"] = 263] = "R13";
  MediumOption4[MediumOption4["R134A"] = 264] = "R134A";
  MediumOption4[MediumOption4["R14"] = 265] = "R14";
  MediumOption4[MediumOption4["R141B"] = 266] = "R141B";
  MediumOption4[MediumOption4["R142B"] = 267] = "R142B";
  MediumOption4[MediumOption4["R143A"] = 268] = "R143A";
  MediumOption4[MediumOption4["R152A"] = 269] = "R152A";
  MediumOption4[MediumOption4["R161"] = 270] = "R161";
  MediumOption4[MediumOption4["R21"] = 271] = "R21";
  MediumOption4[MediumOption4["R218"] = 272] = "R218";
  MediumOption4[MediumOption4["R22Refprop"] = 273] = "R22Refprop";
  MediumOption4[MediumOption4["R227EA"] = 274] = "R227EA";
  MediumOption4[MediumOption4["R23Refprop"] = 275] = "R23Refprop";
  MediumOption4[MediumOption4["R236EA"] = 276] = "R236EA";
  MediumOption4[MediumOption4["R236FA"] = 277] = "R236FA";
  MediumOption4[MediumOption4["R245CA"] = 278] = "R245CA";
  MediumOption4[MediumOption4["R245FA"] = 279] = "R245FA";
  MediumOption4[MediumOption4["R32"] = 280] = "R32";
  MediumOption4[MediumOption4["R365MFC"] = 281] = "R365MFC";
  MediumOption4[MediumOption4["R40"] = 282] = "R40";
  MediumOption4[MediumOption4["R401A"] = 283] = "R401A";
  MediumOption4[MediumOption4["R401B"] = 284] = "R401B";
  MediumOption4[MediumOption4["R401C"] = 285] = "R401C";
  MediumOption4[MediumOption4["R402A"] = 286] = "R402A";
  MediumOption4[MediumOption4["R402B"] = 287] = "R402B";
  MediumOption4[MediumOption4["R403A"] = 288] = "R403A";
  MediumOption4[MediumOption4["R403B"] = 289] = "R403B";
  MediumOption4[MediumOption4["R404A"] = 290] = "R404A";
  MediumOption4[MediumOption4["R405A"] = 291] = "R405A";
  MediumOption4[MediumOption4["R406A"] = 292] = "R406A";
  MediumOption4[MediumOption4["R407A"] = 293] = "R407A";
  MediumOption4[MediumOption4["R407B"] = 294] = "R407B";
  MediumOption4[MediumOption4["R407C"] = 295] = "R407C";
  MediumOption4[MediumOption4["R407D"] = 296] = "R407D";
  MediumOption4[MediumOption4["R407E"] = 297] = "R407E";
  MediumOption4[MediumOption4["R407F"] = 298] = "R407F";
  MediumOption4[MediumOption4["R408A"] = 299] = "R408A";
  MediumOption4[MediumOption4["R409A"] = 300] = "R409A";
  MediumOption4[MediumOption4["R409B"] = 301] = "R409B";
  MediumOption4[MediumOption4["R41"] = 302] = "R41";
  MediumOption4[MediumOption4["R410A"] = 303] = "R410A";
  MediumOption4[MediumOption4["R410B"] = 304] = "R410B";
  MediumOption4[MediumOption4["R411A"] = 305] = "R411A";
  MediumOption4[MediumOption4["R411B"] = 306] = "R411B";
  MediumOption4[MediumOption4["R412A"] = 307] = "R412A";
  MediumOption4[MediumOption4["R413A"] = 308] = "R413A";
  MediumOption4[MediumOption4["R414A"] = 309] = "R414A";
  MediumOption4[MediumOption4["R414B"] = 310] = "R414B";
  MediumOption4[MediumOption4["R415A"] = 311] = "R415A";
  MediumOption4[MediumOption4["R415B"] = 312] = "R415B";
  MediumOption4[MediumOption4["R416A"] = 313] = "R416A";
  MediumOption4[MediumOption4["R417A"] = 314] = "R417A";
  MediumOption4[MediumOption4["R418A"] = 315] = "R418A";
  MediumOption4[MediumOption4["R419A"] = 316] = "R419A";
  MediumOption4[MediumOption4["R420A"] = 317] = "R420A";
  MediumOption4[MediumOption4["R421A"] = 318] = "R421A";
  MediumOption4[MediumOption4["R421B"] = 319] = "R421B";
  MediumOption4[MediumOption4["R422A"] = 320] = "R422A";
  MediumOption4[MediumOption4["R422B"] = 321] = "R422B";
  MediumOption4[MediumOption4["R422C"] = 322] = "R422C";
  MediumOption4[MediumOption4["R422D"] = 323] = "R422D";
  MediumOption4[MediumOption4["R423A"] = 324] = "R423A";
  MediumOption4[MediumOption4["R424A"] = 325] = "R424A";
  MediumOption4[MediumOption4["R425A"] = 326] = "R425A";
  MediumOption4[MediumOption4["R426A"] = 327] = "R426A";
  MediumOption4[MediumOption4["R427A"] = 328] = "R427A";
  MediumOption4[MediumOption4["R428A"] = 329] = "R428A";
  MediumOption4[MediumOption4["R429A"] = 330] = "R429A";
  MediumOption4[MediumOption4["R430A"] = 331] = "R430A";
  MediumOption4[MediumOption4["R431A"] = 332] = "R431A";
  MediumOption4[MediumOption4["R432A"] = 333] = "R432A";
  MediumOption4[MediumOption4["R433A"] = 334] = "R433A";
  MediumOption4[MediumOption4["R434A"] = 335] = "R434A";
  MediumOption4[MediumOption4["R435A"] = 336] = "R435A";
  MediumOption4[MediumOption4["R436A"] = 337] = "R436A";
  MediumOption4[MediumOption4["R436B"] = 338] = "R436B";
  MediumOption4[MediumOption4["R437A"] = 339] = "R437A";
  MediumOption4[MediumOption4["R438A"] = 340] = "R438A";
  MediumOption4[MediumOption4["R441A"] = 341] = "R441A";
  MediumOption4[MediumOption4["R442A"] = 342] = "R442A";
  MediumOption4[MediumOption4["R443A"] = 343] = "R443A";
  MediumOption4[MediumOption4["R444A"] = 344] = "R444A";
  MediumOption4[MediumOption4["R448A"] = 345] = "R448A";
  MediumOption4[MediumOption4["R449a"] = 346] = "R449a";
  MediumOption4[MediumOption4["R449B"] = 347] = "R449B";
  MediumOption4[MediumOption4["R452a"] = 348] = "R452a";
  MediumOption4[MediumOption4["R500"] = 349] = "R500";
  MediumOption4[MediumOption4["R501"] = 350] = "R501";
  MediumOption4[MediumOption4["R502"] = 351] = "R502";
  MediumOption4[MediumOption4["R503"] = 352] = "R503";
  MediumOption4[MediumOption4["R504"] = 353] = "R504";
  MediumOption4[MediumOption4["R507ARefprop"] = 354] = "R507ARefprop";
  MediumOption4[MediumOption4["R508A"] = 355] = "R508A";
  MediumOption4[MediumOption4["R508B"] = 356] = "R508B";
  MediumOption4[MediumOption4["R509A"] = 357] = "R509A";
  MediumOption4[MediumOption4["R510A"] = 358] = "R510A";
  MediumOption4[MediumOption4["R512A"] = 359] = "R512A";
  MediumOption4[MediumOption4["R513A"] = 360] = "R513A";
  MediumOption4[MediumOption4["RC318"] = 361] = "RC318";
  MediumOption4[MediumOption4["RE143A"] = 362] = "RE143A";
  MediumOption4[MediumOption4["RE245CB2"] = 363] = "RE245CB2";
  MediumOption4[MediumOption4["RE245FA2"] = 364] = "RE245FA2";
  MediumOption4[MediumOption4["RE347MCC"] = 365] = "RE347MCC";
  MediumOption4[MediumOption4["SF6"] = 366] = "SF6";
  MediumOption4[MediumOption4["SO2"] = 367] = "SO2";
  MediumOption4[MediumOption4["T2BUTENE"] = 368] = "T2BUTENE";
  MediumOption4[MediumOption4["TOLUENE"] = 369] = "TOLUENE";
  MediumOption4[MediumOption4["WATER"] = 370] = "WATER";
  MediumOption4[MediumOption4["XENON"] = 371] = "XENON";
  MediumOption4[MediumOption4["NAOH105020130C"] = 372] = "NAOH105020130C";
  MediumOption4[MediumOption4["ALCALINH3WATER762364020C"] = 373] = "ALCALINH3WATER762364020C";
  MediumOption4[MediumOption4["ETHANOL11604520C"] = 374] = "ETHANOL11604520C";
  MediumOption4[MediumOption4["METHANOL8475020C"] = 375] = "METHANOL8475020C";
  MediumOption4[MediumOption4["GLYCEROL20634040C"] = 376] = "GLYCEROL20634040C";
  MediumOption4[MediumOption4["KALIUMCARBONATE0393530C"] = 377] = "KALIUMCARBONATE0393530C";
  MediumOption4[MediumOption4["MAGNESIUMCHLORIDE0203030C"] = 378] = "MAGNESIUMCHLORIDE0203030C";
  MediumOption4[MediumOption4["NATRIUMCHLORIDE0232130C"] = 379] = "NATRIUMCHLORIDE0232130C";
  MediumOption4[MediumOption4["KALIUMACETATE11414530C"] = 380] = "KALIUMACETATE11414530C";
  MediumOption4[MediumOption4["COOLFLOWDTX22524580C"] = 381] = "COOLFLOWDTX22524580C";
  MediumOption4[MediumOption4["FRICK12B40120C"] = 382] = "FRICK12B40120C";
  MediumOption4[MediumOption4["R1234ZEZ"] = 383] = "R1234ZEZ";
  MediumOption4[MediumOption4["LNGMSC28586MIX"] = 384] = "LNGMSC28586MIX";
  MediumOption4[MediumOption4["FRICK1910100C"] = 385] = "FRICK1910100C";
  MediumOption4[MediumOption4["ARCTICSHC23010120C"] = 386] = "ARCTICSHC23010120C";
  MediumOption4[MediumOption4["R515A"] = 387] = "R515A";
  MediumOption4[MediumOption4["R515B"] = 388] = "R515B";
  MediumOption4[MediumOption4["R1336MZZZ"] = 389] = "R1336MZZZ";
  MediumOption4[MediumOption4["_13BUTADIENE"] = 390] = "_13BUTADIENE";
  MediumOption4[MediumOption4["DYNALINEHC505020C"] = 391] = "DYNALINEHC505020C";
  MediumOption4[MediumOption4["FES1378933"] = 392] = "FES1378933";
  MediumOption4[MediumOption4["PAO6830120"] = 393] = "PAO6830120";
  MediumOption4[MediumOption4["R407I"] = 394] = "R407I";
  MediumOption4[MediumOption4["R417C"] = 395] = "R417C";
  MediumOption4[MediumOption4["R436C"] = 396] = "R436C";
  MediumOption4[MediumOption4["R457B"] = 397] = "R457B";
  MediumOption4[MediumOption4["R460C"] = 398] = "R460C";
  MediumOption4[MediumOption4["R461A"] = 399] = "R461A";
  MediumOption4[MediumOption4["R462A"] = 400] = "R462A";
  MediumOption4[MediumOption4["R463A"] = 401] = "R463A";
  MediumOption4[MediumOption4["R464A"] = 402] = "R464A";
  MediumOption4[MediumOption4["R465A"] = 403] = "R465A";
  MediumOption4[MediumOption4["R466A"] = 404] = "R466A";
  MediumOption4[MediumOption4["R467A"] = 405] = "R467A";
  MediumOption4[MediumOption4["R469A"] = 406] = "R469A";
  MediumOption4[MediumOption4["R470A"] = 407] = "R470A";
  MediumOption4[MediumOption4["R470B"] = 408] = "R470B";
  MediumOption4[MediumOption4["R472A"] = 409] = "R472A";
  MediumOption4[MediumOption4["R516A"] = 410] = "R516A";
  MediumOption4[MediumOption4["R723_MIX"] = 411] = "R723_MIX";
  MediumOption4[MediumOption4["_1BUTYNE"] = 412] = "_1BUTYNE";
  MediumOption4[MediumOption4["_1PENTENE"] = 413] = "_1PENTENE";
  MediumOption4[MediumOption4["_22DIMETHYLBUTANE"] = 414] = "_22DIMETHYLBUTANE";
  MediumOption4[MediumOption4["_23DIMETHYLBUTANE"] = 415] = "_23DIMETHYLBUTANE";
  MediumOption4[MediumOption4["_3METHYLPENTANE"] = 416] = "_3METHYLPENTANE";
  MediumOption4[MediumOption4["ACETYLENE"] = 417] = "ACETYLENE";
  MediumOption4[MediumOption4["AMARILLO"] = 418] = "AMARILLO";
  MediumOption4[MediumOption4["C16"] = 419] = "C16";
  MediumOption4[MediumOption4["C22"] = 420] = "C22";
  MediumOption4[MediumOption4["C6F14"] = 421] = "C6F14";
  MediumOption4[MediumOption4["CHLORINE"] = 422] = "CHLORINE";
  MediumOption4[MediumOption4["CHLOROBENZENE"] = 423] = "CHLOROBENZENE";
  MediumOption4[MediumOption4["CYCLOBUTENE"] = 424] = "CYCLOBUTENE";
  MediumOption4[MediumOption4["DEA"] = 425] = "DEA";
  MediumOption4[MediumOption4["EGLYCOL"] = 426] = "EGLYCOL";
  MediumOption4[MediumOption4["EKOFISK"] = 427] = "EKOFISK";
  MediumOption4[MediumOption4["ETHYLENEOXIDE"] = 428] = "ETHYLENEOXIDE";
  MediumOption4[MediumOption4["GLFCOAST"] = 429] = "GLFCOAST";
  MediumOption4[MediumOption4["HIGHCO2"] = 430] = "HIGHCO2";
  MediumOption4[MediumOption4["HIGHN2"] = 431] = "HIGHN2";
  MediumOption4[MediumOption4["MCR2"] = 432] = "MCR2";
  MediumOption4[MediumOption4["MCR3"] = 433] = "MCR3";
  MediumOption4[MediumOption4["MCR4"] = 434] = "MCR4";
  MediumOption4[MediumOption4["MEA"] = 435] = "MEA";
  MediumOption4[MediumOption4["NGSAMPLE"] = 436] = "NGSAMPLE";
  MediumOption4[MediumOption4["PROPADIENE"] = 437] = "PROPADIENE";
  MediumOption4[MediumOption4["PROPYLENEOXIDE"] = 438] = "PROPYLENEOXIDE";
  MediumOption4[MediumOption4["R1123"] = 439] = "R1123";
  MediumOption4[MediumOption4["R1224YDZ"] = 440] = "R1224YDZ";
  MediumOption4[MediumOption4["R1243ZF"] = 441] = "R1243ZF";
  MediumOption4[MediumOption4["R150"] = 442] = "R150";
  MediumOption4[MediumOption4["R407G"] = 443] = "R407G";
  MediumOption4[MediumOption4["R407H"] = 444] = "R407H";
  MediumOption4[MediumOption4["R417B"] = 445] = "R417B";
  MediumOption4[MediumOption4["R419B"] = 446] = "R419B";
  MediumOption4[MediumOption4["R422E"] = 447] = "R422E";
  MediumOption4[MediumOption4["R433B"] = 448] = "R433B";
  MediumOption4[MediumOption4["R433C"] = 449] = "R433C";
  MediumOption4[MediumOption4["R439A"] = 450] = "R439A";
  MediumOption4[MediumOption4["R440A"] = 451] = "R440A";
  MediumOption4[MediumOption4["R444B"] = 452] = "R444B";
  MediumOption4[MediumOption4["R445A"] = 453] = "R445A";
  MediumOption4[MediumOption4["R446A"] = 454] = "R446A";
  MediumOption4[MediumOption4["R447A"] = 455] = "R447A";
  MediumOption4[MediumOption4["R447B"] = 456] = "R447B";
  MediumOption4[MediumOption4["R449A"] = 457] = "R449A";
  MediumOption4[MediumOption4["R449C"] = 458] = "R449C";
  MediumOption4[MediumOption4["R450A"] = 459] = "R450A";
  MediumOption4[MediumOption4["R451A"] = 460] = "R451A";
  MediumOption4[MediumOption4["R451B"] = 461] = "R451B";
  MediumOption4[MediumOption4["R452A"] = 462] = "R452A";
  MediumOption4[MediumOption4["R452B"] = 463] = "R452B";
  MediumOption4[MediumOption4["R452C"] = 464] = "R452C";
  MediumOption4[MediumOption4["R453A"] = 465] = "R453A";
  MediumOption4[MediumOption4["R454A"] = 466] = "R454A";
  MediumOption4[MediumOption4["R454B"] = 467] = "R454B";
  MediumOption4[MediumOption4["R454C"] = 468] = "R454C";
  MediumOption4[MediumOption4["R455A"] = 469] = "R455A";
  MediumOption4[MediumOption4["R456A"] = 470] = "R456A";
  MediumOption4[MediumOption4["R457A"] = 471] = "R457A";
  MediumOption4[MediumOption4["R458A"] = 472] = "R458A";
  MediumOption4[MediumOption4["R459A"] = 473] = "R459A";
  MediumOption4[MediumOption4["R459B"] = 474] = "R459B";
  MediumOption4[MediumOption4["R460A"] = 475] = "R460A";
  MediumOption4[MediumOption4["R460B"] = 476] = "R460B";
  MediumOption4[MediumOption4["R511A"] = 477] = "R511A";
  MediumOption4[MediumOption4["R513B"] = 478] = "R513B";
  MediumOption4[MediumOption4["VINYLCHLORIDE"] = 479] = "VINYLCHLORIDE";
  MediumOption4[MediumOption4["DYNALENEHC105050110C"] = 480] = "DYNALENEHC105050110C";
  MediumOption4[MediumOption4["FRICK1440150C"] = 481] = "FRICK1440150C";
  MediumOption4[MediumOption4["CP46006840150C"] = 482] = "CP46006840150C";
  MediumOption4[MediumOption4["CP460010040150C"] = 483] = "CP460010040150C";
  MediumOption4[MediumOption4["CP460022040150C"] = 484] = "CP460022040150C";
  return MediumOption4;
})(MediumOption || {});
var mediumOptionMappingLabel = /* @__PURE__ */ new Map([
  [0 /* OtherMedia */, "Other Media"],
  [1 /* Water */, "Water"],
  [2 /* CaCl2 */, "CaCl2"],
  [3 /* Ethyleneglycol */, "Ethyleneglycol"],
  [4 /* Freezium */, "Freezium"],
  [5 /* Hycool */, "Hycool(1-5)"],
  [6 /* Pekasol2000 */, "Pekasol2000"],
  [7 /* Propyleneglycol */, "Propyleneglycol"],
  [8 /* Tyfoxit */, "Tyfoxit(1-5)"],
  [9 /* NH3 */, "NH3"],
  [10 /* CO2 */, "CO2"],
  [11 /* Propane */, "Propane"],
  [12 /* R134a */, "R134a"],
  [13 /* R22 */, "R22"],
  [14 /* R23 */, "R23"],
  [15 /* R404a */, "R404a"],
  [16 /* R407c */, "R407c"],
  [17 /* R410a */, "R410a"],
  [18 /* R507A */, "R507A"],
  [19 /* R408a */, "R408a"],
  [20 /* ArticSHC226 */, "ArticSHC226"],
  [21 /* DowthermJ */, "DowthermJ"],
  [22 /* Essotherm500 */, "Essotherm500"],
  [23 /* GilothermD12 */, "GilothermD12"],
  [24 /* MarlothermL */, "MarlothermL"],
  [25 /* MarlothermLH */, "MarlothermLH"],
  [26 /* MarlothermS */, "MarlothermS"],
  [27 /* Mobiltherm603 */, "Mobiltherm603"],
  [28 /* Palmoil */, "Palmoil"],
  [29 /* SAE40W */, "SAE40W"],
  [30 /* ShellThermiaB */, "ShellThermiaB"],
  [31 /* SylthermXLT */, "SylthermXLT"],
  [32 /* Syltherm */, "Syltherm"],
  [33 /* Temper */, "Temper"],
  [34 /* ACETONE30230C */, "Acetone[-30/230C]"],
  [35 /* ARTICSHC22620100C */, "Artic SHC 226 [20/100C]"],
  [36 /* ARTICSHC32640100C */, "Artic SHC 326[40/100C]"],
  [37 /* BENZOL2575C */, "Benzol[25/75C]"],
  [38 /* BIODIESEL10120C */, "Biodiesel[10/120C]"],
  [39 /* BPTRANSCALN50300C */, "BP Transcal N[50/300C]"],
  [40 /* BSE17040100C */, "BSE170[40/100C]"],
  [41 /* BUTHYLACETAT1020C */, "Buthylacetat[-10/20C]"],
  [42 /* CALFLOLT2020C */, "Calflo LT[-20/20C]"],
  [43 /* CALFLOLT80160C */, "Calflo LT[80/160C]"],
  [44 /* CL001BTTMS20120C */, "CL-001 bttms[20/120C]"],
  [45 /* CL002BTTMS35140C */, "CL-002 bttms[35/140C]"],
  [46 /* CL002FEED60130C */, "CL-002 Feed[60/130C]"],
  [47 /* CLAVUSG6840100C */, "Clavus G68[40/100C]"],
  [48 /* COCOABUTTER20170C */, "Cocoa Butter[20/170C]"],
  [49 /* COOKINGOIL160210C */, "Cooking Oil[160/210C]"],
  [50 /* CP460046378933C */, "CP-4600-46[37.8/93.3C]"],
  [51 /* CRUDEFATTYACID70100C */, "Crude Fatty Acid[70/100C]"],
  [52 /* DIESELOIL520C */, "Diesel oil[-5/20C]"],
  [53 /* DIPHYL180340C */, "Diphyl[180/340C]"],
  [54 /* DISTILLEDFATTYACID16099C */, "Distilled Fatty Acid[160/99C]"],
  [55 /* DOWTHERMAC255405C */, "Dowtherm AC[255/405C]"],
  [56 /* DOWTHERMJ5165C */, "Dowtherm J[5/165C]"],
  [57 /* DOWTHERMJ2545C */, "Dowtherm J[-25/45C]"],
  [58 /* DOWTHERMJ100285C */, "Dowtherm J[100/285C]"],
  [59 /* DOWTHERMJ35125C */, "Dowtherm J[35/125C]"],
  [60 /* DOWTHERMQ40120C */, "Dowtherm Q[40/120C]"],
  [61 /* DYNALINEMV100160C */, "Dynaline MV[-100/160C]"],
  [62 /* ETHYLENE10050C */, "Ethylene[-100/50C]"],
  [63 /* FRICK11489878C */, "Frick #11[48.9/87.8C]"],
  [64 /* FRICK13489878C */, "Frick #13[48.9/87.8C]"],
  [65 /* FRICK14489878C */, "Frick #14[48.9/87.8C]"],
  [66 /* FRICK2A489878C */, "Frick #2a[48.9/87.8C]"],
  [67 /* FRICK3489878C */, "Frick #3[48.9/87.8C]"],
  [68 /* FRICK33893C */, "Frick #3[38/93C]"],
  [69 /* FRICK94988C */, "Frick #9[49/88C]"],
  [70 /* FRICKNG15441011C */, "Frick #NG1[54.4/101.1C]"],
  [71 /* HEAVYFUELOIL380CST50110C */, "Heavy fuel oil 380 cSt[50/110C]"],
  [72 /* HEAVYFUELOIL380CST110150C */, "Heavy fuel oil 380 cSt[110/150C]"],
  [73 /* HEAVYFUELOIL700CST50150C */, "Heavy fuel oil 700 cSt[50/150C]"],
  [74 /* HEAVYFUELOIL700CST110150C */, "Heavy fuel oil 700 cSt[110/150C]"],
  [75 /* HEXANE3050C */, "Hexane[-30/-50C]"],
  [76 /* KEROSINE5070C */, "Kerosine[50/70C]"],
  [77 /* LANOLIN4090C */, "Lanolin[40/90C]"],
  [78 /* LEANGLYCOL45140C */, "Lean glycol[45/140C]"],
  [79 /* LEANGLYCOL5751909C */, "Lean Glycol[57.5/190.9C]"],
  [80 /* LEANGLYCOL4141933C */, "Lean Glycol[41.4/193.3C]"],
  [81 /* LEANMEG32128C */, "Lean MEG[32/128C]"],
  [82 /* LEANSULFINOLD601287C */, "Lean Sulfinol D[60/128.7C]"],
  [83 /* LEANTEG5751909C */, "Lean TEG[57.5/190.9C]"],
  [84 /* LEANTEG451268C */, "Lean TEG[45/126.8C]"],
  [85 /* LEANTEG78210C */, "Lean TEG[78/210C]"],
  [86 /* LEANTEG4641906C */, "Lean TEG[46.4/190.6C]"],
  [87 /* LPG29130C */, "LPG[-29.1/30C]"],
  [88 /* LVGO104159C */, "LVGO[104/159C]"],
  [89 /* M1002080C */, "M100[20/80C]"],
  [90 /* MARLOTHERM2740C */, "Marlotherm[27/40C]"],
  [91 /* MARLOTHERMSH40120C */, "Marlotherm SH[40/120C]"],
  [92 /* MARLOTHERMX60300C */, "Marlotherm X[-60/300C]"],
  [93 /* MEG502080C */, "MEG 50%[20/80C]"],
  [94 /* MEGBRINE075C */, "MEG Brine[0/75C]"],
  [95 /* METHANOL30240C */, "Methanol[-30/240C]"],
  [96 /* METHANOL1020C */, "Methanol[-10/20C]"],
  [97 /* MINERALOIL100285C */, "Mineral oil[100/285C]"],
  [98 /* MOBILTHERM605185205C */, "Mobiltherm 605[185/205C]"],
  [99 /* MÄNTYÖLJY50150C */, "M\xE4nty\xF6ljy[50/150C]"],
  [100 /* NAOCL1030C */, "NaOCl[10/30C]"],
  [101 /* NHEXANE6020C */, "n-hexane[-60/20C]"],
  [102 /* NHEXANE1459C */, "n-hexane[14/59C]"],
  [103 /* NOVECHFE71006585C */, "Novec HFE 7100[-65/-85C]"],
  [104 /* ORIMULSION4001070C */, "ORIMULSION400[10/70C]"],
  [105 /* PARATHERMNF200350C */, "Paratherm NF[200/350C]"],
  [106 /* PHENOLICRESIN1030C */, "Phenolic Resin[10/30C]"],
  [107 /* PLASTIFICANTEDOP90150C */, "Plastificante DOP[90/150C]"],
  [108 /* POLYOL1030C */, "Polyol[10/30C]"],
  [109 /* POLYURETHANE4090C */, "Polyurethane[40/90C]"],
  [110 /* POR1803090C */, "POR180[30/90C]"],
  [111 /* PRODUCEDWATER60100C */, "Produced Water[60/100C]"],
  [112 /* REACTOREFFLUENT112226C */, "Reactor Effluent[112/226C]"],
  [113 /* REACTORFEED28220C */, "Reactor Feed[28/220C]"],
  [114 /* REFLO4630100C */, "Reflo 46[30/100C]"],
  [115 /* REFLO6840120C */, "Reflo 68[40/120C]"],
  [116 /* REOFOS75200C */, "Reofos[75/200C]"],
  [117 /* REOFOS175200C */, "Reofos 1[75/200C]"],
  [118 /* RICHGLYCOL466170C */, "Rich Glycol[46.6/170C]"],
  [119 /* RICHGLYCOL666160C */, "Rich Glycol[66.6/160C]"],
  [120 /* RICHMEG2254C */, "Rich MEG[22/54C]"],
  [121 /* RICHSULFINOLD401087C */, "Rich Sulfinol D[40/108.7C]"],
  [122 /* RICHTEG669170C */, "Rich TEG[66.9/170C]"],
  [123 /* RICHTEG4794C */, "Rich TEG[4/79.4C]"],
  [124 /* RICHTEG511180C */, "Rich TEG[51.1/180C]"],
  [125 /* RICHTEG45180C */, "Rich TEG[45/180C]"],
  [126 /* SAE4060100C */, "SAE40[60/100C]"],
  [127 /* SANTOTHERM6660300C */, "Santotherm 66[60/300C]"],
  [128 /* SEAWATER245C */, "Sea water[-2/45C]"],
  [129 /* SERIOLAETA10050300C */, "Seriola ETA 100[50/300C]"],
  [130 /* SHELLTHERMIAB20150C */, "Shell Thermia B[20/150C]"],
  [131 /* SODIUMNITRATE401010C */, "Sodium Nitrate 40%[-10/10C]"],
  [132 /* SOLESTLT3248985C */, "Solest LT 32[48.9/85C]"],
  [133 /* SOLVENT5030100C */, "Solvent 50[30/100C]"],
  [134 /* SOYABEANOIL60260C */, "Soyabean Oil[60/260C]"],
  [135 /* SUNFLOWEROIL160210C */, "Sunflower Oil[160/210C]"],
  [136 /* SYLTHERMXLT30150C */, "Syltherm XLT[-30/150C]"],
  [137 /* SYLTHERMXLT400C */, "Syltherm XLT[-40/0C]"],
  [138 /* TALLOW60226C */, "Tallow[60/226C]"],
  [139 /* TEG58120150C */, "TEG 58%[120/150C]"],
  [140 /* TEXACOA6830110C */, "Texaco A68[30/110C]"],
  [141 /* TEXACOPREMIUM6830110C */, "Texaco Premium 68[30/110C]"],
  [142 /* TEXACOWF6830110C */, "Texaco WF68[30/110C]"],
  [143 /* THERMERA351020C */, "Thermera 35% [-10/20C]"],
  [144 /* THERMERA502520C */, "Thermera 50%[-25/20C]"],
  [145 /* THERMINOL55149216C */, "Therminol 55[149/216C]"],
  [146 /* THERMINOL66120200C */, "Therminol 66[120/200C]"],
  [147 /* THERMINOL72220320C */, "Therminol 72[220/320C]"],
  [148 /* THERMINOLD12200C */, "Therminol D12[-20/0C]"],
  [149 /* THERMINOLD1249149C */, "Therminol D12[49/149C]"],
  [150 /* THERMINOLLT4016C */, "Therminol LT[-40/16C]"],
  [151 /* TMP58210C */, "TMP[58/210C]"],
  [152 /* TOLUENE20240C */, "Toluene[-20/240C]"],
  [153 /* TRANSCALLT0130C */, "Transcal LT[0/130C]"],
  [154 /* TRANSCALN1030C */, "Transcal N[10/30C]"],
  [155 /* UCOTHERMFG8450C */, "UCOTHERM FG-8[-45/0C]"],
  [156 /* UCOTHERMFG80280C */, "UCOTHERM FG-8[0/280C]"],
  [157 /* VEGOIL100260C */, "Veg Oil[100/260C]"],
  [158 /* VG6840100C */, "VG68[40/100C]"],
  [159 /* VGO100245C */, "VGO[100/245C]"],
  [160 /* XYLENE25145C */, "Xylene[25/145C]"],
  [161 /* ISOVG2230180C */, "ISO VG 22[-30/180C]"],
  [162 /* ISOVG3230180C */, "ISO VG 32[-30/180C]"],
  [163 /* ISOVG4630180C */, "ISO VG 46[-30/180C]"],
  [164 /* ISOVG6815180C */, "ISO VG 68[-15/180C]"],
  [165 /* ISOVG10015180C */, "ISO VG 100[-15/180C]"],
  [166 /* ISOVG1500140C */, "ISO VG 150[0/140C]"],
  [167 /* ISOVG2200140C */, "ISO VG 220[0/140C]"],
  [168 /* MOBILARCTICSHC2340200C */, "Mobil Arctic SHC 234[0/200C]"],
  [169 /* THERMINOLVP12425C */, "Therminol VP[12/425C]"],
  [170 /* MOLTENSALT260593C */, "Molten Salt[260/593C]"],
  [171 /* NXT717OIL0140C */, "NXT-717 oil[0/140C]"],
  [172 /* _1BUTENE */, "1BUTENE"],
  [173 /* ACETONE */, "ACETONE"],
  [174 /* AIR */, "AIR"],
  [175 /* AMMONIA */, "AMMONIA"],
  [176 /* ARGON */, "ARGON"],
  [177 /* BENZENE */, "BENZENE"],
  [178 /* BUTANE */, "BUTANE"],
  [179 /* C11 */, "C11"],
  [180 /* C12 */, "C12"],
  [181 /* C1CC6 */, "C1CC6"],
  [182 /* C2BUTENE */, "C2BUTENE"],
  [183 /* C3CC6 */, "C3CC6"],
  [184 /* C4F10 */, "C4F10"],
  [185 /* C5F12 */, "C5F12"],
  [186 /* CF3I */, "CF3I"],
  [187 /* CO */, "CO"],
  [188 /* CO2Refprop */, "CO2"],
  [189 /* COS */, "COS"],
  [190 /* CYCLOHEX */, "CYCLOHEX"],
  [191 /* CYCLOPEN */, "CYCLOPEN"],
  [192 /* CYCLOPRO */, "CYCLOPRO"],
  [193 /* D2 */, "D2"],
  [194 /* D2O */, "D2O"],
  [195 /* D4 */, "D4"],
  [196 /* D5 */, "D5"],
  [197 /* D6 */, "D6"],
  [198 /* DECANE */, "DECANE"],
  [199 /* DEE */, "DEE"],
  [200 /* DMC */, "DMC"],
  [201 /* DME */, "DME"],
  [202 /* EBENZENE */, "EBENZENE"],
  [203 /* ETHANE */, "ETHANE"],
  [204 /* ETHANOL */, "ETHANOL"],
  [205 /* ETHYLENE */, "ETHYLENE"],
  [206 /* FLUORINE */, "FLUORINE"],
  [207 /* H2S */, "H2S"],
  [208 /* HCL */, "HCL"],
  [209 /* HELIUM */, "HELIUM"],
  [210 /* HEPTANE */, "HEPTANE"],
  [211 /* HEXANE */, "HEXANE"],
  [212 /* HYDROGEN */, "HYDROGEN"],
  [213 /* IBUTENE */, "IBUTENE"],
  [214 /* IHEXANE */, "IHEXANE"],
  [215 /* IOCTANE */, "IOCTANE"],
  [216 /* IPENTANE */, "IPENTANE"],
  [217 /* ISOBUTAN */, "ISOBUTAN"],
  [218 /* KRYPTON */, "KRYPTON"],
  [219 /* LNG */, "LNG.mix"],
  [220 /* MD2M */, "MD2M"],
  [221 /* MD3M */, "MD3M"],
  [222 /* MD4M */, "MD4M"],
  [223 /* MDM */, "MDM"],
  [224 /* METHANE */, "METHANE"],
  [225 /* METHANOL */, "METHANOL"],
  [226 /* MLINOLEA */, "MLINOLEA"],
  [227 /* MLINOLEN */, "MLINOLEN"],
  [228 /* MM */, "MM"],
  [229 /* MOLEATE */, "MOLEATE"],
  [230 /* MPALMITA */, "MPALMITA"],
  [231 /* MSTEARAT */, "MSTEARAT"],
  [232 /* MXYLENE */, "MXYLENE"],
  [233 /* N2O */, "N2O"],
  [234 /* NEON */, "NEON"],
  [235 /* NEOPENTN */, "NEOPENTN"],
  [236 /* NF3 */, "NF3"],
  [237 /* NITROGEN */, "NITROGEN"],
  [238 /* NONANE */, "NONANE"],
  [239 /* NOVEC649 */, "NOVEC649"],
  [240 /* OCTANE */, "OCTANE"],
  [241 /* ORTHOHYD */, "ORTHOHYD"],
  [242 /* OXYGEN */, "OXYGEN"],
  [243 /* OXYLENE */, "OXYLENE"],
  [244 /* PARAHYD */, "PARAHYD"],
  [245 /* PENTANE */, "PENTANE"],
  [246 /* PROPANE */, "PROPANE"],
  [247 /* PROPYLEN */, "PROPYLEN"],
  [248 /* PROPYNE */, "PROPYNE"],
  [249 /* PXYLENE */, "PXYLENE"],
  [250 /* R11 */, "R11"],
  [251 /* R113 */, "R113"],
  [252 /* R114 */, "R114"],
  [253 /* R115 */, "R115"],
  [254 /* R116 */, "R116"],
  [255 /* R12 */, "R12"],
  [256 /* R1216 */, "R1216"],
  [257 /* R123 */, "R123"],
  [258 /* R1233ZDE */, "R1233ZDE"],
  [259 /* R1234YF */, "R1234YF"],
  [260 /* R1234ZEE */, "R1234ZEE"],
  [261 /* R124 */, "R124"],
  [262 /* R125 */, "R125"],
  [263 /* R13 */, "R13"],
  [264 /* R134A */, "R134A"],
  [265 /* R14 */, "R14"],
  [266 /* R141B */, "R141B"],
  [267 /* R142B */, "R142B"],
  [268 /* R143A */, "R143A"],
  [269 /* R152A */, "R152A"],
  [360 /* R513A */, "R513A"],
  [270 /* R161 */, "R161"],
  [271 /* R21 */, "R21"],
  [272 /* R218 */, "R218"],
  [273 /* R22Refprop */, "R22"],
  [274 /* R227EA */, "R227EA"],
  [275 /* R23Refprop */, "R23"],
  [276 /* R236EA */, "R236EA"],
  [277 /* R236FA */, "R236FA"],
  [278 /* R245CA */, "R245CA"],
  [279 /* R245FA */, "R245FA"],
  [280 /* R32 */, "R32"],
  [281 /* R365MFC */, "R365MFC"],
  [282 /* R40 */, "R40"],
  [283 /* R401A */, "R401A"],
  [284 /* R401B */, "R401B"],
  [285 /* R401C */, "R401C"],
  [286 /* R402A */, "R402A"],
  [287 /* R402B */, "R402B"],
  [288 /* R403A */, "R403A"],
  [289 /* R403B */, "R403B"],
  [290 /* R404A */, "R404A"],
  [291 /* R405A */, "R405A"],
  [292 /* R406A */, "R406A"],
  [293 /* R407A */, "R407A"],
  [294 /* R407B */, "R407B"],
  [295 /* R407C */, "R407C"],
  [296 /* R407D */, "R407D"],
  [297 /* R407E */, "R407E"],
  [298 /* R407F */, "R407F"],
  [299 /* R408A */, "R408A"],
  [300 /* R409A */, "R409A"],
  [301 /* R409B */, "R409B"],
  [302 /* R41 */, "R41"],
  [303 /* R410A */, "R410A"],
  [304 /* R410B */, "R410B"],
  [305 /* R411A */, "R411A"],
  [306 /* R411B */, "R411B"],
  [307 /* R412A */, "R412A"],
  [308 /* R413A */, "R413A"],
  [309 /* R414A */, "R414A"],
  [310 /* R414B */, "R414B"],
  [311 /* R415A */, "R415A"],
  [312 /* R415B */, "R415B"],
  [313 /* R416A */, "R416A"],
  [314 /* R417A */, "R417A"],
  [315 /* R418A */, "R418A"],
  [316 /* R419A */, "R419A"],
  [317 /* R420A */, "R420A"],
  [318 /* R421A */, "R421A"],
  [319 /* R421B */, "R421B"],
  [320 /* R422A */, "R422A"],
  [321 /* R422B */, "R422B"],
  [322 /* R422C */, "R422C"],
  [323 /* R422D */, "R422D"],
  [324 /* R423A */, "R423A"],
  [325 /* R424A */, "R424A"],
  [326 /* R425A */, "R425A"],
  [327 /* R426A */, "R426A"],
  [328 /* R427A */, "R427A"],
  [329 /* R428A */, "R428A"],
  [330 /* R429A */, "R429A"],
  [331 /* R430A */, "R430A"],
  [332 /* R431A */, "R431A"],
  [333 /* R432A */, "R432A"],
  [334 /* R433A */, "R433A"],
  [335 /* R434A */, "R434A"],
  [336 /* R435A */, "R435A"],
  [337 /* R436A */, "R436A"],
  [338 /* R436B */, "R436B"],
  [339 /* R437A */, "R437A"],
  [340 /* R438A */, "R438A"],
  [341 /* R441A */, "R441A"],
  [342 /* R442A */, "R442A"],
  [343 /* R443A */, "R443A"],
  [344 /* R444A */, "R444A"],
  [345 /* R448A */, "R448A"],
  [346 /* R449a */, "R449a"],
  [347 /* R449B */, "R449B"],
  [348 /* R452a */, "R452a"],
  [349 /* R500 */, "R500"],
  [350 /* R501 */, "R501"],
  [351 /* R502 */, "R502"],
  [352 /* R503 */, "R503"],
  [353 /* R504 */, "R504"],
  [354 /* R507ARefprop */, "R507A"],
  [355 /* R508A */, "R508A"],
  [356 /* R508B */, "R508B"],
  [357 /* R509A */, "R509A"],
  [358 /* R510A */, "R510A"],
  [359 /* R512A */, "R512A"],
  [361 /* RC318 */, "RC318"],
  [362 /* RE143A */, "RE143A"],
  [363 /* RE245CB2 */, "RE245CB2"],
  [364 /* RE245FA2 */, "RE245FA2"],
  [365 /* RE347MCC */, "RE347MCC"],
  [366 /* SF6 */, "SF6"],
  [367 /* SO2 */, "SO2"],
  [368 /* T2BUTENE */, "T2BUTENE"],
  [369 /* TOLUENE */, "TOLUENE"],
  [370 /* WATER */, "WATER"],
  [371 /* XENON */, "XENON"],
  [372 /* NAOH105020130C */, "NaOH[10/50%;20/130C]"],
  [
    373 /* ALCALINH3WATER762364020C */,
    "ALCALI (NH3/Water)[7.6/23.6%;-40/20C]"
  ],
  [374 /* ETHANOL11604520C */, "Ethanol[11/60%;-45/20C]"],
  [375 /* METHANOL8475020C */, "Methanol[8/47%;-50/20C]"],
  [376 /* GLYCEROL20634040C */, "Glycerol[20/63%;-40/40C]"],
  [377 /* KALIUMCARBONATE0393530C */, "Kalium carbonate[0/39%;-35/30C]"],
  [378 /* MAGNESIUMCHLORIDE0203030C */, "Magnesium chloride[0/20%;-30/30C]"],
  [379 /* NATRIUMCHLORIDE0232130C */, "Natrium chloride[0/23%;-21/30C]"],
  [380 /* KALIUMACETATE11414530C */, "Kalium acetate[11/41%;-45/30C]"],
  [381 /* COOLFLOWDTX22524580C */, "Coolflow DTX[22/52%;-45/80C]"],
  [382 /* FRICK12B40120C */, "Frick #12b[40/120]"],
  [383 /* R1234ZEZ */, "R1234ZEZ"],
  [384 /* LNGMSC28586MIX */, "LNG-MSC-285(86).Mix"],
  [385 /* FRICK1910100C */, "Frick #19[10/100C]"],
  [386 /* ARCTICSHC23010120C */, "Arctic SHC 230[-10/120C]"],
  [387 /* R515A */, "R515A"],
  [388 /* R515B */, "R515B"],
  [389 /* R1336MZZZ */, "R1336MZZZ"],
  [390 /* _13BUTADIENE */, "13BUTADIENE"],
  [391 /* DYNALINEHC505020C */, "Dynaline HC-50[-50/20C]"],
  [392 /* FES1378933 */, "FES #1[37.8/93.3C]"],
  [393 /* PAO6830120 */, "PAO 68[-30/120C]"],
  [394 /* R407I */, "R407I"],
  [395 /* R417C */, "R417C"],
  [396 /* R436C */, "R436C"],
  [397 /* R457B */, "R457B"],
  [398 /* R460C */, "R460C"],
  [399 /* R461A */, "R461A"],
  [400 /* R462A */, "R462A"],
  [401 /* R463A */, "R463A"],
  [402 /* R464A */, "R464A"],
  [403 /* R465A */, "R465A"],
  [404 /* R466A */, "R466A"],
  [405 /* R467A */, "R467A"],
  [406 /* R469A */, "R469A"],
  [407 /* R470A */, "R470A"],
  [408 /* R470B */, "R470B"],
  [409 /* R472A */, "R472A"],
  [410 /* R516A */, "R516A"],
  [411 /* R723_MIX */, "R723.MIX"],
  [412 /* _1BUTYNE */, "1BUTYNE"],
  [413 /* _1PENTENE */, "1PENTENE"],
  [414 /* _22DIMETHYLBUTANE */, "22DIMETHYLBUTANE"],
  [415 /* _23DIMETHYLBUTANE */, "23DIMETHYLBUTANE"],
  [416 /* _3METHYLPENTANE */, "3METHYLPENTANE"],
  [417 /* ACETYLENE */, "ACETYLENE"],
  [418 /* AMARILLO */, "AMARILLO"],
  [419 /* C16 */, "C16"],
  [420 /* C22 */, "C22"],
  [421 /* C6F14 */, "C6F14"],
  [422 /* CHLORINE */, "CHLORINE"],
  [423 /* CHLOROBENZENE */, "CHLOROBENZENE"],
  [424 /* CYCLOBUTENE */, "CYCLOBUTENE"],
  [425 /* DEA */, "DEA"],
  [426 /* EGLYCOL */, "EGLYCOL"],
  [427 /* EKOFISK */, "EKOFISK"],
  [428 /* ETHYLENEOXIDE */, "ETHYLENEOXIDE"],
  [429 /* GLFCOAST */, "GLFCOAST"],
  [430 /* HIGHCO2 */, "HIGHCO2"],
  [431 /* HIGHN2 */, "HIGHN2"],
  [432 /* MCR2 */, "MCR2"],
  [433 /* MCR3 */, "MCR3"],
  [434 /* MCR4 */, "MCR4"],
  [435 /* MEA */, "MEA"],
  [436 /* NGSAMPLE */, "NGSAMPLE"],
  [437 /* PROPADIENE */, "PROPADIENE"],
  [438 /* PROPYLENEOXIDE */, "PROPYLENEOXIDE"],
  [439 /* R1123 */, "R1123"],
  [440 /* R1224YDZ */, "R1224YDZ"],
  [441 /* R1243ZF */, "R1243ZF"],
  [442 /* R150 */, "R150"],
  [443 /* R407G */, "R407G"],
  [444 /* R407H */, "R407H"],
  [445 /* R417B */, "R417B"],
  [446 /* R419B */, "R419B"],
  [447 /* R422E */, "R422E"],
  [448 /* R433B */, "R433B"],
  [449 /* R433C */, "R433C"],
  [450 /* R439A */, "R439A"],
  [451 /* R440A */, "R440A"],
  [452 /* R444B */, "R444B"],
  [453 /* R445A */, "R445A"],
  [454 /* R446A */, "R446A"],
  [455 /* R447A */, "R447A"],
  [456 /* R447B */, "R447B"],
  [457 /* R449A */, "R449A"],
  [458 /* R449C */, "R449C"],
  [459 /* R450A */, "R450A"],
  [460 /* R451A */, "R451A"],
  [461 /* R451B */, "R451B"],
  [462 /* R452A */, "R452A"],
  [463 /* R452B */, "R452B"],
  [464 /* R452C */, "R452C"],
  [465 /* R453A */, "R453A"],
  [466 /* R454A */, "R454A"],
  [467 /* R454B */, "R454B"],
  [468 /* R454C */, "R454C"],
  [469 /* R455A */, "R455A"],
  [470 /* R456A */, "R456A"],
  [471 /* R457A */, "R457A"],
  [472 /* R458A */, "R458A"],
  [473 /* R459A */, "R459A"],
  [474 /* R459B */, "R459B"],
  [475 /* R460A */, "R460A"],
  [476 /* R460B */, "R460B"],
  [477 /* R511A */, "R511A"],
  [478 /* R513B */, "R513B"],
  [479 /* VINYLCHLORIDE */, "VINYLCHLORIDE"],
  [480 /* DYNALENEHC105050110C */, "Dynalene HC[10/50%;-50/110C]"],
  [481 /* FRICK1440150C */, "Frick #14[-40/150C]"],
  [482 /* CP46006840150C */, "CP-4600-68[-40/150C]"],
  [483 /* CP460010040150C */, "CP-4600-100[-40/150C]"],
  [484 /* CP460022040150C */, "CP-4600-220[-40/150C]"]
]);
var internalOrJciMediumOptions = [
  481 /* FRICK1440150C */,
  482 /* CP46006840150C */,
  483 /* CP460010040150C */,
  484 /* CP460022040150C */
];
var isInternalOrJciMedium = (option) => internalOrJciMediumOptions.includes(option);

// src/enums/medium-property-calculation.enum.ts
var MediumPropertyCalculation = /* @__PURE__ */ ((MediumPropertyCalculation2) => {
  MediumPropertyCalculation2[MediumPropertyCalculation2["Hot"] = 0] = "Hot";
  MediumPropertyCalculation2[MediumPropertyCalculation2["Cold"] = 1] = "Cold";
  MediumPropertyCalculation2[MediumPropertyCalculation2["Liquid"] = 2] = "Liquid";
  return MediumPropertyCalculation2;
})(MediumPropertyCalculation || {});

// src/enums/medium-source.enum.ts
var MediumSource = /* @__PURE__ */ ((MediumSource2) => {
  MediumSource2[MediumSource2["Imported"] = 0] = "Imported";
  MediumSource2[MediumSource2["Brine"] = 1] = "Brine";
  MediumSource2[MediumSource2["Liquid"] = 2] = "Liquid";
  MediumSource2[MediumSource2["RefProp"] = 3] = "RefProp";
  return MediumSource2;
})(MediumSource || {});
var mediumSourceMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Imported */, "Imported"],
  [1 /* Brine */, "Brine"],
  [2 /* Liquid */, "Liquids-Internal"],
  [3 /* RefProp */, "RefProp"]
]);

// src/enums/medium-type.enum.ts
var MediumTypeOption = /* @__PURE__ */ ((MediumTypeOption2) => {
  MediumTypeOption2[MediumTypeOption2["Liquid"] = 1] = "Liquid";
  MediumTypeOption2[MediumTypeOption2["Gas"] = 2] = "Gas";
  return MediumTypeOption2;
})(MediumTypeOption || {});
var mediumTypeOptionMappingLabel = /* @__PURE__ */ new Map([
  [2 /* Gas */, "Gas"],
  [1 /* Liquid */, "Liquid"]
]);
var CondenserMediumTypeOption = /* @__PURE__ */ ((CondenserMediumTypeOption2) => {
  CondenserMediumTypeOption2[CondenserMediumTypeOption2["Liquid"] = 0] = "Liquid";
  CondenserMediumTypeOption2[CondenserMediumTypeOption2["Gas"] = 1] = "Gas";
  return CondenserMediumTypeOption2;
})(CondenserMediumTypeOption || {});
var condenserMediumTypeOptionMappingLabel = /* @__PURE__ */ new Map([
  [1 /* Gas */, "Gas"],
  [0 /* Liquid */, "Liquid"]
]);

// src/enums/multi-pass-combination.enum.ts
var MultiPassCombination = /* @__PURE__ */ ((MultiPassCombination2) => {
  MultiPassCombination2[MultiPassCombination2["DesupCondSubcWaterOnPlateSide"] = 1] = "DesupCondSubcWaterOnPlateSide";
  MultiPassCombination2[MultiPassCombination2["DesupCondWaterOnPlateSide"] = 2] = "DesupCondWaterOnPlateSide";
  MultiPassCombination2[MultiPassCombination2["CondSubcWaterOnPlateSide"] = 3] = "CondSubcWaterOnPlateSide";
  MultiPassCombination2[MultiPassCombination2["DesupCondSubcWaterOnShellSide"] = 4] = "DesupCondSubcWaterOnShellSide";
  MultiPassCombination2[MultiPassCombination2["DesupCondWaterOnShellSide"] = 5] = "DesupCondWaterOnShellSide";
  MultiPassCombination2[MultiPassCombination2["CondSubcWaterOnShellSide"] = 6] = "CondSubcWaterOnShellSide";
  return MultiPassCombination2;
})(MultiPassCombination || {});
var MultiPassCombinationLabelMapping = /* @__PURE__ */ new Map([
  [
    1 /* DesupCondSubcWaterOnPlateSide */,
    "Desuperheater Condenser Subcooler Water On Plate Side"
  ],
  [
    2 /* DesupCondWaterOnPlateSide */,
    "Desuperheater Condenser Water On Plate Side"
  ],
  [
    3 /* CondSubcWaterOnPlateSide */,
    "Condenser Subcooler Water On Plate Side"
  ],
  [
    4 /* DesupCondSubcWaterOnShellSide */,
    "Desuperheater Condenser Subcooler Water OnShell Side"
  ],
  [
    5 /* DesupCondWaterOnShellSide */,
    "Desuperheater Condenser Water On Shell Side"
  ],
  [
    6 /* CondSubcWaterOnShellSide */,
    "Condenser Subcooler Water On Shell Side"
  ]
]);

// src/enums/nozzle-shell.enum.ts
var NozzleShell = /* @__PURE__ */ ((NozzleShell3) => {
  NozzleShell3[NozzleShell3["DN25"] = 25] = "DN25";
  NozzleShell3[NozzleShell3["DN32"] = 32] = "DN32";
  NozzleShell3[NozzleShell3["DN40"] = 40] = "DN40";
  NozzleShell3[NozzleShell3["DN50"] = 50] = "DN50";
  NozzleShell3[NozzleShell3["DN65"] = 65] = "DN65";
  NozzleShell3[NozzleShell3["DN80"] = 80] = "DN80";
  NozzleShell3[NozzleShell3["DN100"] = 100] = "DN100";
  NozzleShell3[NozzleShell3["DN125"] = 125] = "DN125";
  NozzleShell3[NozzleShell3["DN150"] = 150] = "DN150";
  NozzleShell3[NozzleShell3["DN200"] = 200] = "DN200";
  NozzleShell3[NozzleShell3["DN250"] = 250] = "DN250";
  NozzleShell3[NozzleShell3["DN300"] = 300] = "DN300";
  NozzleShell3[NozzleShell3["DN350"] = 350] = "DN350";
  NozzleShell3[NozzleShell3["DN400"] = 400] = "DN400";
  NozzleShell3[NozzleShell3["DN500"] = 500] = "DN500";
  NozzleShell3[NozzleShell3["DN600"] = 600] = "DN600";
  NozzleShell3[NozzleShell3["DN800"] = 800] = "DN800";
  NozzleShell3[NozzleShell3["DN1000"] = 1e3] = "DN1000";
  return NozzleShell3;
})(NozzleShell || {});
var nozzleShellPEDAndPEDENDatasheetLabel = /* @__PURE__ */ new Map([
  [25 /* DN25 */, "25"],
  [32 /* DN32 */, "32"],
  [40 /* DN40 */, "40"],
  [50 /* DN50 */, "50"],
  [65 /* DN65 */, "65"],
  [80 /* DN80 */, "80"],
  [100 /* DN100 */, "100"],
  [125 /* DN125 */, "125"],
  [150 /* DN150 */, "150"],
  [200 /* DN200 */, "200"],
  [250 /* DN250 */, "250"],
  [300 /* DN300 */, "300"],
  [350 /* DN350 */, "350"],
  [400 /* DN400 */, "400"],
  [500 /* DN500 */, "500"],
  [600 /* DN600 */, "600"],
  [800 /* DN800 */, "800"],
  [1e3 /* DN1000 */, "1000"]
]);
var nozzleShellASMEDatasheetLabel = /* @__PURE__ */ new Map([
  [25 /* DN25 */, '1"'],
  [32 /* DN32 */, '1.25"'],
  [40 /* DN40 */, '1.5"'],
  [50 /* DN50 */, '2"'],
  [65 /* DN65 */, '2.5"'],
  [80 /* DN80 */, '3"'],
  [100 /* DN100 */, '4"'],
  [125 /* DN125 */, '5"'],
  [150 /* DN150 */, '6"'],
  [200 /* DN200 */, '8"'],
  [250 /* DN250 */, '10"'],
  [300 /* DN300 */, '12"'],
  [350 /* DN350 */, '14"'],
  [400 /* DN400 */, '16"'],
  [500 /* DN500 */, '20"'],
  [600 /* DN600 */, '24"'],
  [800 /* DN800 */, '32"'],
  [1e3 /* DN1000 */, '40"']
]);
var nozzleShellLabelMapping = /* @__PURE__ */ new Map([
  [25 /* DN25 */, "DN 25"],
  [32 /* DN32 */, "DN 32"],
  [40 /* DN40 */, "DN 40"],
  [50 /* DN50 */, "DN 50"],
  [65 /* DN65 */, "DN 65"],
  [80 /* DN80 */, "DN 80"],
  [100 /* DN100 */, "DN 100"],
  [125 /* DN125 */, "DN 125"],
  [150 /* DN150 */, "DN 150"],
  [200 /* DN200 */, "DN 200"],
  [250 /* DN250 */, "DN 250"],
  [300 /* DN300 */, "DN 300"],
  [350 /* DN350 */, "DN 350"],
  [400 /* DN400 */, "DN 400"],
  [500 /* DN500 */, "DN 500"],
  [600 /* DN600 */, "DN 600"],
  [800 /* DN800 */, "DN 800"],
  [1e3 /* DN1000 */, "DN 1000"]
]);

// src/enums/number-of-passes.enum.ts
var NumberOfPasses = /* @__PURE__ */ ((NumberOfPasses2) => {
  NumberOfPasses2[NumberOfPasses2["OnePass"] = 1] = "OnePass";
  NumberOfPasses2[NumberOfPasses2["TwoPasses"] = 2] = "TwoPasses";
  NumberOfPasses2[NumberOfPasses2["ThreePasses"] = 3] = "ThreePasses";
  NumberOfPasses2[NumberOfPasses2["FourPasses"] = 4] = "FourPasses";
  NumberOfPasses2[NumberOfPasses2["FivePasses"] = 5] = "FivePasses";
  return NumberOfPasses2;
})(NumberOfPasses || {});
var NumberOfPassesLabelMapping = /* @__PURE__ */ new Map([
  [1 /* OnePass */, "1 pass"],
  [2 /* TwoPasses */, "2 passes"],
  [3 /* ThreePasses */, "3 passes"],
  [4 /* FourPasses */, "4 passes"],
  [5 /* FivePasses */, "5 passes"]
]);

// src/enums/number-of-plate-nozzle.enum.ts
var NumberOfPlateNozzle = /* @__PURE__ */ ((NumberOfPlateNozzle2) => {
  NumberOfPlateNozzle2[NumberOfPlateNozzle2["oneEnd"] = 1] = "oneEnd";
  NumberOfPlateNozzle2[NumberOfPlateNozzle2["differentEnds"] = 2] = "differentEnds";
  NumberOfPlateNozzle2[NumberOfPlateNozzle2["bothEnds"] = 3] = "bothEnds";
  return NumberOfPlateNozzle2;
})(NumberOfPlateNozzle || {});
var numberOfPlateNozzleMappingLabel = /* @__PURE__ */ new Map([
  [1 /* oneEnd */, "2 (One end)"],
  [2 /* differentEnds */, "2 (Different ends)"],
  [3 /* bothEnds */, "4 (Both ends)"]
]);

// src/enums/number-of-shell-nozzle.enum.ts
var NumberOfShellNozzle = /* @__PURE__ */ ((NumberOfShellNozzle2) => {
  NumberOfShellNozzle2[NumberOfShellNozzle2["_1pc"] = 1] = "_1pc";
  NumberOfShellNozzle2[NumberOfShellNozzle2["_2pc"] = 2] = "_2pc";
  NumberOfShellNozzle2[NumberOfShellNozzle2["_4pc"] = 4] = "_4pc";
  return NumberOfShellNozzle2;
})(NumberOfShellNozzle || {});
var numberOfShellNozzleMappingLabel = /* @__PURE__ */ new Map([
  [1 /* _1pc */, "1 pc"],
  [2 /* _2pc */, "2 pc"],
  [4 /* _4pc */, "4 pc"]
]);

// src/enums/offer.enum.ts
var OfferInfoType = /* @__PURE__ */ ((OfferInfoType2) => {
  OfferInfoType2["Input"] = "input";
  OfferInfoType2["TextArea"] = "textarea";
  OfferInfoType2["Select"] = "select";
  OfferInfoType2["Custom"] = "customTerm";
  return OfferInfoType2;
})(OfferInfoType || {});
var OfferStatus = /* @__PURE__ */ ((OfferStatus2) => {
  OfferStatus2["Initial"] = "Initial";
  OfferStatus2["Lost"] = "Lost";
  OfferStatus2["RequestReceived"] = "Request received";
  OfferStatus2["SendToCustomer"] = "Send to customer";
  OfferStatus2["sizing"] = "Sizing";
  OfferStatus2["Order"] = "Order";
  OfferStatus2["OldRevision"] = "Old revision";
  OfferStatus2["Rejected"] = "Rejected to offer";
  OfferStatus2["Expired"] = "Expired";
  return OfferStatus2;
})(OfferStatus || {});

// src/enums/paint-option.enum.ts
var SurfaceTreatment = /* @__PURE__ */ ((SurfaceTreatment2) => {
  SurfaceTreatment2[SurfaceTreatment2["System0Grey"] = 0] = "System0Grey";
  SurfaceTreatment2[SurfaceTreatment2["System1White"] = 1] = "System1White";
  SurfaceTreatment2[SurfaceTreatment2["System1Blue"] = 2] = "System1Blue";
  SurfaceTreatment2[SurfaceTreatment2["System21GreenishGray"] = 3] = "System21GreenishGray";
  SurfaceTreatment2[SurfaceTreatment2["System22Silver"] = 4] = "System22Silver";
  SurfaceTreatment2[SurfaceTreatment2["System3White"] = 5] = "System3White";
  SurfaceTreatment2[SurfaceTreatment2["System4White"] = 6] = "System4White";
  SurfaceTreatment2[SurfaceTreatment2["System5"] = 7] = "System5";
  SurfaceTreatment2[SurfaceTreatment2["System6"] = 8] = "System6";
  SurfaceTreatment2[SurfaceTreatment2["SystemE"] = 9] = "SystemE";
  SurfaceTreatment2[SurfaceTreatment2["VahterusZJGStandard1White"] = 10] = "VahterusZJGStandard1White";
  SurfaceTreatment2[SurfaceTreatment2["VahterusZJGStandard2"] = 11] = "VahterusZJGStandard2";
  return SurfaceTreatment2;
})(SurfaceTreatment || {});
var SurfaceTreatmentPart = /* @__PURE__ */ ((SurfaceTreatmentPart2) => {
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["INTERPRIME19850Grey"] = 0] = "INTERPRIME19850Grey";
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["INTERCURE99100Blue"] = 1] = "INTERCURE99100Blue";
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["INTERCURE99100White"] = 2] = "INTERCURE99100White";
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["INTERCURE99240White"] = 3] = "INTERCURE99240White";
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["INTERZINC2250GreenishGrey"] = 4] = "INTERZINC2250GreenishGrey";
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["INTERZINC2250INTERTHERM5025Silver"] = 5] = "INTERZINC2250INTERTHERM5025Silver";
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["INTERZINC5280INTERCURE99240White"] = 6] = "INTERZINC5280INTERCURE99240White";
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["INTERTHERM228HS200White"] = 7] = "INTERTHERM228HS200White";
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["INTERTHERM5025Silver"] = 8] = "INTERTHERM5025Silver";
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["SteelGritBlasting"] = 9] = "SteelGritBlasting";
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["AluminumOxideBlasting"] = 10] = "AluminumOxideBlasting";
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["Other"] = 11] = "Other";
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["OrganicSiliconeHeatResistantPaintWhite"] = 12] = "OrganicSiliconeHeatResistantPaintWhite";
  SurfaceTreatmentPart2[SurfaceTreatmentPart2["QuartzSandBlasting"] = 13] = "QuartzSandBlasting";
  return SurfaceTreatmentPart2;
})(SurfaceTreatmentPart || {});
var surfaceTreatmentMappingValue = /* @__PURE__ */ new Map([
  [0 /* System0Grey */, "System 0, Grey"],
  [1 /* System1White */, "System 1, White"],
  [2 /* System1Blue */, "System 1, Blue"],
  [3 /* System21GreenishGray */, "System 2.1, Greenish grey"],
  [4 /* System22Silver */, "System 2.2, Silver"],
  [5 /* System3White */, "System 3, White"],
  [6 /* System4White */, "System 4, White"],
  [7 /* System5 */, "System 5"],
  [8 /* System6 */, "System 6"],
  [9 /* SystemE */, "System E"],
  [
    10 /* VahterusZJGStandard1White */,
    "Vahterus ZJG Standard 1, White"
  ],
  [11 /* VahterusZJGStandard2 */, "Vahterus ZJG Standard 2"]
]);
var surfaceTreatmentPartMappingValue = /* @__PURE__ */ new Map([
  [0 /* INTERPRIME19850Grey */, "INTERPRIME 198, 50 \xB5m, grey"],
  [
    2 /* INTERCURE99100White */,
    "INTERCURE 99, 100 \xB5m, white (RAL 9010)"
  ],
  [
    1 /* INTERCURE99100Blue */,
    "INTERCURE 99, 100 \xB5m, blue (RAL 5010)"
  ],
  [
    4 /* INTERZINC2250GreenishGrey */,
    "INTERZINC 22, 50 \xB5m, Greenish grey"
  ],
  [
    5 /* INTERZINC2250INTERTHERM5025Silver */,
    "INTERZINC 22, 50 \xB5m + INTERTHERM 50, 25 \xB5m, Silver"
  ],
  [
    6 /* INTERZINC5280INTERCURE99240White */,
    "INTERZINC 52, 80 \xB5m + INTERCURE 99, 240 \xB5m, white (RAL 9010)"
  ],
  [
    7 /* INTERTHERM228HS200White */,
    "INTERTHERM 228HS 2x 100 \xB5m (200 \xB5m), white (RAL 9010)"
  ],
  [9 /* SteelGritBlasting */, "Steel grit blasting"],
  [10 /* AluminumOxideBlasting */, "Aluminum oxide blasting"],
  [11 /* Other */, "Other"],
  [8 /* INTERTHERM5025Silver */, "INTERTHERM 50, 25 \xB5m, Silver"],
  [
    3 /* INTERCURE99240White */,
    "INTERCURE 99, 240 \xB5m, white (RAL 9010)"
  ],
  [
    12 /* OrganicSiliconeHeatResistantPaintWhite */,
    "Organic silicone heat-resistant paint, white"
  ],
  [13 /* QuartzSandBlasting */, "Quartz sand blasting"]
]);
var carboonSteelMappingList = /* @__PURE__ */ new Map([
  [0 /* System0Grey */, [0 /* INTERPRIME19850Grey */]],
  [1 /* System1White */, [2 /* INTERCURE99100White */]],
  [2 /* System1Blue */, [1 /* INTERCURE99100Blue */]],
  [
    3 /* System21GreenishGray */,
    [4 /* INTERZINC2250GreenishGrey */]
  ],
  [
    4 /* System22Silver */,
    [5 /* INTERZINC2250INTERTHERM5025Silver */]
  ],
  [
    5 /* System3White */,
    [6 /* INTERZINC5280INTERCURE99240White */]
  ],
  [
    6 /* System4White */,
    [7 /* INTERTHERM228HS200White */]
  ],
  [8 /* System6 */, [9 /* SteelGritBlasting */]],
  [
    9 /* SystemE */,
    [
      0 /* INTERPRIME19850Grey */,
      2 /* INTERCURE99100White */,
      1 /* INTERCURE99100Blue */,
      4 /* INTERZINC2250GreenishGrey */,
      5 /* INTERZINC2250INTERTHERM5025Silver */,
      6 /* INTERZINC5280INTERCURE99240White */,
      7 /* INTERTHERM228HS200White */,
      9 /* SteelGritBlasting */,
      11 /* Other */
    ]
  ]
]);
var stainlessSteelMappingList = /* @__PURE__ */ new Map([
  [0 /* System0Grey */, [0 /* INTERPRIME19850Grey */]],
  [1 /* System1White */, [2 /* INTERCURE99100White */]],
  [2 /* System1Blue */, [1 /* INTERCURE99100Blue */]],
  [
    3 /* System21GreenishGray */,
    [10 /* AluminumOxideBlasting */]
  ],
  [
    4 /* System22Silver */,
    [8 /* INTERTHERM5025Silver */]
  ],
  [5 /* System3White */, [3 /* INTERCURE99240White */]],
  [
    6 /* System4White */,
    [7 /* INTERTHERM228HS200White */]
  ],
  [7 /* System5 */, [10 /* AluminumOxideBlasting */]],
  [
    9 /* SystemE */,
    [
      0 /* INTERPRIME19850Grey */,
      2 /* INTERCURE99100White */,
      1 /* INTERCURE99100Blue */,
      7 /* INTERTHERM228HS200White */,
      8 /* INTERTHERM5025Silver */,
      3 /* INTERCURE99240White */,
      10 /* AluminumOxideBlasting */,
      11 /* Other */
    ]
  ]
]);
var paintOptionInputMappingValue = /* @__PURE__ */ new Map(
  [
    [0 /* System0Grey */, ["System 0", "INTERPRIME 198, 50 \xB5m"]],
    [
      1 /* System1White */,
      ["System 1, White RAL 9010", "INTERCURE 99, 100 \xB5m (RAL 9010)"]
    ],
    [
      2 /* System1Blue */,
      ["System 1, Blue RAL 5010", "INTERCURE 99, 100 \xB5m (RAL 5010)"]
    ],
    [
      3 /* System21GreenishGray */,
      ["System 2.1 Greenish Grey", "INTERZINC 22, 50 \xB5m"]
    ],
    [
      4 /* System22Silver */,
      ["System 2.2 Silver", "INTERZINC 22, 50 \xB5m + INTERTHERM 50, 25 \xB5m"]
    ],
    [
      5 /* System3White */,
      ["System 3 White", "INTERZINC 52, 80 \xB5m + INTERCURE 99, 240 \xB5m"]
    ],
    [
      6 /* System4White */,
      ["System 4 White", "INTERTHERM 228, 200 \xB5m"]
    ],
    [7 /* System5 */, ["System 5", "Aluminum oxide blasting"]],
    [8 /* System6 */, ["System 6", "Steel-grit blasting"]],
    [9 /* SystemE */, ["System E", "Customer specific"]]
  ]
);
var PaintColor = /* @__PURE__ */ ((PaintColor2) => {
  PaintColor2[PaintColor2["Grey"] = 0] = "Grey";
  PaintColor2[PaintColor2["White"] = 1] = "White";
  PaintColor2[PaintColor2["GreenishGrey"] = 2] = "GreenishGrey";
  PaintColor2[PaintColor2["Silver"] = 3] = "Silver";
  PaintColor2[PaintColor2["Blue"] = 4] = "Blue";
  PaintColor2[PaintColor2["Other"] = 5] = "Other";
  return PaintColor2;
})(PaintColor || {});
var paintColorMappingValue = /* @__PURE__ */ new Map([
  [0 /* Grey */, "Grey"],
  [1 /* White */, "White"],
  [2 /* GreenishGrey */, "Greenish Grey"],
  [3 /* Silver */, "Silver"],
  [4 /* Blue */, "Blue"],
  [5 /* Other */, "Other"]
]);
var PaintThickness = /* @__PURE__ */ ((PaintThickness2) => {
  PaintThickness2[PaintThickness2["_25"] = 0] = "_25";
  PaintThickness2[PaintThickness2["_50"] = 1] = "_50";
  PaintThickness2[PaintThickness2["_80"] = 2] = "_80";
  PaintThickness2[PaintThickness2["_100"] = 3] = "_100";
  PaintThickness2[PaintThickness2["_200"] = 4] = "_200";
  PaintThickness2[PaintThickness2["_240"] = 5] = "_240";
  PaintThickness2[PaintThickness2["Other"] = 6] = "Other";
  return PaintThickness2;
})(PaintThickness || {});
var paintThicknessMappingValue = /* @__PURE__ */ new Map([
  [0 /* _25 */, "25 \xB5m"],
  [1 /* _50 */, "50 \xB5m"],
  [2 /* _80 */, "80 \xB5m"],
  [3 /* _100 */, "100 \xB5m"],
  [4 /* _200 */, "200 \xB5m"],
  [5 /* _240 */, "240 \xB5m"],
  [6 /* Other */, "Other"]
]);

// src/enums/par-file.enum.ts
var Parfile = /* @__PURE__ */ ((Parfile2) => {
  Parfile2[Parfile2["NoOfferDrawing"] = 0] = "NoOfferDrawing";
  Parfile2[Parfile2["PDFDWGType"] = 1] = "PDFDWGType";
  Parfile2[Parfile2["PDFDWGSTEPMODEL"] = 2] = "PDFDWGSTEPMODEL";
  return Parfile2;
})(Parfile || {});

// src/enums/part-cascade-type.enum.ts
var PartCascadeType = /* @__PURE__ */ ((PartCascadeType2) => {
  PartCascadeType2[PartCascadeType2["Standard"] = 0] = "Standard";
  PartCascadeType2[PartCascadeType2["Kettle001"] = 1] = "Kettle001";
  PartCascadeType2[PartCascadeType2["Kettle002"] = 2] = "Kettle002";
  PartCascadeType2[PartCascadeType2["Kettle003"] = 3] = "Kettle003";
  PartCascadeType2[PartCascadeType2["CondGasSeparator"] = 4] = "CondGasSeparator";
  return PartCascadeType2;
})(PartCascadeType || {});
var partialCascadeTypeLableMapping = /* @__PURE__ */ new Map([
  [0 /* Standard */, "Standard"],
  [1 /* Kettle001 */, "Kettle 001"],
  [2 /* Kettle002 */, "Kettle 002"],
  [3 /* Kettle003 */, "Kettle 003"],
  [4 /* CondGasSeparator */, "Condenser-Gas-Separtor"]
]);

// src/enums/plate-material.enum.ts
var PlateMaterial = /* @__PURE__ */ ((PlateMaterial2) => {
  PlateMaterial2[PlateMaterial2["AISI316L"] = 1] = "AISI316L";
  PlateMaterial2[PlateMaterial2["Titanium"] = 2] = "Titanium";
  PlateMaterial2[PlateMaterial2["AISI904L"] = 3] = "AISI904L";
  PlateMaterial2[PlateMaterial2["_254SMO"] = 4] = "_254SMO";
  PlateMaterial2[PlateMaterial2["C22"] = 5] = "C22";
  PlateMaterial2[PlateMaterial2["Duplex2205"] = 6] = "Duplex2205";
  PlateMaterial2[PlateMaterial2["AISI304L"] = 7] = "AISI304L";
  PlateMaterial2[PlateMaterial2["DC_04_FEP04"] = 8] = "DC_04_FEP04";
  PlateMaterial2[PlateMaterial2["V_4432_SA240_316L"] = 9] = "V_4432_SA240_316L";
  PlateMaterial2[PlateMaterial2["V_4435_SA240_316L"] = 10] = "V_4435_SA240_316L";
  PlateMaterial2[PlateMaterial2["V_4501_SA240_UNS_S32760"] = 11] = "V_4501_SA240_UNS_S32760";
  PlateMaterial2[PlateMaterial2["V_4541_SA240_321"] = 12] = "V_4541_SA240_321";
  PlateMaterial2[PlateMaterial2["V_4571_SA240_316TI"] = 13] = "V_4571_SA240_316TI";
  PlateMaterial2[PlateMaterial2["V_4637_SA240_UNS_S82031"] = 14] = "V_4637_SA240_UNS_S82031";
  PlateMaterial2[PlateMaterial2["V_4835_SA240_UNS_S30815"] = 15] = "V_4835_SA240_UNS_S30815";
  PlateMaterial2[PlateMaterial2["V_4068_SB162_UNS_N02201"] = 16] = "V_4068_SB162_UNS_N02201";
  PlateMaterial2[PlateMaterial2["V_4605_SB575_UNS_N06059"] = 17] = "V_4605_SB575_UNS_N06059";
  PlateMaterial2[PlateMaterial2["V_4819_SB575_UNS_N10276"] = 18] = "V_4819_SB575_UNS_N10276";
  PlateMaterial2[PlateMaterial2["TITANIUM_GR_11"] = 19] = "TITANIUM_GR_11";
  PlateMaterial2[PlateMaterial2["OTHER"] = 20] = "OTHER";
  return PlateMaterial2;
})(PlateMaterial || {});
var plateMaterialSpec = {
  [1 /* AISI316L */]: {
    label: "AISI 316L",
    orpLabel: "1.4404 / SA240-316L",
    cpq: 1,
    orp: 1,
    sizing: 1,
    sizingMatrixIndex: 0
  },
  [2 /* Titanium */]: {
    label: "Titanium",
    orpLabel: "Titanium Gr.1",
    cpq: 2,
    orp: 2,
    sizing: 2,
    sizingMatrixIndex: 1
  },
  [3 /* AISI904L */]: {
    label: "AISI 904L",
    orpLabel: "1.4539 / SA240-UNS N08904",
    cpq: 3,
    orp: 3,
    sizing: 3,
    sizingMatrixIndex: 2
  },
  [4 /* _254SMO */]: {
    label: "254SMO",
    orpLabel: "1.4547 / SA240-UNS S31254",
    cpq: 4,
    orp: 4,
    sizing: 4,
    sizingMatrixIndex: 3
  },
  [5 /* C22 */]: {
    label: "C-22",
    orpLabel: "2.4602 / SB575-UNS N06022",
    cpq: 5,
    orp: 5,
    sizing: 5,
    sizingMatrixIndex: 4
  },
  [6 /* Duplex2205 */]: {
    label: "Duplex (2205)",
    orpLabel: "1.4462 / SA240-UNS S31803",
    cpq: 6,
    orp: 6,
    sizing: 6,
    sizingMatrixIndex: 5
  },
  [7 /* AISI304L */]: {
    label: "AISI 304L",
    orpLabel: "1.4307 / SA240-304L",
    cpq: 7,
    orp: 7,
    sizing: 7,
    sizingMatrixIndex: 6
  },
  [8 /* DC_04_FEP04 */]: {
    label: "DC 04 (FeP04)",
    orpLabel: "DC 04 (FeP04)",
    cpq: null,
    orp: 8,
    sizing: null,
    sizingMatrixIndex: null
  },
  [9 /* V_4432_SA240_316L */]: {
    label: "1.4432 / SA240-316L",
    orpLabel: "1.4432 / SA240-316L",
    cpq: null,
    orp: 9,
    sizing: null,
    sizingMatrixIndex: null
  },
  [10 /* V_4435_SA240_316L */]: {
    label: "1.4435 / SA240-316L",
    orpLabel: "1.4435 / SA240-316L",
    cpq: null,
    orp: 10,
    sizing: null,
    sizingMatrixIndex: null
  },
  [11 /* V_4501_SA240_UNS_S32760 */]: {
    label: "1.4501 / SA240-UNS S32760",
    orpLabel: "1.4501 / SA240-UNS S32760",
    cpq: null,
    orp: 11,
    sizing: null,
    sizingMatrixIndex: null
  },
  [12 /* V_4541_SA240_321 */]: {
    label: "1.4541 / SA240-321",
    orpLabel: "1.4541 / SA240-321",
    cpq: null,
    orp: 12,
    sizing: null,
    sizingMatrixIndex: null
  },
  [13 /* V_4571_SA240_316TI */]: {
    label: "1.4571 / SA240-316Ti",
    orpLabel: "1.4571 / SA240-316Ti",
    cpq: null,
    orp: 13,
    sizing: null,
    sizingMatrixIndex: null
  },
  [14 /* V_4637_SA240_UNS_S82031 */]: {
    label: "1.4637 / SA240-UNS S82031",
    orpLabel: "1.4637 / SA240-UNS S82031",
    cpq: null,
    orp: 14,
    sizing: null,
    sizingMatrixIndex: null
  },
  [15 /* V_4835_SA240_UNS_S30815 */]: {
    label: "1.4835 / SA240-UNS S30815",
    orpLabel: "1.4835 / SA240-UNS S30815",
    cpq: null,
    orp: 15,
    sizing: null,
    sizingMatrixIndex: null
  },
  [16 /* V_4068_SB162_UNS_N02201 */]: {
    label: "2.4068 / SB162-UNS N02201",
    orpLabel: "2.4068 / SB162-UNS N02201",
    cpq: null,
    orp: 16,
    sizing: null,
    sizingMatrixIndex: null
  },
  [17 /* V_4605_SB575_UNS_N06059 */]: {
    label: "2.4605 / SB575-UNS N06059",
    orpLabel: "2.4605 / SB575-UNS N06059",
    cpq: null,
    orp: 17,
    sizing: null,
    sizingMatrixIndex: null
  },
  [18 /* V_4819_SB575_UNS_N10276 */]: {
    label: "2.4819 / SB575-UNS N10276",
    orpLabel: "2.4819 / SB575-UNS N10276",
    cpq: null,
    orp: 18,
    sizing: null,
    sizingMatrixIndex: null
  },
  [19 /* TITANIUM_GR_11 */]: {
    label: "Titanium Gr.11",
    orpLabel: "Titanium Gr.11",
    cpq: null,
    orp: 19,
    sizing: null,
    sizingMatrixIndex: null
  },
  [20 /* OTHER */]: {
    label: "Other",
    orpLabel: "Other",
    cpq: null,
    orp: 20,
    sizing: null,
    sizingMatrixIndex: null
  }
};
var plateMaterialMappingLabel = new Map(
  Object.entries(plateMaterialSpec).map(([k, v]) => [
    Number(k),
    v.label
  ])
);
var orpPlateMaterialLabels = Object.fromEntries(
  Object.entries(plateMaterialSpec).map(([k, v]) => [Number(k), v.orpLabel])
);
var CpqPlateMaterial = Object.keys(plateMaterialSpec).map(Number).filter((m) => plateMaterialSpec[m].cpq !== null);
var OrpPlateMaterial = Object.keys(plateMaterialSpec).map(Number).filter((m) => plateMaterialSpec[m].orp !== null);
var SizeablePlateMaterial = Object.keys(plateMaterialSpec).map(Number).filter((m) => plateMaterialSpec[m].sizing !== null);

// src/enums/plate-shell-connection.enum.ts
var PlateShellConnection = /* @__PURE__ */ ((PlateShellConnection2) => {
  PlateShellConnection2[PlateShellConnection2["StubEnds"] = 0] = "StubEnds";
  PlateShellConnection2[PlateShellConnection2["ENFlanges"] = 1] = "ENFlanges";
  PlateShellConnection2[PlateShellConnection2["ANSIFlanges"] = 2] = "ANSIFlanges";
  PlateShellConnection2[PlateShellConnection2["MaleThread"] = 3] = "MaleThread";
  PlateShellConnection2[PlateShellConnection2["EnFlangesCS"] = 5] = "EnFlangesCS";
  PlateShellConnection2[PlateShellConnection2["ANSIFlangesCS"] = 6] = "ANSIFlangesCS";
  PlateShellConnection2[PlateShellConnection2["ENFlangesTitanium"] = 7] = "ENFlangesTitanium";
  PlateShellConnection2[PlateShellConnection2["ANSIFlangesTitanium"] = 8] = "ANSIFlangesTitanium";
  PlateShellConnection2[PlateShellConnection2["StubEndSTReduced"] = 9] = "StubEndSTReduced";
  PlateShellConnection2[PlateShellConnection2["StubEndClient"] = 10] = "StubEndClient";
  return PlateShellConnection2;
})(PlateShellConnection || {});
var plateShellConnectionMappingLabel = /* @__PURE__ */ new Map([
  [0 /* StubEnds */, "Stub ends"],
  [1 /* ENFlanges */, "EN-Flanges-SS"],
  [2 /* ANSIFlanges */, "ANSI-Flanges-SS"],
  [3 /* MaleThread */, "Male Thread"],
  [5 /* EnFlangesCS */, "EN-Flanges-CS"],
  [6 /* ANSIFlangesCS */, "ANSI-Flanges-CS"],
  [7 /* ENFlangesTitanium */, "EN-Flanges-Titanium"],
  [8 /* ANSIFlangesTitanium */, "ANSI-Flanges-Titanium"],
  [9 /* StubEndSTReduced */, "Stub-End-ST-Reduced"],
  [10 /* StubEndClient */, "Stub-End-Client"]
]);

// src/enums/plate-thickness-option.enum.ts
var PlateThicknessOption = /* @__PURE__ */ ((PlateThicknessOption2) => {
  PlateThicknessOption2[PlateThicknessOption2["ZeroDotSevenMillimeter"] = 0] = "ZeroDotSevenMillimeter";
  PlateThicknessOption2[PlateThicknessOption2["ZeroDotEightMillimeter"] = 1] = "ZeroDotEightMillimeter";
  PlateThicknessOption2[PlateThicknessOption2["OneMillimeter"] = 2] = "OneMillimeter";
  PlateThicknessOption2[PlateThicknessOption2["OneDotTwoMillimeter"] = 3] = "OneDotTwoMillimeter";
  PlateThicknessOption2[PlateThicknessOption2["OneDotTwentyFiveMillimeter"] = 4] = "OneDotTwentyFiveMillimeter";
  PlateThicknessOption2[PlateThicknessOption2["OneDotFiveMillimeter"] = 5] = "OneDotFiveMillimeter";
  PlateThicknessOption2[PlateThicknessOption2["ZeroDotNinetySevenMillimeter"] = 6] = "ZeroDotNinetySevenMillimeter";
  return PlateThicknessOption2;
})(PlateThicknessOption || {});
var plateThicknessOptionValueMapping = /* @__PURE__ */ new Map([
  [0 /* ZeroDotSevenMillimeter */, 0.7],
  [1 /* ZeroDotEightMillimeter */, 0.8],
  [6 /* ZeroDotNinetySevenMillimeter */, 0.97],
  [2 /* OneMillimeter */, 1],
  [3 /* OneDotTwoMillimeter */, 1.2],
  [4 /* OneDotTwentyFiveMillimeter */, 1.25],
  [5 /* OneDotFiveMillimeter */, 1.5]
]);
var plateThicknessOptionMappingLabel = /* @__PURE__ */ new Map([
  [0 /* ZeroDotSevenMillimeter */, "0.7 mm"],
  [1 /* ZeroDotEightMillimeter */, "0.8 mm"],
  [6 /* ZeroDotNinetySevenMillimeter */, "0.97 mm"],
  [2 /* OneMillimeter */, "1.0 mm"],
  [3 /* OneDotTwoMillimeter */, "1.2 mm"],
  [4 /* OneDotTwentyFiveMillimeter */, "1.25 mm"],
  [5 /* OneDotFiveMillimeter */, "1.5 mm"]
]);

// src/enums/plate-type-option.enum.ts
var PlateTypeOption = /* @__PURE__ */ ((PlateTypeOption2) => {
  PlateTypeOption2[PlateTypeOption2["HH"] = 0] = "HH";
  PlateTypeOption2[PlateTypeOption2["LL"] = 1] = "LL";
  PlateTypeOption2[PlateTypeOption2["HA"] = 2] = "HA";
  PlateTypeOption2[PlateTypeOption2["TH"] = 3] = "TH";
  PlateTypeOption2[PlateTypeOption2["WA"] = 4] = "WA";
  PlateTypeOption2[PlateTypeOption2["LA"] = 5] = "LA";
  PlateTypeOption2[PlateTypeOption2["WH"] = 6] = "WH";
  PlateTypeOption2[PlateTypeOption2["WL"] = 7] = "WL";
  PlateTypeOption2[PlateTypeOption2["SH"] = 8] = "SH";
  PlateTypeOption2[PlateTypeOption2["GH"] = 9] = "GH";
  PlateTypeOption2[PlateTypeOption2["TWO_R"] = 10] = "TWO_R";
  return PlateTypeOption2;
})(PlateTypeOption || {});
var plateTypeOptionSpec = {
  [0 /* HH */]: { label: "HH=1", cpq: 0, orp: 0, sizing: 1 },
  [1 /* LL */]: { label: "LL=2", cpq: 1, orp: 1, sizing: 2 },
  [2 /* HA */]: { label: "HA=3", cpq: 2, orp: 2, sizing: 3 },
  [3 /* TH */]: { label: "TH=3", cpq: 3, orp: 3, sizing: 3 },
  [4 /* WA */]: { label: "WA=3", cpq: 4, orp: 4, sizing: 3 },
  [5 /* LA */]: { label: "LA=4", cpq: 5, orp: 5, sizing: 4 },
  [6 /* WH */]: { label: "WH=7", cpq: 6, orp: 6, sizing: 7 },
  [7 /* WL */]: { label: "WL=9", cpq: 7, orp: 7, sizing: 9 },
  [8 /* SH */]: { label: "SH=11", cpq: 8, orp: 8, sizing: 11 },
  [9 /* GH */]: { label: "GH", cpq: null, orp: 9, sizing: null },
  [10 /* TWO_R */]: { label: "2R", cpq: null, orp: 10, sizing: null }
};
var plateTypeOptionMappingValue = new Map(
  Object.keys(plateTypeOptionSpec).map(Number).filter((p) => plateTypeOptionSpec[p].sizing !== null).map((p) => [p, plateTypeOptionSpec[p].sizing])
);
var plateTypeOptionsBySizingValue = Object.keys(plateTypeOptionSpec).map(Number).reduce(
  (bySizing, p) => {
    var _a;
    const sizing = plateTypeOptionSpec[p].sizing;
    if (sizing === null) return bySizing;
    return bySizing.set(sizing, [...(_a = bySizing.get(sizing)) != null ? _a : [], p]);
  },
  /* @__PURE__ */ new Map()
);
var resolveSizingPlateType = (previous, sizingValue) => {
  const candidates = plateTypeOptionsBySizingValue.get(sizingValue);
  if (!candidates) throw new Error("SizingDLL return internal error");
  return candidates.length === 1 ? candidates[0] : previous;
};
var plateTypeOptionMappingLabel = new Map(
  Object.entries(plateTypeOptionSpec).map(([k, v]) => [
    Number(k),
    v.label
  ])
);
var CpqPlateType = Object.keys(plateTypeOptionSpec).map(Number).filter((p) => plateTypeOptionSpec[p].cpq !== null);
var OrpPlateType = Object.keys(plateTypeOptionSpec).map(Number).filter((p) => plateTypeOptionSpec[p].orp !== null);

// src/enums/position-comment-type.enum.ts
var PositionCommentType = /* @__PURE__ */ ((PositionCommentType2) => {
  PositionCommentType2[PositionCommentType2["ShellComment"] = 0] = "ShellComment";
  PositionCommentType2[PositionCommentType2["PlateComment"] = 1] = "PlateComment";
  PositionCommentType2[PositionCommentType2["FDMComment"] = 2] = "FDMComment";
  PositionCommentType2[PositionCommentType2["MultiComment"] = 3] = "MultiComment";
  PositionCommentType2[PositionCommentType2["PaintComment"] = 4] = "PaintComment";
  PositionCommentType2[PositionCommentType2["FeetComment"] = 5] = "FeetComment";
  PositionCommentType2[PositionCommentType2["NozzlePlateComment"] = 6] = "NozzlePlateComment";
  PositionCommentType2[PositionCommentType2["NozzleShell1Comment"] = 7] = "NozzleShell1Comment";
  PositionCommentType2[PositionCommentType2["NozzleShell2Comment"] = 8] = "NozzleShell2Comment";
  PositionCommentType2[PositionCommentType2["NozzleShell3Comment"] = 9] = "NozzleShell3Comment";
  PositionCommentType2[PositionCommentType2["FlangeShell1Comment"] = 10] = "FlangeShell1Comment";
  PositionCommentType2[PositionCommentType2["FlangeShell2Comment"] = 11] = "FlangeShell2Comment";
  PositionCommentType2[PositionCommentType2["FlangeShell3Comment"] = 12] = "FlangeShell3Comment";
  PositionCommentType2[PositionCommentType2["OtherComment"] = 13] = "OtherComment";
  PositionCommentType2[PositionCommentType2["ShellPriceFixedPartComment"] = 14] = "ShellPriceFixedPartComment";
  PositionCommentType2[PositionCommentType2["ShellPricePerPlateComment"] = 15] = "ShellPricePerPlateComment";
  PositionCommentType2[PositionCommentType2["PositionComment"] = 16] = "PositionComment";
  return PositionCommentType2;
})(PositionCommentType || {});

// src/enums/shell-diameter.enum.ts
var ShellDiameter = /* @__PURE__ */ ((ShellDiameter2) => {
  ShellDiameter2[ShellDiameter2["_213"] = 213] = "_213";
  ShellDiameter2[ShellDiameter2["_267"] = 267] = "_267";
  ShellDiameter2[ShellDiameter2["_340"] = 340] = "_340";
  ShellDiameter2[ShellDiameter2["_380"] = 380] = "_380";
  ShellDiameter2[ShellDiameter2["_490"] = 490] = "_490";
  ShellDiameter2[ShellDiameter2["_590"] = 590] = "_590";
  ShellDiameter2[ShellDiameter2["_640"] = 640] = "_640";
  ShellDiameter2[ShellDiameter2["_730"] = 730] = "_730";
  ShellDiameter2[ShellDiameter2["_820"] = 820] = "_820";
  ShellDiameter2[ShellDiameter2["_960"] = 960] = "_960";
  ShellDiameter2[ShellDiameter2["_1100"] = 1100] = "_1100";
  ShellDiameter2[ShellDiameter2["_1310"] = 1310] = "_1310";
  ShellDiameter2[ShellDiameter2["_1350"] = 1350] = "_1350";
  ShellDiameter2[ShellDiameter2["_1550"] = 1550] = "_1550";
  ShellDiameter2[ShellDiameter2["_1800"] = 1800] = "_1800";
  return ShellDiameter2;
})(ShellDiameter || {});

// src/enums/shell-material.enum.ts
var ShellMaterial = /* @__PURE__ */ ((ShellMaterial2) => {
  ShellMaterial2[ShellMaterial2["AISI316L_316"] = 0] = "AISI316L_316";
  ShellMaterial2[ShellMaterial2["CarbonSteel"] = 1] = "CarbonSteel";
  ShellMaterial2[ShellMaterial2["_254SMO"] = -3] = "_254SMO";
  ShellMaterial2[ShellMaterial2["Duplex2205"] = -2] = "Duplex2205";
  ShellMaterial2[ShellMaterial2["AISI304L"] = -1] = "AISI304L";
  ShellMaterial2[ShellMaterial2["OTHER"] = 2] = "OTHER";
  return ShellMaterial2;
})(ShellMaterial || {});
var shellMaterialSpec = {
  [0 /* AISI316L_316 */]: {
    label: "AISI 316L/316",
    orpLabel: "AISI 316L / 316",
    orp: 0,
    sizing: 0
  },
  [1 /* CarbonSteel */]: {
    label: "Carbon Steel",
    orpLabel: "Carbon steel",
    orp: 1,
    sizing: 1
  },
  [-3 /* _254SMO */]: {
    label: "254SMO",
    orpLabel: "254 SMO",
    orp: null,
    sizing: -3
  },
  [-2 /* Duplex2205 */]: {
    label: "Duplex (2205)",
    orpLabel: "Duplex 2205",
    orp: null,
    sizing: -2
  },
  [-1 /* AISI304L */]: {
    label: "AISI 304L",
    orpLabel: "AISI 304L / 304",
    orp: -1,
    sizing: -1
  },
  [2 /* OTHER */]: {
    label: "Other",
    orpLabel: "Other",
    orp: 2,
    sizing: null
  }
};
var shellMaterialMappingLabel = new Map(
  Object.entries(shellMaterialSpec).map(([k, v]) => [
    Number(k),
    v.label
  ])
);
var orpShellMaterialLabels = Object.fromEntries(
  Object.entries(shellMaterialSpec).map(([k, v]) => [Number(k), v.orpLabel])
);
var CpqShellMaterial = Object.keys(shellMaterialSpec).map(Number).filter((m) => shellMaterialSpec[m].sizing !== null);
var OrpShellMaterial = Object.keys(shellMaterialSpec).map(Number).filter((m) => shellMaterialSpec[m].orp !== null);

// src/enums/size.enum.ts
var Size = /* @__PURE__ */ ((Size8) => {
  Size8[Size8["Size2"] = 2] = "Size2";
  Size8[Size8["Size3"] = 3] = "Size3";
  Size8[Size8["Size4"] = 4] = "Size4";
  Size8[Size8["Size5"] = 5] = "Size5";
  Size8[Size8["Size6"] = 6] = "Size6";
  Size8[Size8["Size7"] = 7] = "Size7";
  Size8[Size8["Size9"] = 9] = "Size9";
  Size8[Size8["Size12"] = 12] = "Size12";
  Size8[Size8["Size14"] = 14] = "Size14";
  return Size8;
})(Size || {});
var sizeMappingLabel = /* @__PURE__ */ new Map([
  [2 /* Size2 */, "Size 2"],
  [3 /* Size3 */, "Size 3"],
  [4 /* Size4 */, "Size 4"],
  [5 /* Size5 */, "Size 5"],
  [6 /* Size6 */, "Size 6"],
  [7 /* Size7 */, "Size 7"],
  [9 /* Size9 */, "Size 9"],
  [12 /* Size12 */, "Size 12"],
  [14 /* Size14 */, "Size 14"]
]);

// src/enums/unit-model.enum.ts
var UnitDynamicViscosityOption = /* @__PURE__ */ ((UnitDynamicViscosityOption2) => {
  UnitDynamicViscosityOption2[UnitDynamicViscosityOption2["kgms"] = 0] = "kgms";
  UnitDynamicViscosityOption2[UnitDynamicViscosityOption2["Poise"] = 1] = "Poise";
  UnitDynamicViscosityOption2[UnitDynamicViscosityOption2["cP"] = 2] = "cP";
  UnitDynamicViscosityOption2[UnitDynamicViscosityOption2["MPas"] = 3] = "MPas";
  UnitDynamicViscosityOption2[UnitDynamicViscosityOption2["lbf_s_in2"] = 4] = "lbf_s_in2";
  UnitDynamicViscosityOption2[UnitDynamicViscosityOption2["lbf_s_ft2"] = 5] = "lbf_s_ft2";
  return UnitDynamicViscosityOption2;
})(UnitDynamicViscosityOption || {});
var unitDynamicViscosityOptionLabelMapping = /* @__PURE__ */ new Map([
  [0 /* kgms */, "kg/ms"],
  [1 /* Poise */, "Poise"],
  [2 /* cP */, "cP"],
  [3 /* MPas */, "mPas"],
  [4 /* lbf_s_in2 */, "lbf s /in\xB2"],
  [5 /* lbf_s_ft2 */, "lbf s /ft\xB2"]
]);
var unitDynamicViscosityLabelOptionMapping = /* @__PURE__ */ new Map([
  ["kg/ms", 0 /* kgms */],
  ["Poise", 1 /* Poise */],
  ["cP", 2 /* cP */],
  ["mPas", 3 /* MPas */],
  ["lbf s /in\xB2", 4 /* lbf_s_in2 */],
  ["lbf s /ft\xB2", 5 /* lbf_s_ft2 */]
]);
var UnitSpecificGravityOption = /* @__PURE__ */ ((UnitSpecificGravityOption2) => {
  UnitSpecificGravityOption2[UnitSpecificGravityOption2["kgm3"] = 0] = "kgm3";
  UnitSpecificGravityOption2[UnitSpecificGravityOption2["gcm3"] = 1] = "gcm3";
  UnitSpecificGravityOption2[UnitSpecificGravityOption2["ozin3"] = 2] = "ozin3";
  UnitSpecificGravityOption2[UnitSpecificGravityOption2["ozgal_UK"] = 3] = "ozgal_UK";
  UnitSpecificGravityOption2[UnitSpecificGravityOption2["ozgal_US"] = 4] = "ozgal_US";
  UnitSpecificGravityOption2[UnitSpecificGravityOption2["lbgal_UK"] = 5] = "lbgal_UK";
  UnitSpecificGravityOption2[UnitSpecificGravityOption2["lbgal_US"] = 6] = "lbgal_US";
  UnitSpecificGravityOption2[UnitSpecificGravityOption2["lbin3"] = 7] = "lbin3";
  UnitSpecificGravityOption2[UnitSpecificGravityOption2["lbft3"] = 8] = "lbft3";
  UnitSpecificGravityOption2[UnitSpecificGravityOption2["lbyd3"] = 9] = "lbyd3";
  return UnitSpecificGravityOption2;
})(UnitSpecificGravityOption || {});
var unitSpecificGravityOptionLabelInputMapping = /* @__PURE__ */ new Map([
  [0 /* kgm3 */, "kg/m\xB3"],
  [1 /* gcm3 */, "g/cm\xB3"],
  [2 /* ozin3 */, "oz/in\xB3"],
  [3 /* ozgal_UK */, "oz/gal (UK)"],
  [4 /* ozgal_US */, "oz/gal (US)"],
  [5 /* lbgal_UK */, "lb/gal (UK)"],
  [6 /* lbgal_US */, "lb/gal (US)"],
  [7 /* lbin3 */, "lb/in\xB3"],
  [8 /* lbft3 */, "lb/ft\xB3"],
  [9 /* lbyd3 */, "lb/yd\xB3"]
]);
var unitSpecificGravityOptionLabelCalculateMapping = /* @__PURE__ */ new Map([
  [0 /* kgm3 */, "kg/m3"],
  [1 /* gcm3 */, "g/cm3"],
  [2 /* ozin3 */, "oz/in3"],
  [3 /* ozgal_UK */, "oz/gal (UK)"],
  [4 /* ozgal_US */, "oz/gal (US)"],
  [5 /* lbgal_UK */, "lb/gal (UK)"],
  [6 /* lbgal_US */, "lb/gal (US)"],
  [7 /* lbin3 */, "lb/in3"],
  [8 /* lbft3 */, "lb/ft3"],
  [9 /* lbyd3 */, "lb/yd3"]
]);
var unitSpecificGravityLabelOptionCalculateMapping = /* @__PURE__ */ new Map([
  ["kg/m3", 0 /* kgm3 */],
  ["g/cm3", 1 /* gcm3 */],
  ["oz/in3", 2 /* ozin3 */],
  ["oz/gal (UK)", 3 /* ozgal_UK */],
  ["oz/gal (US)", 4 /* ozgal_US */],
  ["lb/gal (UK)", 5 /* lbgal_UK */],
  ["lb/gal (US)", 6 /* lbgal_US */],
  ["lb/in3", 7 /* lbin3 */],
  ["lb/ft3", 8 /* lbft3 */],
  ["lb/yd3", 9 /* lbyd3 */]
]);
var UnitSpecificHeatOption = /* @__PURE__ */ ((UnitSpecificHeatOption2) => {
  UnitSpecificHeatOption2[UnitSpecificHeatOption2["JkgK"] = 0] = "JkgK";
  UnitSpecificHeatOption2[UnitSpecificHeatOption2["calgC"] = 1] = "calgC";
  UnitSpecificHeatOption2[UnitSpecificHeatOption2["kcalkgC"] = 2] = "kcalkgC";
  UnitSpecificHeatOption2[UnitSpecificHeatOption2["btulbF"] = 3] = "btulbF";
  return UnitSpecificHeatOption2;
})(UnitSpecificHeatOption || {});
var unitSpecificHeatOptionLabelMapping = /* @__PURE__ */ new Map([
  [0 /* JkgK */, "J/kgK"],
  [1 /* calgC */, "cal/(g\xB0C)"],
  [2 /* kcalkgC */, "kcal/(kg\xB0C)"],
  [3 /* btulbF */, "Btu/(lb\xB0F)"]
]);
var unitSpecificHeatLabelOptionMapping = /* @__PURE__ */ new Map([
  ["J/kgK", 0 /* JkgK */],
  ["cal/(g\xB0C)", 1 /* calgC */],
  ["kcal/(kg\xB0C)", 2 /* kcalkgC */],
  ["Btu/(lb\xB0F)", 3 /* btulbF */]
]);
var UnitThermalConductivityOption = /* @__PURE__ */ ((UnitThermalConductivityOption2) => {
  UnitThermalConductivityOption2[UnitThermalConductivityOption2["WmK"] = 0] = "WmK";
  UnitThermalConductivityOption2[UnitThermalConductivityOption2["Btu_ins_ft2_F"] = 1] = "Btu_ins_ft2_F";
  UnitThermalConductivityOption2[UnitThermalConductivityOption2["Btu_inh_ft2_F"] = 2] = "Btu_inh_ft2_F";
  UnitThermalConductivityOption2[UnitThermalConductivityOption2["Btu_fth_ft2_F"] = 3] = "Btu_fth_ft2_F";
  UnitThermalConductivityOption2[UnitThermalConductivityOption2["cals_cm_C"] = 4] = "cals_cm_C";
  UnitThermalConductivityOption2[UnitThermalConductivityOption2["kcalh_m_C"] = 5] = "kcalh_m_C";
  return UnitThermalConductivityOption2;
})(UnitThermalConductivityOption || {});
var unitThermalConductivityOptionLabelInputMapping = /* @__PURE__ */ new Map([
  [0 /* WmK */, "W/mK"],
  [1 /* Btu_ins_ft2_F */, "Btu in/(s ft\xB2 \xB0F)"],
  [2 /* Btu_inh_ft2_F */, "Btu in/(h ft\xB2 \xB0F)"],
  [3 /* Btu_fth_ft2_F */, "Btu ft/(h ft\xB2 \xB0F)"],
  [4 /* cals_cm_C */, "cal/(s cm \xB0C)"],
  [5 /* kcalh_m_C */, "kcal/(h m \xB0C)"]
]);
var unitThermalConductivityOptionLabelCalculateMapping = /* @__PURE__ */ new Map([
  [0 /* WmK */, "W/mK"],
  [1 /* Btu_ins_ft2_F */, "Btu in/(s ft2 \xB0F)"],
  [2 /* Btu_inh_ft2_F */, "Btu in/(h ft2 \xB0F)"],
  [3 /* Btu_fth_ft2_F */, "Btu ft/(h ft2 \xB0F)"],
  [4 /* cals_cm_C */, "cal/(s cm \xB0C)"],
  [5 /* kcalh_m_C */, "kcal/(h m \xB0C)"]
]);
var unitThermalConductivityLabelOptionCalculateMapping = /* @__PURE__ */ new Map([
  ["W/mK", 0 /* WmK */],
  ["Btu in/(s ft2 \xB0F)", 1 /* Btu_ins_ft2_F */],
  ["Btu in/(h ft2 \xB0F)", 2 /* Btu_inh_ft2_F */],
  ["Btu ft/(h ft2 \xB0F)", 3 /* Btu_fth_ft2_F */],
  ["cal/(s cm \xB0C)", 4 /* cals_cm_C */],
  ["kcal/(h m \xB0C)", 5 /* kcalh_m_C */]
]);
var UnitPressureOption = /* @__PURE__ */ ((UnitPressureOption2) => {
  UnitPressureOption2[UnitPressureOption2["kPa"] = 0] = "kPa";
  UnitPressureOption2[UnitPressureOption2["MPa"] = 1] = "MPa";
  UnitPressureOption2[UnitPressureOption2["bar"] = 2] = "bar";
  UnitPressureOption2[UnitPressureOption2["mmHg"] = 3] = "mmHg";
  UnitPressureOption2[UnitPressureOption2["atm"] = 4] = "atm";
  UnitPressureOption2[UnitPressureOption2["Torr"] = 5] = "Torr";
  UnitPressureOption2[UnitPressureOption2["Psi"] = 6] = "Psi";
  UnitPressureOption2[UnitPressureOption2["lbin2"] = 7] = "lbin2";
  UnitPressureOption2[UnitPressureOption2["lbft2"] = 8] = "lbft2";
  UnitPressureOption2[UnitPressureOption2["mBar"] = 9] = "mBar";
  return UnitPressureOption2;
})(UnitPressureOption || {});
var unitPressureOptionLabelInputMapping = /* @__PURE__ */ new Map([
  [0 /* kPa */, "kPa"],
  [1 /* MPa */, "MPa"],
  [2 /* bar */, "bar(a)"],
  [3 /* mmHg */, "mmHg"],
  [4 /* atm */, "atm"],
  [5 /* Torr */, "Torr"],
  [6 /* Psi */, "Psi"],
  [7 /* lbin2 */, "lb/in2"],
  [8 /* lbft2 */, "lb/ft2"],
  [9 /* mBar */, "mbar"]
]);
var unitPressureOptionLabelCalculatelMapping = /* @__PURE__ */ new Map([
  [0 /* kPa */, "kPa"],
  [1 /* MPa */, "MPa"],
  [2 /* bar */, "bar(a)"],
  [3 /* mmHg */, "mmHg"],
  [4 /* atm */, "atm"],
  [5 /* Torr */, "Torr"],
  [6 /* Psi */, "Psi"],
  [7 /* lbin2 */, "lb/in2"],
  [8 /* lbft2 */, "lb/ft2"],
  [9 /* mBar */, "mbar"]
]);
var unitPressureLabelOptionCalculateMapping = /* @__PURE__ */ new Map([
  ["kPa", 0 /* kPa */],
  ["MPa", 1 /* MPa */],
  ["bar(a)", 2 /* bar */],
  ["mmHg", 3 /* mmHg */],
  ["atm", 4 /* atm */],
  ["Torr", 5 /* Torr */],
  ["Psi", 6 /* Psi */],
  ["lb/in2", 7 /* lbin2 */],
  ["lb/ft2", 8 /* lbft2 */],
  ["mbar", 9 /* mBar */],
  ["bar", 2 /* bar */]
]);
var UnitDesignPressureOption = /* @__PURE__ */ ((UnitDesignPressureOption2) => {
  UnitDesignPressureOption2[UnitDesignPressureOption2["kPa"] = 0] = "kPa";
  UnitDesignPressureOption2[UnitDesignPressureOption2["MPa"] = 1] = "MPa";
  UnitDesignPressureOption2[UnitDesignPressureOption2["bar"] = 2] = "bar";
  UnitDesignPressureOption2[UnitDesignPressureOption2["mmHg"] = 3] = "mmHg";
  UnitDesignPressureOption2[UnitDesignPressureOption2["atm"] = 4] = "atm";
  UnitDesignPressureOption2[UnitDesignPressureOption2["Torr"] = 5] = "Torr";
  UnitDesignPressureOption2[UnitDesignPressureOption2["psi"] = 6] = "psi";
  UnitDesignPressureOption2[UnitDesignPressureOption2["lbin2"] = 7] = "lbin2";
  UnitDesignPressureOption2[UnitDesignPressureOption2["lbft2"] = 8] = "lbft2";
  return UnitDesignPressureOption2;
})(UnitDesignPressureOption || {});
var unitDesignPressureLabelOptionMapping = /* @__PURE__ */ new Map([
  ["kPa(g)", 0 /* kPa */],
  ["MPa(g)", 1 /* MPa */],
  ["bar(g)", 2 /* bar */],
  ["mmHg", 3 /* mmHg */],
  ["atm", 4 /* atm */],
  ["Torr", 5 /* Torr */],
  ["psi(g)", 6 /* psi */],
  ["lb/in\xB2", 7 /* lbin2 */],
  ["lb/ft\xB2", 8 /* lbft2 */]
]);
var unitDesignPressureOptionMappingLabel = /* @__PURE__ */ new Map([
  [0 /* kPa */, "kPa(g)"],
  [1 /* MPa */, "MPa(g)"],
  [2 /* bar */, "bar(g)"],
  [3 /* mmHg */, "mmHg"],
  [4 /* atm */, "atm"],
  [5 /* Torr */, "Torr"],
  [6 /* psi */, "psi(g)"],
  [7 /* lbin2 */, "lb/in\xB2"],
  [8 /* lbft2 */, "lb/ft\xB2"]
]);
var UnitMassFlowOption = /* @__PURE__ */ ((UnitMassFlowOption2) => {
  UnitMassFlowOption2[UnitMassFlowOption2["kgs"] = 0] = "kgs";
  UnitMassFlowOption2[UnitMassFlowOption2["lbs"] = 1] = "lbs";
  UnitMassFlowOption2[UnitMassFlowOption2["kgh"] = 2] = "kgh";
  UnitMassFlowOption2[UnitMassFlowOption2["lbh"] = 3] = "lbh";
  UnitMassFlowOption2[UnitMassFlowOption2["US_tons"] = 4] = "US_tons";
  UnitMassFlowOption2[UnitMassFlowOption2["UK_tons"] = 5] = "UK_tons";
  return UnitMassFlowOption2;
})(UnitMassFlowOption || {});
var unitMassFlowOptionLabelMapping = /* @__PURE__ */ new Map([
  [0 /* kgs */, "kg/s"],
  [1 /* lbs */, "lb/s"],
  [2 /* kgh */, "kg/h"],
  [3 /* lbh */, "lb/h"],
  [4 /* US_tons */, "US ton/s"],
  [5 /* UK_tons */, "UK ton/s"]
]);
var unitMassFlowLabelOptionMapping = /* @__PURE__ */ new Map([
  ["kg/s", 0 /* kgs */],
  ["lb/s", 1 /* lbs */],
  ["kg/h", 2 /* kgh */],
  ["lb/h", 3 /* lbh */],
  ["US ton/s", 4 /* US_tons */],
  ["UK ton/s", 5 /* UK_tons */]
]);
var UnitAreaOption = /* @__PURE__ */ ((UnitAreaOption2) => {
  UnitAreaOption2[UnitAreaOption2["m2"] = 0] = "m2";
  UnitAreaOption2[UnitAreaOption2["in2"] = 1] = "in2";
  UnitAreaOption2[UnitAreaOption2["ft2"] = 2] = "ft2";
  UnitAreaOption2[UnitAreaOption2["yd2"] = 3] = "yd2";
  return UnitAreaOption2;
})(UnitAreaOption || {});
var unitAreaOptionLabelInputMapping = /* @__PURE__ */ new Map([
  [0 /* m2 */, "m\xB2"],
  [1 /* in2 */, "in\xB2"],
  [2 /* ft2 */, "ft\xB2"],
  [3 /* yd2 */, "yd\xB2"]
]);
var unitAreaOptionLabelCalculateMapping = /* @__PURE__ */ new Map([
  [0 /* m2 */, "m2"],
  [1 /* in2 */, "in2"],
  [2 /* ft2 */, "ft2"],
  [3 /* yd2 */, "yd2"]
]);
var unitAreaLabelOptionCalculateMapping = /* @__PURE__ */ new Map([
  ["m2", 0 /* m2 */],
  ["in2", 1 /* in2 */],
  ["ft2", 2 /* ft2 */],
  ["yd2", 3 /* yd2 */]
]);
var UnitKValueOption = /* @__PURE__ */ ((UnitKValueOption2) => {
  UnitKValueOption2[UnitKValueOption2["Wm2K"] = 0] = "Wm2K";
  UnitKValueOption2[UnitKValueOption2["Btuhft2F"] = 1] = "Btuhft2F";
  UnitKValueOption2[UnitKValueOption2["Btusft2F"] = 2] = "Btusft2F";
  UnitKValueOption2[UnitKValueOption2["kcalhm2C"] = 3] = "kcalhm2C";
  UnitKValueOption2[UnitKValueOption2["calscm2C"] = 4] = "calscm2C";
  return UnitKValueOption2;
})(UnitKValueOption || {});
var unitKValueOptionLabelInputMapping = /* @__PURE__ */ new Map([
  [0 /* Wm2K */, "W/m\xB2K"],
  [1 /* Btuhft2F */, "Btu/(h.ft\xB2.\xB0F)"],
  [2 /* Btusft2F */, "Btu/(s.ft\xB2.\xB0F)"],
  [3 /* kcalhm2C */, "kcal/(h.m\xB2.\xB0C)"],
  [4 /* calscm2C */, "cal/(s.cm\xB2.\xB0C)"]
]);
var unitKValueOptionLabelCalculateMapping = /* @__PURE__ */ new Map([
  [0 /* Wm2K */, "W/m2K"],
  [1 /* Btuhft2F */, "Btu/(h.ft2.\xB0F)"],
  [2 /* Btusft2F */, "Btu/(s.ft2.\xB0F)"],
  [3 /* kcalhm2C */, "kcal/(h.m2.\xB0C)"],
  [4 /* calscm2C */, "cal/(s.cm2.\xB0C)"]
]);
var unitKValueLabelOptionMapping = /* @__PURE__ */ new Map([
  ["W/m2K", 0 /* Wm2K */],
  ["Btu/(h.ft2.\xB0F)", 1 /* Btuhft2F */],
  ["Btu/(s.ft2.\xB0F)", 2 /* Btusft2F */],
  ["kcal/(h.m2.\xB0C)", 3 /* kcalhm2C */],
  ["cal/(s.cm2.\xB0C)", 4 /* calscm2C */]
]);
var UnitFoulingFactorOption = /* @__PURE__ */ ((UnitFoulingFactorOption2) => {
  UnitFoulingFactorOption2[UnitFoulingFactorOption2["m2KW"] = 0] = "m2KW";
  UnitFoulingFactorOption2[UnitFoulingFactorOption2["hft2FBtu"] = 1] = "hft2FBtu";
  UnitFoulingFactorOption2[UnitFoulingFactorOption2["sft2FBtu"] = 2] = "sft2FBtu";
  UnitFoulingFactorOption2[UnitFoulingFactorOption2["hm2Ckcal"] = 3] = "hm2Ckcal";
  UnitFoulingFactorOption2[UnitFoulingFactorOption2["scm2Ccal"] = 4] = "scm2Ccal";
  return UnitFoulingFactorOption2;
})(UnitFoulingFactorOption || {});
var unitFoulingFactorOptionLabelInputMapping = /* @__PURE__ */ new Map([
  [0 /* m2KW */, "m\xB2K/W"],
  [1 /* hft2FBtu */, "(h.ft\xB2.\xB0F)/Btu"],
  [2 /* sft2FBtu */, "(s.ft\xB2.\xB0F)/Btu"],
  [3 /* hm2Ckcal */, "(h.m\xB2.\xB0C)/kcal"],
  [4 /* scm2Ccal */, "(s.cm\xB2.\xB0C)/cal"]
]);
var unitFoulingFactorOptionLabelCalculateMapping = /* @__PURE__ */ new Map([
  [0 /* m2KW */, "m2K/W"],
  [1 /* hft2FBtu */, "(h.ft2.\xB0F)/Btu"],
  [2 /* sft2FBtu */, "(s.ft2.\xB0F)/Btu"],
  [3 /* hm2Ckcal */, "(h.m2.\xB0C)/kcal"],
  [4 /* scm2Ccal */, "(s.cm2.\xB0C)/cal"]
]);
var unitFoulingFactorLabelOptionMapping = /* @__PURE__ */ new Map([
  ["m2K/W", 0 /* m2KW */],
  ["(h.ft2.\xB0F)/Btu", 1 /* hft2FBtu */],
  ["(s.ft2.\xB0F)/Btu", 2 /* sft2FBtu */],
  ["(h.m2.\xB0C)/kcal", 3 /* hm2Ckcal */],
  ["(s.cm2.\xB0C)/cal", 4 /* scm2Ccal */]
]);
var UnitVelocityOption = /* @__PURE__ */ ((UnitVelocityOption3) => {
  UnitVelocityOption3[UnitVelocityOption3["ms"] = 0] = "ms";
  UnitVelocityOption3[UnitVelocityOption3["fts"] = 1] = "fts";
  UnitVelocityOption3[UnitVelocityOption3["ftmin"] = 2] = "ftmin";
  UnitVelocityOption3[UnitVelocityOption3["ins"] = 3] = "ins";
  UnitVelocityOption3[UnitVelocityOption3["inmin"] = 4] = "inmin";
  UnitVelocityOption3[UnitVelocityOption3["yds"] = 5] = "yds";
  return UnitVelocityOption3;
})(UnitVelocityOption || {});
var unitVelocityOptionLabelMapping = /* @__PURE__ */ new Map([
  [0 /* ms */, "m/s"],
  [1 /* fts */, "ft/s"],
  [2 /* ftmin */, "ft/min"],
  [3 /* ins */, "in/s"],
  [4 /* inmin */, "in/min"],
  [5 /* yds */, "yd/s"]
]);
var unitVelocityLabelOptionMapping = /* @__PURE__ */ new Map([
  ["m/s", 0 /* ms */],
  ["ft/s", 1 /* fts */],
  ["ft/min", 2 /* ftmin */],
  ["in/s", 3 /* ins */],
  ["in/min", 4 /* inmin */],
  ["yd/s", 5 /* yds */]
]);
var UnitCapacityOption = /* @__PURE__ */ ((UnitCapacityOption2) => {
  UnitCapacityOption2[UnitCapacityOption2["kW"] = 0] = "kW";
  UnitCapacityOption2[UnitCapacityOption2["Btus"] = 1] = "Btus";
  UnitCapacityOption2[UnitCapacityOption2["kBtuh"] = 2] = "kBtuh";
  UnitCapacityOption2[UnitCapacityOption2["ftlbfh"] = 3] = "ftlbfh";
  UnitCapacityOption2[UnitCapacityOption2["ftlbfmin"] = 4] = "ftlbfmin";
  UnitCapacityOption2[UnitCapacityOption2["kcalh"] = 5] = "kcalh";
  UnitCapacityOption2[UnitCapacityOption2["cals"] = 6] = "cals";
  UnitCapacityOption2[UnitCapacityOption2["RefTon"] = 7] = "RefTon";
  return UnitCapacityOption2;
})(UnitCapacityOption || {});
var unitCapacityOptionLabelMapping = /* @__PURE__ */ new Map([
  [0 /* kW */, "kW"],
  [1 /* Btus */, "Btu/s"],
  [2 /* kBtuh */, "kBtu/h"],
  [3 /* ftlbfh */, "ft.lbf/h"],
  [4 /* ftlbfmin */, "ft.lbf/min"],
  [5 /* kcalh */, "kcal/h"],
  [6 /* cals */, "cal/s"],
  [7 /* RefTon */, "Ref.Ton"]
]);
var unitCapacityLabelOptionMapping = /* @__PURE__ */ new Map([
  ["kW", 0 /* kW */],
  ["Btu/s", 1 /* Btus */],
  ["kBtu/h", 2 /* kBtuh */],
  ["ft.lbf/h", 3 /* ftlbfh */],
  ["ft.lbf/min", 4 /* ftlbfmin */],
  ["kcal/h", 5 /* kcalh */],
  ["cal/s", 6 /* cals */],
  ["Ref.Ton", 7 /* RefTon */]
]);
var UnitSurfaceTensionOption = /* @__PURE__ */ ((UnitSurfaceTensionOption2) => {
  UnitSurfaceTensionOption2[UnitSurfaceTensionOption2["Nm"] = 0] = "Nm";
  UnitSurfaceTensionOption2[UnitSurfaceTensionOption2["mNm"] = 1] = "mNm";
  UnitSurfaceTensionOption2[UnitSurfaceTensionOption2["lbfft"] = 2] = "lbfft";
  UnitSurfaceTensionOption2[UnitSurfaceTensionOption2["lbfin"] = 3] = "lbfin";
  UnitSurfaceTensionOption2[UnitSurfaceTensionOption2["ergcm2"] = 4] = "ergcm2";
  UnitSurfaceTensionOption2[UnitSurfaceTensionOption2["kgfm"] = 5] = "kgfm";
  UnitSurfaceTensionOption2[UnitSurfaceTensionOption2["dynecm"] = 6] = "dynecm";
  UnitSurfaceTensionOption2[UnitSurfaceTensionOption2["mjcm2"] = 7] = "mjcm2";
  return UnitSurfaceTensionOption2;
})(UnitSurfaceTensionOption || {});
var unitSurfaceTensionOptionLabelInputMapping = /* @__PURE__ */ new Map([
  [0 /* Nm */, "N/m"],
  [1 /* mNm */, "mN/m"],
  [2 /* lbfft */, "lbf/ft"],
  [3 /* lbfin */, "lbf/in"],
  [4 /* ergcm2 */, "erg/cm\xB2"],
  [5 /* kgfm */, "kgf/m"],
  [6 /* dynecm */, "dyne/cm"],
  [7 /* mjcm2 */, "mJ/cm\xB2"]
]);
var unitSurfaceTensionOptionLabelCalculateMapping = /* @__PURE__ */ new Map([
  [0 /* Nm */, "N/m"],
  [1 /* mNm */, "mN/m"],
  [2 /* lbfft */, "lbf/ft"],
  [3 /* lbfin */, "lbf/in"],
  [4 /* ergcm2 */, "erg/cm2"],
  [5 /* kgfm */, "kgf/m"],
  [6 /* dynecm */, "dyne/cm"],
  [7 /* mjcm2 */, "mJ/cm\xB2"]
]);
var unitSurfaceTensionLabelOptionCalculateMapping = /* @__PURE__ */ new Map([
  ["N/m", 0 /* Nm */],
  ["mN/m", 1 /* mNm */],
  ["lbf/ft", 2 /* lbfft */],
  ["lbf/in", 3 /* lbfin */],
  ["erg/cm2", 4 /* ergcm2 */],
  ["kgf/m", 5 /* kgfm */],
  ["dyne/cm", 6 /* dynecm */],
  ["mJ/cm2", 7 /* mjcm2 */]
]);
var UnitTemperatureLMTDOption = /* @__PURE__ */ ((UnitTemperatureLMTDOption2) => {
  UnitTemperatureLMTDOption2[UnitTemperatureLMTDOption2["C"] = 0] = "C";
  UnitTemperatureLMTDOption2[UnitTemperatureLMTDOption2["F"] = 1] = "F";
  UnitTemperatureLMTDOption2[UnitTemperatureLMTDOption2["R"] = 2] = "R";
  return UnitTemperatureLMTDOption2;
})(UnitTemperatureLMTDOption || {});
var unitTemperatureLMTDOptionLabelMapping = /* @__PURE__ */ new Map([
  [0 /* C */, "\xB0C"],
  [1 /* F */, "\xB0F"],
  [2 /* R */, "\xB0R"]
]);
var unitTemperatureLMTDLabelOptionMapping = /* @__PURE__ */ new Map([
  ["\xB0C", 0 /* C */],
  ["\xB0F", 1 /* F */],
  ["\xB0R", 2 /* R */]
]);
var UnitEntalphyOption = /* @__PURE__ */ ((UnitEntalphyOption2) => {
  UnitEntalphyOption2[UnitEntalphyOption2["Jkg"] = 0] = "Jkg";
  UnitEntalphyOption2[UnitEntalphyOption2["kJkg"] = 1] = "kJkg";
  UnitEntalphyOption2[UnitEntalphyOption2["Btulb"] = 2] = "Btulb";
  UnitEntalphyOption2[UnitEntalphyOption2["Btukg"] = 3] = "Btukg";
  UnitEntalphyOption2[UnitEntalphyOption2["ftlbflb"] = 4] = "ftlbflb";
  UnitEntalphyOption2[UnitEntalphyOption2["kcallb"] = 5] = "kcallb";
  UnitEntalphyOption2[UnitEntalphyOption2["calkg"] = 6] = "calkg";
  return UnitEntalphyOption2;
})(UnitEntalphyOption || {});
var unitEntalphyOptionLabelMapping = /* @__PURE__ */ new Map([
  [0 /* Jkg */, "J/kg"],
  [1 /* kJkg */, "kJ/kg"],
  [2 /* Btulb */, "Btu/lb"],
  [3 /* Btukg */, "Btu/kg"],
  [4 /* ftlbflb */, "ft.lbf/lb"],
  [5 /* kcallb */, "kcal/lb"],
  [6 /* calkg */, "cal/kg"]
]);
var unitEntalphyLabelOptionMapping = /* @__PURE__ */ new Map([
  ["J/kg", 0 /* Jkg */],
  ["kJ/kg", 1 /* kJkg */],
  ["Btu/lb", 2 /* Btulb */],
  ["Btu/kg", 3 /* Btukg */],
  ["ft.lbf/lb", 4 /* ftlbflb */],
  ["kcal/lb", 5 /* kcallb */],
  ["cal/kg", 6 /* calkg */]
]);
var UnitMassOption = /* @__PURE__ */ ((UnitMassOption2) => {
  UnitMassOption2[UnitMassOption2["kg"] = 0] = "kg";
  UnitMassOption2[UnitMassOption2["lb"] = 1] = "lb";
  return UnitMassOption2;
})(UnitMassOption || {});
var unitMassOptionLabelMapping = /* @__PURE__ */ new Map([
  [0 /* kg */, "kg"],
  [1 /* lb */, "lb"]
]);
var unitMassLabelOptionMapping = /* @__PURE__ */ new Map([
  ["kg", 0 /* kg */],
  ["lb", 1 /* lb */]
]);
var UnitVolumeOption = /* @__PURE__ */ ((UnitVolumeOption2) => {
  UnitVolumeOption2[UnitVolumeOption2["m3"] = 0] = "m3";
  UnitVolumeOption2[UnitVolumeOption2["dm3"] = 1] = "dm3";
  UnitVolumeOption2[UnitVolumeOption2["USgal"] = 2] = "USgal";
  return UnitVolumeOption2;
})(UnitVolumeOption || {});
var unitVolumeOptionInputMappingLabel = /* @__PURE__ */ new Map([
  [0 /* m3 */, "m\xB3"],
  [1 /* dm3 */, "dm\xB3"],
  [2 /* USgal */, "USgal"]
]);
var unitVolumeOptionCalculateMappingLabel = /* @__PURE__ */ new Map([
  [0 /* m3 */, "m3"],
  [1 /* dm3 */, "dm3"],
  [2 /* USgal */, "USgal"]
]);
var unitVolumeCalculateLabelOptionMapping = /* @__PURE__ */ new Map([
  ["m3", 0 /* m3 */],
  ["dm3", 1 /* dm3 */],
  ["USgal", 2 /* USgal */]
]);
var UnitAirHumidityOption = /* @__PURE__ */ ((UnitAirHumidityOption2) => {
  UnitAirHumidityOption2[UnitAirHumidityOption2["kgkg"] = 0] = "kgkg";
  return UnitAirHumidityOption2;
})(UnitAirHumidityOption || {});
var unitAirHumidityOptionLabelMapping = /* @__PURE__ */ new Map([[0 /* kgkg */, "kg/kg"]]);
var unitAirHumidityLabelOptionMapping = /* @__PURE__ */ new Map([["kg/kg", 0 /* kgkg */]]);

// src/enums/hazard-analysis.enum.ts
var FluidTemperatureInPlatepack = /* @__PURE__ */ ((FluidTemperatureInPlatepack2) => {
  FluidTemperatureInPlatepack2[FluidTemperatureInPlatepack2["LessThan65"] = 0] = "LessThan65";
  FluidTemperatureInPlatepack2[FluidTemperatureInPlatepack2["From65To110"] = 0.1] = "From65To110";
  FluidTemperatureInPlatepack2[FluidTemperatureInPlatepack2["GreaterThan110"] = 0.2] = "GreaterThan110";
  return FluidTemperatureInPlatepack2;
})(FluidTemperatureInPlatepack || {});
var DangerousnessOfTheContentOfPshePlatePack = /* @__PURE__ */ ((DangerousnessOfTheContentOfPshePlatePack2) => {
  DangerousnessOfTheContentOfPshePlatePack2[DangerousnessOfTheContentOfPshePlatePack2["No"] = 0] = "No";
  DangerousnessOfTheContentOfPshePlatePack2[DangerousnessOfTheContentOfPshePlatePack2["Little"] = 0.1] = "Little";
  return DangerousnessOfTheContentOfPshePlatePack2;
})(DangerousnessOfTheContentOfPshePlatePack || {});
var SignificanceOfTheProcessMediaConfusionCausedByPlateDamage = /* @__PURE__ */ ((SignificanceOfTheProcessMediaConfusionCausedByPlateDamage2) => {
  SignificanceOfTheProcessMediaConfusionCausedByPlateDamage2[SignificanceOfTheProcessMediaConfusionCausedByPlateDamage2["No"] = 0] = "No";
  SignificanceOfTheProcessMediaConfusionCausedByPlateDamage2[SignificanceOfTheProcessMediaConfusionCausedByPlateDamage2["Little"] = 0.1] = "Little";
  SignificanceOfTheProcessMediaConfusionCausedByPlateDamage2[SignificanceOfTheProcessMediaConfusionCausedByPlateDamage2["Significant"] = 1.5] = "Significant";
  return SignificanceOfTheProcessMediaConfusionCausedByPlateDamage2;
})(SignificanceOfTheProcessMediaConfusionCausedByPlateDamage || {});
var VolumeOfContentsInPlatepack = /* @__PURE__ */ ((VolumeOfContentsInPlatepack2) => {
  VolumeOfContentsInPlatepack2[VolumeOfContentsInPlatepack2["LessThan50"] = 0] = "LessThan50";
  VolumeOfContentsInPlatepack2[VolumeOfContentsInPlatepack2["From50To200"] = 0.05] = "From50To200";
  VolumeOfContentsInPlatepack2[VolumeOfContentsInPlatepack2["GreaterThan200"] = 0.1] = "GreaterThan200";
  return VolumeOfContentsInPlatepack2;
})(VolumeOfContentsInPlatepack || {});
var CorrosionAndErosion = /* @__PURE__ */ ((CorrosionAndErosion2) => {
  CorrosionAndErosion2[CorrosionAndErosion2["No"] = 0] = "No";
  CorrosionAndErosion2[CorrosionAndErosion2["Moderate"] = 0.15] = "Moderate";
  CorrosionAndErosion2[CorrosionAndErosion2["Significant"] = 1] = "Significant";
  return CorrosionAndErosion2;
})(CorrosionAndErosion || {});
var Fatigue = /* @__PURE__ */ ((Fatigue2) => {
  Fatigue2[Fatigue2["LessThan500"] = 0] = "LessThan500";
  Fatigue2[Fatigue2["From500To10000"] = 0.05] = "From500To10000";
  Fatigue2[Fatigue2["GreaterThan10000"] = 1] = "GreaterThan10000";
  return Fatigue2;
})(Fatigue || {});
var MeansOfExaminationForPlatepack = /* @__PURE__ */ ((MeansOfExaminationForPlatepack2) => {
  MeansOfExaminationForPlatepack2[MeansOfExaminationForPlatepack2["Vacuum"] = 0] = "Vacuum";
  MeansOfExaminationForPlatepack2[MeansOfExaminationForPlatepack2["Standard"] = 0.05] = "Standard";
  return MeansOfExaminationForPlatepack2;
})(MeansOfExaminationForPlatepack || {});
var Installation = /* @__PURE__ */ ((Installation2) => {
  Installation2[Installation2["Welded4Nozzles"] = 0] = "Welded4Nozzles";
  Installation2[Installation2["Welded2Nozzles"] = 0.05] = "Welded2Nozzles";
  Installation2[Installation2["OpenableModel"] = 0.1] = "OpenableModel";
  return Installation2;
})(Installation || {});
var OperationLifetime = /* @__PURE__ */ ((OperationLifetime2) => {
  OperationLifetime2[OperationLifetime2["LessThan10"] = 0] = "LessThan10";
  OperationLifetime2[OperationLifetime2["From10To20"] = 0.05] = "From10To20";
  OperationLifetime2[OperationLifetime2["GreaterThan20"] = 0.5] = "GreaterThan20";
  return OperationLifetime2;
})(OperationLifetime || {});
var InspectionOfThePlatepack = /* @__PURE__ */ ((InspectionOfThePlatepack2) => {
  InspectionOfThePlatepack2[InspectionOfThePlatepack2["LessThan5"] = 0] = "LessThan5";
  InspectionOfThePlatepack2[InspectionOfThePlatepack2["From5To10"] = 0.1] = "From5To10";
  InspectionOfThePlatepack2[InspectionOfThePlatepack2["GreaterThan10"] = 1] = "GreaterThan10";
  return InspectionOfThePlatepack2;
})(InspectionOfThePlatepack || {});
var HaPlateMaterialAttribute = /* @__PURE__ */ ((HaPlateMaterialAttribute2) => {
  HaPlateMaterialAttribute2[HaPlateMaterialAttribute2["AneNro"] = 0] = "AneNro";
  HaPlateMaterialAttribute2[HaPlateMaterialAttribute2["Rm"] = 1] = "Rm";
  HaPlateMaterialAttribute2[HaPlateMaterialAttribute2["Ainekerroin"] = 2] = "Ainekerroin";
  return HaPlateMaterialAttribute2;
})(HaPlateMaterialAttribute || {});
var HaPlateMaterial = /* @__PURE__ */ ((HaPlateMaterial2) => {
  HaPlateMaterial2[HaPlateMaterial2["_14404"] = 0] = "_14404";
  HaPlateMaterial2[HaPlateMaterial2["_254SMO"] = 1] = "_254SMO";
  HaPlateMaterial2[HaPlateMaterial2["HastelloyC22"] = 2] = "HastelloyC22";
  HaPlateMaterial2[HaPlateMaterial2["HastelloyC276"] = 3] = "HastelloyC276";
  HaPlateMaterial2[HaPlateMaterial2["Nickel201"] = 4] = "Nickel201";
  HaPlateMaterial2[HaPlateMaterial2["TitaniumGr1"] = 5] = "TitaniumGr1";
  HaPlateMaterial2[HaPlateMaterial2["_904L"] = 6] = "_904L";
  HaPlateMaterial2[HaPlateMaterial2["_2205"] = 7] = "_2205";
  HaPlateMaterial2[HaPlateMaterial2["Supra316L"] = 8] = "Supra316L";
  HaPlateMaterial2[HaPlateMaterial2["ASTMFDX27"] = 9] = "ASTMFDX27";
  HaPlateMaterial2[HaPlateMaterial2["_14307"] = 10] = "_14307";
  return HaPlateMaterial2;
})(HaPlateMaterial || {});
var HaPlateSizeAndTypeAttribute = /* @__PURE__ */ ((HaPlateSizeAndTypeAttribute2) => {
  HaPlateSizeAndTypeAttribute2[HaPlateSizeAndTypeAttribute2["Attr1"] = 0] = "Attr1";
  HaPlateSizeAndTypeAttribute2[HaPlateSizeAndTypeAttribute2["Attr2"] = 1] = "Attr2";
  return HaPlateSizeAndTypeAttribute2;
})(HaPlateSizeAndTypeAttribute || {});
var HaPlateSizeAndType = /* @__PURE__ */ ((HaPlateSizeAndType2) => {
  HaPlateSizeAndType2[HaPlateSizeAndType2["_2HA"] = 0] = "_2HA";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_3HH"] = 1] = "_3HH";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_3LL"] = 2] = "_3LL";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_3WH"] = 3] = "_3WH";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_3WA"] = 4] = "_3WA";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_4HH"] = 5] = "_4HH";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_4LL"] = 6] = "_4LL";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_5HH"] = 7] = "_5HH";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_5LL"] = 8] = "_5LL";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_5WH"] = 9] = "_5WH";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_5WL"] = 10] = "_5WL";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_5TH"] = 11] = "_5TH";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_5SH"] = 12] = "_5SH";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_6HH"] = 13] = "_6HH";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_6LL"] = 14] = "_6LL";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_7HH"] = 15] = "_7HH";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_7LL"] = 16] = "_7LL";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_7WH"] = 17] = "_7WH";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_7WL"] = 18] = "_7WL";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_9HH"] = 19] = "_9HH";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_9LL"] = 20] = "_9LL";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_9HA"] = 21] = "_9HA";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_9LA"] = 22] = "_9LA";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_12HH"] = 23] = "_12HH";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_12LL"] = 24] = "_12LL";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_14HH"] = 25] = "_14HH";
  HaPlateSizeAndType2[HaPlateSizeAndType2["_14LL"] = 26] = "_14LL";
  return HaPlateSizeAndType2;
})(HaPlateSizeAndType || {});
var HaPlateSize = /* @__PURE__ */ ((HaPlateSize2) => {
  HaPlateSize2[HaPlateSize2["_2"] = 0] = "_2";
  HaPlateSize2[HaPlateSize2["_3"] = 1] = "_3";
  HaPlateSize2[HaPlateSize2["_31"] = 2] = "_31";
  HaPlateSize2[HaPlateSize2["_32"] = 3] = "_32";
  HaPlateSize2[HaPlateSize2["_4"] = 4] = "_4";
  HaPlateSize2[HaPlateSize2["_5"] = 5] = "_5";
  HaPlateSize2[HaPlateSize2["_51"] = 6] = "_51";
  HaPlateSize2[HaPlateSize2["_52"] = 7] = "_52";
  HaPlateSize2[HaPlateSize2["_53"] = 8] = "_53";
  HaPlateSize2[HaPlateSize2["_6"] = 9] = "_6";
  HaPlateSize2[HaPlateSize2["_61"] = 10] = "_61";
  HaPlateSize2[HaPlateSize2["_7"] = 11] = "_7";
  HaPlateSize2[HaPlateSize2["_71"] = 12] = "_71";
  HaPlateSize2[HaPlateSize2["_9"] = 13] = "_9";
  HaPlateSize2[HaPlateSize2["_12"] = 14] = "_12";
  HaPlateSize2[HaPlateSize2["_14"] = 15] = "_14";
  return HaPlateSize2;
})(HaPlateSize || {});
var HaPlateThickness = /* @__PURE__ */ ((HaPlateThickness2) => {
  HaPlateThickness2[HaPlateThickness2["_0_7mm"] = 0.7] = "_0_7mm";
  HaPlateThickness2[HaPlateThickness2["_0_8mm"] = 0.8] = "_0_8mm";
  HaPlateThickness2[HaPlateThickness2["_1mm"] = 1] = "_1mm";
  HaPlateThickness2[HaPlateThickness2["_1_2mm"] = 1.2] = "_1_2mm";
  HaPlateThickness2[HaPlateThickness2["_1_25mm"] = 1.25] = "_1_25mm";
  HaPlateThickness2[HaPlateThickness2["_1_5mm"] = 1.5] = "_1_5mm";
  return HaPlateThickness2;
})(HaPlateThickness || {});
var AsmeOptions = /* @__PURE__ */ ((AsmeOptions2) => {
  AsmeOptions2[AsmeOptions2["_1_3xDP"] = 1.3] = "_1_3xDP";
  AsmeOptions2[AsmeOptions2["_3_0xDP"] = 3] = "_3_0xDP";
  return AsmeOptions2;
})(AsmeOptions || {});
var fluidTemperatureInPlatepackLabels = {
  [0 /* LessThan65 */]: "T <=65 \xB0C",
  [0.1 /* From65To110 */]: "T >65\xB0C <=110\xB0C",
  [0.2 /* GreaterThan110 */]: "T >110 \xB0C"
};
var dangerousnessOfTheContentOfPshePlatePackLabels = {
  [0 /* No */]: "No risk",
  [0.1 /* Little */]: "Little risk"
};
var significanceOfTheProcessMediaConfusionCausedByPlateDamageLabels = {
  [0 /* No */]: "No significance",
  [0.1 /* Little */]: "Little significance",
  [1.5 /* Significant */]: "Significant risk"
};
var volumeOfContentsInPlatepackLabels = {
  [0 /* LessThan50 */]: "V < 50 dm3",
  [0.05 /* From50To200 */]: "50 <= V <= 200 dm3",
  [0.1 /* GreaterThan200 */]: "V >200 dm3"
};
var corrosionAndErosionLabels = {
  [0 /* No */]: "No significance",
  [0.15 /* Moderate */]: "Moderate danger of corrosion",
  [1 /* Significant */]: "Significant danger of corrosion"
};
var fatigueLabels = {
  [0 /* LessThan500 */]: "<= 500 full pressure cycles during lifetime",
  [0.05 /* From500To10000 */]: "500 - 10000 full pressure cycles during lifetime",
  [1 /* GreaterThan10000 */]: "> 10 000 (for ex. Compressors without damping)"
};
var meansOfExaminationForPlatepackLabels = {
  [0 /* Vacuum */]: "Vacuum He-leak test for the platepack",
  [0.05 /* Standard */]: "Standard leak test by air"
};
var installationLabels = {
  [0 /* Welded4Nozzles */]: "Welded end plates with 4 nozzles",
  [0.05 /* Welded2Nozzles */]: "Welded end plates with 2 nozzles",
  [0.1 /* OpenableModel */]: "Openable model"
};
var operationLifetimeLabels = {
  [0 /* LessThan10 */]: "Operation lifetime <= 10 years",
  [0.05 /* From10To20 */]: "Operation lifetime 10-20 years",
  [0.5 /* GreaterThan20 */]: "Operation lifetime >20 years"
};
var inspectionOfThePlatepackLabels = {
  [0 /* LessThan5 */]: "Inspection of platepack <= 5 year",
  [0.1 /* From5To10 */]: "Inspection of platepack 5-10 year",
  [1 /* GreaterThan10 */]: "Inspection of  platepack > 10 year"
};
var haPlateMaterialLabels = {
  [0 /* _14404 */]: "1.4404 EN 10028-7",
  [1 /* _254SMO */]: "254SMO EN 1.4547",
  [2 /* HastelloyC22 */]: "Hastelloy C-22 VdT\xDCV W-bl. 479",
  [3 /* HastelloyC276 */]: "Hastelloy C-276 VdT\xDCV W-bl. 400",
  [4 /* Nickel201 */]: "Nickel 201",
  [5 /* TitaniumGr1 */]: "Titanium Gr1 ASTM B265",
  [6 /* _904L */]: "904L EN 1.4539",
  [7 /* _2205 */]: "2205 EN 1.4462",
  [8 /* Supra316L */]: "Supra 316L EN 1.4420",
  [9 /* ASTMFDX27 */]: "ASTM FDX 27 ",
  [10 /* _14307 */]: "1.4307 EN 10028-7"
};
var haPlateSizeAndTypeLabels = {
  [0 /* _2HA */]: "2HA",
  [1 /* _3HH */]: "3HH",
  [2 /* _3LL */]: "3LL",
  [3 /* _3WH */]: "3WH",
  [4 /* _3WA */]: "3WA",
  [5 /* _4HH */]: "4HH",
  [6 /* _4LL */]: "4LL",
  [7 /* _5HH */]: "5HH",
  [8 /* _5LL */]: "5LL",
  [9 /* _5WH */]: "5WH",
  [10 /* _5WL */]: "5WL",
  [11 /* _5TH */]: "5TH",
  [12 /* _5SH */]: "5SH",
  [13 /* _6HH */]: "6HH",
  [14 /* _6LL */]: "6LL",
  [15 /* _7HH */]: "7HH",
  [16 /* _7LL */]: "7LL",
  [17 /* _7WH */]: "7WH",
  [18 /* _7WL */]: "7WL",
  [19 /* _9HH */]: "9HH",
  [20 /* _9LL */]: "9LL",
  [21 /* _9HA */]: "9HA",
  [22 /* _9LA */]: "9LA",
  [23 /* _12HH */]: "12HH",
  [24 /* _12LL */]: "12LL",
  [25 /* _14HH */]: "14HH",
  [26 /* _14LL */]: "14LL"
};
var haPlateThicknessLabels = {
  [0.7 /* _0_7mm */]: "0.7 mm",
  [0.8 /* _0_8mm */]: "0.8 mm",
  [1 /* _1mm */]: "1.0 mm",
  [1.2 /* _1_2mm */]: "1.2 mm",
  [1.5 /* _1_5mm */]: "1.5 mm"
};
var asmeOptionsLabels = {
  [1.3 /* _1_3xDP */]: "1.3 x DP, ASME",
  [3 /* _3_0xDP */]: "3.0 x DP, ASME-CRN (Canada)"
};

// src/enums/medium-property-type.enum.ts
var MediumPropertyType = /* @__PURE__ */ ((MediumPropertyType2) => {
  MediumPropertyType2[MediumPropertyType2["Viscosity"] = 1] = "Viscosity";
  MediumPropertyType2[MediumPropertyType2["Gravity"] = 2] = "Gravity";
  MediumPropertyType2[MediumPropertyType2["SpecificHeat"] = 3] = "SpecificHeat";
  MediumPropertyType2[MediumPropertyType2["ThermalConductivity"] = 4] = "ThermalConductivity";
  MediumPropertyType2[MediumPropertyType2["FreezingPoint"] = 5] = "FreezingPoint";
  return MediumPropertyType2;
})(MediumPropertyType || {});

// src/enums/unit-type.enum.ts
var UnitType = /* @__PURE__ */ ((UnitType2) => {
  UnitType2[UnitType2["SI"] = 0] = "SI";
  UnitType2[UnitType2["AME"] = 1] = "AME";
  return UnitType2;
})(UnitType || {});
var unitTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* SI */, "SI"],
  [1 /* AME */, "AME"]
]);

// src/enums/user-roles.enum.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["CPQ_INTERNAL_OY"] = "CPQ-Internal-Oy";
  UserRole2["CPQ_INTERNAL_CHINA"] = "CPQ-Internal-China";
  UserRole2["CPQ_EXTERNAL_DISTRIBUTOR"] = "CPQ-External-Distributor";
  UserRole2["CPQ_EXTERNAL_CONSULTANT"] = "CPQ-External-Consultant";
  UserRole2["CPQ_EXTERNAL_JCI"] = "CPQ-External-JCI";
  UserRole2["CPQ_EXTERNAL_COPELAND"] = "CPQ-External-Copeland";
  UserRole2["CPQ_EXTERNAL_2G"] = "CPQ-External-2G";
  UserRole2["CPQ_INSIGHT_REPORT"] = "CPQ-Insight-Report";
  UserRole2["CPQ_INSIGHT_FACTORY_REPORT"] = "CPQ-Insight-Factory-Report";
  UserRole2["CPQ_INSIGHT_MARKETING_REPORT"] = "CPQ-Insight-Marketing-Report";
  UserRole2["CPQ_INSIGHT_SALES_REPORT"] = "CPQ-Insight-Sales-Report";
  return UserRole2;
})(UserRole || {});
var WorkspaceRole = /* @__PURE__ */ ((WorkspaceRole2) => {
  WorkspaceRole2["WORKSPACE_INTERNAL"] = "workspace:internal";
  return WorkspaceRole2;
})(WorkspaceRole || {});

// src/enums/pricing.enum.ts
var VersionStatus = /* @__PURE__ */ ((VersionStatus2) => {
  VersionStatus2["Draft"] = "draft";
  VersionStatus2["Published"] = "published";
  VersionStatus2["Changed"] = "changed";
  VersionStatus2["Deleted"] = "deleted";
  VersionStatus2["Unpublished"] = "unpublished";
  return VersionStatus2;
})(VersionStatus || {});
var FormulaType = /* @__PURE__ */ ((FormulaType2) => {
  FormulaType2["CORE_FORMULA"] = "CORE_FORMULA";
  FormulaType2["FORMULA"] = "FORMULA";
  FormulaType2["CORE_VARIABLE"] = "CORE_VARIABLE";
  FormulaType2["VARIABLE"] = "VARIABLE";
  FormulaType2["CORE_FUNCTION"] = "CORE_FUNCTION";
  FormulaType2["FUNCTION"] = "FUNCTION";
  return FormulaType2;
})(FormulaType || {});
var CellStatus = /* @__PURE__ */ ((CellStatus2) => {
  CellStatus2["New"] = "NEW";
  CellStatus2["Update"] = "UPDATE";
  CellStatus2["Delete"] = "DELETE";
  return CellStatus2;
})(CellStatus || {});
var PricingSheetStatus = /* @__PURE__ */ ((PricingSheetStatus2) => {
  PricingSheetStatus2["New"] = "NEW";
  PricingSheetStatus2["Update"] = "UPDATE";
  PricingSheetStatus2["Delete"] = "DELETE";
  return PricingSheetStatus2;
})(PricingSheetStatus || {});
var DataStatus = /* @__PURE__ */ ((DataStatus2) => {
  DataStatus2["Primitive"] = "PRIMITIVE";
  DataStatus2["New"] = "NEW";
  DataStatus2["Changed"] = "CHANGED";
  return DataStatus2;
})(DataStatus || {});
var PriceComponentType = /* @__PURE__ */ ((PriceComponentType2) => {
  PriceComponentType2[PriceComponentType2["Extra"] = 0] = "Extra";
  PriceComponentType2[PriceComponentType2["Calculation"] = 1] = "Calculation";
  return PriceComponentType2;
})(PriceComponentType || {});
var priceComponentTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Extra */, "Extras"],
  [1 /* Calculation */, "Calculations"]
]);

// src/enums/chat-role.enum.ts
var ChatUserRole = /* @__PURE__ */ ((ChatUserRole2) => {
  ChatUserRole2["USER"] = "user";
  ChatUserRole2["SYSTEM"] = "system";
  return ChatUserRole2;
})(ChatUserRole || {});

// src/enums/cms/release-note-product.enum.ts
var CmsReleaseNoteProduct = /* @__PURE__ */ ((CmsReleaseNoteProduct2) => {
  CmsReleaseNoteProduct2[CmsReleaseNoteProduct2["CPQ"] = 0] = "CPQ";
  CmsReleaseNoteProduct2[CmsReleaseNoteProduct2["ORP"] = 1] = "ORP";
  CmsReleaseNoteProduct2[CmsReleaseNoteProduct2["CRM"] = 2] = "CRM";
  return CmsReleaseNoteProduct2;
})(CmsReleaseNoteProduct || {});
var cmsReleaseNoteProductMappingLabel = /* @__PURE__ */ new Map([
  [0 /* CPQ */, "CPQ"],
  [1 /* ORP */, "ORP"],
  [2 /* CRM */, "CRM"]
]);

// src/enums/cms/release-note-audience.enum.ts
var CmsReleaseNoteAudience = /* @__PURE__ */ ((CmsReleaseNoteAudience2) => {
  CmsReleaseNoteAudience2[CmsReleaseNoteAudience2["Internal"] = 0] = "Internal";
  CmsReleaseNoteAudience2[CmsReleaseNoteAudience2["ExternalDistributor"] = 1] = "ExternalDistributor";
  CmsReleaseNoteAudience2[CmsReleaseNoteAudience2["ExternalConsultant"] = 2] = "ExternalConsultant";
  return CmsReleaseNoteAudience2;
})(CmsReleaseNoteAudience || {});
var cmsReleaseNoteAudienceMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Internal */, "Internal"],
  [1 /* ExternalDistributor */, "External Distributor"],
  [2 /* ExternalConsultant */, "External Consultant"]
]);

// src/enums/cms/release-note-feature-type.enum.ts
var CmsReleaseNoteFeatureType = /* @__PURE__ */ ((CmsReleaseNoteFeatureType2) => {
  CmsReleaseNoteFeatureType2[CmsReleaseNoteFeatureType2["Update"] = 0] = "Update";
  CmsReleaseNoteFeatureType2[CmsReleaseNoteFeatureType2["NewFeature"] = 1] = "NewFeature";
  return CmsReleaseNoteFeatureType2;
})(CmsReleaseNoteFeatureType || {});
var cmsReleaseNoteFeatureTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Update */, "Update"],
  [1 /* NewFeature */, "New feature"]
]);

// src/enums/customer-system.enum.ts
var CustomerSystem = /* @__PURE__ */ ((CustomerSystem2) => {
  CustomerSystem2[CustomerSystem2["EOEGAndRelatedProcesses"] = 0] = "EOEGAndRelatedProcesses";
  CustomerSystem2[CustomerSystem2["FinalProductCooling"] = 1] = "FinalProductCooling";
  CustomerSystem2[CustomerSystem2["ReactorTemperatureControl"] = 2] = "ReactorTemperatureControl";
  CustomerSystem2[CustomerSystem2["RefineryDistrictHeatingNetworkHeatIntegration"] = 3] = "RefineryDistrictHeatingNetworkHeatIntegration";
  CustomerSystem2[CustomerSystem2["SMRATRHydrogenProcessGreyHydrogenHYCO"] = 4] = "SMRATRHydrogenProcessGreyHydrogenHYCO";
  CustomerSystem2[CustomerSystem2["ProcessGasCompressorSystem"] = 5] = "ProcessGasCompressorSystem";
  CustomerSystem2[CustomerSystem2["CarbonCaptureChemicalAbsorption"] = 6] = "CarbonCaptureChemicalAbsorption";
  CustomerSystem2[CustomerSystem2["ProductTemperatureControl"] = 7] = "ProductTemperatureControl";
  CustomerSystem2[CustomerSystem2["CO2PurificationAndLiquifaction"] = 8] = "CO2PurificationAndLiquifaction";
  CustomerSystem2[CustomerSystem2["LNGReceivingTerminalColdRecoveryDownstream"] = 9] = "LNGReceivingTerminalColdRecoveryDownstream";
  CustomerSystem2[CustomerSystem2["VapourSolventRecovery"] = 10] = "VapourSolventRecovery";
  CustomerSystem2[CustomerSystem2["LubeOilRerefinery"] = 11] = "LubeOilRerefinery";
  CustomerSystem2[CustomerSystem2["PaperCoatingSystem"] = 12] = "PaperCoatingSystem";
  CustomerSystem2[CustomerSystem2["PressurizedAlkalineElectrolysisGreenHydrogen"] = 13] = "PressurizedAlkalineElectrolysisGreenHydrogen";
  CustomerSystem2[CustomerSystem2["N2OLiquifactionAndPurification"] = 14] = "N2OLiquifactionAndPurification";
  CustomerSystem2[CustomerSystem2["NaturalGasDecompressionStationDownstream"] = 15] = "NaturalGasDecompressionStationDownstream";
  CustomerSystem2[CustomerSystem2["EdibleOil"] = 16] = "EdibleOil";
  CustomerSystem2[CustomerSystem2["MelamineAndUreaPlantHeatRecovery"] = 17] = "MelamineAndUreaPlantHeatRecovery";
  CustomerSystem2[CustomerSystem2["PaperMachineSteamAndCondensateSystem"] = 18] = "PaperMachineSteamAndCondensateSystem";
  CustomerSystem2[CustomerSystem2["HeliumLiquefaction"] = 19] = "HeliumLiquefaction";
  CustomerSystem2[CustomerSystem2["BiogasPurificationAndLiquefaction"] = 20] = "BiogasPurificationAndLiquefaction";
  CustomerSystem2[CustomerSystem2["FertilizerPlant"] = 21] = "FertilizerPlant";
  CustomerSystem2[CustomerSystem2["PulpMillRecoverBoilerPlant"] = 22] = "PulpMillRecoverBoilerPlant";
  CustomerSystem2[CustomerSystem2["ColdRecoveryInGasRegasification"] = 23] = "ColdRecoveryInGasRegasification";
  CustomerSystem2[CustomerSystem2["NitrogenRejection"] = 24] = "NitrogenRejection";
  CustomerSystem2[CustomerSystem2["NaturalGasCompressionPipelinePressureLiftDownstream"] = 25] = "NaturalGasCompressionPipelinePressureLiftDownstream";
  CustomerSystem2[CustomerSystem2["TankFarmTerminalCoolingAndHeatingSystemDownstream"] = 26] = "TankFarmTerminalCoolingAndHeatingSystemDownstream";
  CustomerSystem2[CustomerSystem2["NaOH"] = 27] = "NaOH";
  CustomerSystem2[CustomerSystem2["CoffeeExtractingSteamHeater"] = 28] = "CoffeeExtractingSteamHeater";
  CustomerSystem2[CustomerSystem2["SawMillBoilerPlan"] = 29] = "SawMillBoilerPlan";
  CustomerSystem2[CustomerSystem2["EthanolDistillationHeatRecovery"] = 30] = "EthanolDistillationHeatRecovery";
  CustomerSystem2[CustomerSystem2["Biodiesel"] = 31] = "Biodiesel";
  CustomerSystem2[CustomerSystem2["Polyol"] = 32] = "Polyol";
  CustomerSystem2[CustomerSystem2["HPPO"] = 33] = "HPPO";
  CustomerSystem2[CustomerSystem2["MDI"] = 34] = "MDI";
  CustomerSystem2[CustomerSystem2["NitricAcidPlant"] = 35] = "NitricAcidPlant";
  CustomerSystem2[CustomerSystem2["SampleCooling"] = 36] = "SampleCooling";
  CustomerSystem2[CustomerSystem2["NitrogenGasSystemFlushingTheBatchProcess"] = 37] = "NitrogenGasSystemFlushingTheBatchProcess";
  CustomerSystem2[CustomerSystem2["LPGLEGAmmoniaGasCarrierCargoHandlingSystem"] = 38] = "LPGLEGAmmoniaGasCarrierCargoHandlingSystem";
  CustomerSystem2[CustomerSystem2["LNGBogHandling"] = 39] = "LNGBogHandling";
  CustomerSystem2[CustomerSystem2["LNGFgss"] = 40] = "LNGFgss";
  CustomerSystem2[CustomerSystem2["LPGFgss"] = 41] = "LPGFgss";
  CustomerSystem2[CustomerSystem2["FSRURegasificationUnit"] = 42] = "FSRURegasificationUnit";
  CustomerSystem2[CustomerSystem2["MethanolFgss"] = 43] = "MethanolFgss";
  CustomerSystem2[CustomerSystem2["DewPointControlOilAndGas"] = 44] = "DewPointControlOilAndGas";
  CustomerSystem2[CustomerSystem2["HRSGWaterWaterEconomizer"] = 45] = "HRSGWaterWaterEconomizer";
  CustomerSystem2[CustomerSystem2["CompressorSystemsOilAndGas"] = 46] = "CompressorSystemsOilAndGas";
  CustomerSystem2[CustomerSystem2["CrudeOilTreatmentOffshore"] = 47] = "CrudeOilTreatmentOffshore";
  CustomerSystem2[CustomerSystem2["LNGGasCarrierCargoHandlingSystem"] = 48] = "LNGGasCarrierCargoHandlingSystem";
  CustomerSystem2[CustomerSystem2["AmmoniaFgss"] = 49] = "AmmoniaFgss";
  CustomerSystem2[CustomerSystem2["MarineFuelSystemCcs"] = 50] = "MarineFuelSystemCcs";
  CustomerSystem2[CustomerSystem2["AmmoniaChiller"] = 51] = "AmmoniaChiller";
  CustomerSystem2[CustomerSystem2["AmmoniaHeatPump"] = 52] = "AmmoniaHeatPump";
  CustomerSystem2[CustomerSystem2["CO2CascadeCoolingSystem"] = 53] = "CO2CascadeCoolingSystem";
  CustomerSystem2[CustomerSystem2["AbsorptionChiller"] = 54] = "AbsorptionChiller";
  CustomerSystem2[CustomerSystem2["HydrocarbonHeatPumpNH3R507A"] = 55] = "HydrocarbonHeatPumpNH3R507A";
  CustomerSystem2[CustomerSystem2["HFOHeatPump"] = 56] = "HFOHeatPump";
  CustomerSystem2[CustomerSystem2["CO2Chillers"] = 57] = "CO2Chillers";
  CustomerSystem2[CustomerSystem2["CO2HeatPump"] = 58] = "CO2HeatPump";
  CustomerSystem2[CustomerSystem2["CompressorSystemOilCooler"] = 59] = "CompressorSystemOilCooler";
  CustomerSystem2[CustomerSystem2["Economiser"] = 60] = "Economiser";
  CustomerSystem2[CustomerSystem2["SteamSystem"] = 61] = "SteamSystem";
  CustomerSystem2[CustomerSystem2["OtherProcessAndChemical"] = 62] = "OtherProcessAndChemical";
  CustomerSystem2[CustomerSystem2["OtherEnergy"] = 63] = "OtherEnergy";
  CustomerSystem2[CustomerSystem2["OtherRefrigeration"] = 64] = "OtherRefrigeration";
  CustomerSystem2[CustomerSystem2["GasDehydration"] = 65] = "GasDehydration";
  CustomerSystem2[CustomerSystem2["GasSweetening"] = 66] = "GasSweetening";
  CustomerSystem2[CustomerSystem2["BoilerSystem"] = 67] = "BoilerSystem";
  return CustomerSystem2;
})(CustomerSystem || {});
var CustomerSystemSector = /* @__PURE__ */ ((CustomerSystemSector2) => {
  CustomerSystemSector2[CustomerSystemSector2["A"] = 0] = "A";
  CustomerSystemSector2[CustomerSystemSector2["B"] = 1] = "B";
  CustomerSystemSector2[CustomerSystemSector2["C"] = 2] = "C";
  return CustomerSystemSector2;
})(CustomerSystemSector || {});
var customerSystemSectorMappingValue = /* @__PURE__ */ new Map([
  ["A", 0 /* A */],
  ["B", 1 /* B */],
  ["C", 2 /* C */]
]);
var customerSystemSectorMappingLabel = /* @__PURE__ */ new Map([
  [0 /* A */, "A"],
  [1 /* B */, "B"],
  [2 /* C */, "C"]
]);
var customerSystemMappingLabel = /* @__PURE__ */ new Map([
  [62 /* OtherProcessAndChemical */, "Other Process&Chemical"],
  [63 /* OtherEnergy */, "Other Energy"],
  [64 /* OtherRefrigeration */, "Other Refrigeration"],
  [0 /* EOEGAndRelatedProcesses */, "EO/EG and related processes"],
  [1 /* FinalProductCooling */, "Final product cooling"],
  [2 /* ReactorTemperatureControl */, "Reactor temperature control"],
  [
    3 /* RefineryDistrictHeatingNetworkHeatIntegration */,
    "Refinery / district heating network heat integration"
  ],
  [
    4 /* SMRATRHydrogenProcessGreyHydrogenHYCO */,
    "SMR / ATR Hydrogen Process (Grey Hydrogen - HYCO)"
  ],
  [5 /* ProcessGasCompressorSystem */, "Process gas Compressor system"],
  [
    6 /* CarbonCaptureChemicalAbsorption */,
    "Carbon Capture/ (Chemical Absorption)"
  ],
  [7 /* ProductTemperatureControl */, "Product temperature control"],
  [
    8 /* CO2PurificationAndLiquifaction */,
    "CO2 Purification and Liquifaction"
  ],
  [
    9 /* LNGReceivingTerminalColdRecoveryDownstream */,
    "LNG Receiving terminal cold recovery - downstream"
  ],
  [10 /* VapourSolventRecovery */, "Vapour (solvent) recovery"],
  [11 /* LubeOilRerefinery */, "Lube Oil re-refinery"],
  [12 /* PaperCoatingSystem */, "Paper Coating System"],
  [
    13 /* PressurizedAlkalineElectrolysisGreenHydrogen */,
    "Pressurized Alkaline Electrolysis (Green Hydrogen)"
  ],
  [
    14 /* N2OLiquifactionAndPurification */,
    "N2O Liquifaction and Purification"
  ],
  [
    15 /* NaturalGasDecompressionStationDownstream */,
    "Natural gas decompression station - downstream"
  ],
  [16 /* EdibleOil */, "Edible Oil"],
  [
    17 /* MelamineAndUreaPlantHeatRecovery */,
    "Melamine and Urea Plant heat recovery"
  ],
  [
    18 /* PaperMachineSteamAndCondensateSystem */,
    "Paper Machine steam & Condensate system"
  ],
  [19 /* HeliumLiquefaction */, "Helium Liquefaction"],
  [
    20 /* BiogasPurificationAndLiquefaction */,
    "Biogas purification and liquefaction"
  ],
  [21 /* FertilizerPlant */, "Fertilizer plant"],
  [22 /* PulpMillRecoverBoilerPlant */, "Pul mill Recover boiler plant"],
  [
    23 /* ColdRecoveryInGasRegasification */,
    "Cold recovery in gas regasiffcation (CO2, O2, N2 etc)"
  ],
  [24 /* NitrogenRejection */, "Nitrogen Rejection"],
  [
    25 /* NaturalGasCompressionPipelinePressureLiftDownstream */,
    "Natural gas compression (pipeline pressure lift) - downstream"
  ],
  [
    26 /* TankFarmTerminalCoolingAndHeatingSystemDownstream */,
    "Tank farm / terminal cooling and heating system - downstream"
  ],
  [27 /* NaOH */, "NaOH"],
  [
    28 /* CoffeeExtractingSteamHeater */,
    "Coffee extracting (steam heater)"
  ],
  [29 /* SawMillBoilerPlan */, "Saw mill boiler plan"],
  [
    30 /* EthanolDistillationHeatRecovery */,
    "Ethanol distillation heat recovery"
  ],
  [31 /* Biodiesel */, "Biodiesel"],
  [32 /* Polyol */, "Polyol"],
  [33 /* HPPO */, "HPPO"],
  [34 /* MDI */, "MDI"],
  [35 /* NitricAcidPlant */, "Nitric Acid plant"],
  [36 /* SampleCooling */, "Sample cooling"],
  [
    37 /* NitrogenGasSystemFlushingTheBatchProcess */,
    "Nitrogen gas system (flushing the batch process)"
  ],
  [
    38 /* LPGLEGAmmoniaGasCarrierCargoHandlingSystem */,
    "LPG/LEG / Ammonia Gas Carrier Cargo Handling system"
  ],
  [39 /* LNGBogHandling */, "LNG BOG Handling"],
  [40 /* LNGFgss */, "LNG FGSS"],
  [41 /* LPGFgss */, "LPG FSS"],
  [42 /* FSRURegasificationUnit */, "FSRU Regasification Unit"],
  [43 /* MethanolFgss */, "Methanol FSS"],
  [44 /* DewPointControlOilAndGas */, "Dew point control - Oil&Gas"],
  [45 /* HRSGWaterWaterEconomizer */, "HRSG (Water/Water Economizer)"],
  [46 /* CompressorSystemsOilAndGas */, "Compressor systems - Oil&Gas"],
  [47 /* CrudeOilTreatmentOffshore */, "Crude Oil Treatment Offshore"],
  [
    48 /* LNGGasCarrierCargoHandlingSystem */,
    "LNG Gas Carrier Cargo Handling system"
  ],
  [49 /* AmmoniaFgss */, "Ammonia FGSS"],
  [50 /* MarineFuelSystemCcs */, "Marine fuel system CCS"],
  [51 /* AmmoniaChiller */, "Ammonia Chiller"],
  [52 /* AmmoniaHeatPump */, "Ammonia Heat Pump"],
  [
    53 /* CO2CascadeCoolingSystem */,
    "CO2 Cascade cooling system (NH3/R507A)"
  ],
  [54 /* AbsorptionChiller */, "Absorbtion Chiller"],
  [55 /* HydrocarbonHeatPumpNH3R507A */, "Hydrocarbon Heat Pump"],
  [56 /* HFOHeatPump */, "HFO Heat  Pump"],
  [57 /* CO2Chillers */, "CO2 Chillers"],
  [58 /* CO2HeatPump */, "CO2 Heat Pump"],
  [59 /* CompressorSystemOilCooler */, "Compressor system - Oil cooler"],
  [60 /* Economiser */, "Economiser"],
  [61 /* SteamSystem */, "Steam system"],
  [65 /* GasDehydration */, "Gas Dehydration"],
  [66 /* GasSweetening */, "Gas Sweetening"],
  [67 /* BoilerSystem */, "Boiler System"]
]);
var customerSystemMappingValue = /* @__PURE__ */ new Map([
  ["Other Process&Chemical", 62 /* OtherProcessAndChemical */],
  ["Other Energy", 63 /* OtherEnergy */],
  ["Other Refrigeration", 64 /* OtherRefrigeration */],
  ["EO/EG and related processes", 0 /* EOEGAndRelatedProcesses */],
  ["Final product cooling", 1 /* FinalProductCooling */],
  ["Reactor temperature control", 2 /* ReactorTemperatureControl */],
  [
    "Refinery / district heating network heat integration",
    3 /* RefineryDistrictHeatingNetworkHeatIntegration */
  ],
  [
    "SMR / ATR Hydrogen Process (Grey Hydrogen - HYCO)",
    4 /* SMRATRHydrogenProcessGreyHydrogenHYCO */
  ],
  ["Process gas Compressor system", 5 /* ProcessGasCompressorSystem */],
  [
    "Carbon Capture/ (Chemical Absorption)",
    6 /* CarbonCaptureChemicalAbsorption */
  ],
  ["Product temperature control", 7 /* ProductTemperatureControl */],
  [
    "CO2 Purification and Liquifaction",
    8 /* CO2PurificationAndLiquifaction */
  ],
  [
    "LNG Receiving terminal cold recovery - downstream",
    9 /* LNGReceivingTerminalColdRecoveryDownstream */
  ],
  ["Vapour (solvent) recovery", 10 /* VapourSolventRecovery */],
  ["Lube Oil re-refinery", 11 /* LubeOilRerefinery */],
  ["Paper Coating System", 12 /* PaperCoatingSystem */],
  [
    "Pressurized Alkaline Electrolysis (Green Hydrogen)",
    13 /* PressurizedAlkalineElectrolysisGreenHydrogen */
  ],
  [
    "N2O Liquifaction and Purification",
    14 /* N2OLiquifactionAndPurification */
  ],
  [
    "Natural gas decompression station - downstream",
    15 /* NaturalGasDecompressionStationDownstream */
  ],
  ["Edible Oil", 16 /* EdibleOil */],
  [
    "Melamine and Urea Plant heat recovery",
    17 /* MelamineAndUreaPlantHeatRecovery */
  ],
  [
    "Paper Machine steam & Condensate system",
    18 /* PaperMachineSteamAndCondensateSystem */
  ],
  ["Helium Liquefaction", 19 /* HeliumLiquefaction */],
  [
    "Biogas purification and liquefaction",
    20 /* BiogasPurificationAndLiquefaction */
  ],
  ["Fertilizer plant", 21 /* FertilizerPlant */],
  ["Pulp mill Recover boiler plant", 22 /* PulpMillRecoverBoilerPlant */],
  [
    "Cold recovery in gas regasiffcation (CO2, O2, N2 etc)",
    23 /* ColdRecoveryInGasRegasification */
  ],
  ["Nitrogen Rejection", 24 /* NitrogenRejection */],
  [
    "Natural gas compression (pipeline pressure lift) - downstream",
    25 /* NaturalGasCompressionPipelinePressureLiftDownstream */
  ],
  [
    "Tank farm / terminal cooling and heating system - downstream",
    26 /* TankFarmTerminalCoolingAndHeatingSystemDownstream */
  ],
  ["NaOH", 27 /* NaOH */],
  [
    "Coffee extracting (steam heater)",
    28 /* CoffeeExtractingSteamHeater */
  ],
  ["Saw mill boiler plan", 29 /* SawMillBoilerPlan */],
  [
    "Ethanol distillation heat recovery",
    30 /* EthanolDistillationHeatRecovery */
  ],
  ["Biodiesel", 31 /* Biodiesel */],
  ["Polyol", 32 /* Polyol */],
  ["HPPO", 33 /* HPPO */],
  ["MDI", 34 /* MDI */],
  ["Nitric Acid plant", 35 /* NitricAcidPlant */],
  ["Sample cooling", 36 /* SampleCooling */],
  [
    "Nitrogen gas system (flushing the batch process)",
    37 /* NitrogenGasSystemFlushingTheBatchProcess */
  ],
  [
    "LPG/LEG / Ammonia Gas Carrier Cargo Handling system",
    38 /* LPGLEGAmmoniaGasCarrierCargoHandlingSystem */
  ],
  ["LNG BOG Handling", 39 /* LNGBogHandling */],
  ["LNG FGSS", 40 /* LNGFgss */],
  ["LPG FSS", 41 /* LPGFgss */],
  ["FSRU Regasification Unit", 42 /* FSRURegasificationUnit */],
  ["Methanol FSS", 43 /* MethanolFgss */],
  ["Dew point control - Oil&Gas", 44 /* DewPointControlOilAndGas */],
  ["HRSG (Water/Water Economizer)", 45 /* HRSGWaterWaterEconomizer */],
  ["Compressor systems - Oil&Gas", 46 /* CompressorSystemsOilAndGas */],
  ["Crude Oil Treatment Offshore", 47 /* CrudeOilTreatmentOffshore */],
  [
    "LNG Gas Carrier Cargo Handling system",
    48 /* LNGGasCarrierCargoHandlingSystem */
  ],
  ["Ammonia FGSS", 49 /* AmmoniaFgss */],
  ["Marine fuel system CCS", 50 /* MarineFuelSystemCcs */],
  ["Ammonia Chiller", 51 /* AmmoniaChiller */],
  ["Ammonia Heat Pump", 52 /* AmmoniaHeatPump */],
  [
    "CO2 Cascade cooling system (NH3/R507A)",
    53 /* CO2CascadeCoolingSystem */
  ],
  ["Absorbtion Chiller", 54 /* AbsorptionChiller */],
  ["Hydrocarbon Heat Pump", 55 /* HydrocarbonHeatPumpNH3R507A */],
  ["HFO Heat  Pump", 56 /* HFOHeatPump */],
  ["CO2 Chillers", 57 /* CO2Chillers */],
  ["CO2 Heat Pump", 58 /* CO2HeatPump */],
  ["Compressor system - Oil cooler", 59 /* CompressorSystemOilCooler */],
  ["Economiser", 60 /* Economiser */],
  ["Steam system", 61 /* SteamSystem */],
  ["Gas Dehydration", 65 /* GasDehydration */],
  ["Gas Sweetening", 66 /* GasSweetening */],
  ["Boiler System", 67 /* BoilerSystem */]
]);
var customerSystemSectorMapping = /* @__PURE__ */ new Map([
  [0 /* EOEGAndRelatedProcesses */, [0 /* A */]],
  [1 /* FinalProductCooling */, [0 /* A */]],
  [2 /* ReactorTemperatureControl */, [0 /* A */]],
  [
    3 /* RefineryDistrictHeatingNetworkHeatIntegration */,
    [0 /* A */]
  ],
  [
    4 /* SMRATRHydrogenProcessGreyHydrogenHYCO */,
    [0 /* A */]
  ],
  [5 /* ProcessGasCompressorSystem */, [0 /* A */]],
  [6 /* CarbonCaptureChemicalAbsorption */, [0 /* A */]],
  [7 /* ProductTemperatureControl */, [0 /* A */]],
  [8 /* CO2PurificationAndLiquifaction */, [0 /* A */]],
  [
    9 /* LNGReceivingTerminalColdRecoveryDownstream */,
    [0 /* A */]
  ],
  [10 /* VapourSolventRecovery */, [0 /* A */]],
  [11 /* LubeOilRerefinery */, [0 /* A */]],
  [12 /* PaperCoatingSystem */, [0 /* A */]],
  [
    13 /* PressurizedAlkalineElectrolysisGreenHydrogen */,
    [0 /* A */]
  ],
  [14 /* N2OLiquifactionAndPurification */, [0 /* A */]],
  [
    15 /* NaturalGasDecompressionStationDownstream */,
    [0 /* A */]
  ],
  [16 /* EdibleOil */, [0 /* A */]],
  [17 /* MelamineAndUreaPlantHeatRecovery */, [0 /* A */]],
  [
    18 /* PaperMachineSteamAndCondensateSystem */,
    [0 /* A */]
  ],
  [19 /* HeliumLiquefaction */, [0 /* A */]],
  [20 /* BiogasPurificationAndLiquefaction */, [0 /* A */]],
  [21 /* FertilizerPlant */, [0 /* A */]],
  [22 /* PulpMillRecoverBoilerPlant */, [0 /* A */]],
  [23 /* ColdRecoveryInGasRegasification */, [0 /* A */]],
  [24 /* NitrogenRejection */, [0 /* A */]],
  [
    25 /* NaturalGasCompressionPipelinePressureLiftDownstream */,
    [0 /* A */]
  ],
  [
    26 /* TankFarmTerminalCoolingAndHeatingSystemDownstream */,
    [0 /* A */]
  ],
  [27 /* NaOH */, [0 /* A */]],
  [28 /* CoffeeExtractingSteamHeater */, [0 /* A */]],
  [29 /* SawMillBoilerPlan */, [0 /* A */]],
  [30 /* EthanolDistillationHeatRecovery */, [0 /* A */]],
  [31 /* Biodiesel */, [0 /* A */]],
  [32 /* Polyol */, [0 /* A */]],
  [33 /* HPPO */, [0 /* A */]],
  [34 /* MDI */, [0 /* A */]],
  [35 /* NitricAcidPlant */, [0 /* A */]],
  [36 /* SampleCooling */, [0 /* A */]],
  [
    37 /* NitrogenGasSystemFlushingTheBatchProcess */,
    [0 /* A */]
  ],
  [
    38 /* LPGLEGAmmoniaGasCarrierCargoHandlingSystem */,
    [1 /* B */]
  ],
  [39 /* LNGBogHandling */, [1 /* B */]],
  [40 /* LNGFgss */, [1 /* B */]],
  [41 /* LPGFgss */, [1 /* B */]],
  [42 /* FSRURegasificationUnit */, [1 /* B */]],
  [43 /* MethanolFgss */, [1 /* B */]],
  [44 /* DewPointControlOilAndGas */, [1 /* B */]],
  [45 /* HRSGWaterWaterEconomizer */, [1 /* B */]],
  [46 /* CompressorSystemsOilAndGas */, [1 /* B */]],
  [47 /* CrudeOilTreatmentOffshore */, [1 /* B */]],
  [48 /* LNGGasCarrierCargoHandlingSystem */, [1 /* B */]],
  [49 /* AmmoniaFgss */, [1 /* B */]],
  [50 /* MarineFuelSystemCcs */, [1 /* B */]],
  [51 /* AmmoniaChiller */, [2 /* C */]],
  [52 /* AmmoniaHeatPump */, [2 /* C */]],
  [53 /* CO2CascadeCoolingSystem */, [2 /* C */]],
  [54 /* AbsorptionChiller */, [2 /* C */]],
  [55 /* HydrocarbonHeatPumpNH3R507A */, [2 /* C */]],
  [56 /* HFOHeatPump */, [2 /* C */]],
  [57 /* CO2Chillers */, [2 /* C */]],
  [58 /* CO2HeatPump */, [2 /* C */]],
  [59 /* CompressorSystemOilCooler */, [2 /* C */]],
  [60 /* Economiser */, [2 /* C */]],
  [63 /* OtherEnergy */, [1 /* B */]],
  [62 /* OtherProcessAndChemical */, [0 /* A */]],
  [64 /* OtherRefrigeration */, [2 /* C */]],
  [
    61 /* SteamSystem */,
    [0 /* A */, 1 /* B */, 2 /* C */]
  ],
  [65 /* GasDehydration */, [1 /* B */]],
  [66 /* GasSweetening */, [1 /* B */]],
  [67 /* BoilerSystem */, [1 /* B */]]
]);
var customerSystemMappingMfileCSValue = /* @__PURE__ */ new Map([
  [0 /* EOEGAndRelatedProcesses */, 8],
  [1 /* FinalProductCooling */, 11],
  [2 /* ReactorTemperatureControl */, 32],
  [3 /* RefineryDistrictHeatingNetworkHeatIntegration */, 33],
  [4 /* SMRATRHydrogenProcessGreyHydrogenHYCO */, 36],
  [5 /* ProcessGasCompressorSystem */, 29],
  [6 /* CarbonCaptureChemicalAbsorption */, 3],
  [7 /* ProductTemperatureControl */, 30],
  [8 /* CO2PurificationAndLiquifaction */, 4],
  [9 /* LNGReceivingTerminalColdRecoveryDownstream */, 14],
  [10 /* VapourSolventRecovery */, 38],
  [11 /* LubeOilRerefinery */, 15],
  [12 /* PaperCoatingSystem */, 25],
  [13 /* PressurizedAlkalineElectrolysisGreenHydrogen */, 28],
  [14 /* N2OLiquifactionAndPurification */, 18],
  [15 /* NaturalGasDecompressionStationDownstream */, 21],
  [16 /* EdibleOil */, 7],
  [17 /* MelamineAndUreaPlantHeatRecovery */, 17],
  [18 /* PaperMachineSteamAndCondensateSystem */, 26],
  [19 /* HeliumLiquefaction */, 12],
  [20 /* BiogasPurificationAndLiquefaction */, 2],
  [21 /* FertilizerPlant */, 10],
  [22 /* PulpMillRecoverBoilerPlant */, 31],
  [23 /* ColdRecoveryInGasRegasification */, 6],
  [24 /* NitrogenRejection */, 24],
  [25 /* NaturalGasCompressionPipelinePressureLiftDownstream */, 20],
  [26 /* TankFarmTerminalCoolingAndHeatingSystemDownstream */, 37],
  [27 /* NaOH */, 19],
  [28 /* CoffeeExtractingSteamHeater */, 5],
  [29 /* SawMillBoilerPlan */, 35],
  [30 /* EthanolDistillationHeatRecovery */, 9],
  [31 /* Biodiesel */, 1],
  [32 /* Polyol */, 27],
  [33 /* HPPO */, 13],
  [34 /* MDI */, 16],
  [35 /* NitricAcidPlant */, 22],
  [36 /* SampleCooling */, 34],
  [37 /* NitrogenGasSystemFlushingTheBatchProcess */, 23],
  [38 /* LPGLEGAmmoniaGasCarrierCargoHandlingSystem */, 11],
  [39 /* LNGBogHandling */, 7],
  [40 /* LNGFgss */, 8],
  [41 /* LPGFgss */, 10],
  [42 /* FSRURegasificationUnit */, 5],
  [43 /* MethanolFgss */, 13],
  [44 /* DewPointControlOilAndGas */, 4],
  [45 /* HRSGWaterWaterEconomizer */, 6],
  [46 /* CompressorSystemsOilAndGas */, 2],
  [47 /* CrudeOilTreatmentOffshore */, 3],
  [48 /* LNGGasCarrierCargoHandlingSystem */, 9],
  [49 /* AmmoniaFgss */, 1],
  [50 /* MarineFuelSystemCcs */, 12],
  [51 /* AmmoniaChiller */, 1],
  [52 /* AmmoniaHeatPump */, 2],
  [53 /* CO2CascadeCoolingSystem */, 4],
  [54 /* AbsorptionChiller */, 3],
  [55 /* HydrocarbonHeatPumpNH3R507A */, 10],
  [56 /* HFOHeatPump */, 9],
  [57 /* CO2Chillers */, 5],
  [58 /* CO2HeatPump */, 6],
  [59 /* CompressorSystemOilCooler */, 7],
  [60 /* Economiser */, 8],
  [
    61 /* SteamSystem */,
    (sector) => {
      switch (sector) {
        case 0 /* A */:
          return 40;
        case 1 /* B */:
          return 15;
        case 2 /* C */:
          return 12;
        default:
          throw new Error(`Unknown sector: ${sector}`);
      }
    }
  ],
  [62 /* OtherProcessAndChemical */, 39],
  [63 /* OtherEnergy */, 14],
  [64 /* OtherRefrigeration */, 11],
  [65 /* GasDehydration */, 0],
  [66 /* GasSweetening */, 0],
  [67 /* BoilerSystem */, 0]
]);
var getMfileCustomerSystemValue = (system, sector) => {
  const resolver = customerSystemMappingMfileCSValue.get(system);
  if (typeof resolver === "function") {
    if (!sector)
      throw new Error(`sector required for ${CustomerSystem[system]}`);
    return resolver(sector);
  }
  return resolver != null ? resolver : -1;
};
var getCustomerSystemFromMfileCSValue = (id, sector) => {
  for (const [
    system,
    resolver
  ] of customerSystemMappingMfileCSValue.entries()) {
    let systemId;
    if (typeof resolver === "function") {
      systemId = resolver(sector);
    } else {
      systemId = resolver;
    }
    if (systemId === id) {
      const allowedSectors = customerSystemSectorMapping.get(system);
      if (allowedSectors && allowedSectors.includes(sector)) {
        return system;
      }
    }
  }
  return void 0;
};

// src/enums/clickup.enum.ts
var BugStatus = /* @__PURE__ */ ((BugStatus2) => {
  BugStatus2["OPEN"] = "open";
  BugStatus2["IN_DEVELOPMENT"] = "in-development";
  BugStatus2["CLOSED"] = "closed";
  BugStatus2["NOT_A_BUG"] = "not-a-bug";
  return BugStatus2;
})(BugStatus || {});
var bugStatusTabMapToURL = {
  ["open" /* OPEN */]: "&statuses[]=OPEN",
  ["in-development" /* IN_DEVELOPMENT */]: "&statuses[]=IN DEVELOPMENT&statuses[]=IN REVIEW",
  ["closed" /* CLOSED */]: "&statuses[]=CLOSED&statuses[]=READY FOR DEPLOYMENT",
  ["not-a-bug" /* NOT_A_BUG */]: "&statuses[]=NOT A BUG"
};
var SuggestionStatus = /* @__PURE__ */ ((SuggestionStatus2) => {
  SuggestionStatus2["OPEN"] = "open";
  SuggestionStatus2["ADDED_TO_ROADMAP"] = "added-to-roadmap";
  SuggestionStatus2["CLOSED"] = "closed";
  SuggestionStatus2["BLOCKED"] = "blocked";
  return SuggestionStatus2;
})(SuggestionStatus || {});
var suggestionStatusTabMapToURL = {
  ["open" /* OPEN */]: "&statuses[]=OPEN",
  ["added-to-roadmap" /* ADDED_TO_ROADMAP */]: "&statuses[]=ADDED TO ROADMAP&statuses[]=AWAITING PRIORITIZATION",
  ["closed" /* CLOSED */]: "&statuses[]=CLOSED",
  ["blocked" /* BLOCKED */]: "&statuses[]=BLOCKED"
};

// src/enums/custom-extra.enum.ts
var ExtraPriceCategory = /* @__PURE__ */ ((ExtraPriceCategory2) => {
  ExtraPriceCategory2[ExtraPriceCategory2["Documents"] = 0] = "Documents";
  ExtraPriceCategory2[ExtraPriceCategory2["Calculations"] = 1] = "Calculations";
  ExtraPriceCategory2[ExtraPriceCategory2["Drawings"] = 2] = "Drawings";
  ExtraPriceCategory2[ExtraPriceCategory2["Manufacturing"] = 3] = "Manufacturing";
  ExtraPriceCategory2[ExtraPriceCategory2["TestsAndInspections"] = 4] = "TestsAndInspections";
  ExtraPriceCategory2[ExtraPriceCategory2["ThirdPartyDesignApprovalAndInspections"] = 5] = "ThirdPartyDesignApprovalAndInspections";
  ExtraPriceCategory2[ExtraPriceCategory2["ProjectManagement"] = 6] = "ProjectManagement";
  ExtraPriceCategory2[ExtraPriceCategory2["Commercial"] = 7] = "Commercial";
  ExtraPriceCategory2[ExtraPriceCategory2["Other"] = 8] = "Other";
  return ExtraPriceCategory2;
})(ExtraPriceCategory || {});
var extraPriceCategoryMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Documents */, "Documents"],
  [1 /* Calculations */, "Calculations"],
  [2 /* Drawings */, "Drawings"],
  [3 /* Manufacturing */, "Manufacturing"],
  [4 /* TestsAndInspections */, "Tests & Inspections"],
  [
    5 /* ThirdPartyDesignApprovalAndInspections */,
    "3rd party Design Approval & Inspections"
  ],
  [6 /* ProjectManagement */, "Project Management"],
  [7 /* Commercial */, "Commercial"],
  [8 /* Other */, "Other"]
]);
var ExtraPricePer = /* @__PURE__ */ ((ExtraPricePer2) => {
  ExtraPricePer2[ExtraPricePer2["Unit"] = 0] = "Unit";
  ExtraPricePer2[ExtraPricePer2["Type"] = 1] = "Type";
  ExtraPricePer2[ExtraPricePer2["Order"] = 2] = "Order";
  return ExtraPricePer2;
})(ExtraPricePer || {});
var extraPricePerMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Unit */, "unit"],
  [1 /* Type */, "type"],
  [2 /* Order */, "order"]
]);
var ExtraPriceShowOnOffer = /* @__PURE__ */ ((ExtraPriceShowOnOffer2) => {
  ExtraPriceShowOnOffer2[ExtraPriceShowOnOffer2["False"] = 0] = "False";
  ExtraPriceShowOnOffer2[ExtraPriceShowOnOffer2["PerPositionWithoutPrice"] = 1] = "PerPositionWithoutPrice";
  ExtraPriceShowOnOffer2[ExtraPriceShowOnOffer2["PerPositionWithPrice"] = 2] = "PerPositionWithPrice";
  ExtraPriceShowOnOffer2[ExtraPriceShowOnOffer2["LineItem"] = 3] = "LineItem";
  ExtraPriceShowOnOffer2[ExtraPriceShowOnOffer2["OptionalItem"] = 4] = "OptionalItem";
  return ExtraPriceShowOnOffer2;
})(ExtraPriceShowOnOffer || {});
var extraPriceShowOnOfferMappingLabel = /* @__PURE__ */ new Map([
  [0 /* False */, "Do not show"],
  [
    1 /* PerPositionWithoutPrice */,
    "Per position / without price"
  ],
  [2 /* PerPositionWithPrice */, "Per position / with price"],
  [3 /* LineItem */, "As line item"],
  [4 /* OptionalItem */, "As optional item"]
]);
var ExtraPricePriceType = /* @__PURE__ */ ((ExtraPricePriceType2) => {
  ExtraPricePriceType2[ExtraPricePriceType2["Euro"] = 0] = "Euro";
  ExtraPricePriceType2[ExtraPricePriceType2["Percentage"] = 1] = "Percentage";
  ExtraPricePriceType2[ExtraPricePriceType2["InputRequired"] = 2] = "InputRequired";
  return ExtraPricePriceType2;
})(ExtraPricePriceType || {});
var extraPricePriceTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Euro */, "\u20AC"],
  [1 /* Percentage */, "%"],
  [2 /* InputRequired */, "Input required"]
]);
var ExtraPriceCalculationBasis = /* @__PURE__ */ ((ExtraPriceCalculationBasis2) => {
  ExtraPriceCalculationBasis2[ExtraPriceCalculationBasis2["UnitPriceExcludingExtra"] = 0] = "UnitPriceExcludingExtra";
  ExtraPriceCalculationBasis2[ExtraPriceCalculationBasis2["UnitPriceIncludingExtra"] = 1] = "UnitPriceIncludingExtra";
  ExtraPriceCalculationBasis2[ExtraPriceCalculationBasis2["InputRequired"] = 2] = "InputRequired";
  return ExtraPriceCalculationBasis2;
})(ExtraPriceCalculationBasis || {});
var extraPriceCalculationBasisMappingLabel = /* @__PURE__ */ new Map([
  [
    0 /* UnitPriceExcludingExtra */,
    "Unit price excluding extras"
  ],
  [
    1 /* UnitPriceIncludingExtra */,
    "Unit price including extras"
  ],
  [2 /* InputRequired */, "Input required"]
]);

// src/enums/extra-price-item.enum.ts
var ExtraPriceItemOperationType = /* @__PURE__ */ ((ExtraPriceItemOperationType2) => {
  ExtraPriceItemOperationType2[ExtraPriceItemOperationType2["Create"] = 0] = "Create";
  ExtraPriceItemOperationType2[ExtraPriceItemOperationType2["Update"] = 1] = "Update";
  ExtraPriceItemOperationType2[ExtraPriceItemOperationType2["Delete"] = 2] = "Delete";
  return ExtraPriceItemOperationType2;
})(ExtraPriceItemOperationType || {});
var ExtraPriceItemMultiplier = /* @__PURE__ */ ((ExtraPriceItemMultiplier2) => {
  ExtraPriceItemMultiplier2[ExtraPriceItemMultiplier2["Default"] = 0] = "Default";
  ExtraPriceItemMultiplier2[ExtraPriceItemMultiplier2["InputRequired"] = 1] = "InputRequired";
  return ExtraPriceItemMultiplier2;
})(ExtraPriceItemMultiplier || {});

// src/enums/commission.enum.ts
var CommissionAssignmentType = /* @__PURE__ */ ((CommissionAssignmentType2) => {
  CommissionAssignmentType2[CommissionAssignmentType2["Unit"] = 0] = "Unit";
  CommissionAssignmentType2[CommissionAssignmentType2["Order"] = 1] = "Order";
  return CommissionAssignmentType2;
})(CommissionAssignmentType || {});
var commissionAssignmentTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Unit */, "unit"],
  [1 /* Order */, "order"]
]);
var CommissionUnitType = /* @__PURE__ */ ((CommissionUnitType2) => {
  CommissionUnitType2[CommissionUnitType2["Euro"] = 0] = "Euro";
  CommissionUnitType2[CommissionUnitType2["Percent"] = 1] = "Percent";
  return CommissionUnitType2;
})(CommissionUnitType || {});
var commissionUnitTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Euro */, "\u20AC"],
  [1 /* Percent */, "%"]
]);
var CommissionCalculationBasis = /* @__PURE__ */ ((CommissionCalculationBasis2) => {
  CommissionCalculationBasis2[CommissionCalculationBasis2["UnitPriceExcludingExtras"] = 0] = "UnitPriceExcludingExtras";
  CommissionCalculationBasis2[CommissionCalculationBasis2["UnitPriceIncludingExtras"] = 1] = "UnitPriceIncludingExtras";
  return CommissionCalculationBasis2;
})(CommissionCalculationBasis || {});
var commissionCalculationBasisMappingLabel = /* @__PURE__ */ new Map([
  [
    0 /* UnitPriceExcludingExtras */,
    "Unit price excluding extras"
  ],
  [
    1 /* UnitPriceIncludingExtras */,
    "Unit price including extras"
  ]
]);

// src/enums/rounded-type.enum.ts
var RoundedType = /* @__PURE__ */ ((RoundedType2) => {
  RoundedType2[RoundedType2["Nearest10"] = 0] = "Nearest10";
  RoundedType2[RoundedType2["Nearest100"] = 1] = "Nearest100";
  RoundedType2[RoundedType2["Manual"] = 2] = "Manual";
  RoundedType2[RoundedType2["WholeNumber"] = 3] = "WholeNumber";
  return RoundedType2;
})(RoundedType || {});
var roundedTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Nearest10 */, "Nearest 10"],
  [1 /* Nearest100 */, "Nearest 100"],
  [2 /* Manual */, "Manual"],
  [3 /* WholeNumber */, "Whole number"]
  // [RoundedType.NoRound, 'No rounding'],
]);

// src/enums/custom-position.enum.ts
var CustomPositionPriceType = /* @__PURE__ */ ((CustomPositionPriceType2) => {
  CustomPositionPriceType2[CustomPositionPriceType2["FixedPrice"] = 0] = "FixedPrice";
  CustomPositionPriceType2[CustomPositionPriceType2["CustomText"] = 1] = "CustomText";
  return CustomPositionPriceType2;
})(CustomPositionPriceType || {});
var customPositionPriceTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* FixedPrice */, "Fixed price"],
  [1 /* CustomText */, "Custom text"]
]);

// src/enums/nameplate.enum.ts
var Nameplate = /* @__PURE__ */ ((Nameplate2) => {
  Nameplate2[Nameplate2["NoSpecifiedPlace"] = 0] = "NoSpecifiedPlace";
  Nameplate2[Nameplate2["OnTheShell"] = 1] = "OnTheShell";
  Nameplate2[Nameplate2["OnTheEndPlate"] = 2] = "OnTheEndPlate";
  return Nameplate2;
})(Nameplate || {});
var namePlateMappingLabel = /* @__PURE__ */ new Map([
  [0 /* NoSpecifiedPlace */, "No specified place"],
  [1 /* OnTheShell */, "On the shell"],
  [2 /* OnTheEndPlate */, "On the end plate"]
]);

// src/enums/orp/orp-order.enum.ts
var OrpOrderStatus = /* @__PURE__ */ ((OrpOrderStatus2) => {
  OrpOrderStatus2["Draft"] = "draft";
  OrpOrderStatus2["Submitted"] = "submitted";
  OrpOrderStatus2["Deleted"] = "deleted";
  return OrpOrderStatus2;
})(OrpOrderStatus || {});
var Scm = /* @__PURE__ */ ((Scm2) => {
  Scm2[Scm2["No"] = 0] = "No";
  Scm2[Scm2["Vzjg"] = 1] = "Vzjg";
  return Scm2;
})(Scm || {});
var ManagementClass = /* @__PURE__ */ ((ManagementClass2) => {
  ManagementClass2[ManagementClass2["P_A"] = 0] = "P_A";
  ManagementClass2[ManagementClass2["P_B"] = 1] = "P_B";
  ManagementClass2[ManagementClass2["P_C"] = 2] = "P_C";
  ManagementClass2[ManagementClass2["V"] = 3] = "V";
  return ManagementClass2;
})(ManagementClass || {});
var ManagementClassMappingLabel = /* @__PURE__ */ new Map([
  [0 /* P_A */, "P-A"],
  [1 /* P_B */, "P-B"],
  [2 /* P_C */, "P-C"],
  [3 /* V */, "V"]
]);
var managementClassFromLabel = (label) => {
  if (!label) return void 0;
  const trimmed = label.trim();
  const found = [...ManagementClassMappingLabel].find(
    ([, text]) => text === trimmed
  );
  return found ? found[0] : void 0;
};
var PricingPolicyOption = /* @__PURE__ */ ((PricingPolicyOption2) => {
  PricingPolicyOption2[PricingPolicyOption2["Fixed"] = 0] = "Fixed";
  PricingPolicyOption2[PricingPolicyOption2["Attachment1"] = 1] = "Attachment1";
  PricingPolicyOption2[PricingPolicyOption2["Attachment2"] = 2] = "Attachment2";
  return PricingPolicyOption2;
})(PricingPolicyOption || {});
var TermsOfDelivery = /* @__PURE__ */ ((TermsOfDelivery2) => {
  TermsOfDelivery2[TermsOfDelivery2["DapEurope"] = 0] = "DapEurope";
  TermsOfDelivery2[TermsOfDelivery2["FcaKalanti"] = 1] = "FcaKalanti";
  TermsOfDelivery2[TermsOfDelivery2["FobFinlandHarborSea"] = 2] = "FobFinlandHarborSea";
  TermsOfDelivery2[TermsOfDelivery2["CptDestinationAirport"] = 3] = "CptDestinationAirport";
  TermsOfDelivery2[TermsOfDelivery2["CfrDestinationHarborSea"] = 4] = "CfrDestinationHarborSea";
  TermsOfDelivery2[TermsOfDelivery2["CifDestinationHarborSea"] = 5] = "CifDestinationHarborSea";
  TermsOfDelivery2[TermsOfDelivery2["ExwKalanti"] = 6] = "ExwKalanti";
  TermsOfDelivery2[TermsOfDelivery2["Other"] = 7] = "Other";
  return TermsOfDelivery2;
})(TermsOfDelivery || {});
var TermsOfPayment = /* @__PURE__ */ ((TermsOfPayment2) => {
  TermsOfPayment2[TermsOfPayment2["V_30_DAYS_NET"] = 0] = "V_30_DAYS_NET";
  TermsOfPayment2[TermsOfPayment2["V_45_DAYS_NET"] = 1] = "V_45_DAYS_NET";
  TermsOfPayment2[TermsOfPayment2["V_60_DAYS_NET"] = 2] = "V_60_DAYS_NET";
  TermsOfPayment2[TermsOfPayment2["V_90_DAYS_NET"] = 3] = "V_90_DAYS_NET";
  TermsOfPayment2[TermsOfPayment2["V_14_DAYS_NET"] = 4] = "V_14_DAYS_NET";
  TermsOfPayment2[TermsOfPayment2["ADVANCE_PAYMENT"] = 5] = "ADVANCE_PAYMENT";
  TermsOfPayment2[TermsOfPayment2["OTHER"] = 6] = "OTHER";
  return TermsOfPayment2;
})(TermsOfPayment || {});
var IndustrialSector = /* @__PURE__ */ ((IndustrialSector2) => {
  IndustrialSector2[IndustrialSector2["Chemical"] = 0] = "Chemical";
  IndustrialSector2[IndustrialSector2["FoodAndBewerage"] = 1] = "FoodAndBewerage";
  IndustrialSector2[IndustrialSector2["Marine"] = 2] = "Marine";
  IndustrialSector2[IndustrialSector2["OilAndGas"] = 3] = "OilAndGas";
  IndustrialSector2[IndustrialSector2["PulpAndPaper"] = 4] = "PulpAndPaper";
  IndustrialSector2[IndustrialSector2["Pharmaceutical"] = 5] = "Pharmaceutical";
  IndustrialSector2[IndustrialSector2["Other"] = 6] = "Other";
  IndustrialSector2[IndustrialSector2["Many"] = 7] = "Many";
  IndustrialSector2[IndustrialSector2["Refinery"] = 8] = "Refinery";
  IndustrialSector2[IndustrialSector2["IndustrialGas"] = 9] = "IndustrialGas";
  IndustrialSector2[IndustrialSector2["Fertilizers"] = 10] = "Fertilizers";
  IndustrialSector2[IndustrialSector2["EdibleOilAndBiodiesel"] = 11] = "EdibleOilAndBiodiesel";
  IndustrialSector2[IndustrialSector2["MiningMineralsAndMetalIndustry"] = 12] = "MiningMineralsAndMetalIndustry";
  IndustrialSector2[IndustrialSector2["HeatAndPower"] = 13] = "HeatAndPower";
  IndustrialSector2[IndustrialSector2["Sports"] = 14] = "Sports";
  IndustrialSector2[IndustrialSector2["DataCenter"] = 15] = "DataCenter";
  IndustrialSector2[IndustrialSector2["Refrigeration"] = 16] = "Refrigeration";
  IndustrialSector2[IndustrialSector2["Energy"] = 17] = "Energy";
  IndustrialSector2[IndustrialSector2["HeatPump"] = 18] = "HeatPump";
  IndustrialSector2[IndustrialSector2["Co2Transcritical"] = 19] = "Co2Transcritical";
  IndustrialSector2[IndustrialSector2["Absorbtio"] = 20] = "Absorbtio";
  return IndustrialSector2;
})(IndustrialSector || {});
var DrawingLevel = /* @__PURE__ */ ((DrawingLevel2) => {
  DrawingLevel2[DrawingLevel2["DimensionalDataSheetStandard"] = 0] = "DimensionalDataSheetStandard";
  DrawingLevel2[DrawingLevel2["DimensionalDataSheetStandardNdtAndWeldMap"] = 1] = "DimensionalDataSheetStandardNdtAndWeldMap";
  DrawingLevel2[DrawingLevel2["GaDrawingDetailDrawingIncNdtAndWeldMap"] = 2] = "GaDrawingDetailDrawingIncNdtAndWeldMap";
  DrawingLevel2[DrawingLevel2["OtherCustomized"] = 3] = "OtherCustomized";
  return DrawingLevel2;
})(DrawingLevel || {});
var DrawingApproval = /* @__PURE__ */ ((DrawingApproval2) => {
  DrawingApproval2[DrawingApproval2["Normal"] = 1] = "Normal";
  DrawingApproval2[DrawingApproval2["AgreedWithCustomer"] = 2] = "AgreedWithCustomer";
  return DrawingApproval2;
})(DrawingApproval || {});
var DrawingCustDays = /* @__PURE__ */ ((DrawingCustDays2) => {
  DrawingCustDays2[DrawingCustDays2["Days1"] = 1] = "Days1";
  DrawingCustDays2[DrawingCustDays2["Days2"] = 2] = "Days2";
  DrawingCustDays2[DrawingCustDays2["Days4"] = 4] = "Days4";
  DrawingCustDays2[DrawingCustDays2["Days5"] = 5] = "Days5";
  DrawingCustDays2[DrawingCustDays2["Days14"] = 14] = "Days14";
  DrawingCustDays2[DrawingCustDays2["Other"] = 15] = "Other";
  return DrawingCustDays2;
})(DrawingCustDays || {});
var FinalDocumentation = /* @__PURE__ */ ((FinalDocumentation2) => {
  FinalDocumentation2[FinalDocumentation2["DocumentationOnPdfEmailOrMFiles"] = 0] = "DocumentationOnPdfEmailOrMFiles";
  FinalDocumentation2[FinalDocumentation2["DocumentationOnPaper"] = 1] = "DocumentationOnPaper";
  FinalDocumentation2[FinalDocumentation2["DocumentationOnPdfAndPaper"] = 2] = "DocumentationOnPdfAndPaper";
  return FinalDocumentation2;
})(FinalDocumentation || {});
var ManualLanguage = /* @__PURE__ */ ((ManualLanguage2) => {
  ManualLanguage2[ManualLanguage2["Chinese"] = 0] = "Chinese";
  ManualLanguage2[ManualLanguage2["Czech"] = 1] = "Czech";
  ManualLanguage2[ManualLanguage2["Danish"] = 2] = "Danish";
  ManualLanguage2[ManualLanguage2["Dutch"] = 3] = "Dutch";
  ManualLanguage2[ManualLanguage2["English"] = 4] = "English";
  ManualLanguage2[ManualLanguage2["Estonia"] = 5] = "Estonia";
  ManualLanguage2[ManualLanguage2["Finnish"] = 6] = "Finnish";
  ManualLanguage2[ManualLanguage2["French"] = 7] = "French";
  ManualLanguage2[ManualLanguage2["German"] = 8] = "German";
  ManualLanguage2[ManualLanguage2["Hungarian"] = 9] = "Hungarian";
  ManualLanguage2[ManualLanguage2["Italian"] = 10] = "Italian";
  ManualLanguage2[ManualLanguage2["Norwegian"] = 11] = "Norwegian";
  ManualLanguage2[ManualLanguage2["Polish"] = 12] = "Polish";
  ManualLanguage2[ManualLanguage2["Portuguese"] = 13] = "Portuguese";
  ManualLanguage2[ManualLanguage2["Russian"] = 14] = "Russian";
  ManualLanguage2[ManualLanguage2["Spanish"] = 15] = "Spanish";
  ManualLanguage2[ManualLanguage2["Swedish"] = 16] = "Swedish";
  return ManualLanguage2;
})(ManualLanguage || {});
var DocumentationItem = /* @__PURE__ */ ((DocumentationItem2) => {
  DocumentationItem2[DocumentationItem2["AdditionalCopies"] = 0] = "AdditionalCopies";
  DocumentationItem2[DocumentationItem2["AllowableNozzleLoadings"] = 1] = "AllowableNozzleLoadings";
  DocumentationItem2[DocumentationItem2["AllowableNozzleLoadingCalculation"] = 2] = "AllowableNozzleLoadingCalculation";
  DocumentationItem2[DocumentationItem2["AsmeStandardDocumentation"] = 3] = "AsmeStandardDocumentation";
  DocumentationItem2[DocumentationItem2["CopyOfCeTypeApprovalStrengthCalculation"] = 4] = "CopyOfCeTypeApprovalStrengthCalculation";
  DocumentationItem2[DocumentationItem2["CopyOfTypeApproval"] = 5] = "CopyOfTypeApproval";
  DocumentationItem2[DocumentationItem2["CyclicLoadCalculations3rdParty"] = 6] = "CyclicLoadCalculations3rdParty";
  DocumentationItem2[DocumentationItem2["DataBookElectronic"] = 7] = "DataBookElectronic";
  DocumentationItem2[DocumentationItem2["DimensionalDrawing"] = 8] = "DimensionalDrawing";
  DocumentationItem2[DocumentationItem2["DocumentListWithSubmitDays"] = 9] = "DocumentListWithSubmitDays";
  DocumentationItem2[DocumentationItem2["HydraulicPressureTestCertificate"] = 10] = "HydraulicPressureTestCertificate";
  DocumentationItem2[DocumentationItem2["HydraulicPressureTestProcedure"] = 11] = "HydraulicPressureTestProcedure";
  DocumentationItem2[DocumentationItem2["InspectionTestPlanItp"] = 12] = "InspectionTestPlanItp";
  DocumentationItem2[DocumentationItem2["UserManual"] = 13] = "UserManual";
  DocumentationItem2[DocumentationItem2["LeakingTestCertificate"] = 14] = "LeakingTestCertificate";
  DocumentationItem2[DocumentationItem2["MaterialList"] = 15] = "MaterialList";
  DocumentationItem2[DocumentationItem2["MaterialListCertificates"] = 16] = "MaterialListCertificates";
  DocumentationItem2[DocumentationItem2["NamePlateDataJci"] = 17] = "NamePlateDataJci";
  DocumentationItem2[DocumentationItem2["NdtOperatorQualificationCertificates"] = 18] = "NdtOperatorQualificationCertificates";
  DocumentationItem2[DocumentationItem2["NdtProcedures"] = 19] = "NdtProcedures";
  DocumentationItem2[DocumentationItem2["NdtTestReports"] = 20] = "NdtTestReports";
  DocumentationItem2[DocumentationItem2["NorsokCalculations"] = 21] = "NorsokCalculations";
  DocumentationItem2[DocumentationItem2["PaintingProcedure"] = 22] = "PaintingProcedure";
  DocumentationItem2[DocumentationItem2["PaintingReport"] = 23] = "PaintingReport";
  DocumentationItem2[DocumentationItem2["PedStandardDocumentation"] = 24] = "PedStandardDocumentation";
  DocumentationItem2[DocumentationItem2["PneumaticLeakTestProcedure"] = 25] = "PneumaticLeakTestProcedure";
  DocumentationItem2[DocumentationItem2["PressureEquipmentHazardAnalysisPeha"] = 26] = "PressureEquipmentHazardAnalysisPeha";
  DocumentationItem2[DocumentationItem2["PressureTestCertificate"] = 27] = "PressureTestCertificate";
  DocumentationItem2[DocumentationItem2["PressureTestDiagram"] = 28] = "PressureTestDiagram";
  DocumentationItem2[DocumentationItem2["ProgressReport"] = 29] = "ProgressReport";
  DocumentationItem2[DocumentationItem2["QualifiedWeldingProceduresWps"] = 30] = "QualifiedWeldingProceduresWps";
  DocumentationItem2[DocumentationItem2["SeismicCalculationUbc1997"] = 31] = "SeismicCalculationUbc1997";
  DocumentationItem2[DocumentationItem2["StrengthCalculationPedAd2000Vahterus"] = 32] = "StrengthCalculationPedAd2000Vahterus";
  DocumentationItem2[DocumentationItem2["StrengthCalculationEn134453Vahterus"] = 33] = "StrengthCalculationEn134453Vahterus";
  DocumentationItem2[DocumentationItem2["StrengthCalculationAsmeSecViiiDiv1Vahterus"] = 34] = "StrengthCalculationAsmeSecViiiDiv1Vahterus";
  DocumentationItem2[DocumentationItem2["StrengthCalculationPd55003rdParty"] = 35] = "StrengthCalculationPd55003rdParty";
  DocumentationItem2[DocumentationItem2["StrengthCalculationOther3rdParty"] = 36] = "StrengthCalculationOther3rdParty";
  DocumentationItem2[DocumentationItem2["StrengthCalculationForLeg"] = 37] = "StrengthCalculationForLeg";
  DocumentationItem2[DocumentationItem2["TimeSchedule"] = 38] = "TimeSchedule";
  DocumentationItem2[DocumentationItem2["WeldersQualificationsWqr"] = 39] = "WeldersQualificationsWqr";
  DocumentationItem2[DocumentationItem2["WeldingAndNdtPlan"] = 40] = "WeldingAndNdtPlan";
  DocumentationItem2[DocumentationItem2["WeldingMap"] = 41] = "WeldingMap";
  DocumentationItem2[DocumentationItem2["WeldingProcedureApprovalRecord"] = 42] = "WeldingProcedureApprovalRecord";
  DocumentationItem2[DocumentationItem2["WindLoadCalculationBsCp3"] = 43] = "WindLoadCalculationBsCp3";
  DocumentationItem2[DocumentationItem2["StrengthCalculationVahterusOy"] = 44] = "StrengthCalculationVahterusOy";
  DocumentationItem2[DocumentationItem2["StrengthCalculationAsmePed55003rdParty"] = 45] = "StrengthCalculationAsmePed55003rdParty";
  DocumentationItem2[DocumentationItem2["GeneralArrangementDetailDrawing"] = 46] = "GeneralArrangementDetailDrawing";
  DocumentationItem2[DocumentationItem2["ManufacturersDataReportU1"] = 47] = "ManufacturersDataReportU1";
  DocumentationItem2[DocumentationItem2["TechnicalDatasheet"] = 48] = "TechnicalDatasheet";
  DocumentationItem2[DocumentationItem2["StrengthCalculationForSupportUbc1997"] = 49] = "StrengthCalculationForSupportUbc1997";
  DocumentationItem2[DocumentationItem2["WindLoadCalculationAsce7"] = 50] = "WindLoadCalculationAsce7";
  DocumentationItem2[DocumentationItem2["HeliumLeakTestProcedureCertificate"] = 51] = "HeliumLeakTestProcedureCertificate";
  DocumentationItem2[DocumentationItem2["FerriteTestProcedureCertificate"] = 52] = "FerriteTestProcedureCertificate";
  DocumentationItem2[DocumentationItem2["HardnessTestProcedureCertificate"] = 53] = "HardnessTestProcedureCertificate";
  DocumentationItem2[DocumentationItem2["PmiProcedureCertificate"] = 54] = "PmiProcedureCertificate";
  DocumentationItem2[DocumentationItem2["CleaningProcedureReport"] = 55] = "CleaningProcedureReport";
  return DocumentationItem2;
})(DocumentationItem || {});
var OrpOrderStatusMappingLabel = /* @__PURE__ */ new Map([
  ["draft" /* Draft */, "Draft"],
  ["submitted" /* Submitted */, "Submitted"],
  ["deleted" /* Deleted */, "Deleted"]
]);
var ScmMappingLabel = /* @__PURE__ */ new Map([
  [0 /* No */, "No"],
  [1 /* Vzjg */, "VZJG"]
]);
var PricingPolicyOptionMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Fixed */, "Fixed"],
  [1 /* Attachment1 */, "Attachment 1"],
  [2 /* Attachment2 */, "Attachment 2"]
]);
var TermsOfDeliveryMappingLabel = /* @__PURE__ */ new Map([
  [0 /* DapEurope */, "DAP Europe"],
  [1 /* FcaKalanti */, "FCA Kalanti"],
  [2 /* FobFinlandHarborSea */, "FOB Finland harbour (sea)"],
  [3 /* CptDestinationAirport */, "CPT destination airport"],
  [4 /* CfrDestinationHarborSea */, "CFR destination harbour (sea)"],
  [5 /* CifDestinationHarborSea */, "CIF destination harbour (sea)"],
  [6 /* ExwKalanti */, "EXW Kalanti"],
  [7 /* Other */, "Other"]
]);
var TermsOfPaymentMappingLabel = /* @__PURE__ */ new Map([
  [0 /* V_30_DAYS_NET */, "30 days net"],
  [1 /* V_45_DAYS_NET */, "45 days net"],
  [2 /* V_60_DAYS_NET */, "60 days net"],
  [3 /* V_90_DAYS_NET */, "90 days net"],
  [4 /* V_14_DAYS_NET */, "14 days net"],
  [5 /* ADVANCE_PAYMENT */, "Advance payment"],
  [6 /* OTHER */, "Other"]
]);
var IndustrialSectorMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Chemical */, "Chemical"],
  [1 /* FoodAndBewerage */, "Food and beverage"],
  [2 /* Marine */, "Marine"],
  [3 /* OilAndGas */, "Oil and gas"],
  [4 /* PulpAndPaper */, "Pulp and paper"],
  [5 /* Pharmaceutical */, "Pharmaceutical"],
  [6 /* Other */, "Other"],
  [7 /* Many */, "Many"],
  [8 /* Refinery */, "Refinery"],
  [9 /* IndustrialGas */, "Industrial gas"],
  [10 /* Fertilizers */, "Fertilizers"],
  [11 /* EdibleOilAndBiodiesel */, "Edible oil and biodiesel"],
  [
    12 /* MiningMineralsAndMetalIndustry */,
    "Mining, minerals and metal industry"
  ],
  [13 /* HeatAndPower */, "Heat and power"],
  [14 /* Sports */, "Sports"],
  [15 /* DataCenter */, "Data center"],
  [16 /* Refrigeration */, "Refrigeration"],
  [17 /* Energy */, "Energy"],
  [18 /* HeatPump */, "Heat pump"],
  [19 /* Co2Transcritical */, "CO2 transcritical"],
  [20 /* Absorbtio */, "Absorbtion"]
]);
var DrawingLevelMappingLabel = /* @__PURE__ */ new Map([
  [
    0 /* DimensionalDataSheetStandard */,
    "Dimensional + data sheet (standard)"
  ],
  [
    1 /* DimensionalDataSheetStandardNdtAndWeldMap */,
    "Dimensional + data sheet (standard) + NDT and weld map"
  ],
  [
    2 /* GaDrawingDetailDrawingIncNdtAndWeldMap */,
    "GA drawing + detail drawing (incl. NDT and weld map)"
  ],
  [3 /* OtherCustomized */, "Other (customized)"]
]);
var DrawingApprovalMappingLabel = /* @__PURE__ */ new Map([
  [1 /* Normal */, "Normal"],
  [2 /* AgreedWithCustomer */, "Agreed with customer"]
]);
var DrawingCustDaysMappingLabel = /* @__PURE__ */ new Map([
  [1 /* Days1 */, "1 day"],
  [2 /* Days2 */, "2 days"],
  [4 /* Days4 */, "4 days"],
  [5 /* Days5 */, "5 days"],
  [14 /* Days14 */, "14 days"],
  [15 /* Other */, "Other"]
]);
var FinalDocumentationMappingLabel = /* @__PURE__ */ new Map([
  [
    0 /* DocumentationOnPdfEmailOrMFiles */,
    "Documentation on PDF (email or M-Files)"
  ],
  [1 /* DocumentationOnPaper */, "Documentation on paper"],
  [
    2 /* DocumentationOnPdfAndPaper */,
    "Documentation on PDF and paper"
  ]
]);
var ManualLanguageMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Chinese */, "Chinese"],
  [1 /* Czech */, "Czech"],
  [2 /* Danish */, "Danish"],
  [3 /* Dutch */, "Dutch"],
  [4 /* English */, "English"],
  [5 /* Estonia */, "Estonian"],
  [6 /* Finnish */, "Finnish"],
  [7 /* French */, "French"],
  [8 /* German */, "German"],
  [9 /* Hungarian */, "Hungarian"],
  [10 /* Italian */, "Italian"],
  [11 /* Norwegian */, "Norwegian"],
  [12 /* Polish */, "Polish"],
  [13 /* Portuguese */, "Portuguese"],
  [14 /* Russian */, "Russian"],
  [15 /* Spanish */, "Spanish"],
  [16 /* Swedish */, "Swedish"]
]);
var DocumentationItemMappingLabel = /* @__PURE__ */ new Map(
  [
    [
      0 /* AdditionalCopies */,
      "Additional Copys of the Documents (Specify no of pcs in text box below)"
    ],
    [
      1 /* AllowableNozzleLoadings */,
      "Allowable Nozzle Loadings (According to EN 13445-3:2002, 16.5)"
    ],
    [
      2 /* AllowableNozzleLoadingCalculation */,
      "Allowable Nozzle Loading Calculation (According to WRC 107 and BS5500 App. B)"
    ],
    [
      3 /* AsmeStandardDocumentation */,
      "ASME standard documentation"
    ],
    [
      4 /* CopyOfCeTypeApprovalStrengthCalculation */,
      "Copy of CE Type Approval Strength Calculation"
    ],
    [5 /* CopyOfTypeApproval */, "Copy of type approval"],
    [
      6 /* CyclicLoadCalculations3rdParty */,
      "Cyclic load calculations by 3rd party"
    ],
    [7 /* DataBookElectronic */, "Data Book in Electronic Format"],
    [8 /* DimensionalDrawing */, "Dimensional drawing"],
    [
      9 /* DocumentListWithSubmitDays */,
      "Document List With Submit Days"
    ],
    [
      10 /* HydraulicPressureTestCertificate */,
      "Hydraulic Pressure Test Certificate"
    ],
    [
      11 /* HydraulicPressureTestProcedure */,
      "Hydraulic Pressure Test Procedure"
    ],
    [12 /* InspectionTestPlanItp */, "Inspection & Test Plan ITP"],
    [13 /* UserManual */, "User Manual"],
    [14 /* LeakingTestCertificate */, "Leaking Test Certificate"],
    [15 /* MaterialList */, "Material List"],
    [
      16 /* MaterialListCertificates */,
      "Material List + Material Certificates"
    ],
    [17 /* NamePlateDataJci */, "Name Plate Data (JCI)"],
    [
      18 /* NdtOperatorQualificationCertificates */,
      "NDT Operator Qualification Certificates"
    ],
    [19 /* NdtProcedures */, "NDT Procedures"],
    [20 /* NdtTestReports */, "NDT Test Reports"],
    [21 /* NorsokCalculations */, "Norsok calculations"],
    [22 /* PaintingProcedure */, "Painting Procedure"],
    [23 /* PaintingReport */, "Painting Report"],
    [24 /* PedStandardDocumentation */, "PED standard documentation"],
    [
      25 /* PneumaticLeakTestProcedure */,
      "Pneumatic Leat Test Procedure"
    ],
    [
      26 /* PressureEquipmentHazardAnalysisPeha */,
      "Pressure Equipment Hazard Analysis (PEHA)"
    ],
    [27 /* PressureTestCertificate */, "Pressure Test Certificate"],
    [28 /* PressureTestDiagram */, "Pressure Test Diagram"],
    [29 /* ProgressReport */, "Progress report"],
    [
      30 /* QualifiedWeldingProceduresWps */,
      "Qualified Welding Procedures (WPS)"
    ],
    [
      31 /* SeismicCalculationUbc1997 */,
      "Seismic Calculation According to UBC 1997"
    ],
    [
      32 /* StrengthCalculationPedAd2000Vahterus */,
      "Strength calculation PED + AD2000 (By Vahterus)"
    ],
    [
      33 /* StrengthCalculationEn134453Vahterus */,
      "Strength calculation EN 13445-3 (By Vahterus)"
    ],
    [
      34 /* StrengthCalculationAsmeSecViiiDiv1Vahterus */,
      "Strength calculation ASME Sec VIII Div 1. (By Vahterus)"
    ],
    [
      35 /* StrengthCalculationPd55003rdParty */,
      "Strength calculation PD5500 (by 3rd party)"
    ],
    [
      36 /* StrengthCalculationOther3rdParty */,
      "Strength calculation Other (by 3rd party)"
    ],
    [
      37 /* StrengthCalculationForLeg */,
      "Strength Calculation for Leg"
    ],
    [38 /* TimeSchedule */, "Time Schedule"],
    [
      39 /* WeldersQualificationsWqr */,
      "Welders Qualifications (WQR)"
    ],
    [
      40 /* WeldingAndNdtPlan */,
      "Welding and NDT Plan (Welding Details & Scope of NDT)"
    ],
    [41 /* WeldingMap */, "Welding Map (Weld/WPS Locations)"],
    [
      42 /* WeldingProcedureApprovalRecord */,
      "Welding Procedure Approval Record / Procedure Qualified Record (WPAR / PQR)"
    ],
    [
      43 /* WindLoadCalculationBsCp3 */,
      "Wind Load Calculation According to BS-CP.3 Chapter V Part 2 1970"
    ],
    [
      44 /* StrengthCalculationVahterusOy */,
      "Strength Calculation (by Vahterus Oy)"
    ],
    [
      45 /* StrengthCalculationAsmePed55003rdParty */,
      "Strength Calculation ASME, PED5500 (by 3rd party)"
    ],
    [
      46 /* GeneralArrangementDetailDrawing */,
      "General Arrangement + Detail Drawing"
    ],
    [
      47 /* ManufacturersDataReportU1 */,
      "Manufacturer's Data Report (U-1)"
    ],
    [48 /* TechnicalDatasheet */, "Technical Datasheet"],
    [
      49 /* StrengthCalculationForSupportUbc1997 */,
      "Strength Calculation for Support According to UBC 1997"
    ],
    [
      50 /* WindLoadCalculationAsce7 */,
      "Wind Load Calculation According to ASCE 7"
    ],
    [
      51 /* HeliumLeakTestProcedureCertificate */,
      "Helium Leak Test Procedure / Certificate"
    ],
    [
      52 /* FerriteTestProcedureCertificate */,
      "Ferrite Test Procedure / Certificate"
    ],
    [
      53 /* HardnessTestProcedureCertificate */,
      "Hardness Test Procedure / Certificate"
    ],
    [54 /* PmiProcedureCertificate */, "PMI Procedure / Certificate"],
    [55 /* CleaningProcedureReport */, "Cleaning Procedure / Report"]
  ]
);

// src/enums/orp/orp-certification.enum.ts
var PedApproval = /* @__PURE__ */ ((PedApproval2) => {
  PedApproval2[PedApproval2["TypeApproval"] = 0] = "TypeApproval";
  PedApproval2[PedApproval2["SingleApproval"] = 1] = "SingleApproval";
  PedApproval2[PedApproval2["H"] = 2] = "H";
  PedApproval2[PedApproval2["H1"] = 3] = "H1";
  PedApproval2[PedApproval2["Other"] = 4] = "Other";
  return PedApproval2;
})(PedApproval || {});
var AsmeClassification = /* @__PURE__ */ ((AsmeClassification2) => {
  AsmeClassification2[AsmeClassification2["WithUStamp"] = 0] = "WithUStamp";
  AsmeClassification2[AsmeClassification2["WithoutUStamp"] = 1] = "WithoutUStamp";
  return AsmeClassification2;
})(AsmeClassification || {});
var DesignCode = /* @__PURE__ */ ((DesignCode2) => {
  DesignCode2[DesignCode2["EN_13445"] = 0] = "EN_13445";
  DesignCode2[DesignCode2["ASME_VIII_DIV_1"] = 1] = "ASME_VIII_DIV_1";
  DesignCode2[DesignCode2["PD_5500"] = 2] = "PD_5500";
  DesignCode2[DesignCode2["AD_2000"] = 3] = "AD_2000";
  DesignCode2[DesignCode2["GB_150"] = 4] = "GB_150";
  DesignCode2[DesignCode2["OTHER"] = 5] = "OTHER";
  return DesignCode2;
})(DesignCode || {});
var PedTypeApproval = /* @__PURE__ */ ((PedTypeApproval2) => {
  PedTypeApproval2[PedTypeApproval2["AD_2000_B_D_D1"] = 0] = "AD_2000_B_D_D1";
  PedTypeApproval2[PedTypeApproval2["EN_13445_B_D_D1"] = 1] = "EN_13445_B_D_D1";
  return PedTypeApproval2;
})(PedTypeApproval || {});
var PedSingleApproval = /* @__PURE__ */ ((PedSingleApproval2) => {
  PedSingleApproval2[PedSingleApproval2["AD_2000_B_F"] = 0] = "AD_2000_B_F";
  PedSingleApproval2[PedSingleApproval2["AD_2000_G"] = 1] = "AD_2000_G";
  PedSingleApproval2[PedSingleApproval2["EN_13445_B_F"] = 2] = "EN_13445_B_F";
  PedSingleApproval2[PedSingleApproval2["EN_13445_G"] = 3] = "EN_13445_G";
  PedSingleApproval2[PedSingleApproval2["ASME_VIII_DIV1_PED_G"] = 4] = "ASME_VIII_DIV1_PED_G";
  PedSingleApproval2[PedSingleApproval2["OTHER_DESIGN_CODE_G"] = 5] = "OTHER_DESIGN_CODE_G";
  return PedSingleApproval2;
})(PedSingleApproval || {});
var Ped13H = /* @__PURE__ */ ((Ped13H2) => {
  Ped13H2[Ped13H2["AD_2000_H"] = 0] = "AD_2000_H";
  Ped13H2[Ped13H2["AD_2000_H1"] = 1] = "AD_2000_H1";
  Ped13H2[Ped13H2["EN_13445_H"] = 2] = "EN_13445_H";
  Ped13H2[Ped13H2["EN_13445_H1"] = 3] = "EN_13445_H1";
  Ped13H2[Ped13H2["ASME_VIII_DIV1_H"] = 4] = "ASME_VIII_DIV1_H";
  Ped13H2[Ped13H2["ASME_VIII_DIV1_H1"] = 5] = "ASME_VIII_DIV1_H1";
  return Ped13H2;
})(Ped13H || {});
var PedInspectionAuthority = /* @__PURE__ */ ((PedInspectionAuthority2) => {
  PedInspectionAuthority2[PedInspectionAuthority2["DekraIndustrialOy"] = 0] = "DekraIndustrialOy";
  PedInspectionAuthority2[PedInspectionAuthority2["DekraGermany"] = 1] = "DekraGermany";
  PedInspectionAuthority2[PedInspectionAuthority2["Inspecta"] = 2] = "Inspecta";
  PedInspectionAuthority2[PedInspectionAuthority2["KiwaTarkastusOy"] = 3] = "KiwaTarkastusOy";
  PedInspectionAuthority2[PedInspectionAuthority2["Other"] = 4] = "Other";
  return PedInspectionAuthority2;
})(PedInspectionAuthority || {});
var AsmeInspectionAuthority = /* @__PURE__ */ ((AsmeInspectionAuthority2) => {
  AsmeInspectionAuthority2[AsmeInspectionAuthority2["T_V_TH_RINGEN"] = 0] = "T_V_TH_RINGEN";
  AsmeInspectionAuthority2[AsmeInspectionAuthority2["T_V_S_D"] = 1] = "T_V_S_D";
  return AsmeInspectionAuthority2;
})(AsmeInspectionAuthority || {});
var MarineOffshore = /* @__PURE__ */ ((MarineOffshore2) => {
  MarineOffshore2[MarineOffshore2["Marine"] = 0] = "Marine";
  MarineOffshore2[MarineOffshore2["Offshore"] = 1] = "Offshore";
  return MarineOffshore2;
})(MarineOffshore || {});
var MarineOffshoreInspectionAuthority = /* @__PURE__ */ ((MarineOffshoreInspectionAuthority2) => {
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["KIWA_TARKASTUS_OY"] = 0] = "KIWA_TARKASTUS_OY";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["DNV"] = 1] = "DNV";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["DNV_OS"] = 2] = "DNV_OS";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["LR"] = 3] = "LR";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["LR_OS"] = 4] = "LR_OS";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["BV"] = 5] = "BV";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["GL"] = 6] = "GL";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["RINA"] = 7] = "RINA";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["ABS"] = 8] = "ABS";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["ABS_OS"] = 9] = "ABS_OS";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["CLASS_NK"] = 10] = "CLASS_NK";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["RMRS"] = 11] = "RMRS";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["T_V_S_D"] = 12] = "T_V_S_D";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["CUSTOMER"] = 13] = "CUSTOMER";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["KRS"] = 14] = "KRS";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["CCS"] = 15] = "CCS";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["OTHER"] = 16] = "OTHER";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["DNV_GL"] = 17] = "DNV_GL";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["DNV_GL_OS"] = 18] = "DNV_GL_OS";
  MarineOffshoreInspectionAuthority2[MarineOffshoreInspectionAuthority2["INSPECTA"] = 19] = "INSPECTA";
  return MarineOffshoreInspectionAuthority2;
})(MarineOffshoreInspectionAuthority || {});
var ChinaClassification = /* @__PURE__ */ ((ChinaClassification2) => {
  ChinaClassification2[ChinaClassification2["PED_AD_SELO"] = 0] = "PED_AD_SELO";
  ChinaClassification2[ChinaClassification2["ASME_SELO"] = 1] = "ASME_SELO";
  ChinaClassification2[ChinaClassification2["PED_EN13445_3_SELO"] = 2] = "PED_EN13445_3_SELO";
  return ChinaClassification2;
})(ChinaClassification || {});
var OtherClassification = /* @__PURE__ */ ((OtherClassification2) => {
  OtherClassification2[OtherClassification2["MomKiwaTarkastus"] = 0] = "MomKiwaTarkastus";
  OtherClassification2[OtherClassification2["DoshKiwaSweden"] = 1] = "DoshKiwaSweden";
  OtherClassification2[OtherClassification2["Bserr20037B2"] = 2] = "Bserr20037B2";
  OtherClassification2[OtherClassification2["Kgs"] = 3] = "Kgs";
  OtherClassification2[OtherClassification2["MomInspecta"] = 4] = "MomInspecta";
  OtherClassification2[OtherClassification2["DoshInspecta"] = 5] = "DoshInspecta";
  return OtherClassification2;
})(OtherClassification || {});
var PedApprovalMappingLabel = /* @__PURE__ */ new Map([
  [0 /* TypeApproval */, "Type approval"],
  [1 /* SingleApproval */, "Single approval"],
  [2 /* H */, "H"],
  [3 /* H1 */, "H1"],
  [4 /* Other */, "Other"]
]);
var AsmeClassificationMappingLabel = /* @__PURE__ */ new Map([
  [0 /* WithUStamp */, "With U-Stamp"],
  [1 /* WithoutUStamp */, "Without U-Stamp"]
]);
var DesignCodeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* EN_13445 */, "EN 13445"],
  [1 /* ASME_VIII_DIV_1 */, "ASME VIII Div.1"],
  [2 /* PD_5500 */, "PD 5500"],
  [3 /* AD_2000 */, "AD 2000"],
  [4 /* GB_150 */, "GB 150"],
  [5 /* OTHER */, "Other"]
]);
var asmeClassificationMappingLabel = /* @__PURE__ */ new Map([
  [0 /* WithUStamp */, "U-STAMP"],
  [1 /* WithoutUStamp */, "Without U-STAMP"]
]);
var marineOffshoreMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Marine */, "Marine"],
  [1 /* Offshore */, "Offshore"]
]);
var pedTypeApprovalMappingLabel = /* @__PURE__ */ new Map([
  [0 /* AD_2000_B_D_D1 */, "AD 2000 CALCULATIONS (MODULE B+ D/D1)"],
  [1 /* EN_13445_B_D_D1 */, "EN 13445 (MODULE B+ D/D1)"]
]);
var pedSingleApprovalMappingLabel = /* @__PURE__ */ new Map(
  [
    [0 /* AD_2000_B_F */, "AD 2000 CALCULATIONS (MODULE B+F)"],
    [1 /* AD_2000_G */, "AD 2000 CALCULATIONS (MODULE G)"],
    [2 /* EN_13445_B_F */, "EN 13445 (MODULE B+F)"],
    [3 /* EN_13445_G */, "EN 13445 (MODULE G)"],
    [
      4 /* ASME_VIII_DIV1_PED_G */,
      "ASME VIII Div.1 (w/o U-STAMP)+PED (MODULE G)"
    ],
    [5 /* OTHER_DESIGN_CODE_G */, "OTHER DESIGN CODE (MODULE G)"]
  ]
);
var ped13HMappingLabel = /* @__PURE__ */ new Map([
  [0 /* AD_2000_H */, "AD 2000 CALCULATIONS (MODULE H)"],
  [1 /* AD_2000_H1 */, "AD 2000 CALCULATIONS (MODULE H1)"],
  [2 /* EN_13445_H */, "EN 13445 (Module H)"],
  [3 /* EN_13445_H1 */, "EN 13445 (Module H1)"],
  [4 /* ASME_VIII_DIV1_H */, "ASME VIII Div.1 (w/o U-STAMP)+(MODULE H)"],
  [5 /* ASME_VIII_DIV1_H1 */, "ASME VIII Div.1 (w/o U-STAMP)+(MODULE H1)"]
]);
var PedInspectionAuthorityMappingLabel = /* @__PURE__ */ new Map([
  [0 /* DekraIndustrialOy */, "Dekra Industrial Oy"],
  [1 /* DekraGermany */, "Dekra Germany"],
  [2 /* Inspecta */, "Inspecta"],
  [3 /* KiwaTarkastusOy */, "Kiwa Tarkastus Oy"],
  [4 /* Other */, "Other"]
]);
var AsmeInspectionAuthorityMappingLabel = /* @__PURE__ */ new Map([
  [0 /* T_V_TH_RINGEN */, "T\xDCV Th\xFCringen"],
  [1 /* T_V_S_D */, "T\xDCV S\xDCD"]
]);
var MarineOffshoreMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Marine */, "Marine"],
  [1 /* Offshore */, "Offshore"]
]);
var MarineOffshoreInspectionAuthorityMappingLabel = /* @__PURE__ */ new Map([
  [0 /* KIWA_TARKASTUS_OY */, "Kiwa Tarkastus Oy"],
  [1 /* DNV */, "DNV"],
  [2 /* DNV_OS */, "DNV OS"],
  [3 /* LR */, "LR"],
  [4 /* LR_OS */, "LR OS"],
  [5 /* BV */, "BV"],
  [6 /* GL */, "GL"],
  [7 /* RINA */, "Rina"],
  [8 /* ABS */, "ABS"],
  [9 /* ABS_OS */, "ABS OS"],
  [10 /* CLASS_NK */, "Class NK"],
  [11 /* RMRS */, "RMRS"],
  [12 /* T_V_S_D */, "T\xDCV S\xDCD"],
  [13 /* CUSTOMER */, "Asiakas"],
  [14 /* KRS */, "KRS"],
  [15 /* CCS */, "CCS"],
  [16 /* OTHER */, "Other"],
  [17 /* DNV_GL */, "DNV GL"],
  [18 /* DNV_GL_OS */, "DNV GL OS"],
  [19 /* INSPECTA */, "Inspecta"]
]);
var ChinaClassificationMappingLabel = /* @__PURE__ */ new Map([
  [0 /* PED_AD_SELO */, "PED + AD + SELO"],
  [1 /* ASME_SELO */, "ASME + SELO"],
  [2 /* PED_EN13445_3_SELO */, "PED + EN 13445-3 + SELO"]
]);
var OtherClassificationMappingLabel = /* @__PURE__ */ new Map([
  [0 /* MomKiwaTarkastus */, "MOM \u2013 Kiwa Tarkastus Oy"],
  [1 /* DoshKiwaSweden */, "DOSH \u2013 Kiwa Sweden Ab"],
  [2 /* Bserr20037B2 */, "BSERR Decision No. 20-037 chapter B.2"],
  [3 /* Kgs */, "KGS"],
  [4 /* MomInspecta */, "MOM \u2013 Inspecta"],
  [5 /* DoshInspecta */, "DOSH \u2013 Inspecta"]
]);

// src/enums/orp/orp-material.enum.ts
var SupportMaterial = /* @__PURE__ */ ((SupportMaterial2) => {
  SupportMaterial2[SupportMaterial2["StainlessSteel"] = 0] = "StainlessSteel";
  SupportMaterial2[SupportMaterial2["CarbonSteel"] = 1] = "CarbonSteel";
  return SupportMaterial2;
})(SupportMaterial || {});
var CorrosionAllowance = /* @__PURE__ */ ((CorrosionAllowance2) => {
  CorrosionAllowance2[CorrosionAllowance2["SS_0MM"] = 0] = "SS_0MM";
  CorrosionAllowance2[CorrosionAllowance2["CS_1_5MM"] = 1] = "CS_1_5MM";
  CorrosionAllowance2[CorrosionAllowance2["OTHER"] = 2] = "OTHER";
  return CorrosionAllowance2;
})(CorrosionAllowance || {});
var Insulation = /* @__PURE__ */ ((Insulation2) => {
  Insulation2[Insulation2["No"] = 0] = "No";
  Insulation2[Insulation2["Complete"] = 1] = "Complete";
  Insulation2[Insulation2["OnlySupports"] = 2] = "OnlySupports";
  return Insulation2;
})(Insulation || {});
var InsulationSupportsType = /* @__PURE__ */ ((InsulationSupportsType2) => {
  InsulationSupportsType2[InsulationSupportsType2["Lugs"] = 0] = "Lugs";
  InsulationSupportsType2[InsulationSupportsType2["Rings"] = 1] = "Rings";
  return InsulationSupportsType2;
})(InsulationSupportsType || {});
var InsulationCompleteType = /* @__PURE__ */ ((InsulationCompleteType2) => {
  InsulationCompleteType2[InsulationCompleteType2["Aluminum"] = 0] = "Aluminum";
  InsulationCompleteType2[InsulationCompleteType2["Aisi"] = 1] = "Aisi";
  return InsulationCompleteType2;
})(InsulationCompleteType || {});
var SupportMaterialMappingLabel = /* @__PURE__ */ new Map([
  [0 /* StainlessSteel */, "Stainless steel"],
  [1 /* CarbonSteel */, "Carbon steel"]
]);
var InsulationMappingLabel = /* @__PURE__ */ new Map([
  [0 /* No */, "No"],
  [1 /* Complete */, "Complete"],
  [2 /* OnlySupports */, "Only supports"]
]);
var InsulationSupportsTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Lugs */, "Lugs"],
  [1 /* Rings */, "Rings"]
]);
var InsulationCompleteTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Aluminum */, "Aluminium"],
  [1 /* Aisi */, "AISI"]
]);
var CorrosionAllowanceMappingLabel = /* @__PURE__ */ new Map([
  [0 /* SS_0MM */, "0 mm (stainless steel)"],
  [1 /* CS_1_5MM */, "1.5 mm (carbon steel)"],
  [2 /* OTHER */, "Other"]
]);

// src/enums/orp/orp-testing.enum.ts
var ProductTest = /* @__PURE__ */ ((ProductTest2) => {
  ProductTest2[ProductTest2["AsBuiltMeasurement"] = 0] = "AsBuiltMeasurement";
  ProductTest2[ProductTest2["EnergyTest"] = 1] = "EnergyTest";
  ProductTest2[ProductTest2["ThermalShockTest"] = 2] = "ThermalShockTest";
  ProductTest2[ProductTest2["EndoscopeInspection"] = 3] = "EndoscopeInspection";
  ProductTest2[ProductTest2["PressureDiagram"] = 4] = "PressureDiagram";
  ProductTest2[ProductTest2["BurstTest"] = 5] = "BurstTest";
  ProductTest2[ProductTest2["HydraulicPressureTest"] = 6] = "HydraulicPressureTest";
  return ProductTest2;
})(ProductTest || {});
var PlatePressureTest = /* @__PURE__ */ ((PlatePressureTest2) => {
  PlatePressureTest2[PlatePressureTest2["TestWaterInhibited"] = 0] = "TestWaterInhibited";
  PlatePressureTest2[PlatePressureTest2["Water"] = 1] = "Water";
  PlatePressureTest2[PlatePressureTest2["TapWater"] = 2] = "TapWater";
  PlatePressureTest2[PlatePressureTest2["TapWaterNonStandard"] = 3] = "TapWaterNonStandard";
  PlatePressureTest2[PlatePressureTest2["DistilledWater"] = 4] = "DistilledWater";
  PlatePressureTest2[PlatePressureTest2["NdtTesting"] = 5] = "NdtTesting";
  PlatePressureTest2[PlatePressureTest2["NdtConnectionWelds"] = 6] = "NdtConnectionWelds";
  PlatePressureTest2[PlatePressureTest2["NoNdtStubEndsOnly"] = 7] = "NoNdtStubEndsOnly";
  PlatePressureTest2[PlatePressureTest2["EndPlatePressurizedSeparately"] = 8] = "EndPlatePressurizedSeparately";
  return PlatePressureTest2;
})(PlatePressureTest || {});
var ShellPressureTest = /* @__PURE__ */ ((ShellPressureTest2) => {
  ShellPressureTest2[ShellPressureTest2["TapWater"] = 0] = "TapWater";
  ShellPressureTest2[ShellPressureTest2["TestWaterInhibited"] = 1] = "TestWaterInhibited";
  ShellPressureTest2[ShellPressureTest2["DistilledWater"] = 2] = "DistilledWater";
  return ShellPressureTest2;
})(ShellPressureTest || {});
var HeliumVacuumTest = /* @__PURE__ */ ((HeliumVacuumTest2) => {
  HeliumVacuumTest2[HeliumVacuumTest2["No"] = 0] = "No";
  HeliumVacuumTest2[HeliumVacuumTest2["VacuumInShell"] = 1] = "VacuumInShell";
  HeliumVacuumTest2[HeliumVacuumTest2["VacuumInPlates"] = 2] = "VacuumInPlates";
  return HeliumVacuumTest2;
})(HeliumVacuumTest || {});
var PlateShellDrying = /* @__PURE__ */ ((PlateShellDrying2) => {
  PlateShellDrying2[PlateShellDrying2["NoDrying"] = 0] = "NoDrying";
  PlateShellDrying2[PlateShellDrying2["HotAirBoth"] = 1] = "HotAirBoth";
  PlateShellDrying2[PlateShellDrying2["VacuumShellHotAirPlate"] = 2] = "VacuumShellHotAirPlate";
  PlateShellDrying2[PlateShellDrying2["VacuumPlateHotAirShell"] = 3] = "VacuumPlateHotAirShell";
  PlateShellDrying2[PlateShellDrying2["VacuumBoth"] = 4] = "VacuumBoth";
  PlateShellDrying2[PlateShellDrying2["HotAirPlatePack"] = 5] = "HotAirPlatePack";
  PlateShellDrying2[PlateShellDrying2["VacuumPlate"] = 6] = "VacuumPlate";
  return PlateShellDrying2;
})(PlateShellDrying || {});
var N2Filling = /* @__PURE__ */ ((N2Filling2) => {
  N2Filling2[N2Filling2["No"] = 0] = "No";
  N2Filling2[N2Filling2["PlateAndShell"] = 1] = "PlateAndShell";
  N2Filling2[N2Filling2["ShellSide"] = 2] = "ShellSide";
  N2Filling2[N2Filling2["PlateSide"] = 3] = "PlateSide";
  return N2Filling2;
})(N2Filling || {});
var SpecialTesting = /* @__PURE__ */ ((SpecialTesting2) => {
  SpecialTesting2[SpecialTesting2["No"] = 0] = "No";
  SpecialTesting2[SpecialTesting2["WaterShellSide"] = 1] = "WaterShellSide";
  SpecialTesting2[SpecialTesting2["WaterPlateSide"] = 2] = "WaterPlateSide";
  SpecialTesting2[SpecialTesting2["WaterBothSides"] = 3] = "WaterBothSides";
  return SpecialTesting2;
})(SpecialTesting || {});
var SparePartOption = /* @__PURE__ */ ((SparePartOption2) => {
  SparePartOption2[SparePartOption2["NO"] = 0] = "NO";
  SparePartOption2[SparePartOption2["V_10_BOLTING_200_GASKETS"] = 1] = "V_10_BOLTING_200_GASKETS";
  SparePartOption2[SparePartOption2["OTHER"] = 2] = "OTHER";
  return SparePartOption2;
})(SparePartOption || {});
var ProductTestMappingLabel = /* @__PURE__ */ new Map([
  [0 /* AsBuiltMeasurement */, "As-built measurement"],
  [1 /* EnergyTest */, "Energy test"],
  [2 /* ThermalShockTest */, "Thermal shock test"],
  [3 /* EndoscopeInspection */, "Endoscope inspection"],
  [4 /* PressureDiagram */, "Pressure diagram required"],
  [5 /* BurstTest */, "Burst test"],
  [6 /* HydraulicPressureTest */, "Hydraulic pressure test"]
]);
var PlatePressureTestMappingLabel = /* @__PURE__ */ new Map(
  [
    [
      0 /* TestWaterInhibited */,
      "Test water including 1-2% corrosion inhibitor (standard for carbon steel)"
    ],
    [1 /* Water */, "Water"],
    [
      2 /* TapWater */,
      "Tap water (standard for stainless steels and titanium)"
    ],
    [3 /* TapWaterNonStandard */, "Tap water (not standard)"],
    [4 /* DistilledWater */, "Distilled water (special cases only)"],
    [
      5 /* NdtTesting */,
      "Not acceptable with water, testing with NDT (standard for refrigerants and oils)"
    ],
    [
      6 /* NdtConnectionWelds */,
      "Not acceptable with water, NDT testing for connection welds (standard for refrigerants and oils)"
    ],
    [
      7 /* NoNdtStubEndsOnly */,
      "Not acceptable with water, no NDT test, only stub ends, no weld seams"
    ],
    [
      8 /* EndPlatePressurizedSeparately */,
      "PSHE 6-9: end plate for connection pressurized separately"
    ]
  ]
);
var ShellPressureTestMappingLabel = /* @__PURE__ */ new Map(
  [
    [
      0 /* TapWater */,
      "Tap water (standard for stainless steels and titanium)"
    ],
    [
      1 /* TestWaterInhibited */,
      "Test water including 1-2% corrosion inhibitor (standard for carbon steel)"
    ],
    [2 /* DistilledWater */, "Distilled water (special cases only)"]
  ]
);
var PlateShellDryingMappingLabel = /* @__PURE__ */ new Map([
  [0 /* NoDrying */, "No drying"],
  [1 /* HotAirBoth */, "Hot air, plate and shell side"],
  [
    2 /* VacuumShellHotAirPlate */,
    "Vacuum shell side, hot air plate side"
  ],
  [
    3 /* VacuumPlateHotAirShell */,
    "Vacuum plate side, hot air shell side"
  ],
  [4 /* VacuumBoth */, "Vacuum, plate and shell side"],
  [5 /* HotAirPlatePack */, "Hot air, plate pack"],
  [6 /* VacuumPlate */, "Vacuum, plate side"]
]);
var N2FillingMappingLabel = /* @__PURE__ */ new Map([
  [0 /* No */, "No"],
  [1 /* PlateAndShell */, "Plate and shell side"],
  [2 /* ShellSide */, "Shell side"],
  [3 /* PlateSide */, "Plate side"]
]);
var SpecialTestingMappingLabel = /* @__PURE__ */ new Map([
  [0 /* No */, "No"],
  [1 /* WaterShellSide */, "Water, shell side"],
  [2 /* WaterPlateSide */, "Water, plate side"],
  [3 /* WaterBothSides */, "Water, both sides"]
]);
var SparePartOptionMappingLabel = /* @__PURE__ */ new Map([
  [0 /* NO */, "No"],
  [1 /* V_10_BOLTING_200_GASKETS */, "10% bolting, 200% gaskets"],
  [2 /* OTHER */, "Other"]
]);
var HeliumVacuumTestMappingLabel = /* @__PURE__ */ new Map([
  [0 /* No */, "No"],
  [1 /* VacuumInShell */, "Vacuum in shell"],
  [2 /* VacuumInPlates */, "Vacuum in plates"]
]);

// src/enums/orp/orp-construction.enum.ts
var Construction = /* @__PURE__ */ ((Construction2) => {
  Construction2[Construction2["Welded"] = 0] = "Welded";
  Construction2[Construction2["Compact"] = 1] = "Compact";
  Construction2[Construction2["Platepack"] = 2] = "Platepack";
  Construction2[Construction2["Openable"] = 3] = "Openable";
  Construction2[Construction2["Combined"] = 4] = "Combined";
  Construction2[Construction2["JciConstruction"] = 5] = "JciConstruction";
  Construction2[Construction2["WeldedKettle"] = 6] = "WeldedKettle";
  Construction2[Construction2["OpenableKettle"] = 7] = "OpenableKettle";
  Construction2[Construction2["DropletSeparator"] = 8] = "DropletSeparator";
  return Construction2;
})(Construction || {});
var constructionMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Welded */, "Welded heat exchanger"],
  [1 /* Compact */, "Compact"],
  [2 /* Platepack */, "Plate pack"],
  [3 /* Openable */, "Openable heat exchanger"],
  [4 /* Combined */, "Combined"],
  [5 /* JciConstruction */, "JCI construction"],
  [6 /* WeldedKettle */, "Welded kettle"],
  [7 /* OpenableKettle */, "Openable kettle"],
  [8 /* DropletSeparator */, "Droplet separator"]
]);
var PlatePackCode = /* @__PURE__ */ ((PlatePackCode2) => {
  PlatePackCode2[PlatePackCode2["Ped"] = 0] = "Ped";
  PlatePackCode2[PlatePackCode2["Asme"] = 1] = "Asme";
  return PlatePackCode2;
})(PlatePackCode || {});
var CombinedFillingBoxes = /* @__PURE__ */ ((CombinedFillingBoxes2) => {
  CombinedFillingBoxes2[CombinedFillingBoxes2["WithoutFillingBoxes"] = 0] = "WithoutFillingBoxes";
  CombinedFillingBoxes2[CombinedFillingBoxes2["WithFillingBoxes"] = 1] = "WithFillingBoxes";
  return CombinedFillingBoxes2;
})(CombinedFillingBoxes || {});
var ApplicationOption = /* @__PURE__ */ ((ApplicationOption2) => {
  ApplicationOption2[ApplicationOption2["LIQ_001"] = 101] = "LIQ_001";
  ApplicationOption2[ApplicationOption2["LIQ_002"] = 102] = "LIQ_002";
  ApplicationOption2[ApplicationOption2["LIQ_003"] = 103] = "LIQ_003";
  ApplicationOption2[ApplicationOption2["LIQ_004"] = 104] = "LIQ_004";
  ApplicationOption2[ApplicationOption2["GAS_001"] = 201] = "GAS_001";
  ApplicationOption2[ApplicationOption2["GAS_002"] = 202] = "GAS_002";
  ApplicationOption2[ApplicationOption2["GAS_003"] = 203] = "GAS_003";
  ApplicationOption2[ApplicationOption2["GAS_004"] = 204] = "GAS_004";
  ApplicationOption2[ApplicationOption2["COND_001"] = 301] = "COND_001";
  ApplicationOption2[ApplicationOption2["COND_002"] = 302] = "COND_002";
  ApplicationOption2[ApplicationOption2["COND_003"] = 303] = "COND_003";
  ApplicationOption2[ApplicationOption2["COND_004"] = 304] = "COND_004";
  ApplicationOption2[ApplicationOption2["COND_005"] = 305] = "COND_005";
  ApplicationOption2[ApplicationOption2["COND_006"] = 306] = "COND_006";
  ApplicationOption2[ApplicationOption2["EVAP_001"] = 401] = "EVAP_001";
  ApplicationOption2[ApplicationOption2["EVAP_002"] = 402] = "EVAP_002";
  ApplicationOption2[ApplicationOption2["EVAP_003"] = 403] = "EVAP_003";
  ApplicationOption2[ApplicationOption2["COMB_001"] = 501] = "COMB_001";
  ApplicationOption2[ApplicationOption2["COMB_002"] = 502] = "COMB_002";
  ApplicationOption2[ApplicationOption2["COMB_003"] = 503] = "COMB_003";
  ApplicationOption2[ApplicationOption2["COMB_004"] = 504] = "COMB_004";
  ApplicationOption2[ApplicationOption2["COMB_005"] = 505] = "COMB_005";
  ApplicationOption2[ApplicationOption2["CASC_001"] = 601] = "CASC_001";
  ApplicationOption2[ApplicationOption2["CASC_002"] = 602] = "CASC_002";
  ApplicationOption2[ApplicationOption2["CRYO_001"] = 701] = "CRYO_001";
  ApplicationOption2[ApplicationOption2["CRYO_002"] = 702] = "CRYO_002";
  ApplicationOption2[ApplicationOption2["KETTLE_001"] = 801] = "KETTLE_001";
  ApplicationOption2[ApplicationOption2["KETTLE_002"] = 802] = "KETTLE_002";
  ApplicationOption2[ApplicationOption2["KETTLE_003"] = 803] = "KETTLE_003";
  ApplicationOption2[ApplicationOption2["VENT_002"] = 902] = "VENT_002";
  ApplicationOption2[ApplicationOption2["VENT_003"] = 903] = "VENT_003";
  ApplicationOption2[ApplicationOption2["GAS_SEP_001"] = 1001] = "GAS_SEP_001";
  ApplicationOption2[ApplicationOption2["GAS_SEP_002"] = 1002] = "GAS_SEP_002";
  ApplicationOption2[ApplicationOption2["MULT_001"] = 1101] = "MULT_001";
  ApplicationOption2[ApplicationOption2["JCI_1IN1"] = 1201] = "JCI_1IN1";
  ApplicationOption2[ApplicationOption2["JCI_2IN1_DES"] = 1202] = "JCI_2IN1_DES";
  ApplicationOption2[ApplicationOption2["JCI_2IN1_SUB"] = 1203] = "JCI_2IN1_SUB";
  ApplicationOption2[ApplicationOption2["JCI_3IN1"] = 1204] = "JCI_3IN1";
  ApplicationOption2[ApplicationOption2["SYS_001"] = 1301] = "SYS_001";
  ApplicationOption2[ApplicationOption2["SYS_002"] = 1302] = "SYS_002";
  ApplicationOption2[ApplicationOption2["OTHER"] = 1401] = "OTHER";
  return ApplicationOption2;
})(ApplicationOption || {});
var applicationOptionMappingLabel = /* @__PURE__ */ new Map(
  [
    // --- LIQ ---
    [101 /* LIQ_001 */, "Liquid/liquid"],
    [102 /* LIQ_002 */, "Liquid-liquid eco"],
    [103 /* LIQ_003 */, "Oil cooler ref"],
    [104 /* LIQ_004 */, "Subcooler ref"],
    // --- GAS ---
    [201 /* GAS_001 */, "Liquid/Gas"],
    [202 /* GAS_002 */, "Gas/Gas"],
    [203 /* GAS_003 */, "De superheater ref"],
    [204 /* GAS_004 */, "Superheater ref"],
    // --- COND ---
    [301 /* COND_001 */, "Standard Condenser"],
    [302 /* COND_002 */, "Condenser ref"],
    [303 /* COND_003 */, "Steam Condenser"],
    [304 /* COND_004 */, "Cargo Condenser"],
    [305 /* COND_005 */, "Large Shell Condenser"],
    [306 /* COND_006 */, "Partial Condenser (ref)"],
    // --- EVAP ---
    [401 /* EVAP_001 */, "Standard Evaporator"],
    [402 /* EVAP_002 */, "Flooded evaporator ref"],
    [403 /* EVAP_003 */, "DX-Evaporator"],
    // --- COMB ---
    [501 /* COMB_001 */, "Combined ref"],
    [502 /* COMB_002 */, "Combined C, ref"],
    [503 /* COMB_003 */, "Combined Economizer"],
    [504 /* COMB_004 */, "Combined Reboiler"],
    [505 /* COMB_005 */, "Combined Plus"],
    // --- CASC ---
    [601 /* CASC_001 */, "Standard Cascade"],
    [602 /* CASC_002 */, "DX-Cascade"],
    // --- CRYO ---
    [701 /* CRYO_001 */, "Cryo Evaporator"],
    [702 /* CRYO_002 */, "Cryo 2in1"],
    // --- KETTLE ---
    [801 /* KETTLE_001 */, "Kettle Reboiler"],
    [802 /* KETTLE_002 */, "Kettle Reboiler"],
    [803 /* KETTLE_003 */, "Kettle Reboiler + weir"],
    // --- VENT ---
    [902 /* VENT_002 */, "Vent Condenser Type 2"],
    [903 /* VENT_003 */, "Vent Condenser Type 3"],
    // --- GAS SEP ---
    [1001 /* GAS_SEP_001 */, "Separating gas cooler (New)"],
    [1002 /* GAS_SEP_002 */, "Vapour recovery condenser"],
    // --- MULT ---
    [1101 /* MULT_001 */, "Multi-Condenser"],
    // --- JCI ---
    [1201 /* JCI_1IN1 */, "JCI 1in1"],
    [1202 /* JCI_2IN1_DES */, "JCI 2in1des"],
    [1203 /* JCI_2IN1_SUB */, "JCI 2in1sub"],
    [1204 /* JCI_3IN1 */, "JCI 3in1"],
    // --- SYS ---
    [1301 /* SYS_001 */, "VES 1"],
    [1302 /* SYS_002 */, "VES 2"],
    // --- OTHER ---
    [1401 /* OTHER */, "Other"]
  ]
);
var applicationOptionsBySizingApplication = {
  [1 /* OnePhase */]: [
    101 /* LIQ_001 */,
    102 /* LIQ_002 */,
    103 /* LIQ_003 */,
    104 /* LIQ_004 */,
    201 /* GAS_001 */,
    202 /* GAS_002 */,
    203 /* GAS_003 */,
    204 /* GAS_004 */
  ],
  [2 /* Condenser */]: [
    301 /* COND_001 */,
    302 /* COND_002 */,
    303 /* COND_003 */,
    304 /* COND_004 */,
    305 /* COND_005 */,
    902 /* VENT_002 */,
    903 /* VENT_003 */,
    1001 /* GAS_SEP_001 */,
    1002 /* GAS_SEP_002 */
  ],
  [3 /* Evaporator */]: [
    401 /* EVAP_001 */,
    402 /* EVAP_002 */,
    501 /* COMB_001 */,
    502 /* COMB_002 */,
    701 /* CRYO_001 */,
    403 /* EVAP_003 */,
    503 /* COMB_003 */,
    504 /* COMB_004 */,
    801 /* KETTLE_001 */,
    802 /* KETTLE_002 */,
    505 /* COMB_005 */
  ],
  [4 /* Cascade */]: [
    601 /* CASC_001 */,
    602 /* CASC_002 */,
    501 /* COMB_001 */,
    502 /* COMB_002 */,
    504 /* COMB_004 */,
    801 /* KETTLE_001 */,
    802 /* KETTLE_002 */,
    505 /* COMB_005 */
  ],
  [5 /* PartialCascade */]: [
    701 /* CRYO_001 */,
    702 /* CRYO_002 */,
    304 /* COND_004 */,
    902 /* VENT_002 */,
    903 /* VENT_003 */,
    305 /* COND_005 */,
    1001 /* GAS_SEP_001 */,
    1002 /* GAS_SEP_002 */,
    801 /* KETTLE_001 */,
    504 /* COMB_004 */,
    306 /* COND_006 */,
    802 /* KETTLE_002 */,
    803 /* KETTLE_003 */,
    1401 /* OTHER */
  ],
  [6 /* MultiCondenser */]: [
    1101 /* MULT_001 */,
    1201 /* JCI_1IN1 */,
    1202 /* JCI_2IN1_DES */,
    1203 /* JCI_2IN1_SUB */,
    1204 /* JCI_3IN1 */
  ],
  [7 /* DropletSeparator */]: [
    1301 /* SYS_001 */,
    1302 /* SYS_002 */
  ]
};
var NamePlateType = /* @__PURE__ */ ((NamePlateType2) => {
  NamePlateType2[NamePlateType2["StandardAluminumAisi"] = 0] = "StandardAluminumAisi";
  NamePlateType2[NamePlateType2["StandardAisi"] = 1] = "StandardAisi";
  NamePlateType2[NamePlateType2["CustomerNamePlateByVahterus"] = 2] = "CustomerNamePlateByVahterus";
  NamePlateType2[NamePlateType2["CustomerNamePlateProvidedByCustomer"] = 3] = "CustomerNamePlateProvidedByCustomer";
  NamePlateType2[NamePlateType2["PlatePackNamePlate"] = 4] = "PlatePackNamePlate";
  return NamePlateType2;
})(NamePlateType || {});
var NamePlateLanguage = /* @__PURE__ */ ((NamePlateLanguage2) => {
  NamePlateLanguage2[NamePlateLanguage2["English"] = 0] = "English";
  NamePlateLanguage2[NamePlateLanguage2["EnglishItalian"] = 1] = "EnglishItalian";
  NamePlateLanguage2[NamePlateLanguage2["EnglishRussian"] = 2] = "EnglishRussian";
  NamePlateLanguage2[NamePlateLanguage2["EnglishChinese"] = 3] = "EnglishChinese";
  return NamePlateLanguage2;
})(NamePlateLanguage || {});
var DesignModelType = /* @__PURE__ */ ((DesignModelType2) => {
  DesignModelType2[DesignModelType2["IndividualDesign"] = 0] = "IndividualDesign";
  DesignModelType2[DesignModelType2["AutomaticModel"] = 1] = "AutomaticModel";
  DesignModelType2[DesignModelType2["StockModel"] = 2] = "StockModel";
  return DesignModelType2;
})(DesignModelType || {});
var DesignModelTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* IndividualDesign */, "Individual design"],
  [1 /* AutomaticModel */, "Automatic model"],
  [2 /* StockModel */, "Stock model"]
]);
var ConstructionMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Welded */, "Welded"],
  [1 /* Compact */, "Compact"],
  [2 /* Platepack */, "Plate pack"],
  [3 /* Openable */, "Openable"],
  [4 /* Combined */, "Combined"],
  [5 /* JciConstruction */, "JCI construction"],
  [6 /* WeldedKettle */, "Welded kettle"],
  [7 /* OpenableKettle */, "Openable kettle"]
]);
var NamePlateTypeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* StandardAluminumAisi */, "Standard aluminium / AISI"],
  [1 /* StandardAisi */, "Standard AISI"],
  [
    2 /* CustomerNamePlateByVahterus */,
    "Customer name plate, made by Vahterus"
  ],
  [
    3 /* CustomerNamePlateProvidedByCustomer */,
    "Customer name plate, provided by customer"
  ],
  [4 /* PlatePackNamePlate */, "Plate pack name plate"]
]);
var NamePlateLanguageMappingLabel = /* @__PURE__ */ new Map(
  [
    [0 /* English */, "English"],
    [1 /* EnglishItalian */, "English / Italian"],
    [2 /* EnglishRussian */, "English / Russian"],
    [3 /* EnglishChinese */, "English / Chinese"]
  ]
);
var MinimumDesignPressure = /* @__PURE__ */ ((MinimumDesignPressure2) => {
  MinimumDesignPressure2[MinimumDesignPressure2["ZeroBarg"] = 0] = "ZeroBarg";
  MinimumDesignPressure2[MinimumDesignPressure2["MinusOneBarg"] = 1] = "MinusOneBarg";
  MinimumDesignPressure2[MinimumDesignPressure2["FullVacuum"] = 2] = "FullVacuum";
  return MinimumDesignPressure2;
})(MinimumDesignPressure || {});
var PlatePackCodeMappingLabel = /* @__PURE__ */ new Map([
  [0 /* Ped */, "PED plate pack"],
  [1 /* Asme */, "ASME plate pack"]
]);
var CombinedFillingBoxesMappingLabel = /* @__PURE__ */ new Map([
  [0 /* WithoutFillingBoxes */, "Without filling boxes"],
  [1 /* WithFillingBoxes */, "With filling boxes"]
]);
var minimumDesignPressureLabels = /* @__PURE__ */ new Map([
  [0 /* ZeroBarg */, "0"],
  [1 /* MinusOneBarg */, "-1"],
  [2 /* FullVacuum */, "FV"]
]);

// src/enums/orp/orp-connection.enum.ts
var ConnectionType = /* @__PURE__ */ ((ConnectionType2) => {
  ConnectionType2[ConnectionType2["DN"] = 0] = "DN";
  ConnectionType2[ConnectionType2["Inch"] = 1] = "Inch";
  return ConnectionType2;
})(ConnectionType || {});
var connectionTypeLabelMapping = /* @__PURE__ */ new Map([
  [0 /* DN */, "DN"],
  [1 /* Inch */, "inch"]
]);

// src/model/offer.model.ts
var QueueList = /* @__PURE__ */ ((QueueList2) => {
  QueueList2["Offer"] = "{offers}";
  QueueList2["Position"] = "{positions}";
  QueueList2["ChinaInternalOffer"] = "{china-internal-offers}";
  QueueList2["ChinaInternalPosition"] = "{china-internal-positions}";
  return QueueList2;
})(QueueList || {});

// src/dtos/calculation.dto.ts
var DataSheetTextDto = class {
  constructor() {
    this.constructionRow1Text = "";
    this.constructionRow2Text = "";
    this.constructionRow3Text = "";
    this.constructionRow4Text = "";
    this.constructionRow5Text = "";
    this.constructionRow6Text = "";
    this.constructionRow7Text = "";
    this.constructionRow8Text = "";
    this.materialsPlateConnections = "";
    this.materialsShellConnectionsIn = "";
    this.materialsShellConnectionsOut = "";
    this.fillingBoxesText = "";
    this.actualVelocityText = "";
  }
};

// src/dtos/offer.dto.ts
var ShareMode = /* @__PURE__ */ ((ShareMode2) => {
  ShareMode2["READ"] = "READ";
  ShareMode2["EDIT"] = "EDIT";
  return ShareMode2;
})(ShareMode || {});

// src/dtos/search.dto.ts
var SearchScope = /* @__PURE__ */ ((SearchScope2) => {
  SearchScope2["CURRENT_WORKSPACE"] = "current-workspace";
  SearchScope2["ALL_WORKSPACE"] = "all-workspace";
  SearchScope2["MY_OFFER"] = "my-offer";
  SearchScope2["SHARED_WITH_ME"] = "shared-with-me";
  return SearchScope2;
})(SearchScope || {});
var Collections = /* @__PURE__ */ ((Collections2) => {
  Collections2["Offer"] = "offers";
  Collections2["Position"] = "positions";
  Collections2["ChinaInternalOffer"] = "china_internal_offers";
  Collections2["ChinaInternalPosition"] = "china_internal_positions";
  return Collections2;
})(Collections || {});

// src/dtos/si-unit.dto.ts
var SIUnitDto = class {
  constructor(labelMapping) {
    this.id = 0;
    this.labelMapping = labelMapping;
  }
  setWidthOption(option) {
    this.option = option;
    if (this.labelMapping.has(option)) {
      this.stringValue = this.labelMapping.get(option) || "";
    } else this.stringValue = "";
    return this;
  }
  setWithStringValue(value) {
    this.stringValue = value;
    this.labelMapping.forEach((v, key) => {
      if (v && v === value) {
        this.option = key;
      }
    });
    return this;
  }
};

// src/dtos/validate-result.dto.ts
var ValidationResult = class {
  constructor(message, params = []) {
    this.message = "";
    this.params = [];
    this.message = message;
    this.params = params;
  }
};

// src/dtos/orp-draft-fields.dto.ts
var ORP_SERVER_OWNED = {
  SubmittedOrderEntity: [
    "id",
    "createdAt",
    "lastUpdatedAt",
    "orpId",
    "createdByEmail",
    "reviewedAt",
    "reviewer",
    "reviewerEmail",
    "lastModifiedBy",
    "cpqOfferId",
    // NOTE: `cpqMfileId` is deliberately NOT here — the user enters the CPQ
    // offer's M-Files id as the order's "Offer ID". CPQ import is per position,
    // so nothing reads it to pick an offer.
    "offerNumber",
    "managementClass",
    // Values from the ERP.
    "erpOrderId",
    "mainno",
    "subno",
    "erpDesigner",
    "erpProjectManager"
  ],
  PositionBaseEntity: [
    "id",
    // Derived at promote from the document's array order — never client input.
    "positionIndex",
    "createdAt",
    "lastUpdatedAt",
    "replacedProductId",
    "order",
    "spec",
    "products",
    "lastModifiedBy"
    // NOTE: `designModelId` is deliberately NOT here — the user picks it from
    // the PLM model dropdown (see PlmService), so it must survive into the
    // draft. Nor is `designModelType`: the user chooses the kind when creating
    // the position. It is create-only rather than always-typed — see
    // CREATE_ONLY_BY_ENTITY in entity-assign.util.ts.
  ],
  PositionSpecsEntity: [
    // `position` is the shared PRIMARY KEY as well as the foreign key — a client
    // that could set it would be reparenting the specification.
    "position",
    // Backend-owned, never user input: the plate codes are derived from the
    // plate-catalog (OHUTLEVYT) lookup, not typed by anyone.
    "plateProductCode",
    "plateProductCode2"
  ],
  ProductEntity: [
    "id",
    "createdAt",
    "lastUpdatedAt",
    "position",
    "noNumber",
    "serialNumber"
  ]
};
var ORP_ERP_OWNED = ["erpDesigner", "erpProjectManager"];

// src/constants/tcp-messages.ts
var TCP_MESSAGES = {
  ONE_PHASE: {
    CREATE_DEBUG: "ping-onephase-api__create-debug",
    CALCULATE: "ping-onephase-api__calculate",
    GET_BY_ID: "ping-onephase-api__get-by-id",
    CLONE: "ping-onephase-api__clone",
    UPDATE_ONE: "ping-onephase-api__update_one",
    GET_MANY: "ping-onephase-api__get_many",
    GET_MANY_FULL_DATA: "ping-onephase-api__get_many_full_data",
    CREATE: "ping-onephase-api__create",
    DELETE_MULTIPLE: "ping-onephase-api__delete-multiple",
    GET_EMPTY_CALCULATION_ID_LIST: "ping-onephase-api__get-empty-calculation-id-list",
    UPDATE_CALCULATION_ID: "ping-onephase-api__update-calculation-id"
  },
  CONDENSER: {
    GET_BY_ID: "ping-condenser-api__get-by-id",
    CALCULATE: "ping-condenser-api__calculate",
    CLONE: "ping-condenser-api__clone",
    UPDATE_ONE: "ping-condenser-api__update_one",
    GET_MANY: "ping-condenser-api__get_many",
    GET_MANY_FULL_DATA: "ping-condenser-api__get_many_full_data",
    CREATE: "ping-condenser-api__create",
    DELETE_MULTIPLE: "ping-condenser-api__delete-multiple",
    GET_EMPTY_CALCULATION_ID_LIST: "ping-condenser-api__get-empty-calculation-id-list",
    UPDATE_CALCULATION_ID: "ping-condenser-api__update-calculation-id"
  },
  PARTIAL_CASCADE: {
    GET_BY_ID: "ping-partial-cascade-api__get-by-id",
    CALCULATE: "ping-partial-cascade-api__calculate",
    CLONE: "ping-partial-cascade-api__clone",
    UPDATE_ONE: "ping-partial-cascade-api__update_one",
    GET_MANY: "ping-partial-cascade-api__get_many",
    GET_MANY_FULL_DATA: "ping-partial-cascade-api__get_many_full_data",
    CREATE: "ping-partial-cascade-api__create",
    DELETE_MULTIPLE: "ping-partial-cascade-api__delete-multiple",
    GET_EMPTY_CALCULATION_ID_LIST: "ping-partial-cascade-api__get-empty-calculation-id-list",
    UPDATE_CALCULATION_ID: "ping-partial-cascade-api__update-calculation-id"
  },
  EVAPORATOR: {
    GET_BY_ID: "ping-evaporator-api__get-by-id",
    CALCULATE: "ping-evaporator-api__calculate",
    CLONE: "ping-evaporator-api__clone",
    UPDATE_ONE: "ping-evaporator-api__update_one",
    GET_MANY: "ping-evaporator-api__get_many",
    GET_MANY_FULL_DATA: "ping-evaporator-api__get_many_full_data",
    CREATE: "ping-evaporator-api__create",
    DELETE_MULTIPLE: "ping-evaporator-api__delete-multiple",
    GET_EMPTY_CALCULATION_ID_LIST: "ping-evaporator-api__get-empty-calculation-id-list",
    UPDATE_CALCULATION_ID: "ping-evaporator-api__update-calculation-id"
  },
  INTEGRATION_ONEPHASE: {
    CALCULATE: "ping-integration-onephase-api__calculate"
  },
  MULTI_CONDENSER: {
    GET_BY_ID: "ping-multicondenser-api__get-by-id",
    CALCULATE: "ping-multicondenser-api__calculate",
    CLONE: "ping-multicondenser-api__clone",
    UPDATE_ONE: "ping-multicondenser-api__update_one",
    GET_MANY: "ping-multicondenser-api__get_many",
    GET_MANY_FULL_DATA: "ping-multicondenser-api__get_many_full_data",
    CREATE: "ping-multicondenser-api__create",
    DELETE_MULTIPLE: "ping-multicondenser-api__delete-multiple",
    GET_EMPTY_CALCULATION_ID_LIST: "ping-multicondenser-api__get-empty-calculation-id-list",
    UPDATE_CALCULATION_ID: "ping-multicondenser-api__update-calculation-id"
  },
  CASCADE: {
    GET_BY_ID: "ping-cascade-api__get-by-id",
    CALCULATE: "ping-cascade-api__calculate",
    CLONE: "ping-cascade-api__clone",
    UPDATE_ONE: "ping-cascade-api__update_one",
    GET_MANY: "ping-cascade-api__get_many",
    GET_MANY_FULL_DATA: "ping-cascade-api__get_many_full_data",
    CREATE: "ping-cascade-api__create",
    DELETE_MULTIPLE: "ping-cascade-api__delete-multiple",
    GET_EMPTY_CALCULATION_ID_LIST: "ping-cascade-api__get-empty-calculation-id-list",
    UPDATE_CALCULATION_ID: "ping-cascade-api__update-calculation-id"
  },
  MFILE: {
    PING_MFILE: "ping-mfile-api__ping-mfile",
    DELETE_MFILE_CACHE: "ping-mfile-api__delete-mfile-cache",
    GET_INTERNAL_MFILE: "ping-mfile-api__get-internal-mfile",
    GET_EXTERNAL_MFILE: "ping-mfile-api__get-external-mfile",
    GET_REFRESH_MFILE: "ping-mfile-api__get-refresh-mfile",
    CREATE_EXTERNAL_MFILE: "ping-mfile-api__create-external-mfile"
  },
  CPQ: {
    OFFER: {
      CREATE: "ping-cpq-api__offer__create",
      GET: "ping-cpq-api__offer__get",
      EDIT: "ping-cpq-api__offer__edit",
      DELETE: "ping-cpq-api__offer__delete",
      APPLY_VERSION: "ping-cpq-api__offer__apply-version",
      GET_ONE: "ping-cpq-api__offer__get_one",
      GET_MANY: "ping-cpq-api__offer__get_many",
      DUPLICATE: "ping-cpq-api__offer__duplicate",
      MAKE_REVISION: "ping-cpq-api__offer__make-revision",
      CREATE_POSITION: "ping-cpq-api__offer__create-position",
      ADD_POSITIONS: "ping-cpq-api__offer__add-positions",
      SORT_POSITIONS: "ping-cpq-api__offer__sort-positions",
      SPREAD_SHEETS: "ping-cpq-api__offer__spreadsheets",
      GET_ONE_SIMPLE: "ping-cpq-api__offer__get-one-simple",
      GET_INTERNAL_MFILEIDS: "ping-cpq-api__offer__get-internal-mfileIds",
      IS_MFILE_USED_IN_OFFER: "ping-cpq-api__offer__is-mfile-used-in-offer",
      GET_OFFER_BY_CALCULATION_ID: "ping-cpq-api__offer__get-offer-by-calculation-id"
    },
    OFFER_INFO: {
      EDIT: "ping-cpq-api__offer-info__edit",
      DELETE: "ping-cpq-api__offer-info__delete"
    },
    POSITION: {
      EDIT: "ping-cpq-api__position__edit",
      EDIT_MULTIPLE: "ping-cpq-api__position__edit_multiple",
      DELETE: "ping-cpq-api__position__delete",
      GET_ALL_POSITION: "ping-cpq-api__position__get_all",
      GET_ALL_POSITION_PAGINATE: "ping-cpq-api__position__get_all_paginate",
      GET_ONE_POSITION: "ping-cpq-api__position__get_one",
      DUPLICATE_POSITION: "ping-cpq-api__position__duplicate_one",
      UPDATE_PRICING_CALCULATION: "ping-cpq-api__position__update_pricing_calculation",
      DUPLICATE_MANY: "ping-cpq-api__position__duplicate_many",
      DELETE_MULTIPLE_POSITION: "ping-cpq-api__position__delete_many",
      GET_POSITION_FOR_PRICING: "ping-cpq-api__position__get-position-for-pricing",
      GET_CUSTOM_EXTRAS: "ping-cpq-api__position__get-custom-extras",
      GET_POSITION_WITH_PRICING_CALCULATION: "ping-cpq-api__position__get-position-with-pricing-calculation"
    },
    CALCULATION: {
      GET_ONE: "ping-cpq-api__calculation_get_one",
      GET_ALL: "ping-cpq-api__calculation_get_all",
      CREATE_NEW: "ping-cpq-api__calculation_create_new",
      DELETE_ONE: "ping-cpq-api__calculation_delete_one",
      UPDATE_ONE: "ping-cpq-api__calculation_update_one",
      GET_SATURATED: "ping-cpq-api__calculation_get_saturated",
      SEND_DRAWING: "ping-cpq-api__calculation_send_drawing",
      SEND_DRAWING_ISOLATED: "ping-cpq-api__calculation_send_drawing_isolated",
      DUPLICATE: "ping-cpq-api__calculation_duplicate",
      DELETE_MULTIPLE: "ping-cpq-api__calculation_delete_multiple",
      SEND_MULTIPLE_DRAWING: "ping-cpq-api__calculation_send_multiple_drawing",
      GET_MULTIPLE_SIMPLE_HEAT_EXCHANGERS_BY_CALCULATION_IDS: "ping-cpq-api__calculation_get-multiple-simple-heat-exchangers-by-calculation-ids",
      GET_CALCULATION_ID_BY_APPLICATION_IDS: "ping-cpq-api__calculation_get-calculation-id-by-application-ids"
    },
    DRAWING: {
      GET_DRAWING_STATUS: "ping-cpq-api__drawing_get_status",
      GET_DRAWING_SERVER_STATUS: "ping-cpq-api__drawing_server_get_status",
      DRAWING_CALLBACK: "ping-cpq-api__drawing_callback",
      CALCULATION_DRAWING_DOWNLOAD: "ping-cpq-api__drawing_download",
      DRAWING_CALLBACK_ISOLATED: "ping-cpq-api__drawing_callback_isolated"
    }
  },
  DOCUMENT: {
    GET_PDF_OFFER: "ping-document-api__offer-pdf_get_one",
    GET_DATA_SHEET_BY_HEAT_EXCHANGER_ID: "ping-document-api__get-data-sheet-by-heat-exchanger-id",
    GET_DATA_SHEETS_BY_CALCULATION_IDS: "ping-document-api__get-data-sheets-by-calculation-ids",
    GET_MULTIPLE_SPREADSHEET: "ping-document-api__get-multiple-spreadsheet",
    DUPLICATE_MULTIPLE_SPREADSHEET: "ping-document-api__duplicate-multiple-spreadsheet",
    EXPORT_MULTIPLE_SPREADSHEET_EXCEL: "ping-document-api__export-multiple-spreadsheet-excel",
    DELETE_MULTIPLE_SPREADSHEET: "ping-document-api__delete-multiple-spreadsheet",
    UPDATE_SPREADSHEET_HIDE_PSHE_TYPE: "ping-document-api__update-spreadsheet-hide-pshe-type"
  },
  SIZING: {
    CALCULATE_PLATE_THICKNESS_MIN_MAX: "ping-cpq-api__calculate-plate-thickness-min-max"
  },
  SEARCH: {
    GET_SEARCH_KEY: "ping-search-api__get_search_key"
  },
  PRICING: {
    GET_CALCULATION_PRICE: "ping-pricing-api__get_calculation_price",
    SEARCH_EXTRAS: "ping-pricing-api__search_extras",
    GET_ALL_EXTRAS_BY_IDS: "ping-pricing-api__get_all_extras_by_ids",
    GET_ALL_EXTRAS_BY_KEYS: "ping-pricing-api__get_all_extras_by_keys",
    GET_EXTRA_BY_ID: "ping-pricing-api__get_extra_by_id",
    GET_BASIC_PUBLISH_VERSION_BY_WORKSPACE: "ping-pricing-api__get_basic_publish_version_by_workspace",
    GET_BASIC_VERSION_BY_ID: "ping-pricing-api__get_basic_version_by_id",
    UPDATE_EXTRA_PRICE_ITEMS: "ping-pricing-api__update_extra_price_items"
  },
  USER: {
    GET_USER_WORKSPACE: "ping-user-api__get-user-workspace",
    GET_USER_WORKSPACE_INFO: "ping-user-api__get-user-workspace-info",
    GET_GROUP_MEMBERS: "ping-user-api__get-group-members",
    GET_GROUP_NAME: "ping-user-api__get-group-name",
    GET_ALL_GROUPS: "ping-user-api__get-all-groups",
    GET_ALL_INTERNAL_GROUPS: "ping-user-api__get-all-internal-groups"
  }
};

// src/constants/black-list-email.ts
var blackListEmail = ["subodh.patwardhan@atlascopco.com"];

// src/constants/timezone.ts
var UTC_OFFSETS = [
  { value: -12, label: "UTC-12:00" },
  { value: -11, label: "UTC-11:00" },
  { value: -10, label: "UTC-10:00" },
  { value: -9, label: "UTC-09:00" },
  { value: -8, label: "UTC-08:00" },
  { value: -7, label: "UTC-07:00" },
  { value: -6, label: "UTC-06:00" },
  { value: -5, label: "UTC-05:00" },
  { value: -4, label: "UTC-04:00" },
  { value: -3, label: "UTC-03:00" },
  { value: -2, label: "UTC-02:00" },
  { value: -1, label: "UTC-01:00" },
  { value: 0, label: "UTC+00:00" },
  { value: 1, label: "UTC+01:00" },
  { value: 2, label: "UTC+02:00" },
  { value: 3, label: "UTC+03:00" },
  { value: 4, label: "UTC+04:00" },
  { value: 5, label: "UTC+05:00" },
  { value: 6, label: "UTC+06:00" },
  { value: 7, label: "UTC+07:00" },
  { value: 8, label: "UTC+08:00" },
  { value: 9, label: "UTC+09:00" },
  { value: 10, label: "UTC+10:00" },
  { value: 11, label: "UTC+11:00" },
  { value: 12, label: "UTC+12:00" },
  { value: 13, label: "UTC+13:00" },
  { value: 14, label: "UTC+14:00" }
];
var DEFAULT_UTC_OFFSET = 3;

// src/constants/custom-extra-key.ts
var customExtraKey = "15290c69-3ff6-4313-bbed-2e0a5e484c85";

// src/constants/properties-calculation-fields.ts
var onePhaseHotPropCalcFields = [
  "dynamicViscosityHotSideFromModalHot",
  "dynamicViscosityColdSideFromModalHot",
  "specificGravityHotSideFromModalHot",
  "specificGravityColdSideFromModalHot",
  "specificHeatHotSideFromModalHot",
  "specificHeatColdSideFromModalHot",
  "thermalConductivityHotSideFromModalHot",
  "thermalConductivityColdSideFromModalHot"
];
var onePhaseColdPropCalcFields = [
  "dynamicViscosityHotSideFromModalCold",
  "dynamicViscosityColdSideFromModalCold",
  "specificGravityHotSideFromModalCold",
  "specificGravityColdSideFromModalCold",
  "specificHeatHotSideFromModalCold",
  "specificHeatColdSideFromModalCold",
  "thermalConductivityHotSideFromModalCold",
  "thermalConductivityColdSideFromModalCold"
];
var evaporatorLiquidPropCalcFields = [
  "dynamicViscosityHotSideFromLiquidModal",
  "dynamicViscosityColdSideFromLiquidModal",
  "specificGravityHotSideFromLiquidModal",
  "specificGravityColdSideFromLiquidModal",
  "specificHeatHotSideFromLiquidModal",
  "specificHeatColdSideFromLiquidModal",
  "thermalConductivityHotSideFromLiquidModal",
  "thermalConductivityColdSideFromLiquidModal"
];

// src/constants/mfile-id.ts
var CPQ_MFILE_ID_PATTERN = /^(?:[A-Z]|VCN)\d{2}-\d{2,3}-\d{4,6}[A-Z]?$/;
var isValidCpqMfileId = (value) => CPQ_MFILE_ID_PATTERN.test(value);
var CPQ_MFILE_ID_FORMAT_MESSAGE = "is not a valid M-Files ID (e.g. A26-16-7021)";

// src/utils/nullable.helper.ts
var hasValue = (input) => {
  if (input === void 0 || input === null) return false;
  return true;
};
var nullableHelper = {
  hasValue
};
var isNotNullOrUndefined = (value) => {
  return value !== null && value !== void 0;
};

// src/utils/roundNumber.ts
function isValidNumber(value) {
  return typeof value === "number" && !isNaN(value) && isFinite(value);
}
function canBeNumber(value) {
  if (value === null || value === void 0) return false;
  const num = Number(value);
  return !isNaN(num) && isFinite(num);
}
var countLeadingZeros = (decimalPart) => {
  let count = 0;
  for (const char of decimalPart) {
    if (char === "0") {
      count++;
    } else {
      break;
    }
  }
  return count;
};
var getNumberParts = (value) => {
  if (value === void 0 || value === null) return null;
  const numberComposition = value.toString().split(".");
  return {
    integerPart: Math.floor(parseFloat(value)),
    decimalPart: numberComposition[1] || "",
    numberComposition
  };
};
var roundNumberToPrecision = (number, precision) => {
  if (!isValidNumber(number)) return null;
  precision = precision == null ? 0 : precision >= 0 ? Math.min(precision, 292) : Math.max(precision, -292);
  if (precision) {
    const factor = Math.pow(10, precision);
    const adjustedNumber = number * factor;
    const roundedValue = Math.sign(number) * Math.round(Math.abs(adjustedNumber));
    return roundedValue / factor;
  }
  return Math.sign(number) * Math.round(Math.abs(number));
};
var dynamicRoundingNumber = (value) => {
  if (value === void 0 || value === null) {
    return null;
  }
  const numberParts = getNumberParts(value);
  let integerPart, numberComposition;
  if (numberParts) {
    integerPart = numberParts.integerPart;
    numberComposition = numberParts.numberComposition;
  } else {
    return null;
  }
  if (numberComposition.length > 1) {
    if (numberComposition[1] && numberComposition[1].trim().length === 0) {
      return null;
    }
    const onlyZerosRegex = /^0+$/;
    if (numberComposition[1] && onlyZerosRegex.test(numberComposition[1])) {
      if (numberComposition[1] && numberComposition[1].length > 2 && integerPart > 0) {
        return parseFloat(value).toFixed(2);
      } else {
        return value;
      }
    }
  }
  const number = parseFloat(value);
  if (integerPart > 0) {
    return roundNumberToPrecision(number, 2);
  } else {
    const decimalPart = number.toString().split(".")[1] || "";
    const leadingZeros = countLeadingZeros(decimalPart);
    if (leadingZeros > 0) {
      const roundingPosition = leadingZeros + 2;
      return roundNumberToPrecision(number, roundingPosition);
    } else {
      return roundNumberToPrecision(number, 2);
    }
  }
};
var getPrecision = (value) => {
  if (value === void 0 || value === null) {
    return null;
  }
  const numberParts = getNumberParts(value);
  let integerPart, numberComposition, decimalPart;
  if (numberParts) {
    integerPart = numberParts.integerPart;
    numberComposition = numberParts.numberComposition;
    decimalPart = numberParts.decimalPart;
  } else {
    return null;
  }
  if (numberComposition.length > 1) {
    if (numberComposition[1] && numberComposition[1].trim().length === 0) {
      return null;
    }
    const onlyZerosRegex = /^0+$/;
    if (numberComposition[1] && onlyZerosRegex.test(numberComposition[1])) {
      return 0;
    }
  }
  if (integerPart > 0) {
    return 2;
  } else {
    const leadingZeros = countLeadingZeros(decimalPart);
    if (leadingZeros > 0) {
      const roundingPosition = leadingZeros + 2;
      return roundingPosition;
    } else {
      return 2;
    }
  }
};

// src/utils/number.helper.ts
var isNaNOrInfinity = (input) => {
  return Number.isNaN(input) || !Number.isFinite(input);
};
var isInfinitiveNumber = (value) => value === 1e35;
var getDecimalScale = (value, fractionDigits = 1) => {
  if (!value || isNaN(value) || Number.isInteger(value)) {
    return 0;
  }
  const isNegative = value < 0;
  const x = isNegative ? value * -1 : value;
  if (x < 0.1) {
    fractionDigits = 3;
  }
  if (x < 0.01) {
    fractionDigits = 4;
  }
  if (x < 1e-3) {
    fractionDigits = 5;
  }
  if (x < 1e-4) {
    fractionDigits = 6;
  }
  if (x < 1e-5) {
    fractionDigits = 7;
  }
  if (x < 1e-6) {
    fractionDigits = 8;
  }
  if (x < 1e-7) {
    fractionDigits = 9;
  }
  return fractionDigits;
};
var handleRoundValue = (cellData) => {
  var _a;
  const regExp = /[A-Za-z+/:]/g;
  if (cellData) {
    if ((cellData == null ? void 0 : cellData.key) == "customer" || (cellData == null ? void 0 : cellData.key) == "offerNumber" || (cellData == null ? void 0 : cellData.key) == "heatExchangerType" || (cellData == null ? void 0 : cellData.key) == "positionNo" || (cellData == null ? void 0 : cellData.key) == "project" || (cellData == null ? void 0 : cellData.key) == "operatingCase" || (cellData == null ? void 0 : cellData.key) == "reference" || (cellData == null ? void 0 : cellData.key) == "offerBy") {
      return cellData.customValue;
    }
    if (cellData.decimalScale || cellData.decimalScale === 0) {
      if (cellData.customValue || cellData.customValue === 0) {
        if (typeof cellData.customValue == "string") {
          if ((cellData == null ? void 0 : cellData.key) == "massOfHeatExchanger") {
            const parsed = parseFloat(cellData.customValue);
            return isNaN(parsed) ? cellData.customValue : Math.round(parsed);
          } else if (regExp.test(cellData.customValue)) {
            return cellData.customValue;
          } else if (parseFloat(cellData.customValue) && !cellData.customValue.includes("/") && !cellData.customValue.startsWith(".")) {
            return roundNumberToPrecision(
              parseFloat(cellData.customValue),
              cellData.decimalScale
            );
          } else {
            return cellData.customValue;
          }
        } else if (typeof cellData.customValue == "number") {
          if ((cellData == null ? void 0 : cellData.key) == "massOfHeatExchanger") {
            const parsed = parseFloat(cellData.customValue.toString());
            return isNaN(parsed) ? cellData.customValue : Math.round(parsed);
          } else
            return roundNumberToPrecision(
              cellData.customValue,
              cellData.decimalScale
            );
        } else {
          return cellData.customValue;
        }
      } else {
        return "";
      }
    } else {
      if (cellData.customValue || cellData.customValue === 0) {
        if (typeof cellData.customValue == "string") {
          if (((_a = cellData.key) == null ? void 0 : _a.includes("excessDesignArea")) && cellData.customValue.includes("/") || cellData.customValue.startsWith(".")) {
            return cellData.customValue;
          } else if ((cellData == null ? void 0 : cellData.key) == "massOfHeatExchanger") {
            const parsed = parseFloat(cellData.customValue);
            return isNaN(parsed) ? cellData.customValue : Math.round(parsed);
          } else if (regExp.test(cellData.customValue)) {
            return cellData.customValue;
          } else if (parseFloat(cellData.customValue) && !cellData.customValue.includes("/") && !cellData.customValue.startsWith(".")) {
            return dynamicRoundingNumber(parseFloat(cellData.customValue));
          } else {
            return cellData.customValue;
          }
        } else if (typeof cellData.customValue == "number") {
          if ((cellData == null ? void 0 : cellData.key) == "massOfHeatExchanger") {
            return Math.round(cellData.customValue);
          } else return dynamicRoundingNumber(cellData.customValue);
        } else {
          return cellData.customValue;
        }
      } else {
        return "";
      }
    }
  }
};
var numberHelper = {
  handleRoundValue,
  isNaNOrInfinity,
  isInfinitiveNumber,
  getDecimalScale,
  roundNumberToPrecision
};

// src/utils/unit-conversion.ts
var TEMPERATURE_UNITS = {
  "\xB0C": { toBase: (v) => v + 273.15, fromBase: (k) => k - 273.15 },
  K: { toBase: (v) => v, fromBase: (k) => k },
  "\xB0F": {
    toBase: (v) => (v - 32) * 5 / 9 + 273.15,
    fromBase: (k) => (k - 273.15) * 9 / 5 + 32
  }
};
var ATM_PA = 101325;
var PSI_PA = 6894.757;
var PRESSURE_UNITS = {
  bar: { toBase: (v) => v * 1e5, fromBase: (p) => p / 1e5 },
  kPa: { toBase: (v) => v * 1e3, fromBase: (p) => p / 1e3 },
  Pa: { toBase: (v) => v, fromBase: (p) => p },
  MPa: { toBase: (v) => v * 1e6, fromBase: (p) => p / 1e6 },
  psi: { toBase: (v) => v * PSI_PA, fromBase: (p) => p / PSI_PA },
  psig: {
    toBase: (v) => v * PSI_PA + ATM_PA,
    fromBase: (p) => (p - ATM_PA) / PSI_PA
  },
  "bar(g)": { toBase: (v) => v * 1e5 + ATM_PA, fromBase: (p) => (p - ATM_PA) / 1e5 }
};
var FLOW_FACTORS_TO_M3S = {
  "m3/s": 1,
  "m3/h": 1 / 3600,
  "l/s": 1e-3
};
var MASS_FLOW_FACTORS_TO_KGS = {
  "kg/s": 1,
  "kg/h": 1 / 3600,
  "lb/h": 0.45359237 / 3600,
  "t/h": 1e3 / 3600
};
var POWER_FACTORS_TO_KW = {
  kW: 1,
  W: 1e-3,
  MW: 1e3,
  "Btu/h": 29307107e-11
};
var buildAffineTable = (units) => {
  const table = {};
  for (const [from, fromUnit] of Object.entries(units)) {
    for (const [to, toUnit] of Object.entries(units)) {
      table[`${from}->${to}`] = (value) => toUnit.fromBase(fromUnit.toBase(value));
    }
  }
  return table;
};
var buildLinearTable = (factorsToBase) => {
  const table = {};
  for (const [from, fromFactor] of Object.entries(factorsToBase)) {
    for (const [to, toFactor] of Object.entries(factorsToBase)) {
      const factor = fromFactor / toFactor;
      table[`${from}->${to}`] = (value) => value * factor;
    }
  }
  return table;
};
var CONVERSION_TABLE = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, buildAffineTable(TEMPERATURE_UNITS)), buildAffineTable(PRESSURE_UNITS)), buildLinearTable(FLOW_FACTORS_TO_M3S)), buildLinearTable(MASS_FLOW_FACTORS_TO_KGS)), buildLinearTable(POWER_FACTORS_TO_KW));
var UNIT_DIMENSIONS = {
  temperature: Object.keys(TEMPERATURE_UNITS),
  pressure: Object.keys(PRESSURE_UNITS),
  flow: Object.keys(FLOW_FACTORS_TO_M3S),
  massFlow: Object.keys(MASS_FLOW_FACTORS_TO_KGS),
  power: Object.keys(POWER_FACTORS_TO_KW)
};
var isVolumetricFlowUnit = (unit) => Object.prototype.hasOwnProperty.call(FLOW_FACTORS_TO_M3S, unit);
var convertUnit = (value, from, to) => {
  const fn = CONVERSION_TABLE[`${from}->${to}`];
  return fn ? fn(value) : null;
};

// src/utils/numericCell.ts
function parseNumericCell(value) {
  var _a;
  const trimmed = (_a = value == null ? void 0 : value.trim()) != null ? _a : "";
  if (trimmed === "") return null;
  const normalized = trimmed.replace(/,/g, ".");
  if (normalized.indexOf(".") !== normalized.lastIndexOf(".")) return null;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}
function isNumericCell(value) {
  return parseNumericCell(value) !== null;
}

// src/utils/pricing.helper.ts
var extractUniqueExpressions = (str) => {
  var _a;
  if (!str) {
    return [];
  }
  const itemRegex = /\[.*?\]|\w+/g;
  const valueMatches = (_a = str.match(itemRegex)) == null ? void 0 : _a.filter((item) => !/^\[.*?\]$/.test(item));
  return valueMatches ? [...new Set(valueMatches)] : [];
};
var extractFunctions = (str) => {
  var _a;
  if (!str) {
    return [];
  }
  const regex = /\b(\w+)\(([^)]*)\)/g;
  const valueMatches = (_a = str.match(regex)) == null ? void 0 : _a.map((match) => match.replace(/\(\w+\)/, "()"));
  const result = valueMatches ? [...new Set(valueMatches)] : [];
  return result;
};

// src/utils/spreadsheet.helper.ts
import cloneDeep from "lodash.clonedeep";

// src/utils/shared-spreadsheet.helper.ts
var getNozzlePlateSideSize = (nozzlePlateSide, typeApproval) => {
  switch (typeApproval) {
    case 0 /* PED */:
      return nozzleShellPEDAndPEDENDatasheetLabel.get(nozzlePlateSide);
    case 2 /* PEDEN */:
      return nozzleShellPEDAndPEDENDatasheetLabel.get(nozzlePlateSide);
    case 1 /* ASME */:
      return nozzleShellASMEDatasheetLabel.get(nozzlePlateSide);
    default:
      return nozzleShellPEDAndPEDENDatasheetLabel.get(nozzlePlateSide);
  }
};
var getNozzleShellSideSize = (nozzleShellSide, typeApproval) => {
  switch (typeApproval) {
    case 0 /* PED */:
      return nozzleShellPEDAndPEDENDatasheetLabel.get(nozzleShellSide);
    case 2 /* PEDEN */:
      return nozzleShellPEDAndPEDENDatasheetLabel.get(nozzleShellSide);
    case 1 /* ASME */:
      return nozzleShellASMEDatasheetLabel.get(nozzleShellSide);
    default:
      return nozzleShellPEDAndPEDENDatasheetLabel.get(nozzleShellSide);
  }
};
var getNumberOfPlateNozzle = (numberOfPlateNozzles) => {
  switch (numberOfPlateNozzles) {
    case 2 /* differentEnds */:
    case 1 /* oneEnd */:
      return 1;
    case 3 /* bothEnds */:
      return 2;
  }
};
var getNumberOfShellNozzle = (numberOfShellNozzles) => {
  switch (numberOfShellNozzles) {
    case 1 /* _1pc */:
    case 2 /* _2pc */:
      return 1;
    case 4 /* _4pc */:
      return 2;
  }
};
var getDesignPressureShellSideUnit = (designPressure) => {
  var _a;
  return (_a = designPressureOptionMappingLabel.get(designPressure)) == null ? void 0 : _a.split(" ")[1];
};
var getShellMaterial = (endPlateType, shellMaterialText) => {
  if (endPlateType == 4 /* OpenableDouble */ || endPlateType == 6 /* OpenableGirthFlange */ || endPlateType == 7 /* OpenableGirthFlangeDouble */ || endPlateType == 1 /* OpenableVersion */) {
    return `${shellMaterialText} (Flange and Openable End: Carbon steel)`;
  } else {
    return shellMaterialText;
  }
};
var getMediumName = (mediumSource, mediumName, mediumNameOtherMedia, concentration) => {
  if (mediumSource === 0 /* Imported */) {
    return mediumNameOtherMedia;
  }
  if (mediumSource === 1 /* Brine */) {
    return `${mediumOptionMappingLabel.get(mediumName)} ${concentration}%`;
  }
  return mediumOptionMappingLabel.get(mediumName);
};
var precise = (x, precision) => {
  if (!x || isNaN(x) || Number.isInteger(x)) {
    return x;
  }
  const precisionValue = precision || 5;
  return Number.parseFloat(x).toPrecision(precisionValue);
};

// src/utils/application-title.ts
var getCondenserType = (condenserType) => {
  switch (condenserType) {
    case 1 /* VentCondenser */:
      return "datasheet.header.appTitle.VentCondenser";
    case 2 /* CondGasSeparator */:
      return "datasheet.header.appTitle.CondGasSeparator";
    case 0 /* Normal */:
      return "datasheet.header.appTitle.Condenser";
  }
};
var getAppTitle = (heatExchangerData) => {
  switch (heatExchangerData.application) {
    case 1 /* OnePhase */: {
      const { hotSideMedium, coldSideMedium } = heatExchangerData;
      return hotSideMedium === 1 /* Liquid */ && coldSideMedium === 1 /* Liquid */ ? "datasheet.header.appTitle.LiquidLiquid" : hotSideMedium === 2 /* Gas */ && coldSideMedium === 2 /* Gas */ ? "datasheet.header.appTitle.GasGas" : "datasheet.header.appTitle.LiquidGas";
    }
    case 2 /* Condenser */:
      return getCondenserType(heatExchangerData.condenserType);
    case 3 /* Evaporator */: {
      const {
        evaporatorType,
        combinedC: combinedCEvaporator,
        circulation: circulationEvaporator
      } = heatExchangerData;
      return evaporatorType === 0 /* DXEvaporator */ ? "datasheet.header.appTitle.EvaporatorDX" : combinedCEvaporator ? "datasheet.header.appTitle.FloodedEvaporatorCombinedC" : circulationEvaporator === 3 /* Combined */ ? "datasheet.header.appTitle.FloodedEvaporatorCombined" : "datasheet.header.appTitle.FloodedEvaporator";
    }
    case 4 /* Cascade */: {
      const {
        cascadeType,
        combinedC: combinedCCascade,
        circulation: circulationCascade
      } = heatExchangerData;
      return cascadeType === 0 /* DX */ ? "datasheet.header.appTitle.CascadeDX" : combinedCCascade ? "datasheet.header.appTitle.FloodedCascadeCombinedC" : circulationCascade === 3 /* Combined */ ? "datasheet.header.appTitle.FloodedCascadeCombined" : "datasheet.header.appTitle.FloodedCascade";
    }
    case 5 /* PartialCascade */:
      return "datasheet.header.appTitle.Partial2Phase";
    default:
      return "";
  }
};

// src/utils/spreadsheet-data.helper.ts
import { v4 as uuidv4 } from "uuid";
var getExcelCellStyle = (style) => {
  const rs = {
    bl: 0,
    it: 0,
    un: 0,
    cl: 0
  };
  style == null ? void 0 : style.forEach((s) => {
    if (s === "bold") rs.bl = 1;
    if (s === "italic") rs.it = 1;
    if (s === "underline") rs.un = 1;
    if (s === "cancelline") rs.cl = 1;
  });
  return rs;
};
var getSpreadSheetCellStyle = (input) => {
  const rs = [];
  if (input.bl) {
    rs.push("bold");
  }
  if (input.it) {
    rs.push("italic");
  }
  if (input.cl) {
    rs.push("cancelline");
  }
  if (input.un) {
    rs.push("underline");
  }
  return rs;
};
var getDecimalScaleFormat = (fractionDigits, value) => {
  if (fractionDigits == null || fractionDigits == void 0 || fractionDigits == 0 || Number.isNaN(fractionDigits)) {
    if ((value || value === 0) && parseFloat(value.toString())) {
      if (fractionDigits === 0) {
        return { fa: "0", t: "n" };
      }
      const precision = getPrecision(value);
      return precision != null ? { fa: `0.${"0".repeat(precision)}`, t: "n" } : { fa: "General", t: "g" };
    } else {
      return { fa: "General", t: "g" };
    }
  } else {
    return { fa: `0.${"0".repeat(fractionDigits)}`, t: "n" };
  }
};
var getDecimalScaleFromDecimalScaleFormat = (decimalScaleFormat) => {
  if (!decimalScaleFormat) return void 0;
  if (decimalScaleFormat === "0" || decimalScaleFormat === "General") {
    return 0;
  } else {
    return decimalScaleFormat.replace("0.", "").split("").length;
  }
};
var handleCellCustomValue = (cell, t = void 0, language) => {
  return t && (cell == null ? void 0 : cell.i18nKey) && [
    "cn" /* Chinese */,
    "de" /* Deutsch */,
    "en" /* English */,
    "es" /* Espanol */,
    "fi" /* Finland */,
    "fr" /* Francais */,
    "nl" /* Nederlands */
  ].some(
    (item) => {
      var _a;
      return !(cell == null ? void 0 : cell.customValue) || t((_a = cell == null ? void 0 : cell.i18nKey) != null ? _a : "", {
        lng: item,
        defaultValue: ""
      }) == (cell == null ? void 0 : cell.customValue);
    }
  ) ? t(cell == null ? void 0 : cell.i18nKey, { lng: language, defaultValue: cell == null ? void 0 : cell.i18nKey }) : cell == null ? void 0 : cell.customValue;
};
var handleDisplayValue = (cell, t = void 0, language) => {
  const displayValue = t && (cell == null ? void 0 : cell.i18nKey) && [
    "cn" /* Chinese */,
    "de" /* Deutsch */,
    "en" /* English */,
    "es" /* Espanol */,
    "fi" /* Finland */,
    "fr" /* Francais */,
    "nl" /* Nederlands */
  ].some(
    (item) => {
      var _a;
      return !(cell == null ? void 0 : cell.customValue) || t((_a = cell == null ? void 0 : cell.i18nKey) != null ? _a : "", {
        lng: item,
        defaultValue: ""
      }) == (cell == null ? void 0 : cell.customValue);
    }
  ) ? t(cell == null ? void 0 : cell.i18nKey, { lng: language, defaultValue: cell == null ? void 0 : cell.i18nKey }) : handleRoundValue(cell);
  return (displayValue == null ? void 0 : displayValue.toString()) == "NaN" ? cell.customValue : displayValue == null ? void 0 : displayValue.toString();
};
var fillingBoxTextHandler = (spreadSheetData, heatExchangerData) => {
  if (heatExchangerData.application == 4 /* Cascade */ || 3 /* Evaporator */) {
    return heatExchangerData.circulation == 3 /* Combined */ ? [
      {
        id: uuidv4(),
        createdAt: /* @__PURE__ */ new Date(),
        lastUpdatedAt: /* @__PURE__ */ new Date(),
        isHidden: false,
        index: 7,
        isAddedRow: false,
        cellList: [
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 0,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 1,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 2,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            key: "fillingBoxesText",
            customValue: spreadSheetData["fillingBoxesText"],
            index: 3,
            isHidden: false,
            isLocked: false
          }
        ]
      },
      {
        id: uuidv4(),
        createdAt: /* @__PURE__ */ new Date(),
        lastUpdatedAt: /* @__PURE__ */ new Date(),
        isHidden: false,
        index: 8,
        isAddedRow: false,
        cellList: [
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 0,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 1,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 2,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 3,
            isHidden: false,
            isLocked: false
          }
        ]
      }
    ] : [
      {
        id: uuidv4(),
        createdAt: /* @__PURE__ */ new Date(),
        lastUpdatedAt: /* @__PURE__ */ new Date(),
        isHidden: false,
        index: 7,
        isAddedRow: false,
        cellList: [
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 0,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 1,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 2,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 3,
            isHidden: false,
            isLocked: false
          }
        ]
      }
    ];
  }
};
var velocityInDemisterHandler = (spreadSheetData, heatExchangerData) => {
  if (heatExchangerData.application == 4 /* Cascade */ || 3 /* Evaporator */) {
    return heatExchangerData.circulation == 3 /* Combined */ ? [
      {
        id: uuidv4(),
        createdAt: /* @__PURE__ */ new Date(),
        lastUpdatedAt: /* @__PURE__ */ new Date(),
        isHidden: false,
        index: 5,
        isAddedRow: false,
        cellList: [
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 0,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 1,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 2,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            key: "actualVelocityText",
            customValue: spreadSheetData["actualVelocityText"],
            index: 3,
            isHidden: false,
            isLocked: false
          }
        ]
      },
      {
        id: uuidv4(),
        createdAt: /* @__PURE__ */ new Date(),
        lastUpdatedAt: /* @__PURE__ */ new Date(),
        isHidden: false,
        index: 6,
        isAddedRow: false,
        cellList: [
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 0,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 1,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 2,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 3,
            isHidden: false,
            isLocked: false
          }
        ]
      }
    ] : [
      {
        id: uuidv4(),
        createdAt: /* @__PURE__ */ new Date(),
        lastUpdatedAt: /* @__PURE__ */ new Date(),
        isHidden: false,
        index: 5,
        isAddedRow: false,
        cellList: [
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 0,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 1,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 2,
            isHidden: false,
            isLocked: false
          },
          {
            id: uuidv4(),
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            index: 3,
            isHidden: false,
            isLocked: false
          }
        ]
      }
    ];
  }
};
var designPressureHandler = (heatExchangerData, spreadSheetData, typeAprroval) => {
  const designPressureForAsme = [
    {
      id: uuidv4(),
      createdAt: /* @__PURE__ */ new Date(),
      lastUpdatedAt: /* @__PURE__ */ new Date(),
      isHidden: false,
      index: 7,
      isAddedRow: false,
      cellList: [
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          i18nKey: "datasheet.table.data.Design pressure",
          index: 0,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          key: "designPressureOnDataSheet1",
          customValue: spreadSheetData["designPressureOnDataSheet1"],
          index: 1,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          key: "designPressureOnDataSheet2",
          customValue: spreadSheetData["designPressureOnDataSheet2"],
          index: 2,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 3,
          isHidden: false,
          isLocked: false
        }
      ]
    },
    {
      id: uuidv4(),
      createdAt: /* @__PURE__ */ new Date(),
      lastUpdatedAt: /* @__PURE__ */ new Date(),
      isHidden: false,
      index: 8,
      isAddedRow: false,
      cellList: [
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 0,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 1,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 2,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 3,
          isHidden: false,
          isLocked: false
        }
      ]
    }
  ];
  const designPressureForPED = heatExchangerData.constructionRow5Text != heatExchangerData.constructionRow6Text ? [
    {
      id: uuidv4(),
      createdAt: /* @__PURE__ */ new Date(),
      lastUpdatedAt: /* @__PURE__ */ new Date(),
      isHidden: false,
      index: 7,
      isAddedRow: false,
      cellList: [
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          i18nKey: "datasheet.table.data.Shell design pressure",
          index: 0,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          key: "designPressureOnDataSheet1",
          customValue: spreadSheetData["designPressureOnDataSheet1"],
          index: 1,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          key: "designPressureOnDataSheet2",
          customValue: spreadSheetData["designPressureOnDataSheet2"],
          index: 2,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 3,
          isHidden: false,
          isLocked: false
        }
      ]
    },
    {
      id: uuidv4(),
      createdAt: /* @__PURE__ */ new Date(),
      lastUpdatedAt: /* @__PURE__ */ new Date(),
      isHidden: false,
      index: 8,
      isAddedRow: false,
      cellList: [
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          i18nKey: "datasheet.table.data.Plate design pressure",
          index: 0,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          key: "plateDesignPressureUnit",
          customValue: spreadSheetData["plateDesignPressureUnit"],
          index: 1,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          key: "plateDesignPressure",
          customValue: spreadSheetData["plateDesignPressure"],
          index: 2,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 3,
          isHidden: false,
          isLocked: false
        }
      ]
    },
    {
      id: uuidv4(),
      createdAt: /* @__PURE__ */ new Date(),
      lastUpdatedAt: /* @__PURE__ */ new Date(),
      isHidden: false,
      index: 9,
      isAddedRow: false,
      cellList: [
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 0,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 1,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 2,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 3,
          isHidden: false,
          isLocked: false
        }
      ]
    }
  ] : [
    {
      id: uuidv4(),
      createdAt: /* @__PURE__ */ new Date(),
      lastUpdatedAt: /* @__PURE__ */ new Date(),
      isHidden: false,
      index: 7,
      isAddedRow: false,
      cellList: [
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          i18nKey: "datasheet.table.data.Design pressure",
          index: 0,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          key: "designPressureOnDataSheet1",
          customValue: spreadSheetData["designPressureOnDataSheet1"],
          index: 1,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          key: "designPressureOnDataSheet2",
          customValue: spreadSheetData["designPressureOnDataSheet2"],
          index: 2,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 3,
          isHidden: false,
          isLocked: false
        }
      ]
    },
    {
      id: uuidv4(),
      createdAt: /* @__PURE__ */ new Date(),
      lastUpdatedAt: /* @__PURE__ */ new Date(),
      isHidden: false,
      index: 8,
      isAddedRow: false,
      cellList: [
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 0,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 1,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 2,
          isHidden: false,
          isLocked: false
        },
        {
          id: uuidv4(),
          createdAt: /* @__PURE__ */ new Date(),
          lastUpdatedAt: /* @__PURE__ */ new Date(),
          index: 3,
          isHidden: false,
          isLocked: false
        }
      ]
    }
  ];
  return typeAprroval === 1 /* ASME */ ? designPressureForAsme : designPressureForPED;
};
var paintingValueHandler = (paintStainlessSteel, paintCarbonSteel, surfaceTreatment, otherStainlessSteel, otherCarbonSteel) => {
  var _a;
  let paintStainlessSteelValue;
  let paintCarbonSteelValue;
  if (paintStainlessSteel != null && paintStainlessSteel != void 0) {
    if (paintStainlessSteel === 11 /* Other */) {
      paintStainlessSteelValue = surfaceTreatmentMappingValue.get(surfaceTreatment) + " (" + otherStainlessSteel + ")";
    } else {
      if (surfaceTreatment === 3 /* System21GreenishGray */) {
        paintStainlessSteelValue = ((_a = surfaceTreatmentMappingValue.get(surfaceTreatment)) == null ? void 0 : _a.replace("Greenish grey", "")) + " (" + surfaceTreatmentPartMappingValue.get(paintStainlessSteel) + ")";
      } else {
        paintStainlessSteelValue = surfaceTreatmentMappingValue.get(surfaceTreatment) + " (" + surfaceTreatmentPartMappingValue.get(paintStainlessSteel) + ")";
      }
    }
  } else {
    paintStainlessSteelValue = surfaceTreatmentMappingValue.get(surfaceTreatment);
  }
  if (paintCarbonSteel != null && paintCarbonSteel != void 0) {
    if (paintCarbonSteel === 11 /* Other */) {
      paintCarbonSteelValue = surfaceTreatmentMappingValue.get(surfaceTreatment) + " (" + otherCarbonSteel + ")";
    } else {
      paintCarbonSteelValue = surfaceTreatmentMappingValue.get(surfaceTreatment) + " (" + surfaceTreatmentPartMappingValue.get(paintCarbonSteel) + ")";
    }
  } else {
    paintCarbonSteelValue = surfaceTreatmentMappingValue.get(surfaceTreatment);
  }
  return {
    paintStainlessSteelValue,
    paintCarbonSteelValue
  };
};
var feetCarbonSteel = [
  1 /* EndPlateFeetBoltedCS */,
  3 /* ShellFeetCS */,
  5 /* EndPlateFeetWeldedCS */,
  7 /* BracketsWelededCS */,
  9 /* VerticalFeetWeldedCS */,
  11 /* SleeveWeldedCS */
];
var spreadSheetDataHelper = {
  handleCellCustomValue,
  handleDisplayValue,
  getExcelCellStyle,
  getSpreadSheetCellStyle,
  feetCarbonSteel,
  getDecimalScaleFormat,
  getDecimalScaleFromDecimalScaleFormat
};

// src/utils/psheType.helper.ts
var getHidePSHEModel = (psheType) => {
  const firstPart = psheType.split("-")[0];
  const match = firstPart.match(/^(\d+(?:\/\d+)?)/);
  return match ? match[1] : null;
};
var getPsheTypeForMultiCondenser = (multiCondenser, withEndPlateType = true, isPSHEModelHidden = false) => {
  var _a;
  let psheType = "";
  switch (multiCondenser.multiPassCombination) {
    case 1 /* DesupCondSubcWaterOnPlateSide */:
    case 4 /* DesupCondSubcWaterOnShellSide */:
      psheType = `${multiCondenser.psheTypeDesuperHeater} + ${multiCondenser.psheTypeCondenser} + ${multiCondenser.psheTypeSubcooler}`;
      break;
    case 3 /* CondSubcWaterOnPlateSide */:
    case 6 /* CondSubcWaterOnShellSide */:
      psheType = `${multiCondenser.psheTypeCondenser} + ${multiCondenser.psheTypeSubcooler}`;
      break;
    case 2 /* DesupCondWaterOnPlateSide */:
    case 5 /* DesupCondWaterOnShellSide */:
      psheType = `${multiCondenser.psheTypeDesuperHeater} + ${multiCondenser.psheTypeCondenser}`;
      break;
  }
  if (isPSHEModelHidden) {
    psheType = `PSHE ${(_a = multiCondenser == null ? void 0 : multiCondenser.size) != null ? _a : 3 /* Size3 */}`;
  }
  return withEndPlateType ? psheType + " " + endPlateTypeMappingLabel.get(multiCondenser.endPlateType) : psheType;
};

// src/utils/cascade-spreadsheet.helper.ts
var mapCascadeCalcuationKeyToSpeadsheetCellValue = (heatExchanger, mfileInfo, position, calculationData, hidePsheType) => {
  var _a, _b, _c, _d, _e, _f;
  const isHotSidePlate = heatExchanger.cascadeType === 1 /* Flooded */;
  const mediumNameCondSide = heatExchanger.mediumSourceCondSide != 0 /* Imported */ ? mediumOptionMappingLabel.get(heatExchanger.mediumCondSide) : heatExchanger.mediumCondSideOtherMedia;
  const mediumNameEvapSide = heatExchanger.mediumSourceEvapSide != 0 /* Imported */ ? mediumOptionMappingLabel.get(heatExchanger.mediumEvapSide) : heatExchanger.mediumEvapSideOtherMedia;
  const paintingValue = paintingValueHandler(
    heatExchanger.paintStainlessSteel,
    heatExchanger.paintCarbonSteel,
    heatExchanger.surfaceTreatment,
    heatExchanger.otherStainlessSteel,
    heatExchanger.otherCarbonSteel
  );
  const paintStainlessSteelValue = paintingValue.paintStainlessSteelValue;
  const paintCarbonSteelValue = paintingValue.paintCarbonSteelValue;
  const getPlateDesignPressureUnit = heatExchanger.designPressurePlateSideOnDataSheet && heatExchanger.designPressureUnitPlateSideOnDataSheet ? unitDesignPressureOptionMappingLabel.get(
    heatExchanger.designPressureUnitPlateSideOnDataSheet
  ) : heatExchanger.typeApproval === 1 /* ASME */ ? unitDesignPressureOptionMappingLabel.get(6 /* psi */) : unitDesignPressureOptionMappingLabel.get(2 /* bar */);
  const rs = {
    cboQ: unitCapacityOptionLabelMapping.get(heatExchanger.cboQ),
    cboArea: unitAreaOptionLabelInputMapping.get(heatExchanger.cboArea),
    cboT: unitTemperatureLMTDOptionLabelMapping.get(heatExchanger.cboT),
    cboKval: unitKValueOptionLabelInputMapping.get(heatExchanger.cboKval),
    cboFF: unitFoulingFactorOptionLabelInputMapping.get(heatExchanger.cboFF),
    cboM: unitMassFlowOptionLabelMapping.get(heatExchanger.cboM),
    cboDp: unitPressureOptionLabelInputMapping.get(heatExchanger.cboDp),
    cboV: unitVolumeOptionInputMappingLabel.get(heatExchanger.cboV),
    cboVisco: unitDynamicViscosityOptionLabelMapping.get(
      heatExchanger.cboVisco
    ),
    cboGravi: unitSpecificGravityOptionLabelInputMapping.get(
      heatExchanger.cboGravi
    ),
    cboSpH: unitSpecificHeatOptionLabelMapping.get(heatExchanger.cboSpH),
    cboCdy: unitThermalConductivityOptionLabelInputMapping.get(
      heatExchanger.cboCdy
    ),
    endPlateType: endPlateTypeMappingLabel.get(heatExchanger.endPlateType),
    cboMass: unitMassOptionLabelMapping.get(heatExchanger.cboMass),
    position: directionMappingLabel.get(heatExchanger.position),
    feet: feetMappingLabel.get(heatExchanger.feet),
    flowDirectorMaterial: flowDirectorMaterialOptionValueMapping.get(
      heatExchanger.flowDirectorMaterial
    ),
    capacity: heatExchanger["capacity"],
    area: heatExchanger["area"],
    lmtd: heatExchanger["lmtd"],
    kval: heatExchanger["kval"],
    foulingFactor: heatExchanger["foulingFactor"],
    excessDesignArea: heatExchanger["excessDesignArea"],
    volumePlateSide: heatExchanger["volumePlateSide"],
    volumeShellSide: heatExchanger["volumeShellSide"],
    nozzlePlateSide: getNozzlePlateSideSize(
      heatExchanger["nozzlePlateSide"],
      heatExchanger.typeApproval
    ),
    nozzleShell: getNozzleShellSideSize(
      heatExchanger["nozzleShell"],
      heatExchanger.typeApproval
    ),
    nozzleShellOut: getNozzleShellSideSize(
      heatExchanger["nozzleShellOut"],
      heatExchanger.typeApproval
    ),
    velocityShellOut: heatExchanger["velocityShellOut"],
    velocityPlate: heatExchanger["velocityPlate"],
    velocityShell: heatExchanger["velocityShell"],
    velocityPlateOut: heatExchanger["velocityPlateOut"],
    massOfHeatExchanger: heatExchanger["massOfHeatExchanger"],
    constructionRow1Text: heatExchanger["constructionRow1Text"],
    constructionRow2Text: heatExchanger["constructionRow2Text"],
    constructionRow3Text: heatExchanger["constructionRow3Text"],
    constructionRow4Text: heatExchanger["constructionRow4Text"],
    constructionRow5Text: heatExchanger["constructionRow5Text"],
    constructionRow6Text: heatExchanger["constructionRow6Text"],
    constructionRow7Text: heatExchanger["constructionRow7Text"],
    constructionRow8Text: heatExchanger["constructionRow8Text"],
    materialsPlateConnections: heatExchanger["materialsPlateConnections"],
    materialsShellConnectionsIn: heatExchanger["materialsShellConnectionsIn"],
    materialsShellConnectionsOut: heatExchanger["materialsShellConnectionsOut"],
    fillingBoxesText: heatExchanger["fillingBoxesText"],
    actualVelocityText: heatExchanger["actualVelocityText"],
    // plateSide: `Plate Side (${isHotSidePlate ? 'Hot' : 'Cold'})`,
    // shellSide: `Shell Side (${isHotSidePlate ? 'Cold' : 'Hot'})`,
    tempInPlateSide: isHotSidePlate ? heatExchanger.inletTemperatureCondSide : heatExchanger.inletTemperatureEvapSide,
    tempInShellSide: isHotSidePlate ? heatExchanger.inletTemperatureEvapSide : heatExchanger.inletTemperatureCondSide,
    tempOutPlateSide: isHotSidePlate ? heatExchanger.outletTemperatureCondSide : (heatExchanger.saturationTemperatureEvapSide || 0) + (heatExchanger.dtSuperHeat || 0),
    tempOutShellSide: isHotSidePlate ? (heatExchanger.saturationTemperatureEvapSide || 0) + (heatExchanger.dtSuperHeat || 0) : heatExchanger.outletTemperatureCondSide,
    evaporatingTempPlateSide: isHotSidePlate ? void 0 : heatExchanger.saturationTemperatureEvapSide,
    evaporatingTempShellSide: isHotSidePlate ? heatExchanger.saturationTemperatureEvapSide : void 0,
    condensingTempPlateSide: isHotSidePlate ? heatExchanger.saturationTemperatureCondSide : void 0,
    condensingTempShellSide: isHotSidePlate ? void 0 : heatExchanger.saturationTemperatureCondSide,
    flowRatePlateSide: isHotSidePlate ? heatExchanger.massFlowRateCondSide : heatExchanger.massFlowRateEvapSide,
    flowRateShellSide: isHotSidePlate ? heatExchanger.massFlowRateEvapSide : heatExchanger.massFlowRateCondSide,
    pressureDropPlateSide: isHotSidePlate ? heatExchanger.pressureDropVaporSideOutput : heatExchanger.pressureDropLiquidSideOutput,
    pressureDropShellSide: isHotSidePlate ? heatExchanger.pressureDropLiquidSideOutput : heatExchanger.pressureDropVaporSideOutput,
    mediumPlateSide: isHotSidePlate ? mediumNameCondSide + ` (${(_a = heatExchanger.saturatedPressureCondSide) == null ? void 0 : _a.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : mediumNameEvapSide + ` (${(_b = heatExchanger.saturatedPressureEvapSide) == null ? void 0 : _b.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})`,
    mediumShellSide: isHotSidePlate ? mediumNameEvapSide + ` (${(_c = heatExchanger.saturatedPressureEvapSide) == null ? void 0 : _c.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : mediumNameCondSide + ` (${(_d = heatExchanger.saturatedPressureCondSide) == null ? void 0 : _d.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})`,
    designCode: heatExchanger.designCode || approvalTypeMappingLabel.get(heatExchanger.typeApproval),
    designPressureUnit: heatExchanger.designPressureShellSideOnDataSheet && heatExchanger.designPressureUnitShellSideOnDataSheet ? unitDesignPressureOptionMappingLabel.get(
      heatExchanger.designPressureUnitShellSideOnDataSheet
    ) : getDesignPressureShellSideUnit(heatExchanger.designPressureShellSide),
    designPressure: heatExchanger.designPressureShellSideOnDataSheet,
    designPressureOnDataSheet1: heatExchanger.designPressureShellSideOnDataSheet && heatExchanger.designPressureUnitShellSideOnDataSheet ? unitDesignPressureOptionMappingLabel.get(
      heatExchanger.designPressureUnitShellSideOnDataSheet
    ) : getDesignPressureShellSideUnit(heatExchanger.designPressureShellSide),
    designPressureOnDataSheet2: heatExchanger.designPressureShellSideOnDataSheet || heatExchanger.constructionRow5Text || designPressureOptionMappingValue.get(
      heatExchanger.designPressureShellSide
    ),
    plateDesignPressureUnit: getPlateDesignPressureUnit,
    plateDesignPressure: heatExchanger.designPressurePlateSideOnDataSheet || heatExchanger["constructionRow6Text"] || heatExchanger["designPressurePlateSide"],
    designTemperature: `${roundNumberToPrecision(
      (_e = heatExchanger.designTemperatureMin) != null ? _e : 0,
      3
    )}/${roundNumberToPrecision((_f = heatExchanger.designTemperatureMax) != null ? _f : 0, 3)}`,
    plateMaterial: `${plateMaterialMappingLabel.get(
      heatExchanger.plateMaterial
    )} ${plateThicknessOptionMappingLabel.get(heatExchanger.plateThickness)}`,
    shellMaterial: getShellMaterial(
      heatExchanger.endPlateType,
      shellMaterialMappingLabel.get(heatExchanger.shellMaterial) || ""
    ),
    numberOfPlateNozzles: getNumberOfPlateNozzle(
      heatExchanger.numberOfPlateNozzles
    ),
    numberOfShellNozzles: heatExchanger.numberOfShellNozzles,
    numberOfShellNozzlesOut: heatExchanger.numberOfShellNozzlesOut,
    paintStainlessSteel: paintStainlessSteelValue,
    paintCarbonSteel: paintCarbonSteelValue,
    offerNumber: mfileInfo ? mfileInfo.mFileId : "",
    customer: mfileInfo ? mfileInfo.companyName : "",
    heatExchangerType: hidePsheType ? "Type PSHE " + getHidePSHEModel(heatExchanger.psheType) : `Type PSHE: ${heatExchanger.psheType}`,
    plateAndShellHeatExchanger: "Plate & Shell Heat Exchanger",
    positionNo: position ? position.name : "",
    project: mfileInfo ? mfileInfo.projectName : "",
    operatingCase: calculationData ? calculationData.name : "",
    reference: mfileInfo ? mfileInfo.reference : "",
    offerBy: mfileInfo ? mfileInfo.responsiblePersonName : "",
    itemNameNo: position ? position.description : "",
    // Special value for i18n key because this need to be translated
    plateSide: isHotSidePlate ? "datasheet.table.data.Plate Side (Hot)" : "datasheet.table.data.Plate Side (Cold)",
    shellSide: isHotSidePlate ? "datasheet.table.data.Shell Side (Cold)" : "datasheet.table.data.Shell Side (Hot)",
    connectionHeader: heatExchanger.typeApproval == 1 /* ASME */ ? "datasheet.table.data.Size (in.)" : "datasheet.table.data.Size (DN)",
    applicationTitle: getAppTitle(heatExchanger)
  };
  return rs;
};

// src/utils/condenser-spreadsheet.helper.ts
var mapCondenserCalcuationKeyToSpeadsheetCellValue = (heatExchanger, mfileInfo, position, calculationData, hidePsheType) => {
  var _a, _b, _c, _d, _e;
  const isVentCondenser = heatExchanger.condenserType === 1 /* VentCondenser */;
  const isPlateSideLiquid = heatExchanger.liquidSide === 1 /* PlateSide */;
  const mediumNameLiquid = getMediumName(
    heatExchanger.mediumSourceLiquidSide,
    heatExchanger.mediumLiquidSide,
    heatExchanger.mediumLiquidSideOtherMedia,
    heatExchanger.concentrationLiquidSide || 0
  );
  const mediumNameLiquidSide = heatExchanger.liquidSidePhase === 1 /* Gas */ ? mediumNameLiquid + ` (${(_a = heatExchanger.gasPressureOnLiquidSide) == null ? void 0 : _a.toFixed(
    2
  )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : mediumNameLiquid;
  const mediumNameVaporSide = heatExchanger.mediumSourceVaporSide !== 0 /* Imported */ ? mediumOptionMappingLabel.get(heatExchanger.mediumVaporSide) : heatExchanger.mediumVaporSideOtherMedia;
  const paintingValue = paintingValueHandler(
    heatExchanger.paintStainlessSteel,
    heatExchanger.paintCarbonSteel,
    heatExchanger.surfaceTreatment,
    heatExchanger.otherStainlessSteel,
    heatExchanger.otherCarbonSteel
  );
  const paintStainlessSteelValue = paintingValue.paintStainlessSteelValue;
  const paintCarbonSteelValue = paintingValue.paintCarbonSteelValue;
  const getPlateDesignPressureUnit = heatExchanger.designPressurePlateSideOnDataSheet && heatExchanger.designPressureUnitPlateSideOnDataSheet ? unitDesignPressureOptionMappingLabel.get(
    heatExchanger.designPressureUnitPlateSideOnDataSheet
  ) : heatExchanger.typeApproval === 1 /* ASME */ ? unitDesignPressureOptionMappingLabel.get(6 /* psi */) : unitDesignPressureOptionMappingLabel.get(2 /* bar */);
  const shouldAppendShort = heatExchanger.flowDirectorMaterial !== 8 /* NoFlDirector */ && isPlateSideLiquid;
  const flowDirectorText = flowDirectorMaterialOptionValueMapping.get(
    heatExchanger.flowDirectorMaterial
  ) + (shouldAppendShort ? " (short)" : "");
  const rs = {
    cboQ: unitCapacityOptionLabelMapping.get(heatExchanger.cboQ),
    cboArea: unitAreaOptionLabelInputMapping.get(heatExchanger.cboArea),
    cboT: unitTemperatureLMTDOptionLabelMapping.get(heatExchanger.cboT),
    cboKval: unitKValueOptionLabelInputMapping.get(heatExchanger.cboKval),
    cboFF: unitFoulingFactorOptionLabelInputMapping.get(heatExchanger.cboFF),
    cboM: unitMassFlowOptionLabelMapping.get(heatExchanger.cboM),
    cboDp: unitPressureOptionLabelInputMapping.get(heatExchanger.cboDp),
    cboV: unitVolumeOptionInputMappingLabel.get(heatExchanger.cboV),
    cboVisco: unitDynamicViscosityOptionLabelMapping.get(
      heatExchanger.cboVisco
    ),
    cboGravi: unitSpecificGravityOptionLabelInputMapping.get(
      heatExchanger.cboGravi
    ),
    cboSpH: unitSpecificHeatOptionLabelMapping.get(heatExchanger.cboSpH),
    cboCdy: unitThermalConductivityOptionLabelInputMapping.get(
      heatExchanger.cboCdy
    ),
    endPlateType: endPlateTypeMappingLabel.get(heatExchanger.endPlateType),
    cboMass: unitMassOptionLabelMapping.get(heatExchanger.cboMass),
    position: directionMappingLabel.get(heatExchanger.position),
    feet: feetMappingLabel.get(heatExchanger.feet),
    flowDirectorMaterial: flowDirectorText,
    capacity: heatExchanger["capacity"],
    area: heatExchanger["area"],
    lmtd: heatExchanger["lmtd"],
    kval: heatExchanger["kval"],
    foulingFactor: heatExchanger["foulingFactor"],
    excessDesignArea: heatExchanger["excessDesignArea"],
    volumePlateSide: heatExchanger["volumePlateSide"],
    volumeShellSide: heatExchanger["volumeShellSide"],
    nozzlePlateSide: getNozzlePlateSideSize(
      heatExchanger["nozzlePlateSide"],
      heatExchanger.typeApproval
    ),
    velocityPlate: heatExchanger["velocityPlate"],
    velocityPlateOut: heatExchanger["velocityPlateOut"],
    velocityShell: heatExchanger["velocityShell"],
    nozzleShell: getNozzleShellSideSize(
      heatExchanger["nozzleShell"],
      heatExchanger.typeApproval
    ),
    massOfHeatExchanger: heatExchanger["massOfHeatExchanger"],
    designCode: heatExchanger["designCode"],
    designPressureOnDataSheet: heatExchanger["designPressureShellSideOnDataSheet"],
    designPressureOnDataSheet1: heatExchanger.designPressureShellSideOnDataSheet && heatExchanger.designPressureUnitShellSideOnDataSheet ? unitDesignPressureOptionMappingLabel.get(
      heatExchanger.designPressureUnitShellSideOnDataSheet
    ) : getDesignPressureShellSideUnit(heatExchanger.designPressureShellSide),
    designPressureOnDataSheet2: heatExchanger.designPressureShellSideOnDataSheet || heatExchanger.constructionRow5Text || designPressureOptionMappingValue.get(
      heatExchanger.designPressureShellSide
    ),
    plateDesignPressureUnit: getPlateDesignPressureUnit,
    plateDesignPressure: heatExchanger.designPressurePlateSideOnDataSheet || heatExchanger["constructionRow6Text"] || heatExchanger["designPressurePlateSide"],
    dynamicViscosityLiquidSide: heatExchanger["dynamicViscosityLiquidSide"],
    dynamicViscosityPlateSide: isPlateSideLiquid ? heatExchanger["dynamicViscosityLiquidSide"] : "",
    dynamicViscosityShellSide: !isPlateSideLiquid ? heatExchanger["dynamicViscosityLiquidSide"] : "",
    specificGravityLiquidSide: heatExchanger["specificGravityLiquidSide"],
    specificGravityPlateSide: isPlateSideLiquid ? heatExchanger["specificGravityLiquidSide"] : "",
    specificGravityShellSide: !isPlateSideLiquid ? heatExchanger["specificGravityLiquidSide"] : "",
    specificHeatLiquidSide: heatExchanger["specificHeatLiquidSide"],
    specificHeatPlateSide: isPlateSideLiquid ? heatExchanger["specificHeatLiquidSide"] : "",
    specificHeatShellSide: !isPlateSideLiquid ? heatExchanger["specificHeatLiquidSide"] : "",
    thermalConductivityLiquidSide: heatExchanger["thermalConductivityLiquidSide"],
    thermalConductivityPlateSide: isPlateSideLiquid ? heatExchanger["thermalConductivityLiquidSide"] : "",
    thermalConductivityShellSide: !isPlateSideLiquid ? heatExchanger["thermalConductivityLiquidSide"] : "",
    condensingTemperature: heatExchanger["condensingTemperature"],
    condensingTemperaturePlateSide: isPlateSideLiquid ? "" : heatExchanger["condensingTemperature"],
    condensingTemperatureShellSide: isPlateSideLiquid ? heatExchanger["condensingTemperature"] : "",
    constructionRow1Text: heatExchanger["constructionRow1Text"],
    constructionRow2Text: heatExchanger["constructionRow2Text"],
    constructionRow3Text: heatExchanger["constructionRow3Text"],
    constructionRow4Text: heatExchanger["constructionRow4Text"],
    constructionRow5Text: heatExchanger["constructionRow5Text"],
    constructionRow6Text: heatExchanger["constructionRow6Text"],
    constructionRow7Text: heatExchanger["constructionRow7Text"],
    constructionRow8Text: heatExchanger["constructionRow8Text"],
    materialsPlateConnections: heatExchanger["materialsPlateConnections"],
    materialsShellConnectionsIn: heatExchanger["materialsShellConnectionsIn"],
    materialsShellConnectionsOut: heatExchanger["materialsShellConnectionsOut"],
    fillingBoxesText: heatExchanger["fillingBoxesText"],
    actualVelocityText: heatExchanger["actualVelocityText"],
    numberOfPlateNozzles: getNumberOfPlateNozzle(
      heatExchanger.numberOfPlateNozzles
    ),
    numberOfShellNozzles: heatExchanger.numberOfShellNozzles,
    designPressure: getDesignPressureShellSideUnit(
      heatExchanger.designPressureShellSide
    ),
    designTemperature: `${roundNumberToPrecision(
      (_b = heatExchanger.designTemperatureMin) != null ? _b : 0,
      3
    )}/${roundNumberToPrecision((_c = heatExchanger.designTemperatureMax) != null ? _c : 0, 3)}`,
    plateMaterial: `${plateMaterialMappingLabel.get(
      heatExchanger.plateMaterial
    )} ${plateThicknessOptionMappingLabel.get(heatExchanger.plateThickness)}`,
    shellMaterial: getShellMaterial(
      heatExchanger.endPlateType,
      shellMaterialMappingLabel.get(heatExchanger.shellMaterial) || ""
    ),
    tempInPlateSide: isPlateSideLiquid ? heatExchanger.inletTemperatureLiquid : heatExchanger.gasInletTemperature,
    tempInShellSide: isPlateSideLiquid ? heatExchanger.gasInletTemperature : heatExchanger.inletTemperatureLiquid,
    tempOutPlateSide: isPlateSideLiquid ? heatExchanger.outletTemperatureLiquid : heatExchanger.subCooledTemperature,
    tempOutShellSide: isPlateSideLiquid ? heatExchanger.subCooledTemperature : heatExchanger.outletTemperatureLiquid,
    flowRatePlateSide: isPlateSideLiquid ? heatExchanger.flowRateLiquid : heatExchanger.flowRateVapor,
    flowRateShellSide: isPlateSideLiquid ? heatExchanger.flowRateVapor : heatExchanger.flowRateLiquid,
    pressureDropPlateSide: isPlateSideLiquid ? heatExchanger.pressureDropLiquidOutput : heatExchanger.pressureDropVaporOutput,
    pressureDropShellSide: isPlateSideLiquid ? heatExchanger.pressureDropVaporOutput : heatExchanger.pressureDropLiquidOutput,
    mediumPlateSide: isPlateSideLiquid ? mediumNameLiquidSide : mediumNameVaporSide + ` (${(_d = heatExchanger.saturatedPressure) == null ? void 0 : _d.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})`,
    mediumShellSide: isPlateSideLiquid ? mediumNameVaporSide + ` (${(_e = heatExchanger.saturatedPressure) == null ? void 0 : _e.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : mediumNameLiquidSide,
    nozzleShellOut: !isVentCondenser ? getNozzleShellSideSize(
      heatExchanger["nozzleShellOut"],
      heatExchanger.typeApproval
    ) : `${precise(heatExchanger.nozzleShellOutUp)} \\ ${precise(
      heatExchanger.nozzleShellOut
    )} (u\\d)`,
    numberOfShellNozzlesOut: !isVentCondenser ? heatExchanger.numberOfShellNozzlesOut : `${precise(heatExchanger.numberOfShellNozzlesUp)} \\ ${precise(
      heatExchanger.numberOfShellNozzlesOut
    )} (u\\d)`,
    velocityShellOut: !isVentCondenser ? heatExchanger.velocityShellOut : `${precise(heatExchanger.velocityShellOutUp)} \\ ${precise(
      heatExchanger.velocityShellOut
    )} (u\\d)`,
    paintStainlessSteel: paintStainlessSteelValue,
    paintCarbonSteel: paintCarbonSteelValue,
    offerNumber: mfileInfo ? mfileInfo.mFileId : "",
    customer: mfileInfo ? mfileInfo.companyName : "",
    heatExchangerType: hidePsheType ? "Type PSHE " + getHidePSHEModel(heatExchanger.psheType) : `Type PSHE: ${heatExchanger.psheType}`,
    plateAndShellHeatExchanger: "Plate & Shell Heat Exchanger",
    positionNo: position ? position.name : "",
    project: mfileInfo ? mfileInfo.projectName : "",
    operatingCase: calculationData ? calculationData.name : "",
    reference: mfileInfo ? mfileInfo.reference : "",
    offerBy: mfileInfo ? mfileInfo.responsiblePersonName : "",
    itemNameNo: position ? position.description : "",
    // Special value for i18n key because this need to be translated
    plateSide: isPlateSideLiquid ? "datasheet.table.data.Plate Side (Cold)" : "datasheet.table.data.Plate Side (Hot)",
    shellSide: isPlateSideLiquid ? "datasheet.table.data.Shell Side (Hot)" : "datasheet.table.data.Shell Side (Cold)",
    connectionHeader: heatExchanger.typeApproval == 1 /* ASME */ ? "datasheet.table.data.Size (in.)" : "datasheet.table.data.Size (DN)",
    applicationTitle: getAppTitle(heatExchanger)
  };
  return rs;
};

// src/utils/evaporator-spreadsheet.helper.ts
var mapEvaporatorCalcuationKeyToSpeadsheetCellValue = (heatExchanger, mfileInfo, position, calculationData, hidePsheType) => {
  var _a, _b, _c, _d;
  const isHotSidePlate = heatExchanger.evaporatorType === 1 /* FloodedEvaporator */;
  const mediumNameLiquidSide = getMediumName(
    heatExchanger.mediumSourceLiquidSide,
    heatExchanger.mediumLiquidSide,
    heatExchanger.mediumLiquidSideOtherMedia,
    heatExchanger.concentrationLiquidSide || 0
  );
  const mediumNameVaporSide = heatExchanger.mediumSourceVaporSide != 0 /* Imported */ ? mediumOptionMappingLabel.get(heatExchanger.mediumVaporSide) : heatExchanger.mediumVaporSideOtherMedia;
  const paintingValue = paintingValueHandler(
    heatExchanger.paintStainlessSteel,
    heatExchanger.paintCarbonSteel,
    heatExchanger.surfaceTreatment,
    heatExchanger.otherStainlessSteel,
    heatExchanger.otherCarbonSteel
  );
  const paintStainlessSteelValue = paintingValue.paintStainlessSteelValue;
  const paintCarbonSteelValue = paintingValue.paintCarbonSteelValue;
  const getPlateDesignPressureUnit = heatExchanger.designPressurePlateSideOnDataSheet && heatExchanger.designPressureUnitPlateSideOnDataSheet ? unitDesignPressureOptionMappingLabel.get(
    heatExchanger.designPressureUnitPlateSideOnDataSheet
  ) : heatExchanger.typeApproval === 1 /* ASME */ ? unitDesignPressureOptionMappingLabel.get(6 /* psi */) : unitDesignPressureOptionMappingLabel.get(2 /* bar */);
  const rs = {
    cboQ: unitCapacityOptionLabelMapping.get(heatExchanger.cboQ),
    cboArea: unitAreaOptionLabelInputMapping.get(heatExchanger.cboArea),
    cboT: unitTemperatureLMTDOptionLabelMapping.get(heatExchanger.cboT),
    cboKval: unitKValueOptionLabelInputMapping.get(heatExchanger.cboKval),
    cboFF: unitFoulingFactorOptionLabelInputMapping.get(heatExchanger.cboFF),
    cboM: unitMassFlowOptionLabelMapping.get(heatExchanger.cboM),
    cboDp: unitPressureOptionLabelInputMapping.get(heatExchanger.cboDp),
    cboV: unitVolumeOptionInputMappingLabel.get(heatExchanger.cboV),
    cboVisco: unitDynamicViscosityOptionLabelMapping.get(
      heatExchanger.cboVisco
    ),
    cboGravi: unitSpecificGravityOptionLabelInputMapping.get(
      heatExchanger.cboGravi
    ),
    cboSpH: unitSpecificHeatOptionLabelMapping.get(heatExchanger.cboSpH),
    cboCdy: unitThermalConductivityOptionLabelInputMapping.get(
      heatExchanger.cboCdy
    ),
    endPlateType: endPlateTypeMappingLabel.get(heatExchanger.endPlateType),
    cboMass: unitMassOptionLabelMapping.get(heatExchanger.cboMass),
    position: directionMappingLabel.get(heatExchanger.position),
    feet: feetMappingLabel.get(heatExchanger.feet),
    flowDirectorMaterial: flowDirectorMaterialOptionValueMapping.get(
      heatExchanger.flowDirectorMaterial
    ),
    paintStainlessSteel: paintStainlessSteelValue,
    paintCarbonSteel: paintCarbonSteelValue,
    capacity: heatExchanger["capacity"],
    area: heatExchanger["area"],
    lmtd: heatExchanger["lmtd"],
    kval: heatExchanger["kval"],
    foulingFactor: heatExchanger["foulingFactor"],
    excessDesignArea: heatExchanger["excessDesignArea"],
    volumePlateSide: heatExchanger["volumePlateSide"],
    volumeShellSide: heatExchanger["volumeShellSide"],
    nozzlePlateSide: getNozzlePlateSideSize(
      heatExchanger["nozzlePlateSide"],
      heatExchanger.typeApproval
    ),
    velocityPlate: heatExchanger["velocityPlate"],
    velocityShell: heatExchanger["velocityShell"],
    velocityPlateOut: heatExchanger["velocityPlateOut"],
    nozzleShell: getNozzleShellSideSize(
      heatExchanger["nozzleShell"],
      heatExchanger.typeApproval
    ),
    massOfHeatExchanger: heatExchanger["massOfHeatExchanger"],
    designCode: heatExchanger["designCode"],
    dynamicViscosityLiquidSide: heatExchanger["dynamicViscosityLiquidSide"],
    specificGravityLiquidSide: heatExchanger["specificGravityLiquidSide"],
    specificHeatLiquidSide: heatExchanger["specificHeatLiquidSide"],
    thermalConductivityLiquidSide: heatExchanger["thermalConductivityLiquidSide"],
    nozzleShellOut: getNozzleShellSideSize(
      heatExchanger["nozzleShellOut"],
      heatExchanger.typeApproval
    ),
    numberOfShellNozzlesOut: heatExchanger["numberOfShellNozzlesOut"],
    velocityShellOut: heatExchanger["velocityShellOut"],
    constructionRow1Text: heatExchanger["constructionRow1Text"],
    constructionRow2Text: heatExchanger["constructionRow2Text"],
    constructionRow3Text: heatExchanger["constructionRow3Text"],
    constructionRow4Text: heatExchanger["constructionRow4Text"],
    constructionRow5Text: heatExchanger["constructionRow5Text"],
    constructionRow6Text: heatExchanger["constructionRow6Text"],
    constructionRow7Text: heatExchanger["constructionRow7Text"],
    constructionRow8Text: heatExchanger["constructionRow8Text"],
    materialsPlateConnections: heatExchanger["materialsPlateConnections"],
    materialsShellConnectionsIn: heatExchanger["materialsShellConnectionsIn"],
    materialsShellConnectionsOut: heatExchanger["materialsShellConnectionsOut"],
    fillingBoxesText: heatExchanger["fillingBoxesText"],
    actualVelocityText: heatExchanger["actualVelocityText"],
    evaporatingTemperature: heatExchanger["evaporatingTemperature"],
    numberOfPlateNozzles: getNumberOfPlateNozzle(
      heatExchanger.numberOfPlateNozzles
    ),
    evaporatingTempPlateSide: isHotSidePlate ? "" : heatExchanger.evaporatingTemperature,
    evaporatingTempShellSide: isHotSidePlate ? heatExchanger.evaporatingTemperature : "",
    numberOfShellNozzles: heatExchanger.numberOfShellNozzles,
    designPressure: getDesignPressureShellSideUnit(
      heatExchanger.designPressureShellSide
    ),
    designTemperature: `${roundNumberToPrecision(
      (_a = heatExchanger.designTemperatureMin) != null ? _a : 0,
      3
    )}/${roundNumberToPrecision((_b = heatExchanger.designTemperatureMax) != null ? _b : 0, 3)}`,
    plateMaterial: `${plateMaterialMappingLabel.get(
      heatExchanger.plateMaterial
    )} ${plateThicknessOptionMappingLabel.get(heatExchanger.plateThickness)}`,
    shellMaterial: getShellMaterial(
      heatExchanger.endPlateType,
      shellMaterialMappingLabel.get(heatExchanger.shellMaterial) || ""
    ),
    // plateSide: `Plate Side (${isHotSidePlate ? 'Cold' : 'Hot'})`,
    // shellSide: `Shell Side (${isHotSidePlate ? 'Hot' : 'Cold'})`,
    tempInPlateSide: isHotSidePlate ? heatExchanger.inletTemperatureLiquid : heatExchanger.inletTempEvapSide,
    tempInShellSide: isHotSidePlate ? heatExchanger.inletTempEvapSide : heatExchanger.inletTemperatureLiquid,
    tempOutPlateSide: isHotSidePlate ? heatExchanger.outletTemperatureLiquid : (heatExchanger.evaporatingTemperature || 0) + (heatExchanger.dtSuperHeat || 0),
    tempOutShellSide: isHotSidePlate ? (heatExchanger.evaporatingTemperature || 0) + (heatExchanger.dtSuperHeat || 0) : heatExchanger.outletTemperatureLiquid,
    flowRatePlateSide: isHotSidePlate ? heatExchanger.flowRateLiquid : heatExchanger.flowRateVapor,
    flowRateShellSide: isHotSidePlate ? heatExchanger.flowRateVapor : heatExchanger.flowRateLiquid,
    pressureDropPlateSide: isHotSidePlate ? heatExchanger.pressureDropLiquidSideOutput : heatExchanger.pressureDropVaporSideOutput,
    pressureDropShellSide: isHotSidePlate ? heatExchanger.pressureDropVaporSideOutput : heatExchanger.pressureDropLiquidSideOutput,
    mediumPlateSide: isHotSidePlate ? mediumNameLiquidSide : mediumNameVaporSide + ` (${(_c = heatExchanger.saturatedPressure) == null ? void 0 : _c.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})`,
    mediumShellSide: isHotSidePlate ? mediumNameVaporSide + ` (${(_d = heatExchanger.saturatedPressure) == null ? void 0 : _d.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : mediumNameLiquidSide,
    designPressureOnDataSheet1: heatExchanger.designPressureShellSideOnDataSheet && heatExchanger.designPressureUnitShellSideOnDataSheet ? unitDesignPressureOptionMappingLabel.get(
      heatExchanger.designPressureUnitShellSideOnDataSheet
    ) : getDesignPressureShellSideUnit(heatExchanger.designPressureShellSide),
    designPressureOnDataSheet2: heatExchanger.designPressureShellSideOnDataSheet || heatExchanger.constructionRow5Text || designPressureOptionMappingValue.get(
      heatExchanger.designPressureShellSide
    ),
    plateDesignPressureUnit: getPlateDesignPressureUnit,
    plateDesignPressure: heatExchanger.designPressurePlateSideOnDataSheet || heatExchanger["constructionRow6Text"] || heatExchanger["designPressurePlateSide"],
    offerNumber: mfileInfo ? mfileInfo.mFileId : "",
    customer: mfileInfo ? mfileInfo.companyName : "",
    heatExchangerType: hidePsheType ? "Type PSHE " + getHidePSHEModel(heatExchanger.psheType) : `Type PSHE: ${heatExchanger.psheType}`,
    plateAndShellHeatExchanger: "Plate & Shell Heat Exchanger",
    positionNo: position ? position.name : "",
    project: mfileInfo ? mfileInfo.projectName : "",
    operatingCase: calculationData ? calculationData.name : "",
    reference: mfileInfo ? mfileInfo.reference : "",
    offerBy: mfileInfo ? mfileInfo.responsiblePersonName : "",
    itemNameNo: position ? position.description : "",
    // Medium section
    dynamicViscosityPlateSide: isHotSidePlate ? heatExchanger.dynamicViscosityLiquidSide : "",
    dynamicViscosityShellSide: isHotSidePlate ? "" : heatExchanger.dynamicViscosityLiquidSide,
    specificGravityPlateSide: isHotSidePlate ? heatExchanger.specificGravityLiquidSide : "",
    specificGravityShellSide: isHotSidePlate ? "" : heatExchanger.specificGravityLiquidSide,
    specificHeatPlateSide: isHotSidePlate ? heatExchanger.specificHeatLiquidSide : "",
    specificHeatShellSide: isHotSidePlate ? "" : heatExchanger.specificHeatLiquidSide,
    thermalConductivityPlateSide: isHotSidePlate ? heatExchanger.thermalConductivityLiquidSide : "",
    thermalConductivityShellSide: isHotSidePlate ? "" : heatExchanger.thermalConductivityLiquidSide,
    // Special value for i18n key because this need to be translated
    plateSide: isHotSidePlate ? "datasheet.table.data.Plate Side (Hot)" : "datasheet.table.data.Plate Side (Cold)",
    shellSide: isHotSidePlate ? "datasheet.table.data.Shell Side (Cold)" : "datasheet.table.data.Shell Side (Hot)",
    connectionHeader: heatExchanger.typeApproval == 1 /* ASME */ ? "datasheet.table.data.Size (in.)" : "datasheet.table.data.Size (DN)",
    applicationTitle: getAppTitle(heatExchanger)
  };
  return rs;
};

// src/utils/multi-condenser-spreadsheet.helper.ts
var getMultiCondenserPsheType = (heatExchangerData, configuratorType) => {
  let psheType = "";
  switch (configuratorType) {
    case "multiCondensers":
      if (heatExchangerData.multiPassCombination == 1 /* DesupCondSubcWaterOnPlateSide */ || heatExchangerData.multiPassCombination == 4 /* DesupCondSubcWaterOnShellSide */) {
        psheType = `${heatExchangerData.psheTypeDesuperHeater} + ${heatExchangerData.psheTypeCondenser} + ${heatExchangerData.psheTypeSubcooler}`;
      } else if (heatExchangerData.multiPassCombination == 2 /* DesupCondWaterOnPlateSide */ || heatExchangerData.multiPassCombination == 5 /* DesupCondWaterOnShellSide */) {
        psheType = `${heatExchangerData.psheTypeDesuperHeater} + ${heatExchangerData.psheTypeCondenser}`;
      } else if (heatExchangerData.multiPassCombination == 3 /* CondSubcWaterOnPlateSide */ || heatExchangerData.multiPassCombination == 6 /* CondSubcWaterOnShellSide */) {
        psheType = `${heatExchangerData.psheTypeCondenser} + ${heatExchangerData.psheTypeSubcooler}`;
      }
      break;
    case "desuperheater":
      psheType = `${heatExchangerData.psheTypeDesuperHeater}`;
      break;
    case "condenser":
      psheType = `${heatExchangerData.psheTypeCondenser}`;
      break;
    case "subcooler":
      psheType = `${heatExchangerData.psheTypeSubcooler}`;
      break;
    default:
      break;
  }
  return psheType;
};
var mapMultiCondenserCalcuationKeyToSpeadsheetCellValue = (heatExchanger, mfileInfo, position, calculationData, hidePsheType, configuratorType) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const isPlateSideLiquid = heatExchanger.liquidSideMultiCondenser === 1 /* PlateSide */;
  const mediumNameVaporSideName = heatExchanger.mediumSourceVaporSide != 0 /* Imported */ ? mediumOptionMappingLabel.get(heatExchanger.mediumVaporSide) : heatExchanger.mediumVaporSideOtherMedia;
  const mediumNameLiquidSideName = getMediumName(
    heatExchanger.mediumSourceLiquidSide,
    heatExchanger.mediumLiquidSide,
    heatExchanger.mediumLiquidSideOtherMedia,
    heatExchanger.concentrationLiquidSide || 0
  );
  const mediumNameLiquidSide = heatExchanger.liquidSidePhase === 1 /* Gas */ ? mediumNameLiquidSideName + ` (${(_a = heatExchanger.gasPressureOnLiquidSide) == null ? void 0 : _a.toFixed(2)} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : mediumNameLiquidSideName;
  const paintingValue = paintingValueHandler(
    heatExchanger.paintStainlessSteel,
    heatExchanger.paintCarbonSteel,
    heatExchanger.surfaceTreatment,
    heatExchanger.otherStainlessSteel,
    heatExchanger.otherCarbonSteel
  );
  const paintStainlessSteelValue = paintingValue.paintStainlessSteelValue;
  const paintCarbonSteelValue = paintingValue.paintCarbonSteelValue;
  const getPlateDesignPressureUnit = heatExchanger.designPressurePlateSideOnDataSheet && heatExchanger.designPressureUnitPlateSideOnDataSheet ? unitDesignPressureOptionMappingLabel.get(
    heatExchanger.designPressureUnitPlateSideOnDataSheet
  ) : heatExchanger.typeApproval === 1 /* ASME */ ? unitDesignPressureOptionMappingLabel.get(6 /* psi */) : unitDesignPressureOptionMappingLabel.get(2 /* bar */);
  const rs = {
    capacity: heatExchanger["capacity"],
    area: heatExchanger["area"],
    lmtd: heatExchanger["lmtd"],
    kval: heatExchanger["kval"],
    foulingFactor: heatExchanger["foulingFactor"],
    excessDesignArea: heatExchanger["excessDesignArea"],
    deltaPCondSide: heatExchanger["deltaPCondSide"],
    nozzlePlateSide: getNozzlePlateSideSize(
      heatExchanger["nozzlePlateSide"],
      heatExchanger.typeApproval
    ),
    velocityPlate: heatExchanger["velocityPlate"],
    velocityPlateOut: heatExchanger["velocityPlateOut"],
    nozzleShell: getNozzleShellSideSize(
      heatExchanger["nozzleShell"],
      heatExchanger.typeApproval
    ),
    nozzleShellOut: getNozzleShellSideSize(
      heatExchanger["nozzleShellOut"],
      heatExchanger.typeApproval
    ),
    velocityShell: heatExchanger["velocityShell"],
    velocityShellOut: heatExchanger["velocityShellOut"],
    numberOfShellNozzlesOut: heatExchanger.numberOfShellNozzlesOut,
    massOfHeatExchanger: heatExchanger["massOfHeatExchanger"],
    capacityDesuperHeater: heatExchanger["capacityDesuperHeater"],
    areaDesuperHeater: heatExchanger["areaDesuperHeater"],
    lmtdDesuperHeater: heatExchanger["lmtdDesuperHeater"],
    kvalDesuperHeater: heatExchanger["kvalDesuperHeater"],
    excessDesignAreaDesuperHeater: heatExchanger["excessDesignAreaDesuperHeater"],
    dynamicViscosityVaporSideL: heatExchanger["dynamicViscosityVaporSideL"],
    dynamicViscosityVaporSideV: heatExchanger["dynamicViscosityVaporSideV"],
    dynamicViscosityVaporSideSuperh: heatExchanger["dynamicViscosityVaporSideSuperh"],
    specificGravityLiquidSide: heatExchanger["specificGravityLiquidSide"],
    specificHeatLiquidSide: heatExchanger["specificHeatLiquidSide"],
    thermalConductivityLiquidSide: heatExchanger["thermalConductivityLiquidSide"],
    capacityCondenser: heatExchanger["capacityCondenser"],
    areaCondenser: heatExchanger["areaCondenser"],
    lmtdCondenser: heatExchanger["lmtdCondenser"],
    kvalCondenser: heatExchanger["kvalCondenser"],
    excessDesignAreaCondenser: heatExchanger["excessDesignAreaCondenser"],
    capacitySubcooler: heatExchanger["capacitySubcooler"],
    areaSubcooler: heatExchanger["areaSubcooler"],
    lmtdSubcooler: heatExchanger["lmtdSubcooler"],
    kvalSubcooler: heatExchanger["kvalSubcooler"],
    excessDesignAreaSubcooler: heatExchanger["excessDesignAreaSubcooler"],
    constructionRow1Text: heatExchanger["constructionRow1Text"],
    constructionRow2Text: heatExchanger["constructionRow2Text"],
    constructionRow3Text: heatExchanger["constructionRow3Text"],
    constructionRow4Text: heatExchanger["constructionRow4Text"],
    constructionRow5Text: heatExchanger["constructionRow5Text"],
    constructionRow6Text: heatExchanger["constructionRow6Text"],
    constructionRow7Text: heatExchanger["constructionRow7Text"],
    constructionRow8Text: heatExchanger["constructionRow8Text"],
    materialsPlateConnections: heatExchanger["materialsPlateConnections"],
    materialsShellConnectionsIn: heatExchanger["materialsShellConnectionsIn"],
    materialsShellConnectionsOut: heatExchanger["materialsShellConnectionsOut"],
    fillingBoxesText: heatExchanger["fillingBoxesText"],
    actualVelocityText: heatExchanger["actualVelocityText"],
    flowRateVapor: heatExchanger["flowRateVapor"],
    flowRateLiquid: heatExchanger["flowRateLiquid"],
    cboQ: unitCapacityOptionLabelMapping.get(heatExchanger.cboQ),
    cboArea: unitAreaOptionLabelInputMapping.get(heatExchanger.cboArea),
    cboT: unitTemperatureLMTDOptionLabelMapping.get(heatExchanger.cboT),
    cboKval: unitKValueOptionLabelInputMapping.get(heatExchanger.cboKval),
    cboFF: unitFoulingFactorOptionLabelInputMapping.get(heatExchanger.cboFF),
    cboDp: unitPressureOptionLabelInputMapping.get(heatExchanger.cboDp),
    cboM: unitMassFlowOptionLabelMapping.get(heatExchanger.cboM),
    endPlateType: endPlateTypeMappingLabel.get(heatExchanger.endPlateType),
    cboMass: unitMassOptionLabelMapping.get(heatExchanger.cboMass),
    cboV: unitVolumeOptionInputMappingLabel.get(heatExchanger.cboV),
    cboGravi: unitSpecificGravityOptionLabelInputMapping.get(
      heatExchanger.cboGravi
    ),
    cboSpH: unitSpecificHeatOptionLabelMapping.get(heatExchanger.cboSpH),
    cboCdy: unitThermalConductivityOptionLabelInputMapping.get(
      heatExchanger.cboCdy
    ),
    cboVisco: unitDynamicViscosityOptionLabelMapping.get(
      heatExchanger.cboVisco
    ),
    position: directionMappingLabel.get(heatExchanger.position),
    feet: feetMappingLabel.get(heatExchanger.feet),
    flowDirectorMaterial: flowDirectorMaterialOptionValueMapping.get(
      heatExchanger.flowDirectorMaterial
    ),
    mediumName: isPlateSideLiquid ? `${mediumNameLiquidSideName}/${mediumNameVaporSideName}` : `${mediumNameVaporSideName}/${mediumNameLiquidSideName}`,
    appName: "Multi-condenser",
    appNameDesuperheater: "Desuperheater",
    appNameCondenser: "Condenser",
    appNameSubcooler: "Subcooler",
    pshe: `Type PSHE ${[
      heatExchanger.psheTypeDesuperHeater,
      heatExchanger.psheTypeCondenser,
      heatExchanger.psheTypeSubcooler
    ].filter((t) => t).join(" + ")}`,
    psheTypeDesuperHeater: `Type PSHE ${heatExchanger.psheTypeDesuperHeater}`,
    psheTypeCondenser: `Type PSHE ${heatExchanger.psheTypeCondenser}`,
    psheTypeSubcooler: `Type PSHE ${heatExchanger.psheTypeSubcooler}`,
    designCase: heatExchanger.designCode || approvalTypeMappingLabel.get(heatExchanger.typeApproval),
    // plateSide: `Plate Side (${isPlateSideLiquid ? 'Cold' : 'Hot'})`,
    // shellSide: `Shell Side (${isPlateSideLiquid ? 'Hot' : 'Cold'})`,
    mediumPlateSide: isPlateSideLiquid ? mediumNameLiquidSide : mediumNameVaporSideName + ` (${(_b = heatExchanger.saturatedPressure) == null ? void 0 : _b.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})`,
    mediumShellSide: isPlateSideLiquid ? mediumNameVaporSideName + ` (${(_c = heatExchanger.saturatedPressure) == null ? void 0 : _c.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : mediumNameLiquidSide,
    mediumPlateSideSubMachine: isPlateSideLiquid ? mediumNameLiquidSide : mediumNameVaporSideName + ` (${(_d = heatExchanger.saturatedPressure) == null ? void 0 : _d.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})`,
    mediumShellSideSubMachine: isPlateSideLiquid ? mediumNameVaporSideName + ` (${(_e = heatExchanger.saturatedPressure) == null ? void 0 : _e.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : mediumNameLiquidSide,
    tempInPlateSide: isPlateSideLiquid ? heatExchanger.inletTemperatureLiquid : heatExchanger.gasInletTemperature,
    tempInShellSide: isPlateSideLiquid ? heatExchanger.gasInletTemperature : heatExchanger.inletTemperatureLiquid,
    condensingTemperaturePlateSide: isPlateSideLiquid ? void 0 : heatExchanger.condensingTemperature,
    condensingTemperatureShellSide: isPlateSideLiquid ? heatExchanger.condensingTemperature : void 0,
    tempOutPlateSide: isPlateSideLiquid ? heatExchanger.outletTemperatureLiquid : heatExchanger.subCooledTemperature,
    tempOutShellSide: isPlateSideLiquid ? heatExchanger.subCooledTemperature : heatExchanger.outletTemperatureLiquid,
    pressureDropPlateSide: isPlateSideLiquid ? heatExchanger.pressureDropVaporOutput : heatExchanger.pressureDropLiquidOutput,
    pressureDropShellSide: isPlateSideLiquid ? heatExchanger.pressureDropLiquidOutput : heatExchanger.pressureDropVaporOutput,
    numberOfPlateNozzles: getNumberOfPlateNozzle(
      heatExchanger.numberOfPlateNozzles
    ),
    numberOfShellNozzles: heatExchanger.numberOfShellNozzles,
    designCode: heatExchanger.designCode || approvalTypeMappingLabel.get(heatExchanger.typeApproval),
    designPressureUnit: getDesignPressureShellSideUnit(
      heatExchanger.designPressureShellSide
    ),
    designPressureOnDataSheet: heatExchanger.designPressureShellSideOnDataSheet,
    designPressureOnDataSheet1: heatExchanger.designPressureShellSideOnDataSheet && heatExchanger.designPressureUnitShellSideOnDataSheet ? unitDesignPressureOptionMappingLabel.get(
      heatExchanger.designPressureUnitShellSideOnDataSheet
    ) : getDesignPressureShellSideUnit(heatExchanger.designPressureShellSide),
    designPressureOnDataSheet2: heatExchanger.designPressureShellSideOnDataSheet || heatExchanger.constructionRow5Text || designPressureOptionMappingValue.get(
      heatExchanger.designPressureShellSide
    ),
    plateDesignPressureUnit: getPlateDesignPressureUnit,
    plateDesignPressure: heatExchanger.designPressurePlateSideOnDataSheet || heatExchanger["constructionRow6Text"] || heatExchanger["designPressurePlateSide"],
    designTemperature: `${roundNumberToPrecision(
      (_f = heatExchanger.designTemperatureMin) != null ? _f : 0,
      3
    )}/${roundNumberToPrecision((_g = heatExchanger.designTemperatureMax) != null ? _g : 0, 3)}`,
    plateMaterial: `${plateMaterialMappingLabel.get(
      heatExchanger.plateMaterial
    )} ${plateThicknessOptionMappingLabel.get(heatExchanger.plateThickness)}`,
    shellMaterial: getShellMaterial(
      heatExchanger.endPlateType,
      shellMaterialMappingLabel.get(heatExchanger.shellMaterial) || ""
    ),
    tempInPlateSideDesuperHeater: isPlateSideLiquid ? heatExchanger.midMediumTempT3B : heatExchanger.gasInletTemperature,
    tempInShellSideDesuperHeater: isPlateSideLiquid ? heatExchanger.gasInletTemperature : heatExchanger.midMediumTempT3B,
    tempOutPlateSideDesuperHeater: isPlateSideLiquid ? heatExchanger.outletTemperatureLiquid : heatExchanger.condensingTemperature,
    tempOutShellSideDesuperHeater: isPlateSideLiquid ? heatExchanger.condensingTemperature : heatExchanger.outletTemperatureLiquid,
    tempInPlateSideCond: isPlateSideLiquid ? heatExchanger.midMediumTempT3A : heatExchanger.condensingTemperature,
    tempInShellSideCond: isPlateSideLiquid ? heatExchanger.condensingTemperature : heatExchanger.midMediumTempT3A,
    tempOutPlateSideCond: isPlateSideLiquid ? heatExchanger.midMediumTempT3B : heatExchanger.condensingTemperature,
    tempOutShellSideCond: isPlateSideLiquid ? heatExchanger.condensingTemperature : heatExchanger.midMediumTempT3B,
    tempInPlateSideSubcooler: isPlateSideLiquid ? heatExchanger.inletTemperatureLiquid : heatExchanger.condensingTemperature,
    tempInShellSideSubcooler: isPlateSideLiquid ? heatExchanger.condensingTemperature : heatExchanger.inletTemperatureLiquid,
    tempOutPlateSideSubcooler: isPlateSideLiquid ? heatExchanger.midMediumTempT3A : heatExchanger.subCooledTemperature,
    tempOutShellSideSubcooler: isPlateSideLiquid ? heatExchanger.subCooledTemperature : heatExchanger.midMediumTempT3A,
    flowRatePlateSide: isPlateSideLiquid ? heatExchanger.flowRateLiquid : heatExchanger.flowRateVapor,
    flowRateShellSide: isPlateSideLiquid ? heatExchanger.flowRateVapor : heatExchanger.flowRateLiquid,
    pressureDropPlateSideDesuperHeater: isPlateSideLiquid ? heatExchanger.pressureDropVaporOutputDesuperHeater : heatExchanger.pressureDropLiquidOutputDesuperHeater,
    pressureDropShellSideDesuperHeater: isPlateSideLiquid ? heatExchanger.pressureDropLiquidOutputDesuperHeater : heatExchanger.pressureDropVaporOutputDesuperHeater,
    pressureDropPlateSideCond: isPlateSideLiquid ? heatExchanger.pressureDropVaporOutputCondenser : heatExchanger.pressureDropLiquidOutputCondenser,
    pressureDropShellSideCond: isPlateSideLiquid ? heatExchanger.pressureDropLiquidOutputCondenser : heatExchanger.pressureDropVaporOutputCondenser,
    pressureDropPlateSideSubCooler: isPlateSideLiquid ? heatExchanger.pressureDropVaporOutputSubcooler : heatExchanger.pressureDropLiquidOutputSubcooler,
    pressureDropShellSideSubCooler: isPlateSideLiquid ? heatExchanger.pressureDropLiquidOutputSubcooler : heatExchanger.pressureDropVaporOutputSubcooler,
    dynamicViscosityPlateSide: isPlateSideLiquid ? heatExchanger.dynamicViscosityLiquidSide : "",
    dynamicViscosityShellSide: isPlateSideLiquid ? "" : heatExchanger.dynamicViscosityLiquidSide,
    specificGravityPlateSide: isPlateSideLiquid ? heatExchanger.specificGravityLiquidSide : "",
    specificGravityShellSide: isPlateSideLiquid ? "" : heatExchanger.specificGravityLiquidSide,
    specificHeatPlateSide: isPlateSideLiquid ? heatExchanger.specificHeatLiquidSide : "",
    specificHeatShellSide: isPlateSideLiquid ? "" : heatExchanger.specificHeatLiquidSide,
    thermalConductivityPlateSide: isPlateSideLiquid ? heatExchanger.thermalConductivityLiquidSide : "",
    thermalConductivityShellSide: isPlateSideLiquid ? "" : heatExchanger.thermalConductivityLiquidSide,
    flowRateColdSide: heatExchanger.flowRateLiquid,
    flowRateHotSide: heatExchanger.flowRateVapor,
    paintStainlessSteel: paintStainlessSteelValue,
    paintCarbonSteel: paintCarbonSteelValue,
    offerNumber: mfileInfo ? mfileInfo.mFileId : "",
    customer: mfileInfo ? mfileInfo.companyName : "",
    plateAndShellHeatExchanger: "Plate & Shell Heat Exchanger",
    heatExchangerType: hidePsheType ? "Type " + getPsheTypeForMultiCondenser(heatExchanger, false, hidePsheType) : "Type PSHE: " + getMultiCondenserPsheType(
      heatExchanger,
      configuratorType || "multiCondensers"
    ),
    positionNo: position ? position.name : "",
    project: mfileInfo ? mfileInfo.projectName : "",
    operatingCase: calculationData ? calculationData.name : "",
    reference: mfileInfo ? mfileInfo.reference : "",
    offerBy: mfileInfo ? mfileInfo.responsiblePersonName : "",
    itemNameNo: position ? position.description : "",
    // Special value for i18n key because this need to be translated
    plateSide: isPlateSideLiquid ? "datasheet.table.data.Plate Side (Cold)" : "datasheet.table.data.Plate Side (Hot)",
    shellSide: isPlateSideLiquid ? "datasheet.table.data.Shell Side (Hot)" : "datasheet.table.data.Shell Side (Cold)",
    connectionHeader: heatExchanger.typeApproval == 1 /* ASME */ ? "datasheet.table.data.Size (in.)" : "datasheet.table.data.Size (DN)",
    applicationTitle: getAppTitle(heatExchanger)
  };
  return rs;
};

// src/utils/onephase-spreadsheet.helper.ts
var mapOnePhaseCalcuationKeyToSpeadsheetCellValue = (heatExchanger, mfileInfo, position, calculationData, hidePsheType) => {
  var _a, _b, _c, _d, _e, _f;
  const isHotSidePlate = heatExchanger.hotSide === 1 /* PlateSide */;
  const paintingValue = paintingValueHandler(
    heatExchanger.paintStainlessSteel,
    heatExchanger.paintCarbonSteel,
    heatExchanger.surfaceTreatment,
    heatExchanger.otherStainlessSteel,
    heatExchanger.otherCarbonSteel
  );
  const paintStainlessSteelValue = paintingValue.paintStainlessSteelValue;
  const paintCarbonSteelValue = paintingValue.paintCarbonSteelValue;
  let mediumNameHotSide;
  if (heatExchanger.mediumMixtureTypeHotSide === 1 /* Mixture */) {
    mediumNameHotSide = (_a = heatExchanger.mediumMixtureListHotSide) == null ? void 0 : _a.map(
      (medium) => `${mediumOptionMappingLabel.get(medium.mediumName)} ${medium.massFraction} `
    ).toString().replaceAll(",", " + ");
  } else {
    mediumNameHotSide = heatExchanger.hotSideMedium === 2 /* Gas */ && heatExchanger.mediumSourceHotSide === 3 /* RefProp */ ? getMediumName(
      heatExchanger.mediumSourceHotSide,
      heatExchanger.mediumHotSide,
      heatExchanger.mediumHotSideOtherMedia,
      heatExchanger.concentrationHotSide || 0
    ) + ` (${(_b = heatExchanger.pressureHotside) == null ? void 0 : _b.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : getMediumName(
      heatExchanger.mediumSourceHotSide,
      heatExchanger.mediumHotSide,
      heatExchanger.mediumHotSideOtherMedia,
      heatExchanger.concentrationHotSide || 0
    );
  }
  let mediumNameColdSide;
  if (heatExchanger.mediumMixtureTypeColdSide === 1 /* Mixture */) {
    mediumNameColdSide = (_c = heatExchanger.mediumMixtureListColdSide) == null ? void 0 : _c.map(
      (medium) => `${mediumOptionMappingLabel.get(medium.mediumName)} ${medium.massFraction} `
    ).toString().replaceAll(",", " + ");
  } else {
    mediumNameColdSide = heatExchanger.coldSideMedium === 2 /* Gas */ && heatExchanger.mediumSourceColdSide === 3 /* RefProp */ ? getMediumName(
      heatExchanger.mediumSourceColdSide,
      heatExchanger.mediumColdSide,
      heatExchanger.mediumColdSideOtherMedia,
      heatExchanger.concentrationColdSide || 0
    ) + ` (${(_d = heatExchanger.pressureColdSide) == null ? void 0 : _d.toFixed(
      2
    )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : getMediumName(
      heatExchanger.mediumSourceColdSide,
      heatExchanger.mediumColdSide,
      heatExchanger.mediumColdSideOtherMedia,
      heatExchanger.concentrationColdSide || 0
    );
  }
  const getPlateDesignPressureUnit = heatExchanger.designPressurePlateSideOnDataSheet && heatExchanger.designPressureUnitPlateSideOnDataSheet ? unitDesignPressureOptionMappingLabel.get(
    heatExchanger.designPressureUnitPlateSideOnDataSheet
  ) : heatExchanger.typeApproval === 1 /* ASME */ ? unitDesignPressureOptionMappingLabel.get(6 /* psi */) : unitDesignPressureOptionMappingLabel.get(2 /* bar */);
  const rs = {
    cboQ: unitCapacityOptionLabelMapping.get(heatExchanger.cboQ),
    cboArea: unitAreaOptionLabelInputMapping.get(heatExchanger.cboArea),
    cboT: unitTemperatureLMTDOptionLabelMapping.get(heatExchanger.cboT),
    cboKval: unitKValueOptionLabelInputMapping.get(heatExchanger.cboKval),
    cboFF: unitFoulingFactorOptionLabelInputMapping.get(heatExchanger.cboFF),
    cboM: unitMassFlowOptionLabelMapping.get(heatExchanger.cboM),
    cboDp: unitPressureOptionLabelInputMapping.get(heatExchanger.cboDp),
    cboV: unitVolumeOptionInputMappingLabel.get(heatExchanger.cboV),
    cboVisco: unitDynamicViscosityOptionLabelMapping.get(
      heatExchanger.cboVisco
    ),
    cboGravi: unitSpecificGravityOptionLabelInputMapping.get(
      heatExchanger.cboGravi
    ),
    cboSpH: unitSpecificHeatOptionLabelMapping.get(heatExchanger.cboSpH),
    cboCdy: unitThermalConductivityOptionLabelInputMapping.get(
      heatExchanger.cboCdy
    ),
    endPlateType: endPlateTypeMappingLabel.get(heatExchanger.endPlateType),
    cboMass: unitMassOptionLabelMapping.get(heatExchanger.cboMass),
    position: directionMappingLabel.get(heatExchanger.position),
    feet: feetMappingLabel.get(heatExchanger.feet),
    flowDirectorMaterial: flowDirectorMaterialOptionValueMapping.get(
      heatExchanger.flowDirectorMaterial
    ),
    capacity: heatExchanger["capacity"],
    area: heatExchanger["area"],
    lmtd: heatExchanger["lmtd"],
    kval: heatExchanger["kval"],
    foulingFactor: heatExchanger["foulingFactor"],
    excessDesignArea: heatExchanger["excessDesignArea"],
    inletTempHotSide: heatExchanger["inletTempHotSide"],
    inletTempColdSide: heatExchanger["inletTempColdSide"],
    outletTempHotSide: heatExchanger["outletTempHotSide"],
    outletTempColdSide: heatExchanger["outletTempColdSide"],
    flowRateHotSide: heatExchanger["flowRateHotSide"],
    flowRateColdSide: heatExchanger["flowRateColdSide"],
    pressureDropHotSideOutput: heatExchanger["pressureDropHotSideOutput"],
    pressureDropColdSideOutput: heatExchanger["pressureDropColdSideOutput"],
    volumePlateSide: heatExchanger["volumePlateSide"],
    volumeShellSide: heatExchanger["volumeShellSide"],
    dynamicViscosityPlateSide: isHotSidePlate ? heatExchanger["dynamicViscosityHotSide"] : heatExchanger["dynamicViscosityColdSide"],
    dynamicViscosityShellSide: isHotSidePlate ? heatExchanger["dynamicViscosityColdSide"] : heatExchanger["dynamicViscosityHotSide"],
    specificGravityPlateSide: isHotSidePlate ? heatExchanger["specificGravityHotSide"] : heatExchanger["specificGravityColdSide"],
    specificGravityShellSide: isHotSidePlate ? heatExchanger["specificGravityColdSide"] : heatExchanger["specificGravityHotSide"],
    specificHeatPlateSide: isHotSidePlate ? heatExchanger["specificHeatHotSide"] : heatExchanger["specificHeatColdSide"],
    specificHeatShellSide: isHotSidePlate ? heatExchanger["specificHeatColdSide"] : heatExchanger["specificHeatHotSide"],
    thermalConductivityPlateSide: isHotSidePlate ? heatExchanger["thermalConductivityHotSide"] : heatExchanger["thermalConductivityColdSide"],
    thermalConductivityShellSide: isHotSidePlate ? heatExchanger["thermalConductivityColdSide"] : heatExchanger["thermalConductivityHotSide"],
    nozzlePlateSide: getNozzlePlateSideSize(
      heatExchanger["nozzlePlateSide"],
      heatExchanger.typeApproval
    ),
    nozzleShell: getNozzleShellSideSize(
      heatExchanger["nozzleShell"],
      heatExchanger.typeApproval
    ),
    velocityPlate: heatExchanger["velocityPlate"],
    velocityPlateOut: heatExchanger["velocityPlateOut"],
    velocityShell: heatExchanger["velocityShell"],
    velocityShellOut: heatExchanger["velocityShellOut"],
    massOfHeatExchanger: heatExchanger["massOfHeatExchanger"],
    designCode: heatExchanger["designCode"],
    designPressureOnDataSheet: heatExchanger["designPressureShellSideOnDataSheet"],
    designPressureOnDataSheet1: heatExchanger.designPressureShellSideOnDataSheet && heatExchanger.designPressureUnitShellSideOnDataSheet ? unitDesignPressureOptionMappingLabel.get(
      heatExchanger.designPressureUnitShellSideOnDataSheet
    ) : getDesignPressureShellSideUnit(heatExchanger.designPressureShellSide),
    designPressureOnDataSheet2: heatExchanger.designPressureShellSideOnDataSheet || heatExchanger.constructionRow5Text || designPressureOptionMappingValue.get(
      heatExchanger.designPressureShellSide
    ),
    plateDesignPressureUnit: getPlateDesignPressureUnit,
    plateDesignPressure: heatExchanger.designPressurePlateSideOnDataSheet || heatExchanger["constructionRow6Text"] || heatExchanger["designPressurePlateSide"],
    constructionRow1Text: heatExchanger["constructionRow1Text"],
    constructionRow2Text: heatExchanger["constructionRow2Text"],
    constructionRow3Text: heatExchanger["constructionRow3Text"],
    constructionRow4Text: heatExchanger["constructionRow4Text"],
    constructionRow5Text: heatExchanger["constructionRow5Text"],
    constructionRow6Text: heatExchanger["constructionRow6Text"],
    constructionRow7Text: heatExchanger["constructionRow7Text"],
    constructionRow8Text: heatExchanger["constructionRow8Text"],
    materialsPlateConnections: heatExchanger["materialsPlateConnections"],
    materialsShellConnectionsIn: heatExchanger["materialsShellConnectionsIn"],
    materialsShellConnectionsOut: heatExchanger["materialsShellConnectionsOut"],
    fillingBoxesText: heatExchanger["fillingBoxesText"],
    actualVelocityText: heatExchanger["actualVelocityText"],
    numberOfPlateNozzles: getNumberOfPlateNozzle(
      heatExchanger.numberOfPlateNozzles
    ),
    numberOfShellNozzles: getNumberOfShellNozzle(
      heatExchanger.numberOfShellNozzles
    ),
    designPressure: getDesignPressureShellSideUnit(
      heatExchanger.designPressureShellSide
    ),
    designTemperature: `${roundNumberToPrecision(
      (_e = heatExchanger.designTemperatureMin) != null ? _e : 0,
      3
    )}/${roundNumberToPrecision((_f = heatExchanger.designTemperatureMax) != null ? _f : 0, 3)}`,
    plateMaterial: `${plateMaterialMappingLabel.get(
      heatExchanger.plateMaterial
    )} ${plateThicknessOptionMappingLabel.get(heatExchanger.plateThickness)}`,
    shellMaterial: getShellMaterial(
      heatExchanger.endPlateType,
      shellMaterialMappingLabel.get(heatExchanger.shellMaterial) || ""
    ),
    paintStainlessSteel: paintStainlessSteelValue,
    paintCarbonSteel: paintCarbonSteelValue,
    mediumPlateSide: isHotSidePlate ? mediumNameHotSide : mediumNameColdSide,
    mediumShellSide: isHotSidePlate ? mediumNameColdSide : mediumNameHotSide,
    tempInPlateSide: isHotSidePlate ? heatExchanger.inletTempHotSide : heatExchanger.inletTempColdSide,
    tempInShellSide: isHotSidePlate ? heatExchanger.inletTempColdSide : heatExchanger.inletTempHotSide,
    tempOutPlateSide: isHotSidePlate ? heatExchanger.outletTempHotSide : heatExchanger.outletTempColdSide,
    tempOutShellSide: isHotSidePlate ? heatExchanger.outletTempColdSide : heatExchanger.outletTempHotSide,
    flowRatePlateSide: isHotSidePlate ? heatExchanger.flowRateHotSide : heatExchanger.flowRateColdSide,
    flowRateShellSide: !isHotSidePlate ? heatExchanger.flowRateHotSide : heatExchanger.flowRateColdSide,
    pressureDropPlateSideOutput: isHotSidePlate ? heatExchanger.pressureDropHotSideOutput : heatExchanger.pressureDropColdSideOutput,
    pressureDropShellSideOutput: !isHotSidePlate ? heatExchanger.pressureDropHotSideOutput : heatExchanger.pressureDropColdSideOutput,
    offerNumber: mfileInfo ? mfileInfo.mFileId : "",
    customer: mfileInfo ? mfileInfo.companyName : "",
    heatExchangerType: hidePsheType ? "Type PSHE " + getHidePSHEModel(heatExchanger.psheType) : `Type PSHE: ${heatExchanger.psheType}`,
    positionNo: position ? position.name : "",
    project: mfileInfo ? mfileInfo.projectName : "",
    operatingCase: calculationData ? calculationData.name : "",
    reference: mfileInfo ? mfileInfo.reference : "",
    offerBy: mfileInfo ? mfileInfo.responsiblePersonName : "",
    itemNameNo: position ? position.description : "",
    plateAndShellHeatExchanger: "Plate & Shell Heat Exchanger",
    // Special value for i18n key because this need to be translated
    plateSide: isHotSidePlate ? "datasheet.table.data.Plate Side (Hot)" : "datasheet.table.data.Plate Side (Cold)",
    shellSide: !isHotSidePlate ? "datasheet.table.data.Shell Side (Hot)" : "datasheet.table.data.Shell Side (Cold)",
    connectionHeader: heatExchanger.typeApproval == 1 /* ASME */ ? "datasheet.table.data.Size (in.)" : "datasheet.table.data.Size (DN)",
    applicationTitle: getAppTitle(heatExchanger)
  };
  return rs;
};

// src/utils/partcascade-spreadsheet.helper.ts
var mapPartialCascadeCalcuationKeyToSpeadsheetCellValue = (heatExchanger, mfileInfo, position, calculationData, hidePsheType) => {
  var _a, _b, _c, _d;
  const isHotSidePlate = heatExchanger.hotSide === 1 /* PlateSide */;
  const saturationHotValue = !numberHelper.isInfinitiveNumber(
    heatExchanger.saturatedLiquidTemperatureHotSide
  ) && !numberHelper.isInfinitiveNumber(
    heatExchanger.saturatedLiquidTemperatureHotSide
  ) ? `${heatExchanger.saturatedLiquidTemperatureHotSide}/${heatExchanger.saturatedVaporTemperatureHotSide}` : void 0;
  const saturationColdValue = !numberHelper.isInfinitiveNumber(
    heatExchanger.saturatedLiquidTemperatureColdSide
  ) && !numberHelper.isInfinitiveNumber(
    heatExchanger.saturatedVaporTemperatureColdSide
  ) ? `${heatExchanger.saturatedLiquidTemperatureColdSide}/${heatExchanger.saturatedVaporTemperatureColdSide}` : void 0;
  const mediumNameHotSide = heatExchanger.mediumMixtureHotSide === 0 /* PureMedium */ ? getMediumName(
    heatExchanger.mediumSourceHotSide,
    heatExchanger.mediumHotSide,
    heatExchanger.mediumHotSideOtherMedia,
    heatExchanger.concentrationHotSide || 0
  ) : "Mixture";
  const mediumNameHotSideExpandProperties = heatExchanger.mediumMixtureHotSide === 0 /* PureMedium */ ? getMediumName(
    heatExchanger.mediumSourceHotSide,
    heatExchanger.mediumHotSide,
    heatExchanger.mediumHotSideOtherMedia,
    heatExchanger.concentrationHotSide || 0
  ) : (_a = heatExchanger.mediumMixturesHotSide) == null ? void 0 : _a.map(
    (medium) => `${mediumOptionMappingLabel.get(medium.mediumName)} ${medium.massFraction} `
  ).toString().replaceAll(",", " + ");
  const mediumNameColdSide = heatExchanger.mediumMixtureColdSide === 0 /* PureMedium */ ? getMediumName(
    heatExchanger.mediumSourceColdSide,
    heatExchanger.mediumColdSide,
    heatExchanger.mediumColdSideOtherMedia,
    heatExchanger.concentrationColdSide || 0
  ) : "Mixture";
  const mediumNameColdSideExpandProperties = heatExchanger.mediumMixtureColdSide === 0 /* PureMedium */ ? getMediumName(
    heatExchanger.mediumSourceColdSide,
    heatExchanger.mediumColdSide,
    heatExchanger.mediumColdSideOtherMedia,
    heatExchanger.concentrationColdSide || 0
  ) : (_b = heatExchanger.mediumMixturesColdSide) == null ? void 0 : _b.map(
    (medium) => `${mediumOptionMappingLabel.get(medium.mediumName)} ${medium.massFraction}`
  ).toString().replaceAll(",", " + ");
  const paintingValue = paintingValueHandler(
    heatExchanger.paintStainlessSteel,
    heatExchanger.paintCarbonSteel,
    heatExchanger.surfaceTreatment,
    heatExchanger.otherStainlessSteel,
    heatExchanger.otherCarbonSteel
  );
  const paintStainlessSteelValue = paintingValue.paintStainlessSteelValue;
  const paintCarbonSteelValue = paintingValue.paintCarbonSteelValue;
  const getPlateDesignPressureUnit = heatExchanger.designPressurePlateSideOnDataSheet && heatExchanger.designPressureUnitPlateSideOnDataSheet ? unitDesignPressureOptionMappingLabel.get(
    heatExchanger.designPressureUnitPlateSideOnDataSheet
  ) : heatExchanger.typeApproval === 1 /* ASME */ ? unitDesignPressureOptionMappingLabel.get(6 /* psi */) : unitDesignPressureOptionMappingLabel.get(2 /* bar */);
  const rs = {
    capacity: heatExchanger["capacity"],
    area: heatExchanger["area"],
    lmtd: heatExchanger["lmtd"],
    kval: heatExchanger["kval"],
    foulingFactor: heatExchanger["foulingFactor"],
    excessDesignArea: heatExchanger["excessDesignArea"],
    volumePlateSide: heatExchanger["volumePlateSide"],
    volumeShellSide: heatExchanger["volumeShellSide"],
    nozzlePlateSide: getNozzlePlateSideSize(
      heatExchanger["nozzlePlateSide"],
      heatExchanger.typeApproval
    ),
    numberOfPlateNozzles: getNumberOfPlateNozzle(
      heatExchanger["numberOfPlateNozzles"]
    ),
    velocityPlate: heatExchanger["velocityPlate"],
    velocityPlateOut: heatExchanger["velocityPlateOut"],
    nozzleShell: getNozzleShellSideSize(
      heatExchanger["nozzleShell"],
      heatExchanger.typeApproval
    ),
    numberOfShellNozzles: heatExchanger["numberOfShellNozzles"],
    velocityShell: heatExchanger["velocityShell"],
    velocityShellOut: heatExchanger["velocityShellOut"],
    numberOfShellNozzlesOut: heatExchanger.numberOfShellNozzlesOut,
    nozzleShellOut: getNozzleShellSideSize(
      heatExchanger["nozzleShellOut"],
      heatExchanger.typeApproval
    ),
    massOfHeatExchanger: heatExchanger["massOfHeatExchanger"],
    designPressure: heatExchanger.designPressureShellSideOnDataSheet,
    constructionRow1Text: heatExchanger["constructionRow1Text"],
    constructionRow2Text: heatExchanger["constructionRow2Text"],
    constructionRow3Text: heatExchanger["constructionRow3Text"],
    constructionRow4Text: heatExchanger["constructionRow4Text"],
    constructionRow5Text: heatExchanger["constructionRow5Text"],
    constructionRow6Text: heatExchanger["constructionRow6Text"],
    constructionRow7Text: heatExchanger["constructionRow7Text"],
    constructionRow8Text: heatExchanger["constructionRow8Text"],
    materialsPlateConnections: heatExchanger["materialsPlateConnections"],
    materialsShellConnectionsIn: heatExchanger["materialsShellConnectionsIn"],
    materialsShellConnectionsOut: heatExchanger["materialsShellConnectionsOut"],
    fillingBoxesText: heatExchanger["fillingBoxesText"],
    actualVelocityText: heatExchanger["actualVelocityText"],
    cboQ: unitCapacityOptionLabelMapping.get(heatExchanger.cboQ),
    cboArea: unitAreaOptionLabelInputMapping.get(heatExchanger.cboArea),
    cboT: unitTemperatureLMTDOptionLabelMapping.get(heatExchanger.cboT),
    cboKval: unitKValueOptionLabelInputMapping.get(heatExchanger.cboKval),
    cboFF: unitFoulingFactorOptionLabelInputMapping.get(heatExchanger.cboFF),
    cboM: unitMassFlowOptionLabelMapping.get(heatExchanger.cboM),
    cboP: unitPressureOptionLabelInputMapping.get(heatExchanger.cboP),
    cboDp: unitPressureOptionLabelInputMapping.get(heatExchanger.cboDp),
    cboV: unitVolumeOptionInputMappingLabel.get(heatExchanger.cboV),
    cboVisco: unitDynamicViscosityOptionLabelMapping.get(
      heatExchanger.cboVisco
    ),
    cboGravi: unitSpecificGravityOptionLabelInputMapping.get(
      heatExchanger.cboGravi
    ),
    cboSpH: unitSpecificHeatOptionLabelMapping.get(heatExchanger.cboSpH),
    cboCdy: unitThermalConductivityOptionLabelInputMapping.get(
      heatExchanger.cboCdy
    ),
    cboSigma: unitSurfaceTensionOptionLabelInputMapping.get(
      heatExchanger.cboSigma
    ),
    endPlateType: endPlateTypeMappingLabel.get(heatExchanger.endPlateType),
    cboMass: unitMassOptionLabelMapping.get(heatExchanger.cboMass),
    position: directionMappingLabel.get(heatExchanger.position),
    feet: feetMappingLabel.get(heatExchanger.feet),
    flowDirectorMaterial: flowDirectorMaterialOptionValueMapping.get(
      heatExchanger.flowDirectorMaterial
    ),
    tempInPlateSide: isHotSidePlate ? heatExchanger.inletTemperatureHotSide : heatExchanger.inletTemperatureColdSide,
    tempInShellSide: isHotSidePlate ? heatExchanger.inletTemperatureColdSide : heatExchanger.inletTemperatureHotSide,
    tempOutPlateSide: isHotSidePlate ? heatExchanger.outletTemperatureHotSide : heatExchanger.outletTemperatureColdSide,
    tempOutShellSide: isHotSidePlate ? heatExchanger.outletTemperatureColdSide : heatExchanger.outletTemperatureHotSide,
    saturationTempPlateSide: isHotSidePlate ? saturationHotValue : saturationColdValue,
    saturationTempShellSide: isHotSidePlate ? saturationColdValue : saturationHotValue,
    liquidFlowRateInletPLateSide: isHotSidePlate ? (1 - (heatExchanger.vaporMassFractionHotSideIn || 0)) * (heatExchanger.flowRateHotSide || 0) : (1 - (heatExchanger.vaporMassFractionColdSideIn || 0)) * (heatExchanger.flowRateColdSide || 0),
    liquidFlowRateInletShellSide: isHotSidePlate ? (1 - (heatExchanger.vaporMassFractionColdSideIn || 0)) * (heatExchanger.flowRateColdSide || 0) : (1 - (heatExchanger.vaporMassFractionHotSideIn || 0)) * (heatExchanger.flowRateHotSide || 0),
    liquidFlowRateOutletPlateSide: isHotSidePlate ? (1 - (heatExchanger.vaporMassFractionHotSideOut || 0)) * (heatExchanger.flowRateHotSide || 0) : (1 - (heatExchanger.vaporMassFractionColdSideOut || 0)) * (heatExchanger.flowRateColdSide || 0),
    liquidFlowRateOutletShellSide: isHotSidePlate ? (1 - (heatExchanger.vaporMassFractionColdSideOut || 0)) * (heatExchanger.flowRateColdSide || 0) : (1 - (heatExchanger.vaporMassFractionHotSideOut || 0)) * (heatExchanger.flowRateHotSide || 0),
    vaporFlowRateInletPlateSide: isHotSidePlate ? (heatExchanger.vaporMassFractionHotSideIn || 0) * (heatExchanger.flowRateHotSide || 0) : (heatExchanger.vaporMassFractionColdSideIn || 0) * (heatExchanger.flowRateColdSide || 0),
    vaporFlowRateInletShellSide: !isHotSidePlate ? (heatExchanger.vaporMassFractionHotSideIn || 0) * (heatExchanger.flowRateHotSide || 0) : (heatExchanger.vaporMassFractionColdSideIn || 0) * (heatExchanger.flowRateColdSide || 0),
    vaporFlowRateOutletPlateSide: isHotSidePlate ? (heatExchanger.vaporMassFractionHotSideOut || 0) * (heatExchanger.flowRateHotSide || 0) : (heatExchanger.vaporMassFractionColdSideOut || 0) * (heatExchanger.flowRateColdSide || 0),
    vaporFlowRateOutletShellSide: !isHotSidePlate ? (heatExchanger.vaporMassFractionHotSideOut || 0) * (heatExchanger.flowRateHotSide || 0) : (heatExchanger.vaporMassFractionColdSideOut || 0) * (heatExchanger.flowRateColdSide || 0),
    pressureDropPlateSide: isHotSidePlate ? heatExchanger.pressureDropHotSideOutput : heatExchanger.pressureDropColdSideOutput,
    pressureDropShellSide: isHotSidePlate ? heatExchanger.pressureDropColdSideOutput : heatExchanger.pressureDropHotSideOutput,
    mediumPlateSide: isHotSidePlate ? mediumNameHotSide : mediumNameColdSide,
    mediumShellSide: !isHotSidePlate ? mediumNameHotSide : mediumNameColdSide,
    designCode: heatExchanger.designCode || approvalTypeMappingLabel.get(heatExchanger.typeApproval),
    designPressureOnDataSheet1: heatExchanger.designPressureShellSideOnDataSheet && heatExchanger.designPressureUnitShellSideOnDataSheet ? unitDesignPressureOptionMappingLabel.get(
      heatExchanger.designPressureUnitShellSideOnDataSheet
    ) : getDesignPressureShellSideUnit(heatExchanger.designPressureShellSide),
    designPressureOnDataSheet2: heatExchanger.designPressureShellSideOnDataSheet || heatExchanger.constructionRow5Text || designPressureOptionMappingValue.get(
      heatExchanger.designPressureShellSide
    ),
    plateDesignPressureUnit: getPlateDesignPressureUnit,
    plateDesignPressure: heatExchanger.designPressurePlateSideOnDataSheet || heatExchanger["constructionRow6Text"] || heatExchanger["designPressurePlateSide"],
    designTemperature: `${roundNumberToPrecision(
      (_c = heatExchanger.designTemperatureMin) != null ? _c : 0,
      3
    )}/${roundNumberToPrecision((_d = heatExchanger.designTemperatureMax) != null ? _d : 0, 3)}`,
    plateMaterial: `${plateMaterialMappingLabel.get(
      heatExchanger.plateMaterial
    )} ${plateThicknessOptionMappingLabel.get(heatExchanger.plateThickness)}`,
    shellMaterial: getShellMaterial(
      heatExchanger.endPlateType,
      shellMaterialMappingLabel.get(heatExchanger.shellMaterial) || ""
    ),
    // mediumPlateSideExpandProperties: `Medium Plate Side (${
    // 	isHotSidePlate ? 'Hot' : 'Cold'
    // })`,
    mediumPlateSideExpandProperties: isHotSidePlate ? "datasheet.table.data.Medium Plate Side (Hot)" : "datasheet.table.data.Medium Plate Side (Cold)",
    mediumShellSideExpandProperties: !isHotSidePlate ? "datasheet.table.data.Medium Shell Side (Hot)" : "datasheet.table.data.Medium Shell Side (Cold)",
    mediumNamePlateSideExpandProperties: isHotSidePlate ? mediumNameHotSideExpandProperties : mediumNameColdSideExpandProperties,
    mediumNamePlateSide: isHotSidePlate ? mediumNameHotSide : mediumNameColdSide,
    inletDynamicViscosityPlateSide: isHotSidePlate ? heatExchanger.inletDynamicViscosityHotSide : heatExchanger.inletDynamicViscosityColdSide,
    outletDynamicViscosityPlateSide: isHotSidePlate ? heatExchanger.outletDynamicViscosityHotSide : heatExchanger.outletDynamicViscosityColdSide,
    saturatedLiquidDynamicViscosityPlateSide: isHotSidePlate ? heatExchanger.saturatedLiquidDynamicViscosityHotSide : heatExchanger.saturatedLiquidDynamicViscosityColdSide,
    inletSpecificGravityPlateSide: isHotSidePlate ? heatExchanger.inletSpecificGravityHotSide : heatExchanger.inletSpecificGravityColdSide,
    outletSpecificGravityPlateSide: isHotSidePlate ? heatExchanger.outletSpecificGravityHotSide : heatExchanger.outletSpecificGravityColdSide,
    saturatedLiquidSpecificGravityPlateSide: isHotSidePlate ? heatExchanger.saturatedLiquidSpecificGravityHotSide : heatExchanger.saturatedLiquidSpecificGravityColdSide,
    inletSpecificHeatPlateSide: isHotSidePlate ? heatExchanger.inletSpecificHeatHotSide : heatExchanger.inletSpecificHeatColdSide,
    outletSpecificHeatPlateSide: isHotSidePlate ? heatExchanger.outletSpecificHeatHotSide : heatExchanger.outletSpecificHeatColdSide,
    saturatedLiquidSpecificHeatPlateSide: isHotSidePlate ? heatExchanger.saturatedLiquidSpecificHeatHotSide : heatExchanger.saturatedLiquidSpecificHeatColdSide,
    inletThermalConductivityPlateSide: isHotSidePlate ? heatExchanger.inletThermalConductivityHotSide : heatExchanger.inletThermalConductivityColdSide,
    outletThermalConductivityPlateSide: isHotSidePlate ? heatExchanger.outletThermalConductivityHotSide : heatExchanger.outletThermalConductivityColdSide,
    saturatedLiquidThermalConductivityPlateSide: isHotSidePlate ? heatExchanger.saturatedLiquidThermalConductivityHotSide : heatExchanger.saturatedLiquidThermalConductivityColdSide,
    surfaceTensionPlateSide: isHotSidePlate ? heatExchanger.saturatedLiquidSurfaceTensionHotSide : heatExchanger.saturatedLiquidSurfaceTensionColdSide,
    saturatedVaporDynamicViscosityPlateSide: isHotSidePlate ? heatExchanger.saturatedVaporDynamicViscosityHotSide : heatExchanger.saturatedVaporDynamicViscosityColdSide,
    saturatedVaporSpecificGravityPlateSide: isHotSidePlate ? heatExchanger.saturatedVaporSpecificGravityHotSide : heatExchanger.saturatedVaporSpecificGravityColdSide,
    saturatedVaporSpecificHeatPlateSide: isHotSidePlate ? heatExchanger.saturatedVaporSpecificHeatHotSide : heatExchanger.saturatedVaporSpecificHeatColdSide,
    saturatedVaporThermalConductivityPlateSide: isHotSidePlate ? heatExchanger.saturatedVaporThermalConductivityHotSide : heatExchanger.saturatedVaporThermalConductivityColdSide,
    // mediumShellSideExpandProperties: `Medium Shell Side (${
    // 	!isHotSidePlate ? 'Hot' : 'Cold'
    // })`,
    mediumNameShellSideExpandProperties: !isHotSidePlate ? mediumNameHotSideExpandProperties : mediumNameColdSideExpandProperties,
    mediumNameShellSide: !isHotSidePlate ? mediumNameHotSide : mediumNameColdSide,
    inletDynamicViscosityShellSide: !isHotSidePlate ? heatExchanger.inletDynamicViscosityHotSide : heatExchanger.inletDynamicViscosityColdSide,
    outletDynamicViscosityShellSide: !isHotSidePlate ? heatExchanger.outletDynamicViscosityHotSide : heatExchanger.outletDynamicViscosityColdSide,
    saturatedLiquidDynamicViscosityShellSide: !isHotSidePlate ? heatExchanger.saturatedLiquidDynamicViscosityHotSide : heatExchanger.saturatedLiquidDynamicViscosityColdSide,
    inletSpecificGravityShellSide: !isHotSidePlate ? heatExchanger.inletSpecificGravityHotSide : heatExchanger.inletSpecificGravityColdSide,
    outletSpecificGravityShellSide: !isHotSidePlate ? heatExchanger.outletSpecificGravityHotSide : heatExchanger.outletSpecificGravityColdSide,
    saturatedLiquidSpecificGravityShellSide: !isHotSidePlate ? heatExchanger.saturatedLiquidSpecificGravityHotSide : heatExchanger.saturatedLiquidSpecificGravityColdSide,
    inletSpecificHeatShellSide: !isHotSidePlate ? heatExchanger.inletSpecificHeatHotSide : heatExchanger.inletSpecificHeatColdSide,
    outletSpecificHeatShellSide: !isHotSidePlate ? heatExchanger.outletSpecificHeatHotSide : heatExchanger.outletSpecificHeatColdSide,
    saturatedLiquidSpecificHeatShellSide: !isHotSidePlate ? heatExchanger.saturatedLiquidSpecificHeatHotSide : heatExchanger.saturatedLiquidSpecificHeatColdSide,
    inletThermalConductivityShellSide: !isHotSidePlate ? heatExchanger.inletThermalConductivityHotSide : heatExchanger.inletThermalConductivityColdSide,
    outletThermalConductivityShellSide: !isHotSidePlate ? heatExchanger.outletThermalConductivityHotSide : heatExchanger.outletThermalConductivityColdSide,
    saturatedLiquidThermalConductivityShellSide: !isHotSidePlate ? heatExchanger.saturatedLiquidThermalConductivityHotSide : heatExchanger.saturatedLiquidThermalConductivityColdSide,
    surfaceTensionShellSide: !isHotSidePlate ? heatExchanger.saturatedLiquidSurfaceTensionHotSide : heatExchanger.saturatedLiquidSurfaceTensionColdSide,
    saturatedVaporDynamicViscosityShellSide: !isHotSidePlate ? heatExchanger.saturatedVaporDynamicViscosityHotSide : heatExchanger.saturatedVaporDynamicViscosityColdSide,
    saturatedVaporSpecificGravityShellSide: !isHotSidePlate ? heatExchanger.saturatedVaporSpecificGravityHotSide : heatExchanger.saturatedVaporSpecificGravityColdSide,
    saturatedVaporSpecificHeatShellSide: !isHotSidePlate ? heatExchanger.saturatedVaporSpecificHeatHotSide : heatExchanger.saturatedVaporSpecificHeatColdSide,
    saturatedVaporThermalConductivityShellSide: !isHotSidePlate ? heatExchanger.saturatedVaporThermalConductivityHotSide : heatExchanger.saturatedVaporThermalConductivityColdSide,
    saturatedPressurePlateSide: isHotSidePlate ? heatExchanger.saturatedPressureHotSide : heatExchanger.saturatedPressureColdSide,
    saturatedPressureShellSide: !isHotSidePlate ? heatExchanger.saturatedPressureHotSide : heatExchanger.saturatedPressureColdSide,
    paintStainlessSteel: paintStainlessSteelValue,
    paintCarbonSteel: paintCarbonSteelValue,
    offerNumber: mfileInfo ? mfileInfo.mFileId : "",
    customer: mfileInfo ? mfileInfo.companyName : "",
    heatExchangerType: hidePsheType ? "Type PSHE " + getHidePSHEModel(heatExchanger.psheType) : `Type PSHE: ${heatExchanger.psheType}`,
    plateAndShellHeatExchanger: "Plate & Shell Heat Exchanger",
    positionNo: position ? position.name : "",
    project: mfileInfo ? mfileInfo.projectName : "",
    operatingCase: calculationData ? calculationData.name : "",
    reference: mfileInfo ? mfileInfo.reference : "",
    offerBy: mfileInfo ? mfileInfo.responsiblePersonName : "",
    itemNameNo: position ? position.description : "",
    // Special value for i18n key because this need to be translated
    plateSide: isHotSidePlate ? "datasheet.table.data.Plate Side (Hot)" : "datasheet.table.data.Plate Side (Cold)",
    shellSide: isHotSidePlate ? "datasheet.table.data.Shell Side (Cold)" : "datasheet.table.data.Shell Side (Hot)",
    connectionHeader: heatExchanger.typeApproval == 1 /* ASME */ ? "datasheet.table.data.Size (in.)" : "datasheet.table.data.Size (DN)",
    applicationTitle: getAppTitle(heatExchanger)
  };
  return rs;
};

// src/utils/spreadsheet.helper.ts
var convertSpreadSheetToExcel = (input, sheetId, t = void 0, language) => {
  const clonedInput = cloneDeep(input);
  const rs = [];
  const rowHidden = {};
  let lastRow = 0;
  const sectionColumn = Math.max(
    ...clonedInput.sectionList.flatMap(
      (section) => section.rowList.map((r) => r.cellList.length)
    )
  );
  clonedInput.sectionList.forEach((section) => {
    section.rowList.forEach((row) => {
      const rowIndex = lastRow + row.index;
      if (row.isHidden) rowHidden[`${rowIndex}`] = 0;
      for (let i = 0; i < sectionColumn; i++) {
        const cell = row.cellList[i];
        const cellCol = (cell == null ? void 0 : cell.index) || i;
        const cellValue = handleCellCustomValue(cell, t, language);
        const displayValue = handleDisplayValue(cell, t, language);
        const decimalScaleFormat = getDecimalScaleFormat(
          cell == null ? void 0 : cell.decimalScale,
          cell == null ? void 0 : cell.customValue
        );
        const newCell = {
          r: rowIndex,
          c: cellCol,
          v: __spreadProps(__spreadValues({}, spreadSheetDataHelper.getExcelCellStyle(cell == null ? void 0 : cell.style)), {
            sectionId: section.id || section.name,
            rowId: row.id || rowIndex.toString(),
            cellId: cell == null ? void 0 : cell.id,
            i18nKey: cell == null ? void 0 : cell.i18nKey,
            key: cell == null ? void 0 : cell.key,
            index: cell == null ? void 0 : cell.index,
            m: displayValue,
            v: cellValue,
            // Disabled formula for now
            // f: cell?.func,
            ct: {
              fa: (cell == null ? void 0 : cell.i18nKey) || (cell == null ? void 0 : cell.key) === "massOfHeatExchanger" || section.name === "connections" && (cell == null ? void 0 : cell.index) === 1 ? "General" : decimalScaleFormat.fa,
              t: (cell == null ? void 0 : cell.i18nKey) || (cell == null ? void 0 : cell.key) === "massOfHeatExchanger" || section.name === "connections" && (cell == null ? void 0 : cell.index) === 1 ? "g" : decimalScaleFormat.t
            },
            // Disabled merging for now
            // mc: cellSpan,
            id: cell == null ? void 0 : cell.id,
            ff: 1,
            locked: cell == null ? void 0 : cell.isLocked,
            hide: (cell == null ? void 0 : cell.isHidden) || (row == null ? void 0 : row.isHidden),
            isAddedRow: (row == null ? void 0 : row.isAddedRow) || false
          })
        };
        rs.push(newCell);
      }
    });
    lastRow += section.rowList.length;
  });
  return {
    data: rs,
    rowHidden
    // calcChain,
  };
};
var applyExcelChangeToSpreadSheet = (originalCalculation, input, cellMatrix, rowHidden, generateUUID, mfileInfo, position, calculationData, t, language, hidePsheType) => {
  const originalData = convertToSpreadSheet(
    originalCalculation,
    mfileInfo,
    position,
    calculationData,
    hidePsheType
  );
  const clonedInput = cloneDeep(input);
  const rowsWithIndex = cellMatrix.map((row, index) => {
    var _a, _b;
    const firstCell = row[0];
    const isAddedRow = row.some((cell) => cell == null ? void 0 : cell.isAddedRow);
    let section;
    if (isAddedRow) {
      let foundSectionId = null;
      for (let i = index; i < cellMatrix.length; i++) {
        const candidate = cellMatrix[i][0];
        if (candidate == null ? void 0 : candidate.sectionId) {
          foundSectionId = candidate.sectionId;
          break;
        }
      }
      section = foundSectionId != null ? foundSectionId : "";
    } else {
      const markSectionCell = (firstCell == null ? void 0 : firstCell.sectionId) ? row[0] : index === 0 ? null : (_a = cellMatrix[index + 1]) == null ? void 0 : _a[0];
      section = (markSectionCell == null ? void 0 : markSectionCell.sectionId) || "";
    }
    const rowId = (_b = row.find((cell) => cell == null ? void 0 : cell.rowId)) == null ? void 0 : _b.rowId;
    return {
      index,
      section,
      rowId,
      data: row
    };
  });
  clonedInput.sectionList.forEach((section) => {
    const rows = rowsWithIndex.filter(
      (rowWithIndex) => rowWithIndex.section === section.id || rowWithIndex.section === section.name
    );
    const rowList = [];
    rows.forEach((rowWithIndex, rowIndex) => {
      const originalRow = section.rowList.find(
        (r) => rowWithIndex.rowId && r.id === rowWithIndex.rowId
      );
      const newRow = {
        id: rowWithIndex.rowId || generateUUID(),
        index: rowIndex,
        isHidden: rowHidden[`${rowWithIndex.index}`] === 0,
        isAddedRow: rowWithIndex.data.some((cell) => cell == null ? void 0 : cell.isAddedRow),
        cellList: rowWithIndex.data.map((cell, cellIndex) => {
          var _a, _b, _c, _d;
          const style = spreadSheetDataHelper.getSpreadSheetCellStyle({
            bl: cell == null ? void 0 : cell.bl,
            it: cell == null ? void 0 : cell.it
          });
          const parsedCell = cell;
          const originalCell = (_a = originalRow == null ? void 0 : originalRow.cellList) == null ? void 0 : _a.find(
            (c) => (parsedCell == null ? void 0 : parsedCell.cellId) && c.id === (parsedCell == null ? void 0 : parsedCell.cellId)
          );
          const decimalScale = (_b = cell == null ? void 0 : cell.ct) == null ? void 0 : _b.fa;
          const newValue = !(originalCell == null ? void 0 : originalCell.key) ? (originalCell == null ? void 0 : originalCell.i18nKey) ? [
            "cn" /* Chinese */,
            "de" /* Deutsch */,
            "en" /* English */,
            "es" /* Espanol */,
            "fi" /* Finland */,
            "fr" /* Francais */,
            "nl" /* Nederlands */
          ].some(
            (item) => {
              var _a2;
              return t((_a2 = originalCell == null ? void 0 : originalCell.i18nKey) != null ? _a2 : "", {
                lng: item,
                defaultValue: ""
              }) === (cell == null ? void 0 : cell.v);
            }
          ) ? t(originalCell.i18nKey, { lng: language, defaultValue: "" }) : cell == null ? void 0 : cell.v : cell == null ? void 0 : cell.v : (_c = cell == null ? void 0 : cell.v) != null ? _c : originalData[originalCell.key];
          const newCell = {
            id: (_d = originalCell == null ? void 0 : originalCell.id) != null ? _d : generateUUID(),
            index: cellIndex,
            createdAt: /* @__PURE__ */ new Date(),
            lastUpdatedAt: /* @__PURE__ */ new Date(),
            customValue: typeof newValue === "boolean" ? +newValue : newValue,
            // Disabled formula for now
            // func: cell?.f,
            key: parsedCell == null ? void 0 : parsedCell.key,
            i18nKey: parsedCell == null ? void 0 : parsedCell.i18nKey,
            style,
            // Disabled merging for now
            // spanX: cell?.mc?.cs,
            // spanY: cell?.mc?.rs,
            decimalScale: getDecimalScaleFromDecimalScaleFormat(decimalScale),
            isHidden: (cell == null ? void 0 : cell.hide) ? cell == null ? void 0 : cell.hide : false,
            isLocked: (cell == null ? void 0 : cell.locked) ? cell == null ? void 0 : cell.locked : false
          };
          return newCell;
        }),
        createdAt: /* @__PURE__ */ new Date(),
        lastUpdatedAt: /* @__PURE__ */ new Date()
      };
      rowList.push(newRow);
    });
    section.rowList = rowList;
  });
  return clonedInput;
};
var convertToSpreadSheet = (applicationDto, mfileInfo, position, calculationData, hidePsheType) => {
  let newSpreadSheetData = {};
  switch (applicationDto.application) {
    case 1 /* OnePhase */:
      newSpreadSheetData = mapOnePhaseCalcuationKeyToSpeadsheetCellValue(
        applicationDto,
        mfileInfo,
        position,
        calculationData,
        hidePsheType
      );
      break;
    case 2 /* Condenser */:
      newSpreadSheetData = mapCondenserCalcuationKeyToSpeadsheetCellValue(
        applicationDto,
        mfileInfo,
        position,
        calculationData,
        hidePsheType
      );
      break;
    case 3 /* Evaporator */:
      newSpreadSheetData = mapEvaporatorCalcuationKeyToSpeadsheetCellValue(
        applicationDto,
        mfileInfo,
        position,
        calculationData,
        hidePsheType
      );
      break;
    case 4 /* Cascade */:
      newSpreadSheetData = mapCascadeCalcuationKeyToSpeadsheetCellValue(
        applicationDto,
        mfileInfo,
        position,
        calculationData,
        hidePsheType
      );
      break;
    case 5 /* PartialCascade */:
      newSpreadSheetData = mapPartialCascadeCalcuationKeyToSpeadsheetCellValue(
        applicationDto,
        mfileInfo,
        position,
        calculationData,
        hidePsheType
      );
      break;
    case 6 /* MultiCondenser */:
      newSpreadSheetData = mapMultiCondenserCalcuationKeyToSpeadsheetCellValue(
        applicationDto,
        mfileInfo,
        position,
        calculationData,
        hidePsheType
      );
      break;
  }
  return newSpreadSheetData;
};
var handleVelocityInDemister = (input, applicationDto, spreadsheetData) => {
  let isLastRowHasValue = false;
  let isRowHasCustomValue = false;
  let isVelocityInDemisterExist = false;
  const clonedInput = cloneDeep(input);
  if (applicationDto.application == 3 /* Evaporator */ || applicationDto.application == 4 /* Cascade */) {
    if (applicationDto.circulation == 3 /* Combined */) {
      clonedInput.sectionList.forEach((section) => {
        var _a, _b;
        if (section.name === "connections") {
          section.rowList.forEach((row, rowIndex) => {
            row.cellList.forEach((cell) => {
              if (rowIndex == section.rowList.length - 1 && !cell.i18nKey && !cell.customValue) {
                isLastRowHasValue = false;
              } else {
                isLastRowHasValue = true;
              }
              if (cell.key == "actualVelocityText") {
                isVelocityInDemisterExist = true;
              }
            });
          });
          if (isLastRowHasValue && isVelocityInDemisterExist == false) {
            section.rowList = section.rowList.concat(
              (_a = velocityInDemisterHandler(spreadsheetData, applicationDto)) != null ? _a : []
            );
          } else if (!isLastRowHasValue && !isVelocityInDemisterExist) {
            section.rowList.pop();
            section.rowList = section.rowList.concat(
              (_b = velocityInDemisterHandler(spreadsheetData, applicationDto)) != null ? _b : []
            );
          }
        }
      });
    } else {
      clonedInput.sectionList.forEach((section) => {
        var _a;
        if (section.name === "connections") {
          const rowListLength = section.rowList.length;
          section.rowList[rowListLength - 2].cellList.forEach((cell) => {
            if (cell.key == "actualVelocityText" && cell.customValue) {
              isRowHasCustomValue = true;
            }
          });
          if (isRowHasCustomValue) {
            section.rowList = section.rowList.slice(0, rowListLength - 2).concat(
              (_a = velocityInDemisterHandler(spreadsheetData, applicationDto)) != null ? _a : []
            );
          } else {
            return clonedInput;
          }
        }
      });
    }
  }
  return clonedInput;
};
var handleDesignPressure = (input, applicationDto, spreadsheetData) => {
  let isDesignPressureTwoRows = false;
  const clonedInput = cloneDeep(input);
  clonedInput.sectionList.forEach((section) => {
    if (section.name.includes("constructionDesign")) {
      section.rowList.forEach((row) => {
        row.cellList.forEach((cell) => {
          if (cell.key === "plateDesignPressure") {
            isDesignPressureTwoRows = true;
          }
        });
      });
    }
  });
  if (applicationDto.typeApproval == 1 /* ASME */) {
    if (isDesignPressureTwoRows) {
      clonedInput.sectionList.forEach((section) => {
        if (section.name.includes("constructionDesign")) {
          section.rowList = section.rowList.slice(0, section.rowList.length - 3).concat(
            designPressureHandler(
              applicationDto,
              spreadsheetData,
              applicationDto.typeApproval
            )
          );
        }
      });
    } else {
      return clonedInput;
    }
  } else {
    if (applicationDto.constructionRow5Text != applicationDto.constructionRow6Text) {
      if (isDesignPressureTwoRows) {
        return clonedInput;
      } else {
        clonedInput.sectionList.forEach((section) => {
          if (section.name.includes("constructionDesign")) {
            section.rowList = section.rowList.slice(0, section.rowList.length - 2).concat(
              designPressureHandler(
                applicationDto,
                spreadsheetData,
                applicationDto.typeApproval
              )
            );
          }
        });
      }
    } else {
      if (isDesignPressureTwoRows) {
        clonedInput.sectionList.forEach((section) => {
          if (section.name.includes("constructionDesign")) {
            section.rowList = section.rowList.slice(0, section.rowList.length - 3).concat(
              designPressureHandler(
                applicationDto,
                spreadsheetData,
                applicationDto.typeApproval
              )
            );
          }
        });
      } else {
        return clonedInput;
      }
    }
  }
  return clonedInput;
};
var handleFillingTextBoxes = (input, applicationDto, spreadsheetData) => {
  let isLastRowHasValue = false;
  let isRowHasCustomValue = false;
  let isFillingBoxesTextExist = false;
  const clonedInput = cloneDeep(input);
  if (applicationDto.application == 3 /* Evaporator */ || applicationDto.application == 4 /* Cascade */) {
    if (applicationDto.circulation == 3 /* Combined */) {
      clonedInput.sectionList.forEach((section) => {
        var _a, _b;
        if (section.name === "flowSection") {
          section.rowList.forEach((row, rowIndex) => {
            row.cellList.forEach((cell) => {
              if (rowIndex == section.rowList.length - 1 && !cell.i18nKey && !cell.customValue) {
                isLastRowHasValue = false;
              } else {
                isLastRowHasValue = true;
              }
              if (cell.key == "fillingBoxesText") {
                isFillingBoxesTextExist = true;
              }
            });
          });
          if (isLastRowHasValue && isFillingBoxesTextExist == false) {
            section.rowList = section.rowList.concat(
              (_a = fillingBoxTextHandler(spreadsheetData, applicationDto)) != null ? _a : []
            );
          } else if (!isLastRowHasValue && !isFillingBoxesTextExist) {
            section.rowList.pop();
            section.rowList = section.rowList.concat(
              (_b = fillingBoxTextHandler(spreadsheetData, applicationDto)) != null ? _b : []
            );
          }
        }
      });
    } else {
      clonedInput.sectionList.forEach((section) => {
        var _a;
        if (section.name === "connections") {
          const rowListLength = section.rowList.length;
          section.rowList[rowListLength - 2].cellList.forEach((cell) => {
            if (cell.key == "fillingBoxesText" && cell.customValue) {
              isRowHasCustomValue = true;
            }
          });
          if (isRowHasCustomValue) {
            section.rowList = section.rowList.slice(0, rowListLength - 2).concat(
              (_a = fillingBoxTextHandler(spreadsheetData, applicationDto)) != null ? _a : []
            );
          } else {
            return clonedInput;
          }
        }
      });
    }
  }
  return clonedInput;
};
var paintHiddenHandler = (input, isCarbonSteelAvailable, isStainlessSteelAvailable) => {
  const clonedInput = cloneDeep(input);
  const materialsSection = clonedInput.sectionList.find(
    (section) => section.name === "materials"
  );
  if (!materialsSection) return clonedInput;
  const keyVisibility = {
    paintCarbonSteel: !isCarbonSteelAvailable,
    paintStainlessSteel: !isStainlessSteelAvailable
  };
  materialsSection.rowList.forEach((row) => {
    row.cellList.forEach((cell) => {
      if (cell.key === "paintCarbonSteel" && row.index === 8) {
        cell.key = "paintStainlessSteel";
      }
      if (cell.key && cell.key in keyVisibility) {
        row.isHidden = keyVisibility[cell.key];
      }
    });
  });
  return clonedInput;
};
var applyNewCalculationToSpreadSheet = (input, applicationDto, t, language, mfileInfo, position, calculationData, hidePsheType) => {
  let clonedInput = cloneDeep(input);
  const newSpreadSheetData = convertToSpreadSheet(
    applicationDto,
    mfileInfo,
    position,
    calculationData,
    hidePsheType
  );
  if (applicationDto.application == 3 /* Evaporator */ || applicationDto.application == 4 /* Cascade */) {
    clonedInput = handleFillingTextBoxes(
      clonedInput,
      applicationDto,
      newSpreadSheetData
    );
    clonedInput = handleVelocityInDemister(
      clonedInput,
      applicationDto,
      newSpreadSheetData
    );
  }
  clonedInput = handleDesignPressure(
    clonedInput,
    applicationDto,
    newSpreadSheetData
  );
  const isCarbonSteelAvailable = applicationDto.shellMaterial != 1 /* CarbonSteel */ && !feetCarbonSteel.includes(applicationDto.feet) && applicationDto.feet !== 0 /* NoFeet */ && (applicationDto.endPlateType === 2 /* WeldedEndPlate */ || applicationDto.endPlateType === 5 /* Compact */) || applicationDto.surfaceTreatment == 7 /* System5 */ ? false : true;
  const isStainlessSteelAvailable = applicationDto.surfaceTreatment == 8 /* System6 */ ? false : true;
  clonedInput = paintHiddenHandler(
    clonedInput,
    isCarbonSteelAvailable,
    isStainlessSteelAvailable
  );
  clonedInput.sectionList.forEach((section) => {
    section.rowList.forEach((row) => {
      row.cellList.forEach((cell) => {
        var _a, _b, _c, _d;
        if (!(cell == null ? void 0 : cell.isLocked)) {
          if (cell.i18nKey === "datasheet.header.appTitle.EvaporatorDX" || cell.i18nKey === "datasheet.header.appTitle.FloodedEvaporator" || cell.i18nKey === "datasheet.header.appTitle.FloodedEvaporatorCombined" || cell.i18nKey === "datasheet.header.appTitle.FloodedEvaporatorCombinedC") {
            if (!cell.key) {
              cell.key = "applicationTitle";
            }
          }
          if (cell.key) {
            if (cell.i18nKey) {
              cell.i18nKey = (_a = newSpreadSheetData[cell.key]) == null ? void 0 : _a.toString();
              cell.customValue = t((_b = cell.i18nKey) != null ? _b : "", {
                lng: language,
                defaultValue: ""
              });
            } else {
              cell.customValue = newSpreadSheetData[cell.key];
            }
          } else if (cell == null ? void 0 : cell.i18nKey) {
            if (cell.i18nKey === "datasheet.table.data.Velocity") {
              cell.customValue = t((_c = cell.i18nKey) != null ? _c : "", {
                lng: language,
                defaultValue: ""
              }) + " (" + unitVelocityOptionLabelMapping.get(applicationDto.cboW) + ")";
            } else {
              cell.customValue = t((_d = cell.i18nKey) != null ? _d : "", {
                lng: language,
                defaultValue: ""
              });
            }
          } else if (row.isAddedRow) {
            cell.customValue = null;
          }
        }
      });
    });
  });
  return clonedInput;
};
var applyNewLanguageToSpreadSheet = (t, language, input, cbow) => {
  if (!input) return input;
  const clonedInput = cloneDeep(input);
  clonedInput.sectionList.forEach((section) => {
    section.rowList.forEach((row) => {
      row.cellList.forEach((cell) => {
        var _a;
        if (cell == null ? void 0 : cell.i18nKey) {
          if (cell.i18nKey === "datasheet.table.data.Velocity" && !cell.isLocked && cbow !== void 0 && cbow !== null) {
            cell.customValue = t("datasheet.table.data.Velocity", {
              lng: language,
              defaultValue: "Velocity"
            }) + " (" + unitVelocityOptionLabelMapping.get(cbow) + ")";
          } else if ((t((_a = cell.i18nKey) != null ? _a : "", { lng: language, defaultValue: "" }) != (cell == null ? void 0 : cell.customValue) || !cell.customValue) && !cell.isLocked) {
            cell.customValue = t(cell.i18nKey, {
              lng: language,
              defaultValue: "en"
            });
          }
        }
      });
    });
  });
  return clonedInput;
};
var removeSpreadsheetLimitedVisibility = (spreadsheet) => {
  const clonedInput = cloneDeep(spreadsheet);
  if (clonedInput.isImageHidden) {
    clonedInput.isImageHidden = false;
  }
  clonedInput.sectionList.forEach((section) => {
    if (section.isHidden) {
      section.isHidden = false;
    }
    section.rowList.forEach((row) => {
      if (row.isHidden) {
        row.isHidden = false;
      }
      row.cellList.forEach((cell) => {
        if (cell.isHidden) {
          cell.isHidden = false;
        }
      });
    });
  });
  return clonedInput;
};
var limitedHiddenDataList = [
  { key: "area", isHiddenRow: true },
  // MultiCondenser sub-machines use suffixed keys
  { key: "areaDesuperHeater", isHiddenRow: true },
  { key: "areaCondenser", isHiddenRow: true },
  { key: "areaSubcooler", isHiddenRow: true },
  { key: "kval", isHiddenRow: true },
  { key: "kvalDesuperHeater", isHiddenRow: true },
  { key: "kvalCondenser", isHiddenRow: true },
  { key: "kvalSubcooler", isHiddenRow: true },
  { key: "foulingFactor", isHiddenRow: true },
  { key: "volumePlateSide", isHiddenRow: true },
  { key: "volumeShellSide", isHiddenRow: true }
];
var limitedSpreadsheetData = (spreadsheet) => {
  const removedLimitedVisibilitySpreadsheet = removeSpreadsheetLimitedVisibility(spreadsheet);
  removedLimitedVisibilitySpreadsheet.sectionList.forEach((section) => {
    if (section.name.includes("thermalDesign") || section.name.includes("flowSection")) {
      section.rowList.forEach((row) => {
        row.cellList.forEach((cell) => {
          limitedHiddenDataList.forEach((hiddenData) => {
            if (cell.key === hiddenData.key) {
              if (hiddenData.isHiddenRow) {
                row.isHidden = true;
              } else {
                cell.isHidden = true;
              }
            }
          });
        });
      });
    }
  });
  return removedLimitedVisibilitySpreadsheet;
};
var minimalHiddenDataList = [
  { key: "area", isHiddenRow: true },
  // MultiCondenser sub-machines use suffixed keys
  { key: "areaDesuperHeater", isHiddenRow: true },
  { key: "areaCondenser", isHiddenRow: true },
  { key: "areaSubcooler", isHiddenRow: true },
  { key: "lmtd", isHiddenRow: true },
  { key: "lmtdDesuperHeater", isHiddenRow: true },
  { key: "lmtdCondenser", isHiddenRow: true },
  { key: "lmtdSubcooler", isHiddenRow: true },
  { key: "kval", isHiddenRow: true },
  { key: "kvalDesuperHeater", isHiddenRow: true },
  { key: "kvalCondenser", isHiddenRow: true },
  { key: "kvalSubcooler", isHiddenRow: true },
  { key: "foulingFactor", isHiddenRow: true },
  { key: "excessDesignArea", isHiddenRow: true },
  { key: "excessDesignAreaDesuperHeater", isHiddenRow: true },
  { key: "excessDesignAreaCondenser", isHiddenRow: true },
  { key: "excessDesignAreaSubcooler", isHiddenRow: true },
  { key: "constructionRow1Text", isHiddenRow: false },
  { key: "constructionRow2Text", isHiddenRow: false },
  { key: "constructionRow3Text", isHiddenRow: false },
  { key: "constructionRow4Text", isHiddenRow: false },
  { key: "constructionRow7Text", isHiddenRow: false },
  { key: "constructionRow8Text", isHiddenRow: false }
];
var minimalSpreadsheetData = (spreadsheet) => {
  const removedLimitedVisibilitySpreadsheet = removeSpreadsheetLimitedVisibility(spreadsheet);
  removedLimitedVisibilitySpreadsheet.sectionList.forEach((section) => {
    if (section.name.includes("thermalDesign") || section.name.includes("flowSection") || section.name.includes("constructionDesign")) {
      section.rowList.forEach((row) => {
        row.cellList.forEach((cell) => {
          minimalHiddenDataList.forEach((hiddenData) => {
            if (cell.key === hiddenData.key) {
              if (hiddenData.isHiddenRow) {
                row.isHidden = true;
              } else {
                cell.isHidden = true;
              }
            }
          });
        });
      });
    }
  });
  return removedLimitedVisibilitySpreadsheet;
};
var hidePsheTypeHiddenRowKeys = [
  "area",
  // MultiCondenser sub-machines use suffixed keys
  "areaDesuperHeater",
  "areaCondenser",
  "areaSubcooler",
  "kval",
  "kvalDesuperHeater",
  "kvalCondenser",
  "kvalSubcooler",
  "foulingFactor",
  "volumePlateSide",
  "volumeShellSide"
];
var hidePsheTypeRowsInSpreadSheet = (spreadsheet) => {
  const cloned = cloneDeep(spreadsheet);
  cloned.sectionList.forEach((section) => {
    if (section.name.includes("thermalDesign") || section.name.includes("flowSection")) {
      section.rowList.forEach((row) => {
        if (row.cellList.some(
          (cell) => cell.key && hidePsheTypeHiddenRowKeys.includes(cell.key)
        )) {
          row.isHidden = true;
        }
      });
    }
  });
  return cloned;
};
var applyHidePsheTypeToContent = (content, hiddenPsheLabel) => {
  const clonedContent = cloneDeep(content);
  clonedContent.forEach((section) => {
    section.rowList.forEach((row) => {
      row.cellList.forEach((cell) => {
        if (cell.key && hidePsheTypeHiddenRowKeys.includes(cell.key)) {
          row.isHidden = true;
        }
        if (cell.key === "heatExchangerType") {
          cell.customValue = hiddenPsheLabel;
        }
      });
    });
  });
  return clonedContent;
};
var restoreHeatExchangerTypeInContent = (content, originalPsheLabel) => {
  const clonedContent = cloneDeep(content);
  clonedContent.forEach((section) => {
    section.rowList.forEach((row) => {
      if (row.cellList.some(
        (cell) => cell.key && hidePsheTypeHiddenRowKeys.includes(cell.key)
      )) {
        row.isHidden = false;
        row.cellList.forEach((cell) => {
          cell.isHidden = false;
        });
      }
      row.cellList.forEach((cell) => {
        if (cell.key === "heatExchangerType") {
          cell.customValue = originalPsheLabel;
        }
      });
    });
  });
  return clonedContent;
};
var spreadSheetHelper = {
  mapOnePhaseCalcuationKeyToSpeadsheetCellValue,
  mapCondenserCalcuationKeyToSpeadsheetCellValue,
  mapEvaporatorCalcuationKeyToSpeadsheetCellValue,
  mapCascadeCalcuationKeyToSpeadsheetCellValue,
  mapPartialCascadeCalcuationKeyToSpeadsheetCellValue,
  mapMultiCondenserCalcuationKeyToSpeadsheetCellValue,
  convertSpreadSheetToExcel,
  applyExcelChangeToSpreadSheet,
  applyNewCalculationToSpreadSheet,
  applyNewLanguageToSpreadSheet,
  removeSpreadsheetLimitedVisibility,
  limitedSpreadsheetData,
  minimalSpreadsheetData,
  applyHidePsheTypeToContent,
  restoreHeatExchangerTypeInContent,
  hidePsheTypeRowsInSpreadSheet
};

// src/utils/orp1-heatexchanger.helper.ts
var getMediumNames = (rawHeatExchanger) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const mediumNames = [];
  switch (rawHeatExchanger.application) {
    case 1 /* OnePhase */:
      {
        const heatExchanger = rawHeatExchanger;
        let mediumNameHotSide;
        const isHotSidePlate = heatExchanger.hotSide === 1 /* PlateSide */;
        if (heatExchanger.mediumMixtureTypeHotSide === 1 /* Mixture */) {
          mediumNameHotSide = (_a = heatExchanger.mediumMixtureListHotSide) == null ? void 0 : _a.map(
            (medium) => `${mediumOptionMappingLabel.get(medium.mediumName)} ${medium.massFraction} `
          ).toString().replaceAll(",", " + ");
        } else {
          mediumNameHotSide = heatExchanger.hotSideMedium === 2 /* Gas */ && heatExchanger.mediumSourceHotSide === 3 /* RefProp */ ? getMediumName(
            heatExchanger.mediumSourceHotSide,
            heatExchanger.mediumHotSide,
            heatExchanger.mediumHotSideOtherMedia,
            heatExchanger.concentrationHotSide || 0
          ) + ` (${(_b = heatExchanger.pressureHotside) == null ? void 0 : _b.toFixed(
            2
          )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : getMediumName(
            heatExchanger.mediumSourceHotSide,
            heatExchanger.mediumHotSide,
            heatExchanger.mediumHotSideOtherMedia,
            heatExchanger.concentrationHotSide || 0
          );
        }
        let mediumNameColdSide;
        if (heatExchanger.mediumMixtureTypeColdSide === 1 /* Mixture */) {
          mediumNameColdSide = (_c = heatExchanger.mediumMixtureListColdSide) == null ? void 0 : _c.map(
            (medium) => `${mediumOptionMappingLabel.get(medium.mediumName)} ${medium.massFraction} `
          ).toString().replaceAll(",", " + ");
        } else {
          mediumNameColdSide = heatExchanger.coldSideMedium === 2 /* Gas */ && heatExchanger.mediumSourceColdSide === 3 /* RefProp */ ? getMediumName(
            heatExchanger.mediumSourceColdSide,
            heatExchanger.mediumColdSide,
            heatExchanger.mediumColdSideOtherMedia,
            heatExchanger.concentrationColdSide || 0
          ) + ` (${(_d = heatExchanger.pressureColdSide) == null ? void 0 : _d.toFixed(
            2
          )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : getMediumName(
            heatExchanger.mediumSourceColdSide,
            heatExchanger.mediumColdSide,
            heatExchanger.mediumColdSideOtherMedia,
            heatExchanger.concentrationColdSide || 0
          );
        }
        const mediumPlateSide = isHotSidePlate ? mediumNameHotSide : mediumNameColdSide;
        const mediumShellSide = isHotSidePlate ? mediumNameColdSide : mediumNameHotSide;
        mediumNames.push(mediumPlateSide, mediumShellSide);
      }
      break;
    case 2 /* Condenser */: {
      const heatExchanger = rawHeatExchanger;
      const isPlateSideLiquid = heatExchanger.liquidSide === 1 /* PlateSide */;
      const mediumNameLiquid = getMediumName(
        heatExchanger.mediumSourceLiquidSide,
        heatExchanger.mediumLiquidSide,
        heatExchanger.mediumLiquidSideOtherMedia,
        heatExchanger.concentrationLiquidSide || 0
      );
      const mediumNameLiquidSide = heatExchanger.liquidSidePhase === 1 /* Gas */ ? mediumNameLiquid + ` (${(_e = heatExchanger.gasPressureOnLiquidSide) == null ? void 0 : _e.toFixed(
        2
      )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : mediumNameLiquid;
      const mediumNameVaporSide = heatExchanger.mediumSourceVaporSide !== 0 /* Imported */ ? mediumOptionMappingLabel.get(heatExchanger.mediumVaporSide) : heatExchanger.mediumVaporSideOtherMedia;
      const mediumPlateSide = isPlateSideLiquid ? mediumNameLiquidSide : mediumNameVaporSide;
      const mediumShellSide = isPlateSideLiquid ? mediumNameVaporSide : mediumNameLiquidSide;
      mediumNames.push(mediumPlateSide, mediumShellSide);
      break;
    }
    case 3 /* Evaporator */: {
      const heatExchanger = rawHeatExchanger;
      const isHotSidePlate = heatExchanger.evaporatorType === 1 /* FloodedEvaporator */;
      const mediumNameLiquidSide = getMediumName(
        heatExchanger.mediumSourceLiquidSide,
        heatExchanger.mediumLiquidSide,
        heatExchanger.mediumLiquidSideOtherMedia,
        heatExchanger.concentrationLiquidSide || 0
      );
      const mediumNameVaporSide = heatExchanger.mediumSourceVaporSide != 0 /* Imported */ ? mediumOptionMappingLabel.get(heatExchanger.mediumVaporSide) : heatExchanger.mediumVaporSideOtherMedia;
      const mediumPlateSide = isHotSidePlate ? mediumNameLiquidSide : mediumNameVaporSide;
      const mediumShellSide = isHotSidePlate ? mediumNameVaporSide : mediumNameLiquidSide;
      mediumNames.push(mediumPlateSide, mediumShellSide);
      break;
    }
    case 4 /* Cascade */: {
      const heatExchanger = rawHeatExchanger;
      const isHotSidePlate = heatExchanger.cascadeType === 1 /* Flooded */;
      const mediumNameCondSide = heatExchanger.mediumSourceCondSide != 0 /* Imported */ ? mediumOptionMappingLabel.get(heatExchanger.mediumCondSide) : heatExchanger.mediumCondSideOtherMedia;
      const mediumNameEvapSide = heatExchanger.mediumSourceEvapSide != 0 /* Imported */ ? mediumOptionMappingLabel.get(heatExchanger.mediumEvapSide) : heatExchanger.mediumEvapSideOtherMedia;
      const mediumPlateSide = isHotSidePlate ? mediumNameCondSide : mediumNameEvapSide;
      const mediumShellSide = isHotSidePlate ? mediumNameEvapSide : mediumNameCondSide;
      mediumNames.push(mediumPlateSide, mediumShellSide);
      break;
    }
    case 5 /* PartialCascade */: {
      const heatExchanger = rawHeatExchanger;
      const mediumNameHotSide = heatExchanger.mediumMixtureHotSide === 0 /* PureMedium */ ? getMediumName(
        heatExchanger.mediumSourceHotSide,
        heatExchanger.mediumHotSide,
        heatExchanger.mediumHotSideOtherMedia,
        heatExchanger.concentrationHotSide || 0
      ) : "Mixture";
      const mediumNameColdSide = heatExchanger.mediumMixtureColdSide === 0 /* PureMedium */ ? getMediumName(
        heatExchanger.mediumSourceColdSide,
        heatExchanger.mediumColdSide,
        heatExchanger.mediumColdSideOtherMedia,
        heatExchanger.concentrationColdSide || 0
      ) : "Mixture";
      const isHotSidePlate = heatExchanger.hotSide === 1 /* PlateSide */;
      const mediumPlateSide = isHotSidePlate ? mediumNameHotSide : mediumNameColdSide;
      const mediumShellSide = isHotSidePlate ? mediumNameColdSide : mediumNameHotSide;
      mediumNames.push(mediumPlateSide, mediumShellSide);
      break;
    }
    case 6 /* MultiCondenser */: {
      const heatExchanger = rawHeatExchanger;
      const isPlateSideLiquid = heatExchanger.liquidSideMultiCondenser === 1 /* PlateSide */;
      const mediumNameVaporSideName = heatExchanger.mediumSourceVaporSide != 0 /* Imported */ ? mediumOptionMappingLabel.get(heatExchanger.mediumVaporSide) : heatExchanger.mediumVaporSideOtherMedia;
      const mediumNameLiquidSideName = getMediumName(
        heatExchanger.mediumSourceLiquidSide,
        heatExchanger.mediumLiquidSide,
        heatExchanger.mediumLiquidSideOtherMedia,
        heatExchanger.concentrationLiquidSide || 0
      );
      const mediumNameLiquidSide = heatExchanger.liquidSidePhase === 1 /* Gas */ ? mediumNameLiquidSideName + ` (${(_f = heatExchanger.gasPressureOnLiquidSide) == null ? void 0 : _f.toFixed(2)} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : mediumNameLiquidSideName;
      const mediumPlateSide = isPlateSideLiquid ? mediumNameLiquidSide : mediumNameVaporSideName + ` (${(_g = heatExchanger.saturatedPressure) == null ? void 0 : _g.toFixed(
        2
      )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})`;
      const mediumShellSide = isPlateSideLiquid ? mediumNameVaporSideName + ` (${(_h = heatExchanger.saturatedPressure) == null ? void 0 : _h.toFixed(
        2
      )} ${unitPressureOptionLabelInputMapping.get(heatExchanger.cboP)})` : mediumNameLiquidSide;
      mediumNames.push(mediumPlateSide, mediumShellSide);
    }
  }
  return mediumNames;
};
var getNumberOfPassed = (rawHeatExchager) => {
  const response = [];
  switch (rawHeatExchager.application) {
    case 1 /* OnePhase */:
      {
        const isHotSidePlate = rawHeatExchager.hotSide === 1 /* PlateSide */;
        const numberOfPassedPlate = isHotSidePlate ? rawHeatExchager.numberOfPassesHotSide : rawHeatExchager.numberOfPassesColdSide;
        const numberOfPassedShell = isHotSidePlate ? rawHeatExchager.numberOfPassesColdSide : rawHeatExchager.numberOfPassesHotSide;
        response.push(
          numberOfPassedPlate.toString(),
          numberOfPassedShell.toString()
        );
      }
      break;
    case 2 /* Condenser */:
      {
        const isPlateSideLiquid = rawHeatExchager.liquidSide === 1 /* PlateSide */;
        const numberOfPassedPlate = isPlateSideLiquid ? rawHeatExchager.numberOfPassesLiquidSide : rawHeatExchager.numberOfPassesLiquidSide;
        const numberOfPassedShell = isPlateSideLiquid ? rawHeatExchager.numberOfPassesLiquidSide : rawHeatExchager.numberOfPassesLiquidSide;
        response.push(
          numberOfPassedPlate.toString(),
          numberOfPassedShell.toString()
        );
      }
      break;
    case 3 /* Evaporator */:
      {
        const isHotSidePlate = rawHeatExchager.evaporatorType === 1 /* FloodedEvaporator */;
        const numberOfPassedPlate = isHotSidePlate ? rawHeatExchager.numberOfPassesDX : rawHeatExchager.numberOfPassesLiquidSide;
        const numberOfPassedShell = isHotSidePlate ? rawHeatExchager.numberOfPassesLiquidSide : rawHeatExchager.numberOfPassesDX;
        response.push(
          numberOfPassedPlate.toString(),
          numberOfPassedShell.toString()
        );
      }
      break;
    case 4 /* Cascade */:
      {
        const isHotSidePlate = rawHeatExchager.cascadeType === 1 /* Flooded */;
        const numberOfPassedPlate = isHotSidePlate ? rawHeatExchager.numberOfPassesDX : rawHeatExchager.numberOfPassesDX;
        const numberOfPassedShell = isHotSidePlate ? rawHeatExchager.numberOfPassesDX : rawHeatExchager.numberOfPassesDX;
        response.push(
          numberOfPassedPlate.toString(),
          numberOfPassedShell.toString()
        );
      }
      break;
    case 5 /* PartialCascade */:
      {
        const isHotSidePlate = rawHeatExchager.hotSide === 1 /* PlateSide */;
        const numberOfPassedPlate = isHotSidePlate ? rawHeatExchager.numberOfPassesHotSidePC : rawHeatExchager.numberOfPassesColdSidePC;
        const numberOfPassedShell = isHotSidePlate ? rawHeatExchager.numberOfPassesColdSidePC : rawHeatExchager.numberOfPassesHotSidePC;
        response.push(
          numberOfPassedPlate.toString(),
          numberOfPassedShell.toString()
        );
      }
      break;
    case 6 /* MultiCondenser */:
      {
      }
      break;
  }
  return response;
};
var getPlateShellTemperatures = (heatExchanger) => {
  const inletTemps = [];
  switch (heatExchanger.application) {
    case 1 /* OnePhase */:
      {
        const hx = heatExchanger;
        const isHotSidePlate = hx.hotSide === 1 /* PlateSide */;
        const tempInPlateSide = isHotSidePlate ? hx.inletTempHotSide : hx.inletTempColdSide;
        const tempInShellSide = isHotSidePlate ? hx.inletTempColdSide : hx.inletTempHotSide;
        const tempOutPlateSide = isHotSidePlate ? hx.outletTempHotSide : hx.outletTempColdSide;
        const tempOutShellSide = isHotSidePlate ? hx.outletTempColdSide : hx.outletTempHotSide;
        inletTemps.push(
          tempInPlateSide,
          tempInShellSide,
          tempOutPlateSide,
          tempOutShellSide
        );
      }
      break;
    case 2 /* Condenser */:
      {
        const hx = heatExchanger;
        const isPlateSideLiquid = hx.liquidSide === 1 /* PlateSide */;
        const tempInPlateSide = isPlateSideLiquid ? hx.inletTemperatureLiquid : hx.gasInletTemperature;
        const tempInShellSide = isPlateSideLiquid ? hx.gasInletTemperature : hx.inletTemperatureLiquid;
        const tempOutPlateSide = isPlateSideLiquid ? hx.outletTemperatureLiquid : hx.subCooledTemperature;
        const tempOutShellSide = isPlateSideLiquid ? hx.subCooledTemperature : hx.outletTemperatureLiquid;
        inletTemps.push(
          tempInPlateSide,
          tempInShellSide,
          tempOutPlateSide,
          tempOutShellSide
        );
      }
      break;
    case 4 /* Cascade */:
      {
        const hx = heatExchanger;
        const isHotSidePlate = hx.cascadeType === 1 /* Flooded */;
        const tempInPlateSide = isHotSidePlate ? hx.inletTemperatureCondSide : hx.inletTemperatureEvapSide;
        const tempInShellSide = isHotSidePlate ? hx.inletTemperatureEvapSide : hx.inletTemperatureCondSide;
        const tempOutPlateSide = isHotSidePlate ? hx.outletTemperatureCondSide : (hx.saturationTemperatureEvapSide || 0) + (hx.dtSuperHeat || 0);
        const tempOutShellSide = isHotSidePlate ? (hx.saturationTemperatureEvapSide || 0) + (hx.dtSuperHeat || 0) : hx.outletTemperatureCondSide;
        inletTemps.push(
          tempInPlateSide,
          tempInShellSide,
          tempOutPlateSide,
          tempOutShellSide
        );
      }
      break;
    case 3 /* Evaporator */:
      {
        const hx = heatExchanger;
        const isHotSidePlate = hx.evaporatorType === 1 /* FloodedEvaporator */;
        const tempInPlateSide = isHotSidePlate ? hx.inletTemperatureLiquid : hx.inletTempEvapSide;
        const tempInShellSide = isHotSidePlate ? hx.inletTempEvapSide : hx.inletTemperatureLiquid;
        const tempOutPlateSide = isHotSidePlate ? hx.outletTemperatureLiquid : (hx.evaporatingTemperature || 0) + (hx.dtSuperHeat || 0);
        const tempOutShellSide = isHotSidePlate ? (hx.evaporatingTemperature || 0) + (hx.dtSuperHeat || 0) : hx.outletTemperatureLiquid;
        inletTemps.push(
          tempInPlateSide,
          tempInShellSide,
          tempOutPlateSide,
          tempOutShellSide
        );
      }
      break;
    case 5 /* PartialCascade */:
      {
        const hx = heatExchanger;
        const isHotSidePlate = hx.hotSide === 1 /* PlateSide */;
        const tempInPlateSide = isHotSidePlate ? hx.inletTemperatureHotSide : hx.inletTemperatureColdSide;
        const tempInShellSide = isHotSidePlate ? hx.inletTemperatureColdSide : hx.inletTemperatureHotSide;
        const tempOutPlateSide = isHotSidePlate ? hx.outletTemperatureHotSide : hx.outletTemperatureColdSide;
        const tempOutShellSide = isHotSidePlate ? hx.outletTemperatureColdSide : hx.outletTemperatureHotSide;
        inletTemps.push(
          tempInPlateSide,
          tempInShellSide,
          tempOutPlateSide,
          tempOutShellSide
        );
      }
      break;
    case 6 /* MultiCondenser */:
      {
        const hx = heatExchanger;
        const isPlateSideLiquid = hx.liquidSideMultiCondenser === 1 /* PlateSide */;
        const tempInPlateSide = isPlateSideLiquid ? hx.inletTemperatureLiquid : hx.gasInletTemperature;
        const tempInShellSide = isPlateSideLiquid ? hx.gasInletTemperature : hx.inletTemperatureLiquid;
        const tempOutPlateSide = isPlateSideLiquid ? hx.outletTemperatureLiquid : hx.subCooledTemperature;
        const tempOutShellSide = isPlateSideLiquid ? hx.subCooledTemperature : hx.outletTemperatureLiquid;
        inletTemps.push(tempInPlateSide);
        inletTemps.push(tempInShellSide);
        inletTemps.push(tempOutPlateSide);
        inletTemps.push(tempOutShellSide);
      }
      break;
  }
  return inletTemps;
};
var getMultiCondenserPassesPlateShellSide = (heatExchanger) => {
  const nbOfPasses = [];
  if (heatExchanger.application === 6 /* MultiCondenser */) {
    const hx = heatExchanger;
    const isPlateSideLiquid = hx.liquidSideMultiCondenser === 1 /* PlateSide */;
    const numberOfPassesPlateDesuperheater = isPlateSideLiquid ? hx.numberOfPassesLiquidSideDesuperHeater : 1;
    const numberOfpassesShellDesuperheater = isPlateSideLiquid ? 1 : hx.numberOfPassesLiquidSideDesuperHeater;
    const numberOfPassesPlateCondenser = isPlateSideLiquid ? hx.numberOfPassesLiquidSideCondenser : 1;
    const numberOfPassesShellCondenser = isPlateSideLiquid ? 1 : hx.numberOfPassesLiquidSideCondenser;
    const numberOfPassesPlateSubcooler = isPlateSideLiquid ? hx.numberOfPassesLiquidSideSubcooler : 1;
    const numberOfPassesShellSubcooler = isPlateSideLiquid ? 1 : hx.numberOfPassesLiquidSideSubcooler;
    nbOfPasses.push(numberOfPassesPlateDesuperheater);
    nbOfPasses.push(numberOfpassesShellDesuperheater);
    nbOfPasses.push(numberOfPassesPlateCondenser);
    nbOfPasses.push(numberOfPassesShellCondenser);
    nbOfPasses.push(numberOfPassesPlateSubcooler);
    nbOfPasses.push(numberOfPassesShellSubcooler);
  }
  return nbOfPasses;
};
var getDesignPressureMin = (typeApproval) => {
  switch (typeApproval) {
    case 0 /* PED */:
    case 2 /* PEDEN */:
      return 1 /* MinusOneBarg */;
    case 1 /* ASME */:
      return 2 /* FullVacuum */;
    default:
      return;
  }
};
var getHotSide = (heatExchanger) => {
  const { application } = heatExchanger;
  switch (application) {
    case 1 /* OnePhase */:
      return heatExchanger.hotSide;
    case 2 /* Condenser */:
      return heatExchanger.liquidSide === 1 /* PlateSide */ ? 2 /* ShellSide */ : 1 /* PlateSide */;
    case 3 /* Evaporator */:
      return heatExchanger.evaporatorType === 1 /* FloodedEvaporator */ ? 1 /* PlateSide */ : 2 /* ShellSide */;
    case 4 /* Cascade */:
      return heatExchanger.cascadeType === 1 /* Flooded */ ? 1 /* PlateSide */ : 2 /* ShellSide */;
    case 5 /* PartialCascade */:
      return heatExchanger.hotSide;
    case 6 /* MultiCondenser */:
      return heatExchanger.liquidSide === 1 /* PlateSide */ ? 2 /* ShellSide */ : 1 /* PlateSide */;
    default:
      break;
  }
};

// src/utils/extra-grouping.helper.ts
var isGroupedExtra = (entry) => "group" in entry;
var byName = (a, b) => {
  var _a, _b;
  return ((_a = a.name) != null ? _a : "").localeCompare((_b = b.name) != null ? _b : "", void 0, { sensitivity: "base" });
};
var getEntryName = (entry) => {
  var _a, _b, _c;
  return isGroupedExtra(entry) ? (_b = (_a = entry.group.groupParent) == null ? void 0 : _a.name) != null ? _b : "" : (_c = entry.item.name) != null ? _c : "";
};
var byEntryName = (a, b) => {
  const cmp = getEntryName(a).localeCompare(getEntryName(b), void 0, {
    sensitivity: "base"
  });
  if (cmp !== 0) return cmp;
  const aRank = isGroupedExtra(a) ? 0 : 1;
  const bRank = isGroupedExtra(b) ? 0 : 1;
  return aRank - bRank;
};
var buildParentChildRelationships = (extraList) => {
  var _a;
  const itemList = extraList.filter((e) => e.isGroup !== true);
  const itemsByGroupId = /* @__PURE__ */ new Map();
  const childItemIds = /* @__PURE__ */ new Set();
  for (const item of itemList) {
    const listOfGroupId = (_a = item.listOfGroupId) != null ? _a : [];
    if (listOfGroupId.length === 0) continue;
    for (const gid of listOfGroupId) {
      if (!itemsByGroupId.has(gid)) itemsByGroupId.set(gid, []);
      itemsByGroupId.get(gid).push(item);
      childItemIds.add(item.id);
    }
  }
  return { itemsByGroupId, childItemIds };
};
var createGroupedEntry = (group, children, generateId) => {
  const uniqueChildren = Array.from(new Set(children)).sort(byName);
  return {
    group: {
      id: generateId(),
      groupParent: __spreadValues({}, group),
      itemList: uniqueChildren
    }
  };
};
var groupExtrasByCategory = (extraList, generateId) => {
  const groupList = extraList.filter((e) => e.isGroup === true);
  const itemList = extraList.filter((e) => e.isGroup !== true);
  const { itemsByGroupId, childItemIds } = buildParentChildRelationships(extraList);
  const standaloneItems = itemList.filter((i) => !childItemIds.has(i.id));
  const categoryMap = {};
  for (const group of groupList) {
    const key = String(group.category);
    if (!categoryMap[key]) {
      categoryMap[key] = {
        categoryName: extraPriceCategoryMappingLabel.get(group.category) || "Other",
        category: group.category,
        groups: [],
        standalones: []
      };
    }
    categoryMap[key].groups.push(group);
  }
  for (const item of standaloneItems) {
    const key = String(item.category);
    if (!categoryMap[key]) {
      categoryMap[key] = {
        categoryName: extraPriceCategoryMappingLabel.get(item.category) || "Other",
        category: item.category,
        groups: [],
        standalones: []
      };
    }
    categoryMap[key].standalones.push(item);
  }
  return Object.values(categoryMap).map(
    ({ categoryName, category, groups, standalones }) => {
      const groupedEntryList = groups.map(
        (group) => {
          var _a;
          return createGroupedEntry(
            group,
            (_a = itemsByGroupId.get(group.id)) != null ? _a : [],
            generateId
          );
        }
      );
      const standaloneEntryList = standalones.map((i) => ({ item: i }));
      return {
        categoryName,
        category,
        extraList: [...groupedEntryList, ...standaloneEntryList].sort(
          byEntryName
        )
      };
    }
  );
};
var generateExtraList = (extraList, generateId, allExtras) => {
  const sourceList = allExtras != null ? allExtras : extraList;
  const groupList = extraList.filter((e) => e.isGroup === true);
  const itemList = extraList.filter((e) => e.isGroup !== true);
  const { itemsByGroupId, childItemIds } = buildParentChildRelationships(sourceList);
  const groupedEntryList = groupList.map(
    (group) => {
      var _a;
      return createGroupedEntry(group, (_a = itemsByGroupId.get(group.id)) != null ? _a : [], generateId);
    }
  );
  const standaloneEntryList = itemList.filter((i) => !childItemIds.has(i.id)).map((i) => ({ item: i }));
  return [...groupedEntryList, ...standaloneEntryList].sort(byEntryName);
};

// src/utils/internal-or-jci-medium.helper.ts
var getInternalOrJciMediumError = (mediums, userRoles) => {
  var _a;
  const canUseInternalOrJciMediums = userRoles.includes("CPQ-Internal-Oy" /* CPQ_INTERNAL_OY */) || userRoles.includes("CPQ-Internal-China" /* CPQ_INTERNAL_CHINA */) || userRoles.includes("CPQ-External-JCI" /* CPQ_EXTERNAL_JCI */);
  if (canUseInternalOrJciMediums) return void 0;
  const restrictedMedium = mediums.find(
    (medium) => medium != null && isInternalOrJciMedium(medium)
  );
  if (restrictedMedium == null) return void 0;
  return `Medium "${(_a = mediumOptionMappingLabel.get(restrictedMedium)) != null ? _a : ""}" is only available for internal and JCI users`;
};

// src/utils/timestampParse.ts
var HOUR = 36e5;
var MINUTE = 6e4;
var SECOND = 1e3;
var EXCEL_EPOCH_MS = Date.UTC(1899, 11, 30);
var MS_PER_DAY = 864e5;
var SERIAL_MIN = 32874;
var SERIAL_MAX = 73051;
var clockMs = (h, m, s) => h * HOUR + m * MINUTE + s * SECOND;
var validClock = (h, m, s) => h >= 0 && h <= 23 && m >= 0 && m <= 59 && s >= 0 && s <= 59;
var validDate = (y, mo, d) => {
  if (mo < 1 || mo > 12 || d < 1 || d > 31) return false;
  const probe = new Date(y, mo - 1, d);
  return probe.getFullYear() === y && probe.getMonth() === mo - 1;
};
var toEpoch = (p) => p.offsetMinutes === null ? Date.UTC(p.year, p.month - 1, p.day, p.hours, p.minutes, p.seconds) : Date.UTC(p.year, p.month - 1, p.day, p.hours, p.minutes, p.seconds) - p.offsetMinutes * MINUTE;
var ISO_RE = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?(Z|[+-]\d{2}:?\d{2})?)?$/;
var US_RE = /^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})(?: (\d{1,2}):(\d{2})(?::(\d{2}))?)?$/;
var EU_RE = /^(\d{1,2})\.(\d{1,2})\.(\d{4})(?: (\d{1,2}):(\d{2})(?::(\d{2}))?)?$/;
var parseOffset = (raw) => {
  if (!raw) return null;
  if (raw === "Z") return 0;
  const m = /^([+-])(\d{2}):?(\d{2})$/.exec(raw);
  if (!m) return null;
  const minutes = Number(m[2]) * 60 + Number(m[3]);
  return m[1] === "-" ? -minutes : minutes;
};
var partsFromString = (text) => {
  const iso = ISO_RE.exec(text);
  if (iso) {
    const [, y, mo, d, h = "0", mi = "0", s = "0", off] = iso;
    const parts = {
      year: Number(y),
      month: Number(mo),
      day: Number(d),
      hours: Number(h),
      minutes: Number(mi),
      seconds: Number(s),
      offsetMinutes: parseOffset(off)
    };
    if (!validDate(parts.year, parts.month, parts.day) || !validClock(parts.hours, parts.minutes, parts.seconds))
      return null;
    return parts;
  }
  const us = US_RE.exec(text);
  if (us) {
    const [, mo, d, y, h = "0", mi = "0", s = "0"] = us;
    const year = y.length === 2 ? 2e3 + Number(y) : Number(y);
    const parts = {
      year,
      month: Number(mo),
      day: Number(d),
      hours: Number(h),
      minutes: Number(mi),
      seconds: Number(s),
      offsetMinutes: null
    };
    if (!validDate(parts.year, parts.month, parts.day) || !validClock(parts.hours, parts.minutes, parts.seconds))
      return null;
    return parts;
  }
  const eu = EU_RE.exec(text);
  if (eu) {
    const [, d, mo, y, h = "0", mi = "0", s = "0"] = eu;
    const parts = {
      year: Number(y),
      month: Number(mo),
      day: Number(d),
      hours: Number(h),
      minutes: Number(mi),
      seconds: Number(s),
      offsetMinutes: null
    };
    if (!validDate(parts.year, parts.month, parts.day) || !validClock(parts.hours, parts.minutes, parts.seconds))
      return null;
    return parts;
  }
  return null;
};
var isPlausibleDateSerial = (serial) => serial >= 0 && serial < 1 || serial >= SERIAL_MIN && serial <= SERIAL_MAX;
var fromSerial = (serial) => {
  if (serial >= 0 && serial < 1) {
    const ms = Math.round(serial * MS_PER_DAY / SECOND) * SECOND;
    return { epochMs: null, timeOfDayMs: ms, hasDate: false };
  }
  if (serial < SERIAL_MIN || serial > SERIAL_MAX) return null;
  const utc = new Date(
    Math.round((EXCEL_EPOCH_MS + serial * MS_PER_DAY) / SECOND) * SECOND
  );
  const parts = {
    year: utc.getUTCFullYear(),
    month: utc.getUTCMonth() + 1,
    day: utc.getUTCDate(),
    hours: utc.getUTCHours(),
    minutes: utc.getUTCMinutes(),
    seconds: utc.getUTCSeconds(),
    offsetMinutes: null
  };
  return {
    epochMs: toEpoch(parts),
    timeOfDayMs: clockMs(parts.hours, parts.minutes, parts.seconds),
    hasDate: true
  };
};
function parseTimestampCell(cell) {
  if (cell === null || cell === void 0) return null;
  if (typeof cell === "number") return fromSerial(cell);
  const text = cell.trim();
  if (text === "") return null;
  if (/^-?\d+(?:\.\d+)?$/.test(text)) return fromSerial(Number(text));
  const clock = TIME_24_RE.exec(text);
  if (clock) {
    const [, h, mi, s = "0"] = clock;
    if (!validClock(Number(h), Number(mi), Number(s))) return null;
    return {
      epochMs: null,
      timeOfDayMs: clockMs(Number(h), Number(mi), Number(s)),
      hasDate: false
    };
  }
  const parts = partsFromString(text);
  if (!parts) return null;
  return {
    epochMs: toEpoch(parts),
    timeOfDayMs: clockMs(parts.hours, parts.minutes, parts.seconds),
    hasDate: true
  };
}
var TIME_24_RE = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/;
var TIME_AMPM_RE = /^(\d{1,2})(?::(\d{2})(?::(\d{2}))?)?\s*(am|pm)$/i;
function parseTimeLiteral(text) {
  const trimmed = text.trim();
  if (trimmed === "") return null;
  const ampm = TIME_AMPM_RE.exec(trimmed);
  if (ampm) {
    const [, hRaw, mi = "0", s = "0", suffix] = ampm;
    const h12 = Number(hRaw);
    if (h12 < 1 || h12 > 12 || !validClock(0, Number(mi), Number(s)))
      return null;
    const hours = suffix.toLowerCase() === "pm" ? h12 % 12 + 12 : h12 % 12;
    return { kind: "timeOfDay", ms: clockMs(hours, Number(mi), Number(s)) };
  }
  const t24 = TIME_24_RE.exec(trimmed);
  if (t24) {
    const [, h, mi, s = "0"] = t24;
    if (!validClock(Number(h), Number(mi), Number(s))) return null;
    return { kind: "timeOfDay", ms: clockMs(Number(h), Number(mi), Number(s)) };
  }
  const parts = partsFromString(trimmed);
  if (parts) return { kind: "instant", epochMs: toEpoch(parts) };
  return null;
}

// src/utils/excelDateCell.ts
var SECOND2 = 1e3;
var MS_PER_DAY2 = 864e5;
var EXCEL_EPOCH_MS2 = Date.UTC(1899, 11, 30);
var pad = (value) => String(value).padStart(2, "0");
var isTimeOnly = (ms) => ms >= EXCEL_EPOCH_MS2 && ms < EXCEL_EPOCH_MS2 + MS_PER_DAY2;
var canonical = (ms) => {
  const date = new Date(ms);
  const clock = `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}` + (date.getUTCSeconds() ? `:${pad(date.getUTCSeconds())}` : "");
  if (isTimeOnly(ms)) return clock;
  const day = `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`;
  return ms === Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()) ? day : `${day} ${clock}`;
};
var roundTrips = (text, ms) => {
  const parsed = parseTimestampCell(text);
  if (!parsed) return false;
  if (parsed.hasDate) return parsed.epochMs === ms;
  return isTimeOnly(ms) && parsed.timeOfDayMs === ms - EXCEL_EPOCH_MS2;
};
var formatDateNumFmt = (ms, numFmt) => {
  var _a;
  const section = numFmt.replace(/\[\$[^\]]*\]/g, "").split(";")[0];
  if (section.trim() === "" || /general/i.test(section)) return null;
  if (/[[\]#0?%]/.test(section) || /am\/pm|a\/p/i.test(section)) return null;
  const parts = [];
  for (let i = 0; i < section.length; i++) {
    const ch = section[i];
    if (ch === '"') {
      const close = section.indexOf('"', i + 1);
      if (close === -1) return null;
      parts.push({ kind: "literal", text: section.slice(i + 1, close) });
      i = close;
    } else if (ch === "\\") {
      if (i + 1 >= section.length) return null;
      parts.push({ kind: "literal", text: section[i + 1] });
      i++;
    } else if (ch === "_") {
      parts.push({ kind: "literal", text: " " });
      i++;
    } else if (/[a-z]/i.test(ch)) {
      const lower = ch.toLowerCase();
      if (!"ymdhs".includes(lower)) return null;
      let len = 1;
      while (((_a = section[i + 1]) == null ? void 0 : _a.toLowerCase()) === lower) {
        len++;
        i++;
      }
      parts.push({ kind: "token", ch: lower, len });
    } else if (ch === "*") {
      return null;
    } else {
      parts.push({ kind: "literal", text: ch });
    }
  }
  const tokens = parts.filter(
    (part) => part.kind === "token"
  );
  if (tokens.length === 0) return null;
  if (tokens.some(
    (token) => (token.ch === "m" || token.ch === "d") && token.len > 2
  ))
    return null;
  const isMinutes = (token) => {
    var _a2, _b;
    const at = tokens.indexOf(token);
    return ((_a2 = tokens[at - 1]) == null ? void 0 : _a2.ch) === "h" || ((_b = tokens[at + 1]) == null ? void 0 : _b.ch) === "s";
  };
  const date = new Date(ms);
  const render = (token) => {
    const wide = token.len >= 2;
    const emit = (value) => wide ? pad(value) : String(value);
    switch (token.ch) {
      case "y":
        return token.len <= 2 ? pad(date.getUTCFullYear() % 100) : String(date.getUTCFullYear());
      case "m":
        return isMinutes(token) ? emit(date.getUTCMinutes()) : emit(date.getUTCMonth() + 1);
      case "d":
        return emit(date.getUTCDate());
      case "h":
        return emit(date.getUTCHours());
      case "s":
        return emit(date.getUTCSeconds());
    }
  };
  return parts.map((part) => part.kind === "literal" ? part.text : render(part)).join("");
};
var renderDateCell = (value, numFmt) => {
  const ms = Math.round(value.getTime() / SECOND2) * SECOND2;
  if (numFmt) {
    const rendered = formatDateNumFmt(ms, numFmt);
    if (rendered !== null && roundTrips(rendered, ms)) return rendered;
  }
  return canonical(ms);
};
var isDateTimeNumFmt = (numFmt) => {
  const section = numFmt.replace(/\[\$[^\]]*\]/g, "").split(";")[0].replace(/"[^"]*"/g, "").replace(/\\./g, "");
  if (/general/i.test(section)) return false;
  return /[ymdhs]/i.test(section);
};
var renderDateSerial = (serial, numFmt) => {
  if (numFmt === void 0 || !isDateTimeNumFmt(numFmt)) return null;
  if (!isPlausibleDateSerial(serial)) return null;
  const ms = Math.round((EXCEL_EPOCH_MS2 + serial * MS_PER_DAY2) / SECOND2) * SECOND2;
  const rendered = formatDateNumFmt(ms, numFmt);
  if (rendered !== null && parseTimestampCell(rendered) !== null) {
    return rendered;
  }
  return canonical(ms);
};

// src/utils/document-columns.helper.ts
var DOCUMENT_COLUMN_CHARS_PER_LINE = 50;
var isListedDocument = (document) => {
  var _a, _b;
  return document.isVisible !== false && ((_b = (_a = document.name) == null ? void 0 : _a.trim().length) != null ? _b : 0) > 0;
};
var splitDocumentsIntoColumns = (documents, getName) => {
  if (documents.length === 0) return { left: [], right: [] };
  const lineCounts = documents.map(
    (document) => Math.ceil((getName(document).length + 2) / DOCUMENT_COLUMN_CHARS_PER_LINE)
  );
  const totalLines = lineCounts.reduce((sum, count) => sum + count, 0);
  let bestSplit = documents.length;
  let leftLines = 0;
  for (let split = 1; split <= documents.length; split++) {
    leftLines += lineCounts[split - 1];
    const rightLines = totalLines - leftLines;
    if (leftLines >= rightLines) {
      bestSplit = split;
      break;
    }
  }
  return {
    left: documents.slice(0, bestSplit),
    right: documents.slice(bestSplit)
  };
};

// src/insight/insight-chat.types.ts
var GRID_ROW_FORMAT = "_format";
var GRID_ROW_ROLE = "_role";
var INSIGHT_FEEDBACK_REASONS = [
  "wrong_number",
  "wrong_period_filter",
  "wrong_name",
  "misunderstood",
  "should_be_chart",
  "refused",
  "slow",
  "other"
];
var INSIGHT_ERROR_TEXT = {
  LLM_UNAVAILABLE: "Ask Insight is unavailable right now. Please try again in a minute.",
  QUERY_TIMEOUT: "That needs too much data at once. Try a shorter period or fewer breakdowns.",
  STEP_LIMIT: "I couldn't work this out. Could you rephrase it?",
  INTERNAL: "Something went wrong on our side. Please try again."
};
var OUTSIDE_CONTEXT_LABEL = "From outside sources, not Vahterus data";
var OUTSIDE_UNREACHABLE_NOTE = "Outside sources couldn't be reached this time.";

// src/insight/insight-format.ts
var MINUS = "\u2212";
var grouped = (n) => Math.round(n).toLocaleString("en-US");
var signOf = (value, printsAsZero) => value < 0 && !printsAsZero ? MINUS : "";
function formatEur(value) {
  const abs = Math.abs(value);
  if (abs < 9999.5) {
    return `${signOf(value, Math.round(abs) === 0)}\u20AC${grouped(abs)}`;
  }
  const sign = signOf(value, false);
  if (abs < 999950) return `${sign}\u20AC${(abs / 1e3).toFixed(1)} k`;
  return `${sign}\u20AC${(abs / 1e6).toFixed(1)} M`;
}
var formatCount = (value) => `${signOf(value, Math.round(Math.abs(value)) === 0)}${grouped(Math.abs(value))}`;
var formatValue = (value, format) => value === null ? "\u2013" : format === "eur" ? formatEur(value) : formatCount(value);
var pctSize = (pct) => {
  const oneDecimal = Math.abs(pct).toFixed(1);
  if (Number(oneDecimal) === 0) return "0";
  if (Number(oneDecimal) < 100) return oneDecimal;
  return String(Math.round(Math.abs(pct)));
};
var formatPct = (pct) => {
  const size = pctSize(pct);
  return `${signOf(pct, size === "0")}${size} %`;
};
var formatChange = (pct) => {
  const size = pctSize(pct);
  return `${pct < 0 && size !== "0" ? MINUS : "+"}${size} %`;
};
var formatNumber = (value) => {
  const text = Math.abs(value).toLocaleString("en-US", {
    maximumFractionDigits: 2
  });
  return `${signOf(value, Number(text.replace(/,/g, "")) === 0)}${text}`;
};
var formatShare = (pct) => {
  const text = Math.abs(pct).toFixed(1);
  return `${signOf(pct, Number(text) === 0)}${text} %`;
};
var formatSignedValue = (value, format) => {
  const size = formatValue(Math.abs(value), format);
  const printsAsZero = size === formatValue(0, format);
  return `${value < 0 && !printsAsZero ? MINUS : "+"}${size}`;
};
var formatFull = (value) => formatCount(value);
var formatSignedFull = (value) => {
  const whole = Math.round(Math.abs(value));
  if (whole === 0) return "0";
  return `${value < 0 ? MINUS : "+"}${grouped(whole)}`;
};
var formatChangeCell = (pct) => {
  const text = Math.abs(pct).toFixed(1);
  if (Number(text) === 0) return "0.0 %";
  return pct < 0 ? `\u25BC ${MINUS}${text} %` : `\u25B2 +${text} %`;
};
function formatGridCell(value, kind, format) {
  if (typeof value === "string") return value;
  if (value === null || value === void 0 || !Number.isFinite(value)) {
    return "\u2013";
  }
  if (kind === "change_pct" || format === "change_pct") {
    return formatChangeCell(value);
  }
  if (kind === "change") return formatSignedFull(value);
  if (kind === "share" || kind === "achieved" || format === "percent") {
    return formatShare(value);
  }
  if (format === "number") return formatNumber(value);
  return formatFull(value);
}
var MARK = /\[\[(up|down):([^\]]*?)\]\]/g;
function narrativeParts(text) {
  var _a;
  const parts = [];
  let last = 0;
  for (const match of text.matchAll(MARK)) {
    const start = (_a = match.index) != null ? _a : 0;
    if (start > last) parts.push({ text: text.slice(last, start), tone: null });
    if (match[2]) {
      parts.push({ text: match[2], tone: match[1] });
    }
    last = start + match[0].length;
  }
  if (last < text.length) parts.push({ text: text.slice(last), tone: null });
  return parts;
}
var withoutToneMarks = (text) => text.replace(MARK, (_, _tone, phrase) => phrase);

// src/insight/insight-admin.types.ts
var INSIGHT_ADMIN_RANGES = [1, 7, 30, 90];
var INSIGHT_ADMIN_FLAGS = [
  "thumbs_down",
  "thumbs_up",
  "error",
  "unsupported",
  "clarify",
  "sql",
  "web",
  "queued",
  "slow"
];
var INSIGHT_ADMIN_SLOW_MS = 6e4;
var INSIGHT_ADMIN_EVENT_KINDS = [
  "rate_limited",
  "internal_error"
];

// src/insight/insight-saved-chart.types.ts
var INSIGHT_SAVED_CHART_LIMIT = 200;
var INSIGHT_SAVED_CHART_TITLE_MAX = 200;

// src/insight/insight-plot.ts
var INSIGHT_CHART_KINDS = [
  "columns",
  "bars",
  "line",
  "area",
  "donut",
  "scatter",
  "combo"
];
var INSIGHT_CHART_KIND_LABELS = {
  columns: "Columns",
  bars: "Bars",
  line: "Line",
  area: "Area",
  donut: "Donut",
  scatter: "Scatter",
  combo: "Bars + line"
};
var INSIGHT_TABLE_VIEW = "table";
var INSIGHT_CHART_VIEW_LABELS = __spreadProps(__spreadValues({}, INSIGHT_CHART_KIND_LABELS), {
  table: "Table"
});
var PLOT_LIMITS = {
  DONUT_SLICES: 6,
  STACK_CATEGORIES: 8,
  BARS: 25,
  SCATTER_POINTS: 2e3,
  SERIES: 4
};
var isNumber = (v) => typeof v === "number" && Number.isFinite(v);
var drawnSeries = (plot) => plot.series.filter((s) => !s.line && !s.marker);
var drawnValues = (plot) => {
  const keys = drawnSeries(plot).map((s) => s.key);
  return plot.data.flatMap((row) => keys.map((k) => row[k]).filter(isNumber));
};
var hasNegative = (plot) => drawnValues(plot).some((v) => v < 0);
var seriesCap = (plot) => plot.stacked ? PLOT_LIMITS.STACK_CATEGORIES + 1 : PLOT_LIMITS.SERIES;
var seriesFit = (plot) => {
  const drawn = drawnSeries(plot);
  if (drawn.length === 0) return "Needs a figure to draw";
  if (drawn.length > seriesCap(plot)) return "Too many series to draw";
  if (new Set(drawn.map((s) => s.format)).size > 1)
    return "Figures are in different units";
  return null;
};
var columnsFit = (plot) => {
  if (plot.x.axis === "number") return "Needs dates or names along the axis";
  const series = seriesFit(plot);
  if (series) return series;
  if (plot.x.axis === "time" && plot.data.length > PLOT_LIMITS.BARS)
    return "Too many periods to draw";
  return null;
};
var barsFit = (plot) => plot.x.axis === "category" ? columnsFit(plot) : "Needs names along the axis";
var lineFit = (plot) => {
  if (plot.x.axis === "category") return "Needs dates or numbers along the axis";
  if (plot.data.length < 2) return "Needs at least two points";
  return seriesFit(plot);
};
var areaFit = (plot) => {
  var _a;
  return (_a = lineFit(plot)) != null ? _a : hasNegative(plot) ? "Has negative values" : null;
};
var donutFit = (plot) => {
  const drawn = drawnSeries(plot);
  const slicesByCategory = plot.x.axis === "category" && drawn.length === 1;
  const slicesOfOneRow = plot.stacked && plot.data.length === 1 && drawn.length > 1;
  if (!slicesByCategory && !slicesOfOneRow)
    return "Needs one figure split by a category";
  if (plot.sumsToTotal === false) return "Figures do not add up to a total";
  const formats = new Set(drawn.map((s) => s.format));
  if (formats.size > 1 || !(formats.has("eur") || formats.has("count")))
    return "Needs amounts or counts";
  if (hasNegative(plot)) return "Has negative values";
  if (!drawnValues(plot).some((v) => v > 0)) return "Has no values above zero";
  return null;
};
var scatterFit = (plot) => {
  const drawn = drawnSeries(plot);
  if (plot.x.axis !== "number" || drawn.length !== 1)
    return "Needs two numeric columns";
  if (plot.data.length > PLOT_LIMITS.SCATTER_POINTS)
    return "Too many rows to draw";
  const y = drawn[0].key;
  const pairs = plot.data.filter(
    (row) => isNumber(row[plot.x.key]) && isNumber(row[y])
  );
  if (pairs.length < 3) return "Needs at least three points";
  return null;
};
var comboFit = (plot) => {
  const lines = plot.series.filter((s) => s.line).length;
  if (lines === 0) return "Needs a line figure";
  if (lines > 1) return "Has more than one line figure";
  return columnsFit(plot);
};
var FIT_RULES = {
  columns: columnsFit,
  bars: barsFit,
  line: lineFit,
  area: areaFit,
  donut: donutFit,
  scatter: scatterFit,
  combo: comboFit
};
function kindFits(plot) {
  const fits = {};
  for (const kind of INSIGHT_CHART_KINDS)
    fits[kind] = plot.data.length === 0 ? "Nothing to draw" : FIT_RULES[kind](plot);
  return fits;
}
function fittingKinds(plot) {
  const fits = kindFits(plot);
  return INSIGHT_CHART_KINDS.filter((kind) => fits[kind] === null);
}
var CLOSEST_KIND = {
  donut: "bars",
  area: "line",
  line: "columns",
  combo: "columns",
  bars: "columns",
  columns: "bars"
};
function fallbackKind(wanted, plot) {
  var _a;
  const fits = kindFits(plot);
  if (fits[wanted] === null) return wanted;
  const closest = CLOSEST_KIND[wanted];
  if (closest && fits[closest] === null) return closest;
  return (_a = INSIGHT_CHART_KINDS.find((kind) => fits[kind] === null)) != null ? _a : null;
}
export {
  ApplicationOption,
  ApplicationType,
  ApprovalType,
  AsmeClassification,
  AsmeClassificationMappingLabel,
  AsmeInspectionAuthority,
  AsmeInspectionAuthorityMappingLabel,
  AsmeOptions,
  BodySideV2,
  BodyTypeV2,
  BugStatus,
  ByPassFactor,
  CPQ_MFILE_ID_FORMAT_MESSAGE,
  CPQ_MFILE_ID_PATTERN,
  CalculationOption,
  CalculationState,
  CascadeType,
  CascadeTypeLableMapping,
  CellStatus,
  ChatUserRole,
  ChinaClassification,
  ChinaClassificationMappingLabel,
  Circulation,
  CirculationMappingLabel,
  CmsReleaseNoteAudience,
  CmsReleaseNoteFeatureType,
  CmsReleaseNoteProduct,
  CoCurrentFlowConfig,
  CoCurrentFlowConfigMappingLabel,
  Collections,
  Combination,
  CombinedFillingBoxes,
  CombinedFillingBoxesMappingLabel,
  CommissionAssignmentType,
  CommissionCalculationBasis,
  CommissionUnitType,
  CondenserMediumTypeOption,
  CondenserType,
  ConnectionType,
  Construction,
  ConstructionMappingLabel,
  CorrosionAllowance,
  CorrosionAllowanceMappingLabel,
  CorrosionAndErosion,
  CpqApplicationType,
  CpqApprovalType,
  CpqPlateMaterial,
  CpqPlateType,
  CpqShellMaterial,
  CurrencyCode,
  CustomPositionPriceType,
  CustomerSystem,
  CustomerSystemSector,
  DEFAULT_UTC_OFFSET,
  DOCUMENT_COLUMN_CHARS_PER_LINE,
  DangerousnessOfTheContentOfPshePlatePack,
  DataSheetTextDto,
  DataStatus,
  DesignClassification,
  DesignCode,
  DesignCodeMappingLabel,
  DesignModelType,
  DesignModelTypeMappingLabel,
  DesignPressureOption,
  Direction,
  DocumentationItem,
  DocumentationItemMappingLabel,
  DrawingApproval,
  DrawingApprovalMappingLabel,
  DrawingCustDays,
  DrawingCustDaysMappingLabel,
  DrawingEndPlateV2,
  DrawingEvent,
  DrawingLevel,
  DrawingLevelMappingLabel,
  DrawingState,
  EndPlateType,
  EvaporatorType,
  EvaporatorTypeLabelMapping,
  ExtraPriceCalculationBasis,
  ExtraPriceCategory,
  ExtraPriceItemMultiplier,
  ExtraPriceItemOperationType,
  ExtraPricePer,
  ExtraPricePriceType,
  ExtraPriceShowOnOffer,
  Fatigue,
  Feet,
  FinalDocumentation,
  FinalDocumentationMappingLabel,
  FlowDirection,
  FlowDirectorMaterialOption,
  FlowTempV2,
  FluidTemperatureInPlatepack,
  FormulaType,
  FractionType,
  GRID_ROW_FORMAT,
  GRID_ROW_ROLE,
  HaPlateMaterial,
  HaPlateMaterialAttribute,
  HaPlateSize,
  HaPlateSizeAndType,
  HaPlateSizeAndTypeAttribute,
  HaPlateThickness,
  HeliumVacuumTest,
  HeliumVacuumTestMappingLabel,
  HotSide,
  HotSideLableMapping,
  INSIGHT_ADMIN_EVENT_KINDS,
  INSIGHT_ADMIN_FLAGS,
  INSIGHT_ADMIN_RANGES,
  INSIGHT_ADMIN_SLOW_MS,
  INSIGHT_CHART_KINDS,
  INSIGHT_CHART_KIND_LABELS,
  INSIGHT_CHART_VIEW_LABELS,
  INSIGHT_ERROR_TEXT,
  INSIGHT_FEEDBACK_REASONS,
  INSIGHT_SAVED_CHART_LIMIT,
  INSIGHT_SAVED_CHART_TITLE_MAX,
  INSIGHT_TABLE_VIEW,
  IndustrialSector,
  IndustrialSectorMappingLabel,
  InspectionOfThePlatepack,
  Installation,
  Insulation,
  InsulationCompleteType,
  InsulationCompleteTypeMappingLabel,
  InsulationMappingLabel,
  InsulationSupportsType,
  InsulationSupportsTypeMappingLabel,
  Language,
  LiquidSide,
  LiquidSideLabelMapping,
  MINUS,
  ManagementClass,
  ManagementClassMappingLabel,
  ManualLanguage,
  ManualLanguageMappingLabel,
  ManyPointCalc,
  ManyPointCalcMappingLabel,
  MarineOffshore,
  MarineOffshoreInspectionAuthority,
  MarineOffshoreInspectionAuthorityMappingLabel,
  MarineOffshoreMappingLabel,
  MeansOfExaminationForPlatepack,
  MediumDangerousOption,
  MediumMixture,
  MediumOption,
  MediumPropertyCalculation,
  MediumPropertyType,
  MediumSource,
  MediumTypeOption,
  MinimumDesignPressure,
  MultiPassCombination,
  MultiPassCombinationLabelMapping,
  N2Filling,
  N2FillingMappingLabel,
  NamePlateLanguage,
  NamePlateLanguageMappingLabel,
  NamePlateType,
  NamePlateTypeMappingLabel,
  Nameplate,
  NozzleFlowV2,
  NozzleShell,
  NozzleTypeV2,
  NumberOfPasses,
  NumberOfPassesLabelMapping,
  NumberOfPlateNozzle,
  NumberOfShellNozzle,
  ORP_ERP_OWNED,
  ORP_SERVER_OWNED,
  OUTSIDE_CONTEXT_LABEL,
  OUTSIDE_UNREACHABLE_NOTE,
  OfferInfoType,
  OfferStatus,
  OperationLifetime,
  OrpApplicationType,
  OrpApprovalType,
  OrpOrderStatus,
  OrpOrderStatusMappingLabel,
  OrpPlateMaterial,
  OrpPlateType,
  OrpShellMaterial,
  OtherClassification,
  OtherClassificationMappingLabel,
  PLOT_LIMITS,
  PaintColor,
  PaintThickness,
  Parfile,
  PartCascadeType,
  Ped13H,
  PedApproval,
  PedApprovalMappingLabel,
  PedInspectionAuthority,
  PedInspectionAuthorityMappingLabel,
  PedSingleApproval,
  PedTypeApproval,
  PlateMaterial,
  PlatePackCode,
  PlatePackCodeMappingLabel,
  PlatePressureTest,
  PlatePressureTestMappingLabel,
  PlateShellConnection,
  PlateShellDrying,
  PlateShellDryingMappingLabel,
  PlateThicknessOption,
  PlateTypeOption,
  PositionCommentType,
  PriceComponentType,
  PricingPolicyOption,
  PricingPolicyOptionMappingLabel,
  PricingSheetStatus,
  ProductTest,
  ProductTestMappingLabel,
  QueueList,
  Region,
  RoundedType,
  SIUnitDto,
  Scm,
  ScmMappingLabel,
  SearchScope,
  ShareMode,
  ShellDiameter,
  ShellMaterial,
  ShellPressureTest,
  ShellPressureTestMappingLabel,
  SignificanceOfTheProcessMediaConfusionCausedByPlateDamage,
  Size,
  SizeablePlateMaterial,
  SparePartOption,
  SparePartOptionMappingLabel,
  SpecialTesting,
  SpecialTestingMappingLabel,
  SuggestionStatus,
  SupportMaterial,
  SupportMaterialMappingLabel,
  SurfaceTreatment,
  SurfaceTreatmentPart,
  TCP_MESSAGES,
  TermsOfDelivery,
  TermsOfDeliveryMappingLabel,
  TermsOfPayment,
  TermsOfPaymentMappingLabel,
  UNIT_DIMENSIONS,
  UTC_OFFSETS,
  UnitAirHumidityOption,
  UnitAreaOption,
  UnitCapacityOption,
  UnitDesignPressureOption,
  UnitDynamicViscosityOption,
  UnitEntalphyOption,
  UnitFoulingFactorOption,
  UnitKValueOption,
  UnitMassFlowOption,
  UnitMassOption,
  UnitPressureOption,
  UnitSpecificGravityOption,
  UnitSpecificHeatOption,
  UnitSurfaceTensionOption,
  UnitTemperatureLMTDOption,
  UnitThermalConductivityOption,
  UnitType,
  UnitVelocityOption,
  UnitVolumeOption,
  UserRole,
  ValidationResult,
  VersionStatus,
  VolumeOfContentsInPlatepack,
  WorkspaceRegion,
  WorkspaceRole,
  applicationOptionMappingLabel,
  applicationOptionsBySizingApplication,
  applicationTypeLabelMapping,
  applicationTypeSpec,
  applyExcelChangeToSpreadSheet,
  applyHidePsheTypeToContent,
  applyNewCalculationToSpreadSheet,
  applyNewLanguageToSpreadSheet,
  approvalTypeMappingLabel,
  approvalTypeSpec,
  asmeClassificationMappingLabel,
  asmeOptionsLabels,
  blackListEmail,
  bugStatusTabMapToURL,
  buildParentChildRelationships,
  calculationOptionLabelMapping,
  canBeNumber,
  carboonSteelMappingList,
  cmsReleaseNoteAudienceMappingLabel,
  cmsReleaseNoteFeatureTypeMappingLabel,
  cmsReleaseNoteProductMappingLabel,
  combinationMappingLabel,
  commissionAssignmentTypeMappingLabel,
  commissionCalculationBasisMappingLabel,
  commissionUnitTypeMappingLabel,
  condenserMediumTypeOptionMappingLabel,
  condenserTypeNameMapping,
  connectionTypeLabelMapping,
  constructionMappingLabel,
  convertSpreadSheetToExcel,
  convertUnit,
  corrosionAndErosionLabels,
  countLeadingZeros,
  createGroupedEntry,
  currencyCodeLabelMapping,
  currencyCodeSymbolMapping,
  customExtraKey,
  customPositionPriceTypeMappingLabel,
  customerSystemMappingLabel,
  customerSystemMappingMfileCSValue,
  customerSystemMappingValue,
  customerSystemSectorMapping,
  customerSystemSectorMappingLabel,
  customerSystemSectorMappingValue,
  dangerousnessOfTheContentOfPshePlatePackLabels,
  designClassificationMappingLabel,
  designPressureHandler,
  designPressureOptionMappingLabel,
  designPressureOptionMappingValue,
  directionMappingLabel,
  dynamicRoundingNumber,
  endPlateTypeMappingLabel,
  evaporatorLiquidPropCalcFields,
  extraPriceCalculationBasisMappingLabel,
  extraPriceCategoryMappingLabel,
  extraPricePerMappingLabel,
  extraPricePriceTypeMappingLabel,
  extraPriceShowOnOfferMappingLabel,
  extractFunctions,
  extractUniqueExpressions,
  fallbackKind,
  fatigueLabels,
  feetCarbonSteel,
  feetMappingLabel,
  fillingBoxTextHandler,
  fittingKinds,
  flowDirectorMaterialOptionValueMapping,
  flowDriectionMappingLabel,
  fluidTemperatureInPlatepackLabels,
  formatChange,
  formatChangeCell,
  formatCount,
  formatEur,
  formatFull,
  formatGridCell,
  formatNumber,
  formatPct,
  formatShare,
  formatSignedFull,
  formatSignedValue,
  formatValue,
  fractionTypeMappingLabel,
  generateExtraList,
  getAppTitle,
  getCustomerSystemFromMfileCSValue,
  getDecimalScaleFormat,
  getDecimalScaleFromDecimalScaleFormat,
  getDesignPressureMin,
  getDesignPressureShellSideUnit,
  getHidePSHEModel,
  getHotSide,
  getInternalOrJciMediumError,
  getMediumName,
  getMediumNames,
  getMfileCustomerSystemValue,
  getMultiCondenserPassesPlateShellSide,
  getMultiCondenserPsheType,
  getNozzlePlateSideSize,
  getNozzleShellSideSize,
  getNumberOfPassed,
  getNumberOfPlateNozzle,
  getNumberOfShellNozzle,
  getPlateShellTemperatures,
  getPrecision,
  getPsheTypeForMultiCondenser,
  getShellMaterial,
  groupExtrasByCategory,
  haPlateMaterialLabels,
  haPlateSizeAndTypeLabels,
  haPlateThicknessLabels,
  handleCellCustomValue,
  handleDisplayValue,
  handleRoundValue,
  hidePsheTypeRowsInSpreadSheet,
  inspectionOfThePlatepackLabels,
  installationLabels,
  internalOrJciMediumOptions,
  isGroupedExtra,
  isInfinitiveNumber,
  isInternalOrJciMedium,
  isListedDocument,
  isNaNOrInfinity,
  isNotNullOrUndefined,
  isNumericCell,
  isPlausibleDateSerial,
  isValidCpqMfileId,
  isValidNumber,
  isVolumetricFlowUnit,
  kindFits,
  languageMappingLabel,
  limitedSpreadsheetData,
  managementClassFromLabel,
  mapMultiCondenserCalcuationKeyToSpeadsheetCellValue,
  marineOffshoreMappingLabel,
  meansOfExaminationForPlatepackLabels,
  mediumMixtureMappingLabel,
  mediumOptionMappingLabel,
  mediumSourceMappingLabel,
  mediumTypeOptionMappingLabel,
  minimalSpreadsheetData,
  minimumDesignPressureLabels,
  namePlateMappingLabel,
  narrativeParts,
  nozzleShellASMEDatasheetLabel,
  nozzleShellLabelMapping,
  nozzleShellPEDAndPEDENDatasheetLabel,
  nullableHelper,
  numberHelper,
  numberOfPlateNozzleMappingLabel,
  numberOfShellNozzleMappingLabel,
  onePhaseColdPropCalcFields,
  onePhaseHotPropCalcFields,
  operationLifetimeLabels,
  orpPlateMaterialLabels,
  orpShellMaterialLabels,
  paintColorMappingValue,
  paintOptionInputMappingValue,
  paintThicknessMappingValue,
  paintingValueHandler,
  parseNumericCell,
  parseTimeLiteral,
  parseTimestampCell,
  partialCascadeTypeLableMapping,
  ped13HMappingLabel,
  pedSingleApprovalMappingLabel,
  pedTypeApprovalMappingLabel,
  plateMaterialMappingLabel,
  plateMaterialSpec,
  plateShellConnectionMappingLabel,
  plateThicknessOptionMappingLabel,
  plateThicknessOptionValueMapping,
  plateTypeOptionMappingLabel,
  plateTypeOptionMappingValue,
  plateTypeOptionSpec,
  plateTypeOptionsBySizingValue,
  precise,
  priceComponentTypeMappingLabel,
  removeSpreadsheetLimitedVisibility,
  renderDateCell,
  renderDateSerial,
  resolveSizingPlateType,
  restoreHeatExchangerTypeInContent,
  roundNumberToPrecision,
  roundedTypeMappingLabel,
  shellMaterialMappingLabel,
  shellMaterialSpec,
  significanceOfTheProcessMediaConfusionCausedByPlateDamageLabels,
  sizeMappingLabel,
  splitDocumentsIntoColumns,
  spreadSheetDataHelper,
  spreadSheetHelper,
  stainlessSteelMappingList,
  suggestionStatusTabMapToURL,
  surfaceTreatmentMappingValue,
  surfaceTreatmentPartMappingValue,
  unitAirHumidityLabelOptionMapping,
  unitAirHumidityOptionLabelMapping,
  unitAreaLabelOptionCalculateMapping,
  unitAreaOptionLabelCalculateMapping,
  unitAreaOptionLabelInputMapping,
  unitCapacityLabelOptionMapping,
  unitCapacityOptionLabelMapping,
  unitDesignPressureLabelOptionMapping,
  unitDesignPressureOptionMappingLabel,
  unitDynamicViscosityLabelOptionMapping,
  unitDynamicViscosityOptionLabelMapping,
  unitEntalphyLabelOptionMapping,
  unitEntalphyOptionLabelMapping,
  unitFoulingFactorLabelOptionMapping,
  unitFoulingFactorOptionLabelCalculateMapping,
  unitFoulingFactorOptionLabelInputMapping,
  unitKValueLabelOptionMapping,
  unitKValueOptionLabelCalculateMapping,
  unitKValueOptionLabelInputMapping,
  unitMassFlowLabelOptionMapping,
  unitMassFlowOptionLabelMapping,
  unitMassLabelOptionMapping,
  unitMassOptionLabelMapping,
  unitPressureLabelOptionCalculateMapping,
  unitPressureOptionLabelCalculatelMapping,
  unitPressureOptionLabelInputMapping,
  unitSpecificGravityLabelOptionCalculateMapping,
  unitSpecificGravityOptionLabelCalculateMapping,
  unitSpecificGravityOptionLabelInputMapping,
  unitSpecificHeatLabelOptionMapping,
  unitSpecificHeatOptionLabelMapping,
  unitSurfaceTensionLabelOptionCalculateMapping,
  unitSurfaceTensionOptionLabelCalculateMapping,
  unitSurfaceTensionOptionLabelInputMapping,
  unitTemperatureLMTDLabelOptionMapping,
  unitTemperatureLMTDOptionLabelMapping,
  unitThermalConductivityLabelOptionCalculateMapping,
  unitThermalConductivityOptionLabelCalculateMapping,
  unitThermalConductivityOptionLabelInputMapping,
  unitTypeMappingLabel,
  unitVelocityLabelOptionMapping,
  unitVelocityOptionLabelMapping,
  unitVolumeCalculateLabelOptionMapping,
  unitVolumeOptionCalculateMappingLabel,
  unitVolumeOptionInputMappingLabel,
  velocityInDemisterHandler,
  volumeOfContentsInPlatepackLabels,
  withoutToneMarks
};
//# sourceMappingURL=index.mjs.map